// ═══════════════════════════════════════════════════════════════════════════
// IFACES DATA — ADVANCED CLM INTERFACE INTELLIGENCE  (Æther//CLM v5)
// Versions: TC 2512 · Opcenter 2601 · CN4T 2510 · CN4S · AIG · SFC · Edge · Hub
//
// 56 interfaces · 189 tasks · 876 DoD criteria
//   · 65 triggers · 385 attribute mappings · 102 API specs
//
// FULL FIDELITY: every native field preserved (triggers, attrMap, apis,
//   integrationStructure, implementationOrder, tasks/dod).
// ENHANCED LAYER per interface (`enhanced`): meaning, purpose, function &
//   sub-functions, architecture, harmonious-flow channel (intra/inter), MoSCoW,
//   scoped source/destination business objects, system-of-record, idempotency,
//   error-handling, security, monitoring, upstream/downstream consumers,
//   criticality score, reusability, Siemens doc search keywords, task hours.
// PER TASK: implementationType (OOTB / OOTB + Config / Customization) +
//   rationale + hierarchical subTasks (step → subSubTasks[]).
//
// Programme classification: OOTB 85 · OOTB+Config 98 · Customization 6
// Generated artefact — regenerate from source + generator; do not hand-edit.
// ═══════════════════════════════════════════════════════════════════════════

export const IFACES_ENHANCED = [
 {
  "id": "IF-001",
  "seq": 1,
  "mvp": 1,
  "phase": 2,
  "grp": "CN4T",
  "type": "BiSync",
  "freq": "Event",
  "name": "BOP Operations to Opcenter WorkflowSteps",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA TCCS v14 + Opcenter REST API v1",
  "bo": "Mfg0BvrOperation → WorkflowStep",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "PLM + MES",
  "outcome": "Production Routing",
  "outcomeCat": "Shop Floor Execution",
  "deps": [],
  "about": "Transforms TC Bill of Process operations into Opcenter Workflow steps. This is the most critical CN4T interface for standard CLM deployments. Supports delta sync, ECO propagation, and EasyPlan MTM time integration.",
  "tags": [
   "BOP",
   "WorkflowStep",
   "CN4T",
   "MTM",
   "ECO",
   "Routing",
   "DeltaSync"
  ],
  "triggers": [
   {
    "id": "TRG-001-01",
    "name": "TC Operation CREATE",
    "type": "CREATE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Mfg0BvrOperation object creation",
    "condition": "Parent BOP in Released state",
    "latency": "< 5 seconds",
    "description": "When a manufacturing engineer creates a new BOP operation, CN4T pushes it to Opcenter as a new WorkflowStep.",
    "technicalDetails": {
     "protocol": "TC SOA TCCS v14 (SOAP)",
     "port": "4545",
     "messageFormat": "SOAP/XML",
     "authentication": "Service Account + Mutual TLS"
    },
    "preConditions": [
     "TC SOA session established with valid service account",
     "CN4T service account has mfg_bop_read role",
     "Opcenter API key generated and accessible",
     "CN4T Windows service running",
     "BOP parent object exists and is Released"
    ],
    "context": "Manufacturing engineer creates new operation in BOP Editor within TC Active Workspace or Rich Client.",
    "prerequisites": {
     "tc": [
      "BMIDE deployment with Mfg0BvrOperation subtypes",
      "TC Subscription Manager configured"
     ],
     "cn4t": [
      "CN4T 2510 installed",
      "CN4T mapping XML configured",
      "Dead-letter queue configured"
     ],
     "opcenter": [
      "Opcenter 2601 REST API accessible",
      "ResourceGroup objects created",
      "WorkflowStep resource type exists"
     ]
    },
    "sla": {
     "latency": "< 5 seconds",
     "throughput": "100 ops/minute",
     "availability": "99.9%",
     "reliability": "99.99%"
    },
    "errorHandling": {
     "tcTimeout": {
      "action": "Retry with exponential backoff (15s, 1min, 5min)",
      "escalation": "Log only"
     },
     "opcenterError": {
      "action": "Send to DLQ with operator alert",
      "escalation": "Email to MES team"
     },
     "mappingError": {
      "action": "Log error, skip record",
      "escalation": "Manual review required"
     },
     "duplicateDetection": {
      "action": "UPDATE not CREATE",
      "escalation": "None"
     }
    },
    "monitoring": {
     "metrics": [
      "sync_duration_seconds",
      "sync_errors_total",
      "queue_depth",
      "last_sync_timestamp"
     ],
     "alerts": [
      "error_rate > 5% → PagerDuty",
      "latency > threshold → Email",
      "queue_depth > 100 → Warning"
     ],
     "dashboard": "Grafana dashboard with real-time status",
     "slaTracking": "Monthly SLA reports auto-generated"
    },
    "security": {
     "encryption": "TLS 1.3 for all connections",
     "authentication": "Mutual TLS + Bearer Token",
     "authorization": "Role-based access control (RBAC)",
     "auditLogging": "All transactions logged to centralized SIEM",
     "secretManagement": "HashiCorp Vault or Azure Key Vault"
    },
    "rollback": {
     "steps": [
      "Stop CN4T service",
      "Delete created WorkflowSteps",
      "Correct TC attributes",
      "Restart CN4T"
     ],
     "estimatedTime": "15 minutes",
     "dataLoss": "None"
    },
    "recommendedMapping": [
     {
      "src": "Mfg0BvrOperation.bl_name",
      "dst": "WorkflowStep.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Operation short name - must be unique per Spec"
     },
     {
      "src": "Mfg0BvrOperation.sequence",
      "dst": "WorkflowStep.SequenceNumber",
      "xform": "×10 increment",
      "mandatory": true,
      "note": "Preserves TC ordering with gap for inserts"
     },
     {
      "src": "Mfg0BvrOperation.mbc0WorkArea",
      "dst": "WorkflowStep.ResourceGroup",
      "xform": "Lookup table",
      "mandatory": true,
      "note": "TC WorkCenter to Opcenter ResourceGroup mapping"
     },
     {
      "src": "UserData.std_time_min",
      "dst": "WorkflowStep.StandardTime",
      "xform": "Direct",
      "mandatory": true,
      "note": "EasyPlan MTM-proven standard time"
     }
    ],
    "optionalMapping": [
     {
      "src": "Mfg0BvrOperation.bl_description",
      "dst": "WorkflowStep.Description",
      "xform": "Direct",
      "note": "Long description for operator guidance"
     },
     {
      "src": "UserData.qc_hold",
      "dst": "WorkflowStep.IsHoldStep",
      "xform": "Boolean",
      "note": "QC inspection gate step"
     },
     {
      "src": "UserData.setup_time_min",
      "dst": "WorkflowStep.SetupTime",
      "xform": "Direct",
      "note": "Setup/changeover time"
     },
     {
      "src": "UserData.control_key",
      "dst": "WorkflowStep.ControlKey",
      "xform": "Direct",
      "note": "PP01/PP02/PP03 control key"
     }
    ],
    "configSteps": [
     "Configure CN4T subscription to Mfg0BvrOperation creation events",
     "Set up CN4T XML mapping file: /config/mappings/bop_to_workflowstep.xml",
     "Configure TC SOA session pooling: min=2, max=10 connections",
     "Test with single operation creation before bulk operations",
     "Validate delta sync for attribute changes",
     "Set up monitoring and alerting"
    ]
   },
   {
    "id": "TRG-001-02",
    "name": "TC BOP Attribute UPDATE",
    "type": "ATTRIBUTE_CHANGE",
    "source": "Teamcenter 2512",
    "sourceEvent": "UserData.std_time_min attribute modification",
    "condition": "Change after EasyPlan MTM completion",
    "latency": "< 10 seconds",
    "description": "When EasyPlan exports balanced MTM times back to TC, CN4T detects the change and updates Opcenter.",
    "technicalDetails": {
     "protocol": "TC SOA TCCS v14",
     "messageFormat": "Delta sync",
     "authentication": "Mutual TLS"
    },
    "preConditions": [
     "Operation exists in Opcenter",
     "std_time_min attribute exists",
     "Delta sync mode enabled"
    ],
    "context": "Manufacturing engineer completes EasyPlan MTM study and exports balanced times back to TC.",
    "prerequisites": {
     "tc": [
      "Subscription Manager watching attribute changes"
     ],
     "cn4t": [
      "Delta detection configured"
     ],
     "opcenter": [
      "Accepts StandardTime updates on active Specs"
     ]
    },
    "sla": {
     "latency": "< 10 seconds",
     "throughput": "500 updates/minute",
     "availability": "99.9%"
    },
    "errorHandling": {
     "operationNotFound": {
      "action": "Fallback to CREATE",
      "escalation": "Log warning"
     },
     "invalidTime": {
      "action": "Reject if >0 and <1440",
      "escalation": "Email to engineer"
     }
    },
    "monitoring": {
     "metrics": [
      "sync_duration_seconds",
      "sync_errors_total",
      "queue_depth",
      "last_sync_timestamp"
     ],
     "alerts": [
      "error_rate > 5% → PagerDuty",
      "latency > threshold → Email",
      "queue_depth > 100 → Warning"
     ],
     "dashboard": "Grafana dashboard with real-time status",
     "slaTracking": "Monthly SLA reports auto-generated"
    },
    "security": {
     "encryption": "TLS 1.3 for all connections",
     "authentication": "Mutual TLS + Bearer Token",
     "authorization": "Role-based access control (RBAC)",
     "auditLogging": "All transactions logged to centralized SIEM",
     "secretManagement": "HashiCorp Vault or Azure Key Vault"
    },
    "recommendedMapping": [
     {
      "src": "UserData.std_time_min",
      "dst": "WorkflowStep.StandardTime",
      "xform": "Direct",
      "mandatory": true,
      "note": "Updated MTM time"
     },
     {
      "src": "Mfg0BvrOperation.bl_name",
      "dst": "WorkflowStep.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Lookup key"
     }
    ],
    "optionalMapping": [
     {
      "src": "UserData.std_time_source",
      "dst": "WorkflowStep.TimeSource",
      "xform": "Direct",
      "note": "MTM/Historical/Estimate"
     },
     {
      "src": "UserData.confidence_score",
      "dst": "WorkflowStep.AIConfidence",
      "xform": "Direct",
      "note": "AI confidence percentage"
     }
    ],
    "configSteps": [
     "Configure CN4T to monitor UserData.std_time_min for changes",
     "Set up delta sync mode to minimize load",
     "Configure Opcenter to accept StandardTime updates on active Specs"
    ]
   },
   {
    "id": "TRG-001-03",
    "name": "TC ECO Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "ECO status change to Released",
    "condition": "ECO contains BOP changes",
    "latency": "< 90 seconds",
    "description": "When ECO is released, CN4T performs delta sync — adds, removes, or updates only changed operations.",
    "technicalDetails": {
     "protocol": "TC SOA TCCS v14",
     "messageFormat": "Delta comparison",
     "authentication": "Mutual TLS"
    },
    "preConditions": [
     "ECO state = Released",
     "ECO contains BOP changes",
     "Approval workflow complete"
    ],
    "context": "Engineering Change Order approved and released, affecting multiple BOP operations.",
    "prerequisites": {
     "tc": [
      "ECO workflow defined",
      "Subscription rule configured"
     ],
     "cn4t": [
      "Delta detection logic"
     ],
     "opcenter": [
      "Spec revision increment configured"
     ]
    },
    "sla": {
     "latency": "< 90 seconds",
     "throughput": "50 ECOs/hour",
     "availability": "99.9%"
    },
    "errorHandling": {
     "noBOPChanges": {
      "action": "Log warning, no sync",
      "escalation": "None"
     },
     "specMismatch": {
      "action": "Quarantine, manual intervention",
      "escalation": "Supervisor alert"
     }
    },
    "monitoring": {
     "metrics": [
      "sync_duration_seconds",
      "sync_errors_total",
      "queue_depth",
      "last_sync_timestamp"
     ],
     "alerts": [
      "error_rate > 5% → PagerDuty",
      "latency > threshold → Email",
      "queue_depth > 100 → Warning"
     ],
     "dashboard": "Grafana dashboard with real-time status",
     "slaTracking": "Monthly SLA reports auto-generated"
    },
    "security": {
     "encryption": "TLS 1.3 for all connections",
     "authentication": "Mutual TLS + Bearer Token",
     "authorization": "Role-based access control (RBAC)",
     "auditLogging": "All transactions logged to centralized SIEM",
     "secretManagement": "HashiCorp Vault or Azure Key Vault"
    },
    "recommendedMapping": [
     {
      "src": "ECO.added_operations",
      "dst": "WorkflowStep.CREATE",
      "xform": "Array loop",
      "mandatory": true,
      "note": "New steps added"
     },
     {
      "src": "ECO.removed_operations",
      "dst": "WorkflowStep.INACTIVATE",
      "xform": "Array loop",
      "mandatory": true,
      "note": "Steps marked inactive"
     },
     {
      "src": "ECO.modified_attributes",
      "dst": "WorkflowStep.UPDATE",
      "xform": "Diff apply",
      "mandatory": true,
      "note": "Only changed fields"
     }
    ],
    "configSteps": [
     "Configure TC Subscription Manager to fire on ECO Released state",
     "Set up CN4T delta detection logic: compare BOP revisions",
     "Configure Opcenter Spec revision increment on ECO sync",
     "Test with open WOs to ensure version isolation"
    ]
   },
   {
    "id": "TRG-001-04",
    "name": "TC Work Package Release",
    "type": "STATE_CHANGE",
    "source": "Teamcenter 2512",
    "sourceEvent": "MEWorkpackage → Released",
    "condition": "All structures (MBOM+BOP+BOE) present",
    "latency": "< 60 seconds",
    "description": "When Work Package is released, CN4T performs full BOP sync creating complete Opcenter Workflow.",
    "recommendedMapping": [
     {
      "src": "MEWorkpackage.item_id",
      "dst": "Spec.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Spec identifier"
     },
     {
      "src": "MEWorkpackage.item_revision_id",
      "dst": "Spec.Revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Spec revision"
     },
     {
      "src": "All BOP operations",
      "dst": "Workflow",
      "xform": "Full sync",
      "mandatory": true,
      "note": "Complete workflow"
     }
    ],
    "configSteps": [
     "Configure CN4T to listen for MEWorkpackage Released events",
     "Set up dependency check: verify MBOM and BOP exist before sync",
     "Configure Spec creation in Opcenter after workflow creation"
    ]
   }
  ],
  "integrationStructure": {
   "architecture": "Publish-Subscribe with Delta Sync",
   "components": [
    {
     "name": "TC Subscription Manager",
     "role": "Event publisher",
     "version": "2512"
    },
    {
     "name": "CN4T Windows Service",
     "role": "Message broker/transformer",
     "version": "2510"
    },
    {
     "name": "Opcenter REST API",
     "role": "WorkflowStep CRUD",
     "version": "2601"
    },
    {
     "name": "CN4T Admin Console",
     "role": "Monitoring & DLQ",
     "version": "2510"
    }
   ],
   "dataFlow": "TC → CN4T (Transform/Map/Delta) → Opcenter",
   "errorHandling": "DLQ with retry (3 attempts: 15s, 1min, 5min)",
   "monitoring": "CN4T admin console + Grafana dashboard"
  },
  "implementationOrder": [
   {
    "step": 1,
    "action": "Install CN4T 2510 Windows service",
    "duration": "2 hours",
    "owner": "IT Team",
    "status": "pending"
   },
   {
    "step": 2,
    "action": "Verify TC 2512 SOA connection",
    "duration": "1 hour",
    "owner": "PLM Team",
    "status": "pending"
   },
   {
    "step": 3,
    "action": "Configure TC Subscription Manager",
    "duration": "3 hours",
    "owner": "PLM Admin",
    "status": "pending"
   },
   {
    "step": 4,
    "action": "Create CN4T mapping XML",
    "duration": "4 hours",
    "owner": "Integration Lead",
    "status": "pending"
   },
   {
    "step": 5,
    "action": "Test single operation sync",
    "duration": "2 hours",
    "owner": "QA",
    "status": "pending"
   },
   {
    "step": 6,
    "action": "Configure delta sync",
    "duration": "2 hours",
    "owner": "Integration Lead",
    "status": "pending"
   },
   {
    "step": 7,
    "action": "Test ECO delta sync",
    "duration": "3 hours",
    "owner": "QA",
    "status": "pending"
   },
   {
    "step": 8,
    "action": "Set up monitoring and alerting",
    "duration": "2 hours",
    "owner": "IT Ops",
    "status": "pending"
   }
  ],
  "tasks": [
   {
    "id": "T001a",
    "name": "Install CN4T + Configure Endpoints",
    "type": "Install",
    "hours": 6,
    "cx": 2,
    "dod": [
     "CN4T Windows service starts cleanly",
     "CN4T admin console accessible on HTTPS",
     "TC SOA test returns HTTP 200",
     "Opcenter REST test returns HTTP 200",
     "Service account has required roles"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the CN4T 2510 component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Teamcenter 2512 and Opcenter 2601",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T001b",
    "name": "Configure Operation Type + WorkCenter Mapping",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "All 6 StepTypes mapped",
     "Mapping file version-controlled",
     "Test sync passes",
     "QCHold flag maps correctly",
     "Work center mapping defined"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Configure Operation Type + WorkCenter Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Configure Operation Type + WorkCenter Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T001c",
    "name": "EasyPlan Standard Time Mapping",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Sequence numbers map correctly",
     "MTM times appear on steps",
     "Work instruction links appear",
     "Resource assignments match"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'EasyPlan Standard Time Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'EasyPlan Standard Time Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T001d",
    "name": "Full BOP Sync Integration Test",
    "type": "Test",
    "hours": 8,
    "cx": 3,
    "dod": [
     "20+ operations sync with 0 errors",
     "Spec auto-created",
     "Work Order routes correctly",
     "Step count matches exactly"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Full BOP Sync Integration Test'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→Opcenter 2601)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through CN4T 2510",
       "Confirm arrival + correctness at Opcenter 2601"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T001e",
    "name": "ECO Delta Sync Validation",
    "type": "Validate",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Added operation syncs within 90s",
     "Removed operation marked inactive",
     "Spec revision increments",
     "Open WOs quarantined",
     "48-hour log shows 0 errors"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'ECO Delta Sync Validation'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Mfg0BvrOperation.bl_name",
    "dst": "WorkflowStep.Name",
    "xform": "Direct",
    "mandatory": true,
    "category": "core"
   },
   {
    "src": "Mfg0BvrOperation.sequence",
    "dst": "WorkflowStep.SequenceNumber",
    "xform": "×10 increment",
    "mandatory": true,
    "category": "core"
   },
   {
    "src": "UserData.std_time_min",
    "dst": "WorkflowStep.StandardTime",
    "xform": "Direct",
    "mandatory": true,
    "category": "core"
   },
   {
    "src": "UserData.qc_hold",
    "dst": "WorkflowStep.IsHoldStep",
    "xform": "Boolean",
    "mandatory": false,
    "category": "quality"
   },
   {
    "src": "Mfg0BvrOperation.mbc0WorkArea",
    "dst": "WorkflowStep.ResourceGroup",
    "xform": "Lookup",
    "mandatory": true,
    "category": "core"
   },
   {
    "src": "Mfg0BvrOperation.bl_description",
    "dst": "WorkflowStep.Description",
    "xform": "Direct",
    "mandatory": false,
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "TC GetProperties (SOA)",
    "method": "POST",
    "url": "https://tc-host:4545/tc/services/Core-2007-01-Session/SessionService",
    "prereq": [
     "SOA session",
     "mfg_bop_read role"
    ],
    "purpose": "Retrieve BOP properties",
    "sample": "<connection host='tc-host' port='4545' user='clm_svc'/>",
    "rateLimit": "100 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Opcenter REST — WorkflowStep",
    "method": "POST/PUT",
    "url": "/opcenter/api/v1/workflowsteps",
    "prereq": [
     "Product exists",
     "Spec in Draft"
    ],
    "purpose": "Create/Update WorkflowStep",
    "sample": "{ \"SpecName\": \"BV-3IN\", \"StepName\": \"OP-040\", \"StandardTime\": 43.0 }",
    "rateLimit": "50 req/sec",
    "timeout": "10s"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Mfg0BvrOperation (in Teamcenter 2512); related: BOP, WorkflowStep, CN4T",
   "destinationBusinessObjectsInScope": "WorkflowStep (in Opcenter 2601)",
   "meaning": "BOP Operations to Opcenter WorkflowSteps: Transforms TC Bill of Process operations into Opcenter Workflow steps.",
   "purpose": "Delivers 'Production Routing' (Shop Floor Execution). This is the most critical CN4T interface for standard CLM deployments.",
   "functionPrimary": "Move/transform Mfg0BvrOperation → WorkflowStep (BiSync, Event-driven).",
   "subFunctions": [
    "Install CN4T + Configure Endpoints",
    "Configure Operation Type + WorkCenter Mapping",
    "EasyPlan Standard Time Mapping",
    "Full BOP Sync Integration Test",
    "ECO Delta Sync Validation"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA TCCS v14 + Opcenter REST API v1]--> CN4T 2510 --> Opcenter 2601. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-002",
    "IF-003",
    "IF-004",
    "IF-005",
    "IF-006",
    "IF-007",
    "IF-027"
   ],
   "criticalityScore": 20,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "CN4T Windows service starts cleanly",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"Mfg0BvrOperation\" mapping",
    "\"WorkflowStep\" configuration",
    "CN4T 2510",
    "BOP",
    "WorkflowStep",
    "CN4T",
    "MTM"
   ],
   "taskHours": 32,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 5
   }
  }
 },
 {
  "id": "IF-002",
  "seq": 2,
  "mvp": 1,
  "phase": 2,
  "grp": "CN4T",
  "type": "BiSync",
  "freq": "Event",
  "name": "TC MBOM to Opcenter Bill of Materials",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA TCCS v14 + Opcenter REST API v1",
  "bo": "Mfg0BvrPart → BOMItem",
  "complexity": 3,
  "effort": 6,
  "risk": 3,
  "team": "PLM + MES",
  "outcome": "Material Kitting",
  "outcomeCat": "Material Control",
  "deps": [
   "IF-001"
  ],
  "about": "Synchronizes TC Manufacturing BOM to Opcenter BOM lines. Supports planned vs backflush issue types, component auto-creation, and ECO delta updates.",
  "tags": [
   "MBOM",
   "BOM",
   "CN4T",
   "Kitting",
   "Backflush",
   "Material"
  ],
  "triggers": [
   {
    "id": "TRG-002-01",
    "name": "TC MBOM Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "MEWorkpackage with MBOM released",
    "latency": "< 10 seconds",
    "description": "When MBOM is released, CN4T pushes BOM structure to Opcenter.",
    "recommendedMapping": [
     {
      "src": "Mfg0BvrPart.bl_quantity",
      "dst": "BOMItem.Qty",
      "xform": "Direct",
      "mandatory": true,
      "note": "Component quantity"
     },
     {
      "src": "Mfg0BvrPart.bl_uom",
      "dst": "BOMItem.UOM",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Unit of measure"
     },
     {
      "src": "Mfg0BvrPart.bl_sequence",
      "dst": "BOMItem.Sequence",
      "xform": "Direct",
      "mandatory": true,
      "note": "BOM line sequence"
     },
     {
      "src": "UserData.issue_type",
      "dst": "BOMItem.IssueType",
      "xform": "Planned/Backflush",
      "mandatory": true,
      "note": "Material consumption method"
     }
    ],
    "optionalMapping": [
     {
      "src": "Mfg0BvrPart.bl_item_object_name",
      "dst": "BOMItem.ProductName",
      "xform": "Direct",
      "note": "Component part number"
     },
     {
      "src": "UserData.issue_step",
      "dst": "BOMItem.StepRef",
      "xform": "Step name",
      "note": "Which operation uses this component"
     }
    ],
    "configSteps": [
     "Configure CN4T BOM item attribute mapping",
     "Set up component product auto-creation rule",
     "Configure UOM conversion table",
     "Test BOM-to-Spec link validation"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T002a",
    "name": "BOM Attribute + UOM Mapping",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Qty maps correctly",
     "UOM codes fully mapped",
     "Sequence preserved",
     "Issue type derived correctly"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'BOM Attribute + UOM Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'BOM Attribute + UOM Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T002b",
    "name": "Component Auto-Creation",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Auto-creates missing Products",
     "Correct fields populated",
     "Re-sync causes UPDATE",
     "Revision matches TC"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Development signal 'auto-creation' implies bespoke build beyond supplied configuration.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify the bespoke logic for 'Component Auto-Creation'",
      "subSubTasks": [
       "Document why supplied config is insufficient",
       "Write the enhancement functional spec",
       "Obtain architecture-board approval"
      ]
     },
     {
      "step": 2,
      "title": "Develop using supplied extension hooks",
      "subSubTasks": [
       "Implement via BAdI/user-exit/callback (no core mod)",
       "Keep enhancement isolated + upgrade-safe",
       "Version the code in the repo"
      ]
     },
     {
      "step": 3,
      "title": "Review and test",
      "subSubTasks": [
       "Peer code review",
       "Unit test the logic",
       "Integration test against Opcenter 2601"
      ]
     },
     {
      "step": 4,
      "title": "Promote with change advisory",
      "subSubTasks": [
       "Raise CHG flagging customization",
       "Document rollback",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T002c",
    "name": "BOM-to-Spec Link Validation",
    "type": "Test",
    "hours": 4,
    "cx": 2,
    "dod": [
     "BOM linked to Spec",
     "Line count matches TC",
     "ECO removal deactivates",
     "Qty change updates"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'BOM-to-Spec Link Validation'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→Opcenter 2601)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through CN4T 2510",
       "Confirm arrival + correctness at Opcenter 2601"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T002d",
    "name": "Material Issue Test",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Points to correct step",
     "Planned requires scan",
     "Backflush auto-issues",
     "Integrity returns 0 orphans"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Material Issue Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Mfg0BvrPart.bl_quantity",
    "dst": "BOMItem.Qty",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Mfg0BvrPart.bl_uom",
    "dst": "BOMItem.UOM",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Mfg0BvrPart.bl_sequence",
    "dst": "BOMItem.Sequence",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "UserData.issue_type",
    "dst": "BOMItem.IssueType",
    "xform": "Map",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — BOMItem",
    "method": "POST",
    "url": "/opcenter/api/v1/bomitems",
    "prereq": [
     "Parent Product exists",
     "BOM in Draft"
    ],
    "purpose": "Create BOM item",
    "sample": "{ \"BOMName\":\"BV-3IN\", \"ProductName\":\"BODY\", \"Qty\":1.0 }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Mfg0BvrPart (in Teamcenter 2512); related: MBOM, BOM, CN4T",
   "destinationBusinessObjectsInScope": "BOMItem (in Opcenter 2601)",
   "meaning": "TC MBOM to Opcenter Bill of Materials: Synchronizes TC Manufacturing BOM to Opcenter BOM lines.",
   "purpose": "Delivers 'Material Kitting' (Material Control). Supports planned vs backflush issue types, component auto-creation, and ECO delta updates.",
   "functionPrimary": "Move/transform Mfg0BvrPart → BOMItem (BiSync, Event-driven).",
   "subFunctions": [
    "BOM Attribute + UOM Mapping",
    "Component Auto-Creation",
    "BOM-to-Spec Link Validation",
    "Material Issue Test"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA TCCS v14 + Opcenter REST API v1]--> CN4T 2510 --> Opcenter 2601. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001"
   ],
   "downstreamConsumers": [
    "IF-003",
    "IF-007",
    "IF-027",
    "IF-034"
   ],
   "criticalityScore": 14,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Qty maps correctly",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"Mfg0BvrPart\" mapping",
    "\"BOMItem\" configuration",
    "CN4T 2510",
    "MBOM",
    "BOM",
    "CN4T",
    "Kitting"
   ],
   "taskHours": 16,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 1,
    "customization": 1,
    "totalTasks": 4
   }
  }
 },
 {
  "id": "IF-003",
  "seq": 3,
  "mvp": 1,
  "phase": 2,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "TC Work Package to Opcenter Spec",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA TCCS v14 + Opcenter REST API v1",
  "bo": "MEWorkpackage → Spec",
  "complexity": 3,
  "effort": 6,
  "risk": 4,
  "team": "PLM + MES",
  "outcome": "Production Execution Gate",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-001",
   "IF-002"
  ],
  "about": "Opcenter Spec is the master container tying Product + BOM + Workflow together — the MES equivalent of the TC Work Package. This is the go/no-go gate for production.",
  "tags": [
   "Spec",
   "WorkPackage",
   "CN4T",
   "Effectivity",
   "Gate"
  ],
  "triggers": [
   {
    "id": "TRG-003-01",
    "name": "TC Work Package Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "MEWorkpackage → Released",
    "condition": "MBOM + BOP + BOE present",
    "latency": "< 60 seconds",
    "description": "When Work Package is released, CN4T creates Opcenter Spec.",
    "recommendedMapping": [
     {
      "src": "MEWorkpackage.item_id",
      "dst": "Spec.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Spec identifier"
     },
     {
      "src": "MEWorkpackage.item_revision_id",
      "dst": "Spec.Revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Spec revision"
     },
     {
      "src": "CC.effectivity_start",
      "dst": "Spec.EffectiveDate",
      "xform": "Date",
      "mandatory": true,
      "note": "Go-live date"
     }
    ],
    "optionalMapping": [
     {
      "src": "CC.effectivity_end",
      "dst": "Spec.EndDate",
      "xform": "Date",
      "note": "Retirement date"
     },
     {
      "src": "MEWorkpackage.bl_description",
      "dst": "Spec.Description",
      "xform": "Direct",
      "note": "Description"
     }
    ],
    "configSteps": [
     "Configure CN4T to listen for Work Package Released events",
     "Set up dependency check: verify MBOM and BOP exist",
     "Configure Spec creation after workflow and BOM creation"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T003a",
    "name": "Spec Creation Rule",
    "type": "Configure",
    "hours": 4,
    "cx": 3,
    "dod": [
     "Rule fires on WP Released",
     "Created only when structures present",
     "Name derived correctly",
     "Dependency order enforced"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Spec Creation Rule'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Spec Creation Rule'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T003b",
    "name": "Effectivity Mapping",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Effectivity maps correctly",
     "Future-dated prevents WO",
     "End effectivity deactivates",
     "SpecGroup configured"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Effectivity Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Effectivity Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T003c",
    "name": "Revision Control",
    "type": "Validate",
    "hours": 4,
    "cx": 3,
    "dod": [
     "Rev B creates Rev B",
     "History shows audit trail",
     "WOs use correct revision",
     "Manual override logged"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Revision Control'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "MEWorkpackage.item_id",
    "dst": "Spec.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "MEWorkpackage.item_revision_id",
    "dst": "Spec.Revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "CC.effectivity_start",
    "dst": "Spec.EffectiveDate",
    "xform": "Date",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — Spec",
    "method": "POST",
    "url": "/opcenter/api/v1/specs",
    "prereq": [
     "Product exists",
     "BOM exists",
     "Workflow exists"
    ],
    "purpose": "Create Spec",
    "sample": "{ \"Name\":\"BV-3IN\",\"Revision\":\"A\",\"ProductName\":\"BV-3IN\" }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "MEWorkpackage (in Teamcenter 2512); related: Spec, WorkPackage, CN4T",
   "destinationBusinessObjectsInScope": "Spec (in Opcenter 2601)",
   "meaning": "TC Work Package to Opcenter Spec: Opcenter Spec is the master container tying Product + BOM + Workflow together — the MES equivalent of the TC Work Package.",
   "purpose": "Delivers 'Production Execution Gate' (Shop Floor Execution). This is the go/no-go gate for production.",
   "functionPrimary": "Move/transform MEWorkpackage → Spec (Push, Event-driven).",
   "subFunctions": [
    "Spec Creation Rule",
    "Effectivity Mapping",
    "Revision Control"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA TCCS v14 + Opcenter REST API v1]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001",
    "IF-002"
   ],
   "downstreamConsumers": [
    "IF-007"
   ],
   "criticalityScore": 9,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Rule fires on WP Released",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"MEWorkpackage\" mapping",
    "\"Spec\" configuration",
    "CN4T 2510",
    "Spec",
    "WorkPackage",
    "CN4T",
    "Effectivity"
   ],
   "taskHours": 11,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-004",
  "seq": 4,
  "mvp": 1,
  "phase": 2,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "NC Programs to Opcenter Documents",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA File Transfer + Opcenter REST API",
  "bo": "TC Dataset → Opcenter Document",
  "complexity": 2,
  "effort": 4,
  "risk": 2,
  "team": "PLM + MES",
  "outcome": "NC Program Management",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-001"
  ],
  "about": "NC machining programs version-controlled in TC, pushed to Opcenter as Documents linked to WorkflowSteps. Prevents wrong NC program version at machine.",
  "tags": [
   "NC",
   "DNC",
   "Document",
   "CNC",
   "VersionControl"
  ],
  "triggers": [
   {
    "id": "TRG-004-01",
    "name": "NC Dataset Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "NC_File dataset released",
    "latency": "< 10 seconds",
    "description": "When NC program is released, CN4T pushes file to Opcenter.",
    "recommendedMapping": [
     {
      "src": "Dataset.object_name",
      "dst": "Document.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Document name"
     },
     {
      "src": "Dataset.revision",
      "dst": "Document.Revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Version"
     },
     {
      "src": "Dataset.ref_to (file)",
      "dst": "Document.FileContent",
      "xform": "Binary",
      "mandatory": true,
      "note": "NC file"
     },
     {
      "src": "BOP.step_name",
      "dst": "Document.StepLink",
      "xform": "Cross-ref",
      "mandatory": true,
      "note": "Associated step"
     }
    ],
    "configSteps": [
     "Configure CN4T to recognize NC_File dataset",
     "Set up Opcenter Document naming convention",
     "Configure step-to-document linking",
     "Test DNC retrieval"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T004a",
    "name": "NC Dataset Configuration",
    "type": "Configure",
    "hours": 3,
    "cx": 1,
    "dod": [
     "CN4T recognizes NC_File",
     "Files transferred without corruption",
     "Naming convention matches"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'NC Dataset Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'NC Dataset Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T004b",
    "name": "Step Linking + Versioning",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Document linked to step",
     "Multi-machine supported",
     "New revision supersedes"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Step Linking + Versioning'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Step Linking + Versioning'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T004c",
    "name": "DNC Retrieval Test",
    "type": "Test",
    "hours": 2,
    "cx": 1,
    "dod": [
     "SFC retrieves program",
     "Version matches TC",
     "Operator sees version"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'DNC Retrieval Test'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→Opcenter 2601)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through CN4T 2510",
       "Confirm arrival + correctness at Opcenter 2601"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Dataset.object_name",
    "dst": "Document.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Dataset.revision",
    "dst": "Document.Revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Dataset.ref_to (file)",
    "dst": "Document.FileContent",
    "xform": "Binary",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — Document",
    "method": "POST",
    "url": "/opcenter/api/v1/documents",
    "prereq": [
     "Document storage configured",
     "WorkflowStep exists"
    ],
    "purpose": "Upload NC file",
    "sample": "{ \"DocumentName\":\"NC-OP020\",\"Revision\":\"C\",\"StepName\":\"OP-020\" }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "TC Dataset (in Teamcenter 2512); related: NC, DNC, Document",
   "destinationBusinessObjectsInScope": "Opcenter Document (in Opcenter 2601)",
   "meaning": "NC Programs to Opcenter Documents: NC machining programs version-controlled in TC, pushed to Opcenter as Documents linked to WorkflowSteps.",
   "purpose": "Delivers 'NC Program Management' (Shop Floor Execution). Prevents wrong NC program version at machine.",
   "functionPrimary": "Move/transform TC Dataset → Opcenter Document (Push, Event-driven).",
   "subFunctions": [
    "NC Dataset Configuration",
    "Step Linking + Versioning",
    "DNC Retrieval Test"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA File Transfer + Opcenter REST API]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001"
   ],
   "downstreamConsumers": [
    "IF-020"
   ],
   "criticalityScore": 7,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "CN4T recognizes NC_File",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"TC Dataset\" mapping",
    "\"Opcenter Document\" configuration",
    "CN4T 2510",
    "NC",
    "DNC",
    "Document",
    "CNC"
   ],
   "taskHours": 8,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-005",
  "seq": 5,
  "mvp": 1,
  "phase": 2,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "Work Instructions to Opcenter Documents",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA + Opcenter REST API",
  "bo": "TC Dataset → Opcenter Document",
  "complexity": 1,
  "effort": 3,
  "risk": 1,
  "team": "PLM + MES",
  "outcome": "Operator Guidance",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-001"
  ],
  "about": "Work instructions managed in TC pushed to Opcenter for operator guidance at SFC terminals.",
  "tags": [
   "WorkInstruction",
   "Document",
   "Operator",
   "PDF"
  ],
  "triggers": [
   {
    "id": "TRG-005-01",
    "name": "Work Instruction Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "WorkInstruction dataset released",
    "condition": "WI linked to BOP operation",
    "latency": "< 10 seconds",
    "description": "When Work Instruction is released, CN4T pushes PDF to Opcenter.",
    "recommendedMapping": [
     {
      "src": "Dataset.object_name",
      "dst": "Document.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Document name"
     },
     {
      "src": "Dataset.revision",
      "dst": "Document.Revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Version"
     },
     {
      "src": "Dataset.ref_to (PDF)",
      "dst": "Document.FileContent",
      "xform": "Binary",
      "mandatory": true,
      "note": "PDF file"
     }
    ],
    "configSteps": [
     "Configure CN4T to recognize WorkInstruction dataset",
     "Set up PDF rendition generation",
     "Test operator access at SFC terminal"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T005a",
    "name": "WI Push Rule",
    "type": "Configure",
    "hours": 4,
    "cx": 1,
    "dod": [
     "Dataset triggers CN4T push",
     "PDF rendition pushed",
     "High-risk displays warning"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'WI Push Rule'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'WI Push Rule'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T005b",
    "name": "Operator Access Test",
    "type": "Validate",
    "hours": 3,
    "cx": 1,
    "dod": [
     "WI opens in ≤3 seconds",
     "Opens without login",
     "Multiple WIs shown as list"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Operator Access Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Dataset.object_name",
    "dst": "Document.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Dataset.revision",
    "dst": "Document.Revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Dataset.ref_to (PDF)",
    "dst": "Document.FileContent",
    "xform": "Binary",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — Link Document",
    "method": "PUT",
    "url": "/opcenter/api/v1/workflowsteps/{stepName}/documents",
    "prereq": [
     "Document exists",
     "WorkflowStep exists"
    ],
    "purpose": "Link WI to step",
    "sample": "{ \"DocumentName\":\"WI-OP040\",\"Revision\":\"B\" }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "TC Dataset (in Teamcenter 2512); related: WorkInstruction, Document, Operator",
   "destinationBusinessObjectsInScope": "Opcenter Document (in Opcenter 2601)",
   "meaning": "Work Instructions to Opcenter Documents: Work instructions managed in TC pushed to Opcenter for operator guidance at SFC terminals.",
   "purpose": "Delivers 'Operator Guidance' (Shop Floor Execution). ",
   "functionPrimary": "Move/transform TC Dataset → Opcenter Document (Push, Event-driven).",
   "subFunctions": [
    "WI Push Rule",
    "Operator Access Test"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA + Opcenter REST API]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 1/4, Risk 1/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Dataset triggers CN4T push",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"TC Dataset\" mapping",
    "\"Opcenter Document\" configuration",
    "CN4T 2510",
    "WorkInstruction",
    "Document",
    "Operator",
    "PDF"
   ],
   "taskHours": 7,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-006",
  "seq": 6,
  "mvp": 2,
  "phase": 2,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "BOE Equipment to Opcenter Resources",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA TCCS v14 + Opcenter REST API",
  "bo": "MEEquipment → Resource",
  "complexity": 2,
  "effort": 4,
  "risk": 2,
  "team": "PLM + MES",
  "outcome": "Resource Management",
  "outcomeCat": "Capacity Management",
  "deps": [
   "IF-001"
  ],
  "about": "Equipment, fixtures, tools, and gauges from TC BOE synchronized to Opcenter Resources for capacity planning and maintenance.",
  "tags": [
   "BOE",
   "Resource",
   "Equipment",
   "Calibration",
   "ToolLife"
  ],
  "triggers": [
   {
    "id": "TRG-006-01",
    "name": "Equipment Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "MEEquipmentRevision created/modified",
    "latency": "< 10 seconds",
    "description": "When equipment master is released, CN4T pushes resource data to Opcenter.",
    "recommendedMapping": [
     {
      "src": "MEEquipmentRevision.item_id",
      "dst": "Resource.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Equipment ID"
     },
     {
      "src": "MEEquipmentRevision.object_type",
      "dst": "Resource.Type",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Machine/Tool/Gauge"
     },
     {
      "src": "MEWorkArea.item_id",
      "dst": "ResourceGroup.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Work center"
     }
    ],
    "optionalMapping": [
     {
      "src": "UserData.calibration_id",
      "dst": "Resource.CalibrationRef",
      "xform": "Direct",
      "note": "Calibration ID"
     },
     {
      "src": "UserData.calibration_due",
      "dst": "Resource.CalibrationDue",
      "xform": "Date",
      "note": "Due date"
     },
     {
      "src": "UserData.tool_life_count",
      "dst": "Resource.ToolLife",
      "xform": "Direct",
      "note": "Max uses"
     }
    ],
    "configSteps": [
     "Configure CN4T to recognize MEEquipmentRevision",
     "Set up ResourceGroup mapping",
     "Configure calibration tracking"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T006a",
    "name": "Resource Type + Capacity Mapping",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Equipment maps correctly",
     "WorkCenter mapping complete",
     "Calibration data appears"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Resource Type + Capacity Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Resource Type + Capacity Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T006b",
    "name": "Tool Life Validation",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Quantity sets capacity",
     "Calendar linked to shift",
     "Tool life initialized",
     "Work Order assigns correctly"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Tool Life Validation'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "MEEquipmentRevision.item_id",
    "dst": "Resource.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "MEEquipmentRevision.object_type",
    "dst": "Resource.Type",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "MEWorkArea.item_id",
    "dst": "ResourceGroup.Name",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — Resource",
    "method": "POST",
    "url": "/opcenter/api/v1/resources",
    "prereq": [
     "ResourceGroup exists",
     "Site exists"
    ],
    "purpose": "Create resource",
    "sample": "{ \"Name\":\"PRESS-01\",\"Type\":\"Machine\",\"ResourceGroup\":\"TEST\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "MEEquipment (in Teamcenter 2512); related: BOE, Resource, Equipment",
   "destinationBusinessObjectsInScope": "Resource (in Opcenter 2601)",
   "meaning": "BOE Equipment to Opcenter Resources: Equipment, fixtures, tools, and gauges from TC BOE synchronized to Opcenter Resources for capacity planning and maintenance.",
   "purpose": "Delivers 'Resource Management' (Capacity Management). ",
   "functionPrimary": "Move/transform MEEquipment → Resource (Push, Event-driven).",
   "subFunctions": [
    "Resource Type + Capacity Mapping",
    "Tool Life Validation"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA TCCS v14 + Opcenter REST API]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001"
   ],
   "downstreamConsumers": [
    "IF-035",
    "IF-040"
   ],
   "criticalityScore": 8,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Equipment maps correctly",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"MEEquipment\" mapping",
    "\"Resource\" configuration",
    "CN4T 2510",
    "BOE",
    "Resource",
    "Equipment",
    "Calibration"
   ],
   "taskHours": 7,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-007",
  "seq": 7,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Event",
  "name": "SAP Production Order to Opcenter Work Order",
  "from": "SAP S/4HANA",
  "to": "Opcenter 2601",
  "mid": "CN4S",
  "protocol": "SAP iDoc LOIPRO + Opcenter REST API",
  "bo": "SAP Production Order → WorkOrder",
  "complexity": 3,
  "effort": 8,
  "risk": 4,
  "team": "ERP + MES",
  "outcome": "Production Execution",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-001",
   "IF-002",
   "IF-003"
  ],
  "about": "Primary production execution trigger: released SAP production order creates Opcenter Work Order and Containers. Supports batch and serial tracking.",
  "tags": [
   "ProductionOrder",
   "WorkOrder",
   "iDoc",
   "SAP-PP",
   "Container"
  ],
  "triggers": [
   {
    "id": "TRG-007-01",
    "name": "SAP Order Release",
    "type": "RELEASE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Production order status → REL",
    "condition": "Material has active Opcenter Spec",
    "latency": "< 30 seconds",
    "description": "When SAP production order is released, iDoc LOIPRO triggers CN4S to create Opcenter Work Order.",
    "recommendedMapping": [
     {
      "src": "LOIPRO.AUFNR",
      "dst": "WorkOrder.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "SAP order number"
     },
     {
      "src": "LOIPRO.MATNR",
      "dst": "WorkOrder.ProductName",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Material to Product"
     },
     {
      "src": "LOIPRO.WERKS",
      "dst": "WorkOrder.Site",
      "xform": "Plant→Site",
      "mandatory": true,
      "note": "Plant mapping"
     },
     {
      "src": "LOIPRO.GAMNG",
      "dst": "WorkOrder.Qty",
      "xform": "Direct",
      "mandatory": true,
      "note": "Quantity"
     }
    ],
    "optionalMapping": [
     {
      "src": "LOIPRO.GSTRS",
      "dst": "WorkOrder.PlannedStart",
      "xform": "ISO date",
      "note": "Start date"
     },
     {
      "src": "LOIPRO.CHARG",
      "dst": "Container.LotNumber",
      "xform": "Direct",
      "note": "Batch"
     },
     {
      "src": "LOIPRO.SERNR",
      "dst": "Container.SerialNumber",
      "xform": "Array",
      "note": "Serial numbers"
     }
    ],
    "configSteps": [
     "Configure SAP ALE/iDoc partner agreement",
     "Set up LOIPRO message type",
     "Configure production order mapping",
     "Test Spec lookup and Container creation"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T007a",
    "name": "iDoc Partner Setup",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Logical system defined",
     "iDoc LOIPRO configured",
     "Endpoint configured",
     "Test iDoc received"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'iDoc Partner Setup'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'iDoc Partner Setup'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T007b",
    "name": "Field Mapping",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Order number maps",
     "Material resolves",
     "Plant maps",
     "Dates populate",
     "Qty maps"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Field Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Field Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T007c",
    "name": "Container Creation Test",
    "type": "Test",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Spec selected correctly",
     "Container count matches",
     "Serials match",
     "WO visible <30s"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Container Creation Test'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (SAP S/4HANA→Opcenter 2601)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through CN4S",
       "Confirm arrival + correctness at Opcenter 2601"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T007d",
    "name": "Error Handling Test",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "No Spec → NACK",
     "Zero qty → reject",
     "Failed iDocs in DLQ",
     "Email notification"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Error Handling Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "LOIPRO.AUFNR",
    "dst": "WorkOrder.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "LOIPRO.MATNR",
    "dst": "WorkOrder.ProductName",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "LOIPRO.GAMNG",
    "dst": "WorkOrder.Qty",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "SAP iDoc LOIPRO",
    "method": "ALE",
    "url": "SAP WE20",
    "prereq": [
     "ALE configured",
     "Partner profile"
    ],
    "purpose": "Send production order",
    "sample": "WE20 → Partner Type LS → Message LOIPRO"
   },
   {
    "name": "Opcenter REST — WorkOrder",
    "method": "POST",
    "url": "/opcenter/api/v1/workorders",
    "prereq": [
     "Spec exists",
     "Site configured"
    ],
    "purpose": "Create Work Order",
    "sample": "{ \"Name\":\"1000012345\",\"SpecName\":\"BV-3IN\",\"Qty\":10 }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "SAP Production Order (in SAP S/4HANA); related: ProductionOrder, WorkOrder, SAP-PP",
   "destinationBusinessObjectsInScope": "WorkOrder (in Opcenter 2601)",
   "meaning": "SAP Production Order to Opcenter Work Order: Primary production execution trigger: released SAP production order creates Opcenter Work Order and Containers.",
   "purpose": "Delivers 'Production Execution' (Shop Floor Execution). Supports batch and serial tracking.",
   "functionPrimary": "Move/transform SAP Production Order → WorkOrder (Push, Event-driven).",
   "subFunctions": [
    "iDoc Partner Setup",
    "Field Mapping",
    "Container Creation Test",
    "Error Handling Test"
   ],
   "architecture": "SAP S/4HANA --[SAP iDoc LOIPRO + Opcenter REST API]--> CN4S --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001",
    "IF-002",
    "IF-003"
   ],
   "downstreamConsumers": [
    "IF-008",
    "IF-009",
    "IF-010",
    "IF-018",
    "IF-029",
    "IF-033",
    "IF-047"
   ],
   "criticalityScore": 21,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Logical system defined",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"SAP Production Order\" mapping",
    "\"WorkOrder\" configuration",
    "CN4S",
    "ProductionOrder",
    "WorkOrder",
    "iDoc",
    "SAP-PP"
   ],
   "taskHours": 20,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 4
   }
  }
 },
 {
  "id": "IF-008",
  "seq": 8,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Event",
  "name": "Material Goods Issue to SAP Inventory",
  "from": "Opcenter 2601",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "Opcenter REST Event → CN4S → SAP BAPI",
  "bo": "MaterialIssue → SAP GI mvt 261",
  "complexity": 2,
  "effort": 6,
  "risk": 3,
  "team": "MES + ERP",
  "outcome": "Inventory Accuracy",
  "outcomeCat": "Material Control",
  "deps": [
   "IF-007"
  ],
  "about": "When shop floor operators issue BOM components, CN4S immediately calls SAP BAPI to reduce inventory in real time.",
  "tags": [
   "GoodsIssue",
   "Inventory",
   "SAP-MM",
   "BAPI",
   "Backflush"
  ],
  "triggers": [
   {
    "id": "TRG-008-01",
    "name": "Material Issue",
    "type": "COMPLETE",
    "source": "Opcenter 2601",
    "sourceEvent": "MaterialIssued event",
    "condition": "Planned or Backflush issue",
    "latency": "< 5 seconds",
    "description": "When operator scans component or backflush occurs, CN4S posts GI to SAP.",
    "recommendedMapping": [
     {
      "src": "ActualMaterialIssue.productName",
      "dst": "BAPI.MATNR",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Material number"
     },
     {
      "src": "ActualMaterialIssue.qty",
      "dst": "BAPI.MENGE",
      "xform": "UOM convert",
      "mandatory": true,
      "note": "Quantity"
     },
     {
      "src": "WorkOrder.Name",
      "dst": "BAPI.AUFNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Order number"
     }
    ],
    "optionalMapping": [
     {
      "src": "Container.LotNumber",
      "dst": "BAPI.CHARG",
      "xform": "Direct",
      "note": "Batch"
     },
     {
      "src": "Site.StorageLocation",
      "dst": "BAPI.LGORT",
      "xform": "Map",
      "note": "Storage location"
     }
    ],
    "configSteps": [
     "Configure CN4S to subscribe to MaterialIssued events",
     "Set up BAPI_GOODSMVT_CREATE mapping",
     "Configure UOM conversion table",
     "Test reversal flow"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T008a",
    "name": "Event + BAPI Mapping",
    "type": "Configure",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Subscribes to MaterialIssued",
     "Planned and Backflush tested",
     "Payload complete",
     "UOM conversion applied",
     "Posting date correct"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Event + BAPI Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Event + BAPI Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T008b",
    "name": "Inventory Accuracy Test",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "MB51 shows GI <30s",
     "MMBE stock decrements",
     "Batch matches",
     "Reversal triggers mvt 262"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Inventory Accuracy Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "ActualMaterialIssue.productName",
    "dst": "BAPI.MATNR",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "ActualMaterialIssue.qty",
    "dst": "BAPI.MENGE",
    "xform": "UOM convert",
    "category": "core"
   },
   {
    "src": "WorkOrder.Name",
    "dst": "BAPI.AUFNR",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_GOODSMVT_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Material exists",
     "Order open"
    ],
    "purpose": "Post goods issue",
    "sample": "BAPI_GOODSMVT_CREATE( MOVE_TYPE:'261', MATERIAL:'BODY', QUANTITY:1 )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "MaterialIssue (in Opcenter 2601); related: GoodsIssue, Inventory, SAP-MM",
   "destinationBusinessObjectsInScope": "SAP GI mvt 261 (in SAP S/4HANA)",
   "meaning": "Material Goods Issue to SAP Inventory: When shop floor operators issue BOM components, CN4S immediately calls SAP BAPI to reduce inventory in real time.",
   "purpose": "Delivers 'Inventory Accuracy' (Material Control). ",
   "functionPrimary": "Move/transform MaterialIssue → SAP GI mvt 261 (Push, Event-driven).",
   "subFunctions": [
    "Event + BAPI Mapping",
    "Inventory Accuracy Test"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST Event → CN4S → SAP BAPI]--> CN4S --> SAP S/4HANA. Pattern: Push integration, Event trigger. Complexity 2/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007"
   ],
   "downstreamConsumers": [
    "IF-009",
    "IF-034"
   ],
   "criticalityScore": 10,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Subscribes to MaterialIssued",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"MaterialIssue\" mapping",
    "\"SAP GI mvt 261\" configuration",
    "CN4S",
    "GoodsIssue",
    "Inventory",
    "SAP-MM",
    "BAPI"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-009",
  "seq": 9,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Event",
  "name": "Labor + GR Confirmation to SAP CO",
  "from": "Opcenter 2601",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "Opcenter REST → CN4S → BAPI_PRODORDCONF_CREATE",
  "bo": "StepCompletion → SAP Confirmation + GR mvt 101",
  "complexity": 3,
  "effort": 7,
  "risk": 3,
  "team": "MES + ERP",
  "outcome": "Cost Accuracy",
  "outcomeCat": "Financial Accuracy",
  "deps": [
   "IF-007",
   "IF-008"
  ],
  "about": "Actual labor and machine hours from each Opcenter step confirmed to SAP CO. Final step triggers Goods Receipt.",
  "tags": [
   "Labor",
   "CO",
   "Confirmation",
   "GR",
   "Variance"
  ],
  "triggers": [
   {
    "id": "TRG-009-01",
    "name": "Step Completion",
    "type": "COMPLETE",
    "source": "Opcenter 2601",
    "sourceEvent": "StepCompleted event",
    "condition": "Actual times recorded",
    "latency": "< 10 seconds",
    "description": "When operator completes a step, CN4S posts confirmation to SAP CO.",
    "recommendedMapping": [
     {
      "src": "StepExecution.actualLaborTime",
      "dst": "BAPI.CONF_ACTTIM",
      "xform": "min→hr",
      "mandatory": true,
      "note": "Labor hours"
     },
     {
      "src": "WorkOrder.Name",
      "dst": "BAPI.AUFNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Order number"
     },
     {
      "src": "StepExecution.stepName",
      "dst": "BAPI.VORNR",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Operation"
     }
    ],
    "optionalMapping": [
     {
      "src": "Container.Qty",
      "dst": "BAPI.CONF_QTY",
      "xform": "Direct",
      "note": "Quantity"
     },
     {
      "src": "Container.ScrapQty",
      "dst": "BAPI.SCRAP_QTY",
      "xform": "Direct",
      "note": "Scrap"
     }
    ],
    "configSteps": [
     "Configure activity type mapping",
     "Set up Cost Center linkage",
     "Configure GR trigger on final operation",
     "Test variance analysis"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T009a",
    "name": "Activity Type Mapping",
    "type": "Configure",
    "hours": 4,
    "cx": 3,
    "dod": [
     "StepType maps to activity",
     "Cost Center linked",
     "BAPI receives fields",
     "Time conversion applied"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Activity Type Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Activity Type Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T009b",
    "name": "GR + Variance Test",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Final step triggers GR",
     "Variance calculation correct",
     "Labor variance formula correct",
     "Zero-labor posts zero",
     "Scrap posts correctly"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'GR + Variance Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "StepExecution.actualLaborTime",
    "dst": "BAPI.CONF_ACTTIM",
    "xform": "min→hr",
    "category": "core"
   },
   {
    "src": "WorkOrder.Name",
    "dst": "BAPI.AUFNR",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Container.Qty",
    "dst": "BAPI.CONF_QTY",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_PRODORDCONF_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Order released",
     "Routing defined"
    ],
    "purpose": "Post confirmation",
    "sample": "BAPI_PRODORDCONF_CREATE( AUFNR:'12345', VORNR:'0040', CONF_QTY:1 )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "StepCompletion (in Opcenter 2601); related: Labor, CO, Confirmation",
   "destinationBusinessObjectsInScope": "SAP Confirmation + GR mvt 101 (in SAP S/4HANA)",
   "meaning": "Labor + GR Confirmation to SAP CO: Actual labor and machine hours from each Opcenter step confirmed to SAP CO.",
   "purpose": "Delivers 'Cost Accuracy' (Financial Accuracy). Final step triggers Goods Receipt.",
   "functionPrimary": "Move/transform StepCompletion → SAP Confirmation + GR mvt 101 (Push, Event-driven).",
   "subFunctions": [
    "Activity Type Mapping",
    "GR + Variance Test"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST → CN4S → BAPI_PRODORDCONF_CREATE]--> CN4S --> SAP S/4HANA. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007",
    "IF-008"
   ],
   "downstreamConsumers": [
    "IF-026",
    "IF-033"
   ],
   "criticalityScore": 10,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "StepType maps to activity",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"StepCompletion\" mapping",
    "\"SAP Confirmation + GR mvt 101\" configuration",
    "CN4S",
    "Labor",
    "CO",
    "Confirmation",
    "GR"
   ],
   "taskHours": 9,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-010",
  "seq": 10,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "BiSync",
  "freq": "Event",
  "name": "Opcenter QM Results to SAP QM",
  "from": "Opcenter 2601",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "Opcenter REST → CN4S → BAPI_INSPLOT_CHARACT_POST",
  "bo": "DataCollection → Inspection Lot",
  "complexity": 3,
  "effort": 7,
  "risk": 3,
  "team": "MES + Quality + ERP",
  "outcome": "Quality Traceability",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-007"
  ],
  "about": "Quality measurements from Opcenter posted to SAP QM inspection lot for regulatory compliance.",
  "tags": [
   "QM",
   "InspectionLot",
   "SPC",
   "SAP-QM",
   "UsageDecision"
  ],
  "triggers": [
   {
    "id": "TRG-010-01",
    "name": "DataCollection Complete",
    "type": "COMPLETE",
    "source": "Opcenter 2601",
    "sourceEvent": "DataCollection posted",
    "condition": "At inspection step",
    "latency": "< 10 seconds",
    "description": "When quality measurements are recorded, CN4S posts to SAP QM.",
    "recommendedMapping": [
     {
      "src": "DataCollection.CharName",
      "dst": "BAPI.KURZTEXT",
      "xform": "Direct",
      "mandatory": true,
      "note": "Characteristic"
     },
     {
      "src": "DataCollection.MeasuredValue",
      "dst": "BAPI.MESSWERT",
      "xform": "Direct",
      "mandatory": true,
      "note": "Value"
     },
     {
      "src": "DataCollection.PassFail",
      "dst": "BAPI.KLASSE",
      "xform": "0/1",
      "mandatory": true,
      "note": "Pass/Fail"
     }
    ],
    "optionalMapping": [
     {
      "src": "DataCollection.UCL",
      "dst": "BAPI.SOLLWERT",
      "xform": "Direct",
      "note": "Upper limit"
     },
     {
      "src": "DataCollection.LCL",
      "dst": "BAPI.UNTOL",
      "xform": "Direct",
      "note": "Lower limit"
     }
    ],
    "configSteps": [
     "Configure inspection lot creation",
     "Set up characteristic posting",
     "Configure Usage Decision sync",
     "Test batch status changes"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T010a",
    "name": "Inspection Lot Posting",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Inspection lot exists",
     "Number stored in map",
     "Origin key correct",
     "Decimal precision correct",
     "Attribute results coded"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Inspection Lot Posting'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Inspection Lot Posting'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T010b",
    "name": "Usage Decision Sync",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "ACCEPT → UD code A",
     "REJECT → code R + blocked",
     "Stock type changes",
     "QA32 shows results"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Usage Decision Sync'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "DataCollection.CharName",
    "dst": "BAPI.KURZTEXT",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "DataCollection.MeasuredValue",
    "dst": "BAPI.MESSWERT",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "DataCollection.PassFail",
    "dst": "BAPI.KLASSE",
    "xform": "0/1",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_INSPLOT_CHARACT_POST",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Inspection lot exists",
     "Plan active"
    ],
    "purpose": "Post QM results",
    "sample": "BAPI_INSPLOT_CHARACT_POST( PRUEFLOS:'1234', MERKMAL:'HARDNESS', MESSWERT:18.5 )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "DataCollection (in Opcenter 2601); related: QM, InspectionLot, SPC",
   "destinationBusinessObjectsInScope": "Inspection Lot (in SAP S/4HANA)",
   "meaning": "Opcenter QM Results to SAP QM: Quality measurements from Opcenter posted to SAP QM inspection lot for regulatory compliance.",
   "purpose": "Delivers 'Quality Traceability' (Quality Assurance). ",
   "functionPrimary": "Move/transform DataCollection → Inspection Lot (BiSync, Event-driven).",
   "subFunctions": [
    "Inspection Lot Posting",
    "Usage Decision Sync"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST → CN4S → BAPI_INSPLOT_CHARACT_POST]--> CN4S --> SAP S/4HANA. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007"
   ],
   "downstreamConsumers": [
    "IF-011",
    "IF-025",
    "IF-031",
    "IF-036"
   ],
   "criticalityScore": 14,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Inspection lot exists",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"DataCollection\" mapping",
    "\"Inspection Lot\" configuration",
    "CN4S",
    "QM",
    "InspectionLot",
    "SPC",
    "SAP-QM"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-011",
  "seq": 11,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Event",
  "name": "Opcenter NCR to SAP Quality Notification",
  "from": "Opcenter 2601",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "Opcenter REST → CN4S → BAPI_QMEL_CREATE",
  "bo": "NonConformance → QM Notification",
  "complexity": 2,
  "effort": 4,
  "risk": 2,
  "team": "MES + Quality + ERP",
  "outcome": "8D Corrective Action",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-010"
  ],
  "about": "NonConformance in Opcenter automatically creates SAP QM notification for 8D corrective action process.",
  "tags": [
   "NCR",
   "8D",
   "CAPA",
   "SAP-QM"
  ],
  "triggers": [
   {
    "id": "TRG-011-01",
    "name": "NCR Creation",
    "type": "CREATE",
    "source": "Opcenter 2601",
    "sourceEvent": "NonConformance created",
    "condition": "Status = Open",
    "latency": "< 2 minutes",
    "description": "When quality creates NCR, CN4S creates SAP QM notification.",
    "recommendedMapping": [
     {
      "src": "NonConformance.Description",
      "dst": "BAPI.QMTXT",
      "xform": "Direct",
      "mandatory": true,
      "note": "Description"
     },
     {
      "src": "NonConformance.DefectClass",
      "dst": "BAPI.QMART",
      "xform": "Q1/Q2/Q3",
      "mandatory": true,
      "note": "Type"
     },
     {
      "src": "WorkOrder.ProductName",
      "dst": "BAPI.MATNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material"
     }
    ],
    "optionalMapping": [
     {
      "src": "NonConformance.ID",
      "dst": "BAPI.QMNUM",
      "xform": "External",
      "note": "Reference"
     },
     {
      "src": "Container.SerialNumber",
      "dst": "BAPI.SERNR",
      "xform": "Direct",
      "note": "Serial"
     }
    ],
    "configSteps": [
     "Configure NCR-to-Notification mapping",
     "Set up 8D trigger rules",
     "Configure repeat defect escalation",
     "Test email notifications"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T011a",
    "name": "NCR Mapping",
    "type": "Configure",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Internal → Q2",
     "Customer → Q1",
     "Supplier → Q3",
     "Text contains details",
     "Number stored external"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'NCR Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'NCR Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T011b",
    "name": "8D Escalation Test",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Notification <2 minutes",
     "Email received",
     "Status updates",
     "3rd defect escalates"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for '8D Escalation Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "NonConformance.Description",
    "dst": "BAPI.QMTXT",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "NonConformance.DefectClass",
    "dst": "BAPI.QMART",
    "xform": "Map",
    "category": "core"
   },
   {
    "src": "WorkOrder.ProductName",
    "dst": "BAPI.MATNR",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_QMEL_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "QM active",
     "Defect catalog"
    ],
    "purpose": "Create QM notification",
    "sample": "BAPI_QMEL_CREATE( QMART:'Q2', MATNR:'BV-3IN', QMTXT:'Defect' )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "NonConformance (in Opcenter 2601); related: NCR, CAPA, SAP-QM",
   "destinationBusinessObjectsInScope": "QM Notification (in SAP S/4HANA)",
   "meaning": "Opcenter NCR to SAP Quality Notification: NonConformance in Opcenter automatically creates SAP QM notification for 8D corrective action process.",
   "purpose": "Delivers '8D Corrective Action' (Quality Assurance). ",
   "functionPrimary": "Move/transform NonConformance → QM Notification (Push, Event-driven).",
   "subFunctions": [
    "NCR Mapping",
    "8D Escalation Test"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST → CN4S → BAPI_QMEL_CREATE]--> CN4S --> SAP S/4HANA. Pattern: Push integration, Event trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-010"
   ],
   "downstreamConsumers": [
    "IF-037",
    "IF-059"
   ],
   "criticalityScore": 9,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Internal → Q2",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"NonConformance\" mapping",
    "\"QM Notification\" configuration",
    "CN4S",
    "NCR",
    "8D",
    "CAPA",
    "SAP-QM"
   ],
   "taskHours": 8,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-012",
  "seq": 12,
  "mvp": 1,
  "phase": 4,
  "grp": "AIG",
  "type": "BiSync",
  "freq": "Event",
  "name": "TC EBOM/MBOM to SAP Material + CS BOM",
  "from": "Teamcenter 2512",
  "to": "SAP S/4HANA",
  "mid": "AIG",
  "protocol": "TC SOA → AIG → SAP BAPI",
  "bo": "TC Item → SAP Material Master + CS BOM",
  "complexity": 4,
  "effort": 12,
  "risk": 4,
  "team": "PLM + ERP",
  "outcome": "Supply Chain Integration",
  "outcomeCat": "Supply Chain",
  "deps": [],
  "about": "Foundational PLM-ERP interface. TC Item becomes SAP Material Master; TC BOM becomes SAP CS BOM. Critical for procurement and costing.",
  "tags": [
   "MaterialMaster",
   "CSBOM",
   "AIG",
   "MRP",
   "ECO"
  ],
  "triggers": [
   {
    "id": "TRG-012-01",
    "name": "TC Item Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "ItemRevision → Released",
    "condition": "Material type = ROH/HALB/FERT",
    "latency": "< 60 seconds",
    "description": "When item is released, AIG creates SAP Material Master.",
    "recommendedMapping": [
     {
      "src": "Item.item_id",
      "dst": "Material.MATNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material number"
     },
     {
      "src": "Item.object_desc",
      "dst": "Material.MAKTX",
      "xform": "40-char",
      "mandatory": true,
      "note": "Description"
     },
     {
      "src": "UserData.material_type",
      "dst": "Material.MTART",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Type"
     },
     {
      "src": "UserData.base_uom",
      "dst": "Material.MEINS",
      "xform": "UOM",
      "mandatory": true,
      "note": "Unit"
     }
    ],
    "optionalMapping": [
     {
      "src": "UserData.mrp_type",
      "dst": "Material.DISMM",
      "xform": "Code",
      "note": "MRP type"
     },
     {
      "src": "UserData.weight_kg",
      "dst": "Material.BRGEW",
      "xform": "Direct",
      "note": "Weight"
     }
    ],
    "configSteps": [
     "Install AIG adapter with TC SOA",
     "Configure SAP RFC destination",
     "Set up material master mapping",
     "Test CS BOM creation",
     "Configure ECO delta sync"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T012a",
    "name": "AIG Adapter Setup",
    "type": "Install",
    "hours": 6,
    "cx": 3,
    "dod": [
     "TC adapter authenticated",
     "SAP RFC tested",
     "Admin UI accessible",
     "Dashboard shows Connected"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the AIG component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Teamcenter 2512 and SAP S/4HANA",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T012b",
    "name": "Material Mapping",
    "type": "Configure",
    "hours": 8,
    "cx": 4,
    "dod": [
     "Material type maps correctly",
     "UOM conversion complete",
     "Special chars handled",
     "MRP type populated",
     "Plant data created"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Material Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Material Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T012c",
    "name": "CS BOM + ECO Test",
    "type": "Validate",
    "hours": 8,
    "cx": 4,
    "dod": [
     "MBOM maps correctly",
     "Quantities transferred",
     "Validity matches",
     "ECO add creates item",
     "ECO remove sets validity",
     "Email on failure"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'CS BOM + ECO Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Item.item_id",
    "dst": "Material.MATNR",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Item.object_desc",
    "dst": "Material.MAKTX",
    "xform": "40-char",
    "category": "core"
   },
   {
    "src": "UserData.material_type",
    "dst": "Material.MTART",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "BOM.bl_quantity",
    "dst": "BOM.MENGE",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_MATERIAL_SAVEDATA",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Number range assigned"
    ],
    "purpose": "Create material master",
    "sample": "BAPI_MATERIAL_SAVEDATA( MATERIAL:'BV-3IN', BASE_UOM:'EA' )"
   },
   {
    "name": "CSAP_MAT_BOM_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Material exists",
     "BOM Usage 1"
    ],
    "purpose": "Create CS BOM",
    "sample": "CSAP_MAT_BOM_CREATE( MATERIAL:'BV-3IN', PLANT:'1010' )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "TC Item (in Teamcenter 2512); related: MaterialMaster, CSBOM, AIG",
   "destinationBusinessObjectsInScope": "SAP Material Master + CS BOM (in SAP S/4HANA)",
   "meaning": "TC EBOM/MBOM to SAP Material + CS BOM: Foundational PLM-ERP interface.",
   "purpose": "Delivers 'Supply Chain Integration' (Supply Chain). TC Item becomes SAP Material Master; TC BOM becomes SAP CS BOM.",
   "functionPrimary": "Move/transform TC Item → SAP Material Master + CS BOM (BiSync, Event-driven).",
   "subFunctions": [
    "AIG Adapter Setup",
    "Material Mapping",
    "CS BOM + ECO Test"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → SAP BAPI]--> AIG --> SAP S/4HANA. Pattern: BiSync integration, Event trigger. Complexity 4/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-013",
    "IF-014",
    "IF-032",
    "IF-037",
    "IF-041",
    "IF-045"
   ],
   "criticalityScore": 19,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "TC adapter authenticated",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"TC Item\" mapping",
    "\"SAP Material Master + CS BOM\" configuration",
    "AIG",
    "MaterialMaster",
    "CSBOM",
    "MRP"
   ],
   "taskHours": 22,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-013",
  "seq": 13,
  "mvp": 1,
  "phase": 4,
  "grp": "AIG",
  "type": "Push",
  "freq": "Event",
  "name": "TC BOP to SAP PP Routing",
  "from": "Teamcenter 2512",
  "to": "SAP S/4HANA",
  "mid": "AIG",
  "protocol": "TC SOA → AIG → BAPI_ROUTING_CREATE",
  "bo": "TC BOP → SAP Routing",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "PLM + ERP",
  "outcome": "Capacity Planning",
  "outcomeCat": "Production Planning",
  "deps": [
   "IF-012"
  ],
  "about": "TC BOP with EasyPlan MTM times becomes SAP PP routing for capacity planning and costing.",
  "tags": [
   "BOP",
   "Routing",
   "WorkCenter",
   "MTM",
   "Capacity"
  ],
  "triggers": [
   {
    "id": "TRG-013-01",
    "name": "TC BOP Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "MEWorkpackage Released with std_time",
    "condition": "MTM study complete",
    "latency": "< 90 seconds",
    "description": "When BOP with MTM times is released, AIG creates SAP PP routing.",
    "recommendedMapping": [
     {
      "src": "BOP.operation_name",
      "dst": "Routing.LTXA1",
      "xform": "Direct",
      "mandatory": true,
      "note": "Operation text"
     },
     {
      "src": "BOP.sequence_number",
      "dst": "Routing.VORNR",
      "xform": "×10",
      "mandatory": true,
      "note": "Sequence"
     },
     {
      "src": "UserData.std_time_min",
      "dst": "Routing.BEAZE",
      "xform": "min→hr×3600",
      "mandatory": true,
      "note": "Machine time"
     },
     {
      "src": "WorkCenter.item_id",
      "dst": "Routing.ARBPL",
      "xform": "Direct",
      "mandatory": true,
      "note": "Work center"
     }
    ],
    "optionalMapping": [
     {
      "src": "UserData.setup_time_min",
      "dst": "Routing.RUSTE",
      "xform": "min→hr×3600",
      "note": "Setup time"
     },
     {
      "src": "UserData.control_key",
      "dst": "Routing.STEUS",
      "xform": "Direct",
      "note": "Control key"
     }
    ],
    "configSteps": [
     "Configure work center mapping",
     "Set up capacity category",
     "Test routing creation",
     "Validate capacity planning"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T013a",
    "name": "Work Center + Routing",
    "type": "Configure",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Work centers map",
     "Capacity configured",
     "Cost center linked",
     "Shift model set"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Work Center + Routing'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Work Center + Routing'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T013b",
    "name": "Capacity Validation",
    "type": "Validate",
    "hours": 6,
    "cx": 3,
    "dod": [
     "MTM time within ±1%",
     "CM01 matches within 5%",
     "Lead time within 5%",
     "CK11N uses correct times"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Capacity Validation'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "BOP.operation_name",
    "dst": "Routing.LTXA1",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "BOP.sequence_number",
    "dst": "Routing.VORNR",
    "xform": "×10",
    "category": "core"
   },
   {
    "src": "UserData.std_time_min",
    "dst": "Routing.BEAZE",
    "xform": "min→sec",
    "category": "core"
   },
   {
    "src": "WorkCenter.item_id",
    "dst": "Routing.ARBPL",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "CA_ROUTING_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Material exists",
     "Work centers exist"
    ],
    "purpose": "Create routing",
    "sample": "CA_ROUTING_CREATE( MATERIAL:'BV-3IN', OPERATIONS:[{COUNTER:'0040',WORK_CNTR:'PRESS-01'}] )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "TC BOP (in Teamcenter 2512); related: BOP, Routing, WorkCenter",
   "destinationBusinessObjectsInScope": "SAP Routing (in SAP S/4HANA)",
   "meaning": "TC BOP to SAP PP Routing: TC BOP with EasyPlan MTM times becomes SAP PP routing for capacity planning and costing.",
   "purpose": "Delivers 'Capacity Planning' (Production Planning). ",
   "functionPrimary": "Move/transform TC BOP → SAP Routing (Push, Event-driven).",
   "subFunctions": [
    "Work Center + Routing",
    "Capacity Validation"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → BAPI_ROUTING_CREATE]--> AIG --> SAP S/4HANA. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-012"
   ],
   "downstreamConsumers": [
    "IF-026"
   ],
   "criticalityScore": 8,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Work centers map",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"TC BOP\" mapping",
    "\"SAP Routing\" configuration",
    "AIG",
    "BOP",
    "Routing",
    "WorkCenter",
    "MTM"
   ],
   "taskHours": 12,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-014",
  "seq": 14,
  "mvp": 2,
  "phase": 4,
  "grp": "AIG",
  "type": "BiSync",
  "freq": "Batch",
  "name": "Supplier EDI (ORDERS/DESADV/INVOIC)",
  "from": "SAP S/4HANA",
  "to": "Supplier Systems",
  "mid": "AIG",
  "protocol": "AS2/SFTP + X12/EDIFACT",
  "bo": "SAP PO → EDI 850; ASN → 856",
  "complexity": 3,
  "effort": 10,
  "risk": 2,
  "team": "ERP + IT",
  "outcome": "Automated Procurement",
  "outcomeCat": "Supply Chain",
  "deps": [
   "IF-012"
  ],
  "about": "Automates procurement cycle with strategic suppliers via EDI. ASN enables pre-receipt inspection queue.",
  "tags": [
   "EDI",
   "AS2",
   "X12",
   "EDIFACT",
   "PO",
   "ASN"
  ],
  "triggers": [
   {
    "id": "TRG-014-01",
    "name": "SAP PO Creation",
    "type": "CREATE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Purchase order created",
    "condition": "Supplier EDI-enabled",
    "latency": "< 5 minutes",
    "description": "When PO is created, AIG sends EDI 850 to supplier.",
    "recommendedMapping": [
     {
      "src": "SAP PO.EBELN",
      "dst": "EDI 850.BEG03",
      "xform": "Direct",
      "mandatory": true,
      "note": "PO number"
     },
     {
      "src": "SAP PO.MATNR",
      "dst": "EDI 850.PO1",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material"
     },
     {
      "src": "SAP PO.MENGE",
      "dst": "EDI 850.QTY",
      "xform": "Direct",
      "mandatory": true,
      "note": "Quantity"
     }
    ],
    "optionalMapping": [
     {
      "src": "SAP PO.EINDT",
      "dst": "EDI 850.DTM",
      "xform": "Date",
      "note": "Delivery date"
     },
     {
      "src": "SAP PO.NETWR",
      "dst": "EDI 850.AMT",
      "xform": "Direct",
      "note": "Value"
     }
    ],
    "configSteps": [
     "Configure trading partner profiles",
     "Set up AS2 certificate exchange",
     "Configure PO output type",
     "Test ASN processing"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T014a",
    "name": "Trading Partner Setup",
    "type": "Configure",
    "hours": 7,
    "cx": 2,
    "dod": [
     "Partners configured",
     "AS2 encryption tested",
     "EDIFACT headers correct",
     "PO output triggers EDI"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Trading Partner Setup'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Trading Partner Setup'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T014b",
    "name": "ASN Processing Test",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "ASN received → inbound delivery",
     "Batch/heat stored",
     "Opcenter queue created",
     "Reconciliation 100%"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'ASN Processing Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP PO.EBELN",
    "dst": "EDI 850.BEG03",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP PO.MATNR",
    "dst": "EDI 850.PO1",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP PO.MENGE",
    "dst": "EDI 850.QTY",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "AIG EDI AS2 Send",
    "method": "HTTP-AS2",
    "url": "https://supplier-as2-url",
    "prereq": [
     "AS2 certificate",
     "Partner profile"
    ],
    "purpose": "Send EDI 850",
    "sample": "ISA*00* *00* *ZZ*CUSTOMER *ZZ*SUPPLIER..."
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "SAP PO (in SAP S/4HANA); related: EDI, AS2, X12",
   "destinationBusinessObjectsInScope": "EDI 850; ASN (in Supplier Systems)",
   "meaning": "Supplier EDI (ORDERS/DESADV/INVOIC): Automates procurement cycle with strategic suppliers via EDI.",
   "purpose": "Delivers 'Automated Procurement' (Supply Chain). ASN enables pre-receipt inspection queue.",
   "functionPrimary": "Move/transform SAP PO → EDI 850; ASN (BiSync, Batch-driven).",
   "subFunctions": [
    "Trading Partner Setup",
    "ASN Processing Test"
   ],
   "architecture": "SAP S/4HANA --[AS2/SFTP + X12/EDIFACT]--> AIG --> Supplier Systems. Pattern: BiSync integration, Batch trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "BiSync · Batch",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-012"
   ],
   "downstreamConsumers": [
    "IF-051",
    "IF-052"
   ],
   "criticalityScore": 8,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Partners configured",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"SAP PO\" mapping",
    "\"EDI 850; ASN\" configuration",
    "AIG",
    "EDI",
    "AS2",
    "X12",
    "EDIFACT"
   ],
   "taskHours": 12,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-015",
  "seq": 15,
  "mvp": 1,
  "phase": 1,
  "grp": "EP",
  "type": "BiSync",
  "freq": "OnDemand",
  "name": "EasyPlan ↔ TC BOP (Import/Export)",
  "from": "Teamcenter 2512",
  "to": "EasyPlan",
  "mid": "PLMXML",
  "protocol": "PLMXML + EasyPlan API",
  "bo": "TC BOP ↔ EasyPlan Balanced BOP",
  "complexity": 4,
  "effort": 14,
  "risk": 4,
  "team": "PLM + Manufacturing Engineering",
  "outcome": "Process Validation",
  "outcomeCat": "Manufacturing Engineering",
  "deps": [],
  "about": "THE MOST CRITICAL EASYPLAN INTERFACE. TC raw BOP imported into EasyPlan. After MTM study, line balancing, and ergonomics analysis, the PROVEN process plan is exported back to TC.",
  "tags": [
   "EasyPlan",
   "MTM",
   "LineBalance",
   "Takt",
   "Ergonomics",
   "PLMXML"
  ],
  "triggers": [
   {
    "id": "TRG-015-01",
    "name": "EasyPlan Balance Complete",
    "type": "COMPLETE",
    "source": "EasyPlan",
    "sourceEvent": "Line balance simulation complete",
    "condition": "Balance efficiency ≥85%",
    "latency": "Manual",
    "description": "When line balancing is complete, balanced BOP exported back to TC.",
    "recommendedMapping": [
     {
      "src": "EasyPlan.MTM.standard_time_min",
      "dst": "TC.std_time_min",
      "xform": "Direct",
      "mandatory": true,
      "note": "MTM time"
     },
     {
      "src": "EasyPlan.Balance.station_assign",
      "dst": "TC.station_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Station"
     },
     {
      "src": "EasyPlan.Ergo.reba_score",
      "dst": "TC.ergonomics_note",
      "xform": "Append",
      "mandatory": true,
      "note": "REBA score"
     }
    ],
    "optionalMapping": [
     {
      "src": "EasyPlan.Balance.cycle_time",
      "dst": "TC.cycle_time",
      "xform": "Direct",
      "note": "Cycle time"
     },
     {
      "src": "EasyPlan.Plant.layout_validated",
      "dst": "TC.layout_status",
      "xform": "Flag",
      "note": "Validated"
     }
    ],
    "configSteps": [
     "Install EasyPlan with TC plugin",
     "Configure PLMXML import/export",
     "Train engineers on MTM",
     "Test balanced export cascade"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T015a",
    "name": "EasyPlan Install",
    "type": "Install",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Server installed",
     "TC plugin configured",
     "PLMXML schema matches",
     "User accounts created"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the PLMXML component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Teamcenter 2512 and EasyPlan",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T015b",
    "name": "MTM Time Study",
    "type": "Configure",
    "hours": 14,
    "cx": 4,
    "dod": [
     "BOP exported",
     "Import without errors",
     "Plant structure correct",
     "Takt configured",
     "MTM breakdown for 5 ops",
     "Balance efficiency ≥85%",
     "Bottleneck identified",
     "Ergonomics for REBA≥7"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the PLMXML configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'MTM Time Study'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'MTM Time Study'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T015c",
    "name": "Balanced Export Test",
    "type": "Validate",
    "hours": 8,
    "cx": 4,
    "dod": [
     "Exports successfully",
     "New BOP revision created",
     "Times match balance chart",
     "CN4T delta updates Opcenter",
     "SAP routing updated"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Balanced Export Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "EasyPlan.MTM.standard_time_min",
    "dst": "TC.std_time_min",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "EasyPlan.Balance.station_assign",
    "dst": "TC.station_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "EasyPlan.Ergo.reba_score",
    "dst": "TC.ergonomics_note",
    "xform": "Append",
    "category": "quality"
   }
  ],
  "apis": [
   {
    "name": "EasyPlan TC Plugin",
    "method": "Plugin",
    "url": "EasyPlan → Import → TC Manufacturing",
    "prereq": [
     "TC PLMXML exported",
     "Plugin licensed"
    ],
    "purpose": "Import/export BOP",
    "sample": "Tools → TC Connection → Configure | Server: tc-host:4545"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "TC BOP ↔ EasyPlan Balanced BOP (in Teamcenter 2512); related: EasyPlan, MTM, LineBalance",
   "destinationBusinessObjectsInScope": "TC BOP ↔ EasyPlan Balanced BOP (in EasyPlan)",
   "meaning": "EasyPlan ↔ TC BOP (Import/Export): THE MOST CRITICAL EASYPLAN INTERFACE.",
   "purpose": "Delivers 'Process Validation' (Manufacturing Engineering). TC raw BOP imported into EasyPlan.",
   "functionPrimary": "Move/transform TC BOP ↔ EasyPlan Balanced BOP → TC BOP ↔ EasyPlan Balanced BOP (BiSync, OnDemand-driven).",
   "subFunctions": [
    "EasyPlan Install",
    "MTM Time Study",
    "Balanced Export Test"
   ],
   "architecture": "Teamcenter 2512 --[PLMXML + EasyPlan API]--> PLMXML --> EasyPlan. Pattern: BiSync integration, OnDemand trigger. Complexity 4/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: PLMXML. INTRA-engineering: harmonises planning (EasyPlan) within the PLM domain.",
   "interfacePattern": "BiSync · OnDemand",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Recalculation deterministic from volume input; re-runs overwrite, no duplication.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: ep_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-016",
    "IF-017"
   ],
   "criticalityScore": 11,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Server installed",
   "docSearchKeywords": [
    "Opcenter EasyPlan / RD&L Line Balancing documentation",
    "\"TC BOP ↔ EasyPlan Balanced BOP\" mapping",
    "\"TC BOP ↔ EasyPlan Balanced BOP\" configuration",
    "PLMXML",
    "EasyPlan",
    "MTM",
    "LineBalance",
    "Takt"
   ],
   "taskHours": 28,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-016",
  "seq": 16,
  "mvp": 1,
  "phase": 1,
  "grp": "EP",
  "type": "BiSync",
  "freq": "Batch",
  "name": "EasyPlan ↔ SAP Takt + Opcenter APS",
  "from": "SAP S/4HANA",
  "to": "EasyPlan → Opcenter APS",
  "mid": "AIG + EasyPlan API",
  "protocol": "SAP OData → AIG → EasyPlan → Opcenter REST",
  "bo": "SAP volume → Takt → APS capacity",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "PLM + MES + ERP",
  "outcome": "Capacity Alignment",
  "outcomeCat": "Production Planning",
  "deps": [
   "IF-015"
  ],
  "about": "EasyPlan sits at intersection of SAP demand (takt) and Opcenter execution (APS). SAP volume defines EasyPlan takt; EasyPlan capacity populates APS.",
  "tags": [
   "EasyPlan",
   "Takt",
   "APS",
   "Capacity",
   "SAP-PP"
  ],
  "triggers": [
   {
    "id": "TRG-016-01",
    "name": "SAP Volume Change",
    "type": "UPDATE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Production planning volume update",
    "condition": "Change >10%",
    "latency": "< 1 hour",
    "description": "When SAP production plan changes, EasyPlan recalculates takt time.",
    "recommendedMapping": [
     {
      "src": "SAP PP.BGMNG",
      "dst": "EasyPlan.RequiredQty",
      "xform": "Units/period",
      "mandatory": true,
      "note": "Demand"
     },
     {
      "src": "SAP PP.ARBEI",
      "dst": "EasyPlan.AvailableTime",
      "xform": "min",
      "mandatory": true,
      "note": "Available time"
     },
     {
      "src": "Calc: AvailTime/RequiredQty",
      "dst": "EasyPlan.TaktTime_min",
      "xform": "Division",
      "mandatory": true,
      "note": "Takt"
     }
    ],
    "configSteps": [
     "Configure SAP OData service",
     "Set up AIG transformation",
     "Configure EasyPlan export to APS",
     "Validate APS schedule match"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T016a",
    "name": "SAP Volume → Takt",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Volume extracted",
     "Takt calculation verified",
     "EasyPlan configured",
     "Volume >10% triggers recalculation"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG + EasyPlan API configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Volume → Takt'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Volume → Takt'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T016b",
    "name": "Capacity → APS",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Station capacity exported",
     "APS utilization within ±5%",
     "Dates returned to SAP",
     "Shift model matches"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Capacity → APS'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP PP.BGMNG",
    "dst": "EasyPlan.RequiredQty",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "EasyPlan.station_cycle_time",
    "dst": "APS.MachineCapacity",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "SAP OData - ProductionPlanning",
    "method": "GET",
    "url": "/sap/opu/odata/sap/API_PRODUCTION_ORDER_2_SRV",
    "prereq": [
     "OData activated",
     "Read permissions"
    ],
    "purpose": "Get production volume",
    "sample": "GET /A_ProductionOrder?$filter=Material eq 'BV-3IN'"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "SAP volume (in SAP S/4HANA); related: EasyPlan, Takt, APS",
   "destinationBusinessObjectsInScope": "Takt (in EasyPlan → Opcenter APS)",
   "meaning": "EasyPlan ↔ SAP Takt + Opcenter APS: EasyPlan sits at intersection of SAP demand (takt) and Opcenter execution (APS).",
   "purpose": "Delivers 'Capacity Alignment' (Production Planning). SAP volume defines EasyPlan takt; EasyPlan capacity populates APS.",
   "functionPrimary": "Move/transform SAP volume → Takt (BiSync, Batch-driven).",
   "subFunctions": [
    "SAP Volume → Takt",
    "Capacity → APS"
   ],
   "architecture": "SAP S/4HANA --[SAP OData → AIG → EasyPlan → Opcenter REST]--> AIG + EasyPlan API --> EasyPlan → Opcenter APS. Pattern: BiSync integration, Batch trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG + EasyPlan API. INTRA-engineering: harmonises planning (EasyPlan) within the PLM domain.",
   "interfacePattern": "BiSync · Batch",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Recalculation deterministic from volume input; re-runs overwrite, no duplication.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: ep_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-015"
   ],
   "downstreamConsumers": [
    "IF-047"
   ],
   "criticalityScore": 8,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Volume extracted",
   "docSearchKeywords": [
    "Opcenter EasyPlan / RD&L Line Balancing documentation",
    "\"SAP volume\" mapping",
    "\"Takt\" configuration",
    "AIG + EasyPlan API",
    "EasyPlan",
    "Takt",
    "APS",
    "Capacity"
   ],
   "taskHours": 9,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-017",
  "seq": 17,
  "mvp": 2,
  "phase": 1,
  "grp": "EP",
  "type": "Push",
  "freq": "Batch",
  "name": "EasyPlan to Insights Hub OEE",
  "from": "EasyPlan",
  "to": "Insights Hub",
  "mid": "EasyPlan API + Hub REST",
  "protocol": "REST API",
  "bo": "Planned OEE target → Hub baseline",
  "complexity": 3,
  "effort": 6,
  "risk": 2,
  "team": "Manufacturing Engineering + Cloud",
  "outcome": "CI Feedback Loop",
  "outcomeCat": "Performance Analytics",
  "deps": [
   "IF-015"
  ],
  "about": "EasyPlan planned OEE becomes benchmark in Insights Hub. Gap between planned and actual drives recalibration.",
  "tags": [
   "OEE",
   "InsightsHub",
   "CI",
   "Performance"
  ],
  "triggers": [
   {
    "id": "TRG-017-01",
    "name": "EasyPlan Rebalance",
    "type": "COMPLETE",
    "source": "EasyPlan",
    "sourceEvent": "Line balance recalibration",
    "condition": "Balance changed",
    "latency": "< 24 hours",
    "description": "When EasyPlan re-balances, OEE targets update in Hub.",
    "recommendedMapping": [
     {
      "src": "EasyPlan.planned_oee_pct",
      "dst": "Hub.PlannedOEE",
      "xform": "Direct",
      "mandatory": true,
      "note": "OEE target"
     },
     {
      "src": "EasyPlan.station_cycle_time",
      "dst": "Hub.PlannedCT",
      "xform": "Direct",
      "mandatory": true,
      "note": "Cycle time"
     },
     {
      "src": "EasyPlan.balance_efficiency",
      "dst": "Hub.LineEfficiency",
      "xform": "Direct",
      "mandatory": true,
      "note": "Efficiency"
     }
    ],
    "configSteps": [
     "Configure EasyPlan OEE export",
     "Set up Hub OEE dashboard",
     "Configure monthly recalibration",
     "Test feedback loop"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T017a",
    "name": "OEE Push",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Planned OEE exported",
     "Dashboard shows planned vs actual",
     "Updates on rebalance"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the EasyPlan API + Hub REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'OEE Push'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'OEE Push'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T017b",
    "name": "Feedback Loop",
    "type": "Validate",
    "hours": 4,
    "cx": 3,
    "dod": [
     "API query configured",
     "Actual times imported",
     "Variance report generated",
     ">5% triggers rebalance"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Feedback Loop'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "EasyPlan.planned_oee_pct",
    "dst": "Hub.PlannedOEE",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Hub.actual_oee_pct",
    "dst": "EasyPlan.ActualOEE",
    "xform": "API",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Insights Hub Asset API",
    "method": "PUT",
    "url": "https://gateway.mindsphere.io/api/assetmanagement/v3/assets",
    "prereq": [
     "Hub tenant",
     "Asset hierarchy"
    ],
    "purpose": "Push OEE targets",
    "sample": "{ \"aspects\":[{ \"name\":\"PlannedPerformance\",\"properties\":[{ \"name\":\"PlannedOEE\",\"value\":87.5 }] }] }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Planned OEE target (in EasyPlan); related: OEE, InsightsHub, CI",
   "destinationBusinessObjectsInScope": "Hub baseline (in Insights Hub)",
   "meaning": "EasyPlan to Insights Hub OEE: EasyPlan planned OEE becomes benchmark in Insights Hub.",
   "purpose": "Delivers 'CI Feedback Loop' (Performance Analytics). Gap between planned and actual drives recalibration.",
   "functionPrimary": "Move/transform Planned OEE target → Hub baseline (Push, Batch-driven).",
   "subFunctions": [
    "OEE Push",
    "Feedback Loop"
   ],
   "architecture": "EasyPlan --[REST API]--> EasyPlan API + Hub REST --> Insights Hub. Pattern: Push integration, Batch trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: EasyPlan API + Hub REST. INTRA-engineering: harmonises planning (EasyPlan) within the PLM domain.",
   "interfacePattern": "Push · Batch",
   "systemOfRecord": "Source system owns the object; target holds a projection.",
   "idempotencyStrategy": "Recalculation deterministic from volume input; re-runs overwrite, no duplication.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: ep_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-015"
   ],
   "downstreamConsumers": [
    "IF-028"
   ],
   "criticalityScore": 6,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Planned OEE exported",
   "docSearchKeywords": [
    "Opcenter EasyPlan / RD&L Line Balancing documentation",
    "\"Planned OEE target\" mapping",
    "\"Hub baseline\" configuration",
    "EasyPlan API + Hub REST",
    "OEE",
    "InsightsHub",
    "CI",
    "Performance"
   ],
   "taskHours": 8,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-018",
  "seq": 18,
  "mvp": 1,
  "phase": 5,
  "grp": "SFC",
  "type": "BiSync",
  "freq": "RT",
  "name": "SFC ↔ Opcenter Dispatch",
  "from": "Opcenter 2601",
  "to": "SFC",
  "mid": "SFC REST API",
  "protocol": "REST Webhook + Callback",
  "bo": "WorkOrder dispatch → SFC Job Order; Completion → Opcenter",
  "complexity": 3,
  "effort": 8,
  "risk": 4,
  "team": "MES + Shop Floor",
  "outcome": "Paperless Execution",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-007"
  ],
  "about": "Primary MES-shop-floor integration: Opcenter dispatches work to SFC terminals, SFC sends completions back.",
  "tags": [
   "SFC",
   "Dispatch",
   "JobOrder",
   "Operator"
  ],
  "triggers": [
   {
    "id": "TRG-018-01",
    "name": "Work Order Dispatch",
    "type": "STATE_CHANGE",
    "source": "Opcenter 2601",
    "sourceEvent": "WorkOrder → Dispatched",
    "condition": "Previous step complete",
    "latency": "< 5 seconds",
    "description": "When Opcenter dispatches step, SFC receives job order.",
    "recommendedMapping": [
     {
      "src": "Opcenter.WorkOrder.Name",
      "dst": "SFC.JobOrder.ID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Order ID"
     },
     {
      "src": "Opcenter.Container.SerialNumber",
      "dst": "SFC.Part.Serial",
      "xform": "Direct",
      "mandatory": true,
      "note": "Serial"
     },
     {
      "src": "Opcenter.WorkflowStep.Name",
      "dst": "SFC.Step.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Step"
     }
    ],
    "configSteps": [
     "Install SFC server",
     "Configure Opcenter REST integration",
     "Set up webhook",
     "Configure step completion callback",
     "Test sequence enforcement"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T018a",
    "name": "SFC Integration",
    "type": "Install",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Server accessible",
     "REST endpoint configured",
     "Webhook <5s",
     "Callback <10s"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the SFC REST API component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Opcenter 2601 and SFC",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T018b",
    "name": "Sequence + QC Logic",
    "type": "Configure",
    "hours": 4,
    "cx": 3,
    "dod": [
     "Out-of-order blocked",
     "QC steps require inspector",
     "Rework routes correctly",
     "Scrap moves to scrapped"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the SFC REST API configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Sequence + QC Logic'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Sequence + QC Logic'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T018c",
    "name": "Usability Test",
    "type": "Test",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Step ≤3 taps",
     "Screen shows all info",
     "Offline recording works",
     "Login <3s"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Usability Test'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Opcenter 2601→SFC)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through SFC REST API",
       "Confirm arrival + correctness at SFC"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Opcenter.WorkOrder.Name",
    "dst": "SFC.JobOrder.ID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.Container.SerialNumber",
    "dst": "SFC.Part.Serial",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SFC.StepActualStartTime",
    "dst": "Opcenter.StepExecution.ActualStart",
    "xform": "ISO",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST Webhook",
    "method": "POST",
    "url": "https://sfc-server/api/v1/dispatch",
    "prereq": [
     "Webhook configured"
    ],
    "purpose": "Dispatch to SFC",
    "sample": "{ \"StepName\":\"OP-040\",\"OperatorName\":\"BADGE-12345\" }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "WorkOrder dispatch (in Opcenter 2601); related: SFC, Dispatch, JobOrder",
   "destinationBusinessObjectsInScope": "SFC Job Order; Completion (in SFC)",
   "meaning": "SFC ↔ Opcenter Dispatch: Primary MES-shop-floor integration: Opcenter dispatches work to SFC terminals, SFC sends completions back.",
   "purpose": "Delivers 'Paperless Execution' (Shop Floor Execution). ",
   "functionPrimary": "Move/transform WorkOrder dispatch → SFC Job Order; Completion (BiSync, RT-driven).",
   "subFunctions": [
    "SFC Integration",
    "Sequence + QC Logic",
    "Usability Test"
   ],
   "architecture": "Opcenter 2601 --[REST Webhook + Callback]--> SFC REST API --> SFC. Pattern: BiSync integration, RT trigger. Complexity 3/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: SFC REST API. INTRA-shop-floor: harmonises content surfacing to the operator workplace.",
   "interfacePattern": "BiSync · RT",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Read-mostly surfacing; uploads keyed by container+step.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: sfc_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007"
   ],
   "downstreamConsumers": [
    "IF-019",
    "IF-027",
    "IF-039",
    "IF-047"
   ],
   "criticalityScore": 15,
   "reusability": "MEDIUM — workplace surfacing reusable; station layout varies by line.",
   "keyAcceptanceSignal": "Server accessible",
   "docSearchKeywords": [
    "Opcenter Execution Shop Floor Connect / Active Workspace embed",
    "\"WorkOrder dispatch\" mapping",
    "\"SFC Job Order; Completion\" configuration",
    "SFC REST API",
    "SFC",
    "Dispatch",
    "JobOrder",
    "Operator"
   ],
   "taskHours": 15,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-019",
  "seq": 19,
  "mvp": 1,
  "phase": 5,
  "grp": "SFC",
  "type": "BiSync",
  "freq": "RT",
  "name": "OPC-UA Machine Connectivity",
  "from": "CNC/PLC Machines",
  "to": "SFC / Industrial Edge",
  "mid": "OPC-UA Server",
  "protocol": "OPC-UA IEC 62541 (SignAndEncrypt)",
  "bo": "Machine OPC-UA nodes → SFC Signals",
  "complexity": 4,
  "effort": 12,
  "risk": 3,
  "team": "OT + IT + Shop Floor",
  "outcome": "Machine Data Collection",
  "outcomeCat": "Shop Floor Execution",
  "deps": [
   "IF-018"
  ],
  "about": "Connects SFC and Industrial Edge to machine controllers via OPC-UA. Collects high-frequency machine data (spindle speed, load, feed rate, alarms) for OEE calculation and quality correlation.",
  "tags": [
   "OPC-UA",
   "CNC",
   "PLC",
   "MachineData",
   "OEE",
   "IEC62541"
  ],
  "triggers": [
   {
    "id": "TRG-019-01",
    "name": "OPC-UA Data Subscription",
    "type": "STATE_CHANGE",
    "source": "CNC Machine",
    "sourceEvent": "OPC-UA node value change",
    "condition": "Production step active",
    "latency": "< 100ms",
    "description": "SFC subscribes to machine OPC-UA nodes for real-time data collection during production steps.",
    "technicalDetails": {
     "protocol": "OPC-UA IEC 62541",
     "port": "4840",
     "securityMode": "SignAndEncrypt",
     "securityPolicy": "Basic256Sha256",
     "authentication": "X.509 Client Certificate"
    },
    "preConditions": [
     "OPC-UA server enabled on CNC controller",
     "PKI certificate exchange completed",
     "Anonymous access disabled",
     "Firewall allows TCP 4840"
    ],
    "context": "During active production step, SFC subscribes to machine nodes for real-time performance monitoring.",
    "prerequisites": {
     "cnc": [
      "Sinumerik 840D with Option A3",
      "OPC-UA configuration file",
      "Trusted certificates folder"
     ],
     "pki": [
      "Root CA installed",
      "Client certificates issued",
      "CRL distribution configured"
     ],
     "sfc": [
      "OPC-UA client SDK",
      "Certificate keystore configured"
     ]
    },
    "sla": {
     "latency": "< 100ms",
     "availability": "99.9%",
     "dataCompleteness": "≥99.5%"
    },
    "errorHandling": {
     "certExpired": {
      "action": "Reject connection, alert PKI admin",
      "escalation": "Critical"
     },
     "serverUnavailable": {
      "action": "Retry with backoff (5s,15s,45s)",
      "escalation": "Warning"
     },
     "badStatusCode": {
      "action": "Log error, skip writing",
      "escalation": "Info"
     }
    },
    "monitoring": {
     "metrics": [
      "connection_status",
      "subscription_latency_ms",
      "data_quality_score"
     ],
     "alerts": [
      "Disconnection >30s → PagerDuty",
      "Data quality <99% → Email"
     ]
    },
    "security": {
     "encryption": "TLS 1.3",
     "authentication": "X.509 Mutual TLS",
     "authorization": "Certificate-based access control"
    },
    "recommendedMapping": [
     {
      "src": "OPC-UA.ActualFeedRate",
      "dst": "SFC.FeedRate",
      "xform": "Subscribed",
      "mandatory": true,
      "note": "mm/min"
     },
     {
      "src": "OPC-UA.ActualSpindleSpeed",
      "dst": "SFC.SpindleRPM",
      "xform": "Subscribed",
      "mandatory": true,
      "note": "RPM"
     },
     {
      "src": "OPC-UA.SpindleLoad",
      "dst": "SFC.SpindleLoad",
      "xform": "Subscribed",
      "mandatory": true,
      "note": "Percentage"
     },
     {
      "src": "OPC-UA.ActiveProgram",
      "dst": "SFC.ActiveProgram",
      "xform": "Subscribed",
      "mandatory": true,
      "note": "NC program name"
     }
    ],
    "optionalMapping": [
     {
      "src": "OPC-UA.ActiveToolNumber",
      "dst": "SFC.ActiveTool",
      "xform": "Subscribed",
      "note": "Tool identifier"
     },
     {
      "src": "OPC-UA.AlarmList",
      "dst": "SFC.AlarmLog",
      "xform": "Filter",
      "note": "Alarm codes"
     },
     {
      "src": "OPC-UA.ActivePower",
      "dst": "SFC.Power_kW",
      "xform": "Subscribed",
      "note": "kW"
     }
    ],
    "configSteps": [
     "Enable OPC-UA server on CNC controllers (Option A3)",
     "Set security mode to SignAndEncrypt on all machines",
     "Exchange PKI certificates between SFC and machines",
     "Configure subscription with 100-500ms sampling interval",
     "Test data quality and latency validation"
    ]
   }
  ],
  "integrationStructure": {
   "architecture": "OPC-UA Pub-Sub with PKI Security",
   "components": [
    {
     "name": "OPC-UA Server",
     "role": "Data source on CNC",
     "version": "IEC 62541"
    },
    {
     "name": "PKI Infrastructure",
     "role": "Certificate management",
     "version": "Enterprise"
    },
    {
     "name": "OPC-UA Client (SFC)",
     "role": "Data subscriber",
     "version": "asyncua/OPC Foundation"
    }
   ],
   "dataFlow": "Machine OPC-UA Server → SFC OPC-UA Client (100ms interval)",
   "errorHandling": "Retry with exponential backoff, certificate validation",
   "monitoring": "Connection status, latency, data completeness"
  },
  "implementationOrder": [
   {
    "step": 1,
    "action": "Enable OPC-UA server on CNC controllers",
    "duration": "2 hours",
    "owner": "OT Team"
   },
   {
    "step": 2,
    "action": "Set up PKI certificate infrastructure",
    "duration": "4 hours",
    "owner": "Security Team"
   },
   {
    "step": 3,
    "action": "Configure OPC-UA security (SignAndEncrypt)",
    "duration": "2 hours",
    "owner": "OT Team"
   },
   {
    "step": 4,
    "action": "Implement OPC-UA client in SFC",
    "duration": "4 hours",
    "owner": "Integration Lead"
   },
   {
    "step": 5,
    "action": "Test subscription and data quality",
    "duration": "4 hours",
    "owner": "QA"
   }
  ],
  "tasks": [
   {
    "id": "T019a",
    "name": "OPC-UA Server Configuration",
    "type": "Configure",
    "hours": 8,
    "cx": 4,
    "dod": [
     "OPC-UA server enabled on each CNC",
     "Security mode SignAndEncrypt set",
     "PKI certificates exchanged",
     "Namespace documented per machine"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the OPC-UA Server configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'OPC-UA Server Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'OPC-UA Server Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T019b",
    "name": "Signal Subscription + Alarms",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "All required nodes subscribed",
     "Sampling interval ≤500ms",
     "Alarms trigger log entry",
     "Energy node connected"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the OPC-UA Server configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Signal Subscription + Alarms'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Signal Subscription + Alarms'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T019c",
    "name": "Data Quality Validation",
    "type": "Validate",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Latency ≤100ms confirmed",
     "No data gaps in 8-hour run",
     "Signal difference ≤1%",
     "Bad status handled correctly"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Data Quality Validation'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "OPC-UA.ActualFeedRate",
    "dst": "SFC.FeedRate",
    "xform": "Subscribed",
    "category": "core"
   },
   {
    "src": "OPC-UA.ActualSpindleSpeed",
    "dst": "SFC.SpindleRPM",
    "xform": "Subscribed",
    "category": "core"
   },
   {
    "src": "OPC-UA.SpindleLoad",
    "dst": "SFC.SpindleLoad",
    "xform": "Subscribed",
    "category": "core"
   },
   {
    "src": "OPC-UA.AlarmList",
    "dst": "SFC.AlarmLog",
    "xform": "Filter",
    "category": "quality"
   }
  ],
  "apis": [
   {
    "name": "OPC-UA Client Subscription",
    "method": "OPC-UA",
    "url": "opc.tcp://{machine-ip}:4840",
    "prereq": [
     "OPC-UA server running",
     "Certificate exchanged"
    ],
    "purpose": "Subscribe to machine data",
    "sample": "async with Client(url='opc.tcp://sinumerik-001:4840') as client: await client.create_subscription(200, handler)"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Machine OPC-UA nodes (in CNC/PLC Machines); related: OPC-UA, CNC, PLC",
   "destinationBusinessObjectsInScope": "SFC Signals (in SFC / Industrial Edge)",
   "meaning": "OPC-UA Machine Connectivity: Connects SFC and Industrial Edge to machine controllers via OPC-UA.",
   "purpose": "Delivers 'Machine Data Collection' (Shop Floor Execution). Collects high-frequency machine data (spindle speed, load, feed rate, alarms) for OEE calculation and quality correlation.",
   "functionPrimary": "Move/transform Machine OPC-UA nodes → SFC Signals (BiSync, RT-driven).",
   "subFunctions": [
    "OPC-UA Server Configuration",
    "Signal Subscription + Alarms",
    "Data Quality Validation"
   ],
   "architecture": "CNC/PLC Machines --[OPC-UA IEC 62541 (SignAndEncrypt)]--> OPC-UA Server --> SFC / Industrial Edge. Pattern: BiSync integration, RT trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: OPC-UA Server. INTRA-shop-floor: harmonises content surfacing to the operator workplace.",
   "interfacePattern": "BiSync · RT",
   "systemOfRecord": "The machine/Edge is source of truth for the raw signal; target aggregates it.",
   "idempotencyStrategy": "Read-mostly surfacing; uploads keyed by container+step.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: sfc_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-018"
   ],
   "downstreamConsumers": [
    "IF-020",
    "IF-021"
   ],
   "criticalityScore": 10,
   "reusability": "MEDIUM — workplace surfacing reusable; station layout varies by line.",
   "keyAcceptanceSignal": "OPC-UA server enabled on each CNC",
   "docSearchKeywords": [
    "Opcenter Execution Shop Floor Connect / Active Workspace embed",
    "\"Machine OPC-UA nodes\" mapping",
    "\"SFC Signals\" configuration",
    "OPC-UA Server",
    "OPC-UA",
    "CNC",
    "PLC",
    "MachineData"
   ],
   "taskHours": 20,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-020",
  "seq": 20,
  "mvp": 1,
  "phase": 5,
  "grp": "SFC",
  "type": "Push",
  "freq": "Event",
  "name": "DNC NC Program Delivery to Machine",
  "from": "Opcenter 2601",
  "to": "CNC Machine",
  "mid": "SFC / DNC Server",
  "protocol": "DNC per control type (Heidenhain, FOCAS, FTP)",
  "bo": "Opcenter Document → Machine Controller",
  "complexity": 3,
  "effort": 6,
  "risk": 4,
  "team": "Shop Floor + IT",
  "outcome": "Wrong-Program Prevention",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-004",
   "IF-019"
  ],
  "about": "When machining step is dispatched, SFC retrieves approved NC program from Opcenter and delivers directly to CNC controller via DNC.",
  "tags": [
   "DNC",
   "NC",
   "CNC",
   "VersionControl"
  ],
  "triggers": [
   {
    "id": "TRG-020-01",
    "name": "Step Dispatch with NC",
    "type": "STATE_CHANGE",
    "source": "Opcenter 2601",
    "sourceEvent": "Machining step dispatched",
    "condition": "Step has NC Document linked",
    "latency": "< 10 seconds",
    "description": "When machining step dispatched, SFC transfers NC program to CNC.",
    "recommendedMapping": [
     {
      "src": "Opcenter.Document.Name",
      "dst": "DNC.ProgramName",
      "xform": "Direct",
      "mandatory": true,
      "note": "Program name"
     },
     {
      "src": "Opcenter.Document.Revision",
      "dst": "DNC.Revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Version"
     },
     {
      "src": "Opcenter.Document.FileContent",
      "dst": "Machine.ProgramBuffer",
      "xform": "Binary",
      "mandatory": true,
      "note": "NC file"
     }
    ],
    "configSteps": [
     "Configure DNC server for each control type",
     "Set up folder structure for NC programs",
     "Configure version lock for active production",
     "Test transfer with 20 consecutive parts"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T020a",
    "name": "DNC Server Configuration",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "DNC configured per control type",
     "Folder structure documented",
     "Transfer <10 seconds",
     "Failure prevents step start"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the SFC / DNC Server configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'DNC Server Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'DNC Server Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T020b",
    "name": "Version Lock Validation",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Retrieves NC at dispatch",
     "Version displayed on SFC",
     "Version isolation works",
     "20 parts zero wrong-program",
     "Traceability complete"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Version Lock Validation'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Opcenter.Document.Name",
    "dst": "DNC.ProgramName",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.Document.Revision",
    "dst": "DNC.Revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.Document.FileContent",
    "dst": "Machine.ProgramBuffer",
    "xform": "Binary",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Siemens Sinumerik DNC",
    "method": "DNC",
    "url": "Network share",
    "prereq": [
     "DNC software",
     "Network access"
    ],
    "purpose": "Transfer NC program",
    "sample": "DNC.Transfer( MachineID:'SINUMERIK-001', SourcePath:'\\\\opcenter-dms\\NC\\OP020.MPF' )"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Opcenter Document (in Opcenter 2601); related: DNC, NC, CNC",
   "destinationBusinessObjectsInScope": "Machine Controller (in CNC Machine)",
   "meaning": "DNC NC Program Delivery to Machine: When machining step is dispatched, SFC retrieves approved NC program from Opcenter and delivers directly to CNC controller via DNC.",
   "purpose": "Delivers 'Wrong-Program Prevention' (Quality Assurance). ",
   "functionPrimary": "Move/transform Opcenter Document → Machine Controller (Push, Event-driven).",
   "subFunctions": [
    "DNC Server Configuration",
    "Version Lock Validation"
   ],
   "architecture": "Opcenter 2601 --[DNC per control type (Heidenhain, FOCAS, FTP)]--> SFC / DNC Server --> CNC Machine. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: SFC / DNC Server. INTRA-shop-floor: harmonises content surfacing to the operator workplace.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Read-mostly surfacing; uploads keyed by container+step.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: sfc_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-004",
    "IF-019"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 7,
   "reusability": "MEDIUM — workplace surfacing reusable; station layout varies by line.",
   "keyAcceptanceSignal": "DNC configured per control type",
   "docSearchKeywords": [
    "Opcenter Execution Shop Floor Connect / Active Workspace embed",
    "\"Opcenter Document\" mapping",
    "\"Machine Controller\" configuration",
    "SFC / DNC Server",
    "DNC",
    "NC",
    "CNC",
    "VersionControl"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-021",
  "seq": 21,
  "mvp": 1,
  "phase": 6,
  "grp": "EDGE",
  "type": "Push",
  "freq": "RT",
  "name": "Industrial Edge OPC-UA to Opcenter + Hub",
  "from": "CNC/PLC Machines",
  "to": "Industrial Edge → Opcenter + Hub",
  "mid": "IEM + IED",
  "protocol": "OPC-UA + MQTT/TLS + REST",
  "bo": "Machine signals → Process Data + Timeseries",
  "complexity": 4,
  "effort": 12,
  "risk": 3,
  "team": "OT + Cloud + MES",
  "outcome": "Process Traceability",
  "outcomeCat": "Digital Twin",
  "deps": [
   "IF-019"
  ],
  "about": "Industrial Edge pre-processes high-frequency OPC-UA data, routes to Opcenter (step-level aggregates) and Hub (raw timeseries for analytics).",
  "tags": [
   "IndustrialEdge",
   "IEM",
   "MQTT",
   "Timeseries"
  ],
  "triggers": [
   {
    "id": "TRG-021-01",
    "name": "OPC-UA Data at IED",
    "type": "STATE_CHANGE",
    "source": "Industrial Edge Device",
    "sourceEvent": "OPC-UA subscription update",
    "condition": "Production step active",
    "latency": "< 500ms",
    "description": "IED collects OPC-UA data, pre-processes, and sends to Opcenter and Hub.",
    "recommendedMapping": [
     {
      "src": "OPC-UA.SpindleLoad",
      "dst": "Opcenter.DC.SpindleLoad",
      "xform": "1s avg",
      "mandatory": true,
      "note": "Step-level"
     },
     {
      "src": "OPC-UA.FeedRate",
      "dst": "Opcenter.DC.FeedRate",
      "xform": "1s avg",
      "mandatory": true,
      "note": "Step-level"
     },
     {
      "src": "OPC-UA.SpindleLoad",
      "dst": "Hub.TS.SpindleLoad",
      "xform": "100ms raw",
      "mandatory": true,
      "note": "Timeseries"
     }
    ],
    "configSteps": [
     "Install IEM server and onboard IED units",
     "Configure OPC-UA Connector Edge app",
     "Set up MQTT over TLS to Hub",
     "Test data completeness and retention"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T021a",
    "name": "IEM Install + IED Onboarding",
    "type": "Install",
    "hours": 6,
    "cx": 3,
    "dod": [
     "IEM server installed",
     "IED units provisioned",
     "IEM connected to Hub",
     "Edge app store accessible"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the IEM + IED component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to CNC/PLC Machines and Industrial Edge → Opcenter + Hub",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T021b",
    "name": "OPC-UA Connector Config",
    "type": "Configure",
    "hours": 7,
    "cx": 3,
    "dod": [
     "Edge app deployed",
     "Nodes subscribed ≤500ms",
     "Pre-processing configured",
     "REST to Opcenter works"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the IEM + IED configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'OPC-UA Connector Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'OPC-UA Connector Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T021c",
    "name": "MQTT Upload Test",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "MQTT/TLS established",
     "Hub shows live data",
     "Completeness ≥99%",
     "Retention policy confirmed"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'MQTT Upload Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "OPC-UA.SpindleLoad",
    "dst": "Opcenter.DC.SpindleLoad",
    "xform": "1s avg",
    "category": "core"
   },
   {
    "src": "OPC-UA.SpindleLoad",
    "dst": "Hub.TS.SpindleLoad",
    "xform": "100ms raw",
    "category": "analytics"
   }
  ],
  "apis": [
   {
    "name": "Insights Hub Timeseries Ingest",
    "method": "PUT",
    "url": "https://gateway.mindsphere.io/api/iottsaggregates/v4/timeseries",
    "prereq": [
     "Hub asset",
     "MQTT bridge"
    ],
    "purpose": "Ingest timeseries data",
    "sample": "[{ \"time\":\"2025-03-01T08:15:00Z\",\"SpindleLoad\":78.5 }]"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Machine signals (in CNC/PLC Machines); related: IndustrialEdge, IEM, MQTT",
   "destinationBusinessObjectsInScope": "Process Data + Timeseries (in Industrial Edge → Opcenter + Hub)",
   "meaning": "Industrial Edge OPC-UA to Opcenter + Hub: Industrial Edge pre-processes high-frequency OPC-UA data, routes to Opcenter (step-level aggregates) and Hub (raw timeseries for analytics).",
   "purpose": "Delivers 'Process Traceability' (Digital Twin). ",
   "functionPrimary": "Move/transform Machine signals → Process Data + Timeseries (Push, RT-driven).",
   "subFunctions": [
    "IEM Install + IED Onboarding",
    "OPC-UA Connector Config",
    "MQTT Upload Test"
   ],
   "architecture": "CNC/PLC Machines --[OPC-UA + MQTT/TLS + REST]--> IEM + IED --> Industrial Edge → Opcenter + Hub. Pattern: Push integration, RT trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: IEM + IED. INTRA-OT: harmonises shop-floor machine signal into the digital thread.",
   "interfacePattern": "Push · RT",
   "systemOfRecord": "The machine/Edge is source of truth for the raw signal; target aggregates it.",
   "idempotencyStrategy": "Telemetry keyed by machine+timestamp; at-least-once with dedup window at the Edge.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM. OT/IT segmentation + OPC-UA SignAndEncrypt.",
   "monitoringSignals": "Metrics: edge_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-019"
   ],
   "downstreamConsumers": [
    "IF-022",
    "IF-023",
    "IF-030",
    "IF-038"
   ],
   "criticalityScore": 14,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "IEM server installed",
   "docSearchKeywords": [
    "Industrial Edge IEM-IED + OPC-UA / MQTT connectivity",
    "\"Machine signals\" mapping",
    "\"Process Data + Timeseries\" configuration",
    "IEM + IED",
    "IndustrialEdge",
    "IEM",
    "MQTT",
    "Timeseries"
   ],
   "taskHours": 18,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-022",
  "seq": 22,
  "mvp": 2,
  "phase": 6,
  "grp": "EDGE",
  "type": "Push",
  "freq": "Event",
  "name": "Edge AI Anomaly Detection to Opcenter Hold",
  "from": "Industrial Edge",
  "to": "Opcenter 2601",
  "mid": "Edge REST Webhook",
  "protocol": "ML Inference → REST",
  "bo": "ML Anomaly Score → NCR + QC Hold",
  "complexity": 4,
  "effort": 10,
  "risk": 3,
  "team": "OT + Cloud + MES + Quality",
  "outcome": "Proactive Defect Prevention",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-021"
  ],
  "about": "AI-powered defect detection on Edge sends quality hold signals to Opcenter before end-of-line inspection finds defects.",
  "tags": [
   "EdgeAI",
   "ML",
   "AnomalyDetection",
   "QualityHold"
  ],
  "triggers": [
   {
    "id": "TRG-022-01",
    "name": "ML Anomaly Detection",
    "type": "STATE_CHANGE",
    "source": "Industrial Edge",
    "sourceEvent": "Anomaly score > threshold",
    "condition": "Container active",
    "latency": "< 500ms",
    "description": "When Edge AI detects anomaly, creates Opcenter NCR and QC Hold.",
    "recommendedMapping": [
     {
      "src": "EdgeML.AnomalyScore",
      "dst": "Opcenter.NCR.DefectCode",
      "xform": "Score→code",
      "mandatory": true,
      "note": "Defect classification"
     },
     {
      "src": "SFC.ContainerSerial",
      "dst": "Opcenter.NCR.ContainerRef",
      "xform": "Direct",
      "mandatory": true,
      "note": "Container reference"
     },
     {
      "src": "EdgeML.AnomalyType",
      "dst": "Opcenter.NCR.Description",
      "xform": "Translate",
      "mandatory": true,
      "note": "Human-readable"
     }
    ],
    "configSteps": [
     "Deploy Edge ML model on IED",
     "Configure anomaly threshold tuning",
     "Set up Opcenter webhook receiver",
     "Test false positive management"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T022a",
    "name": "ML Model Deployment",
    "type": "Configure",
    "hours": 8,
    "cx": 4,
    "dod": [
     "Model deployed, latency <500ms",
     "Precision ≥85%, recall ≥90%",
     "False positive ≤5%",
     "Webhook receives data"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Edge REST Webhook configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'ML Model Deployment'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'ML Model Deployment'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T022b",
    "name": "Quality Hold + FP Management",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "NCR auto-created",
     "Container status = QC Hold",
     "False positive workflow tested",
     "Drift monitoring configured"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Quality Hold + FP Management'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "EdgeML.AnomalyScore",
    "dst": "Opcenter.NCR.DefectCode",
    "xform": "Score→code",
    "category": "core"
   },
   {
    "src": "SFC.ContainerSerial",
    "dst": "Opcenter.NCR.ContainerRef",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST - NCR",
    "method": "POST",
    "url": "/opcenter/api/v1/nonconformances",
    "prereq": [
     "Container exists"
    ],
    "purpose": "Create NCR from Edge AI",
    "sample": "{ \"ContainerName\":\"SN-001\",\"DefectCode\":\"EDGE-ANOMALY\",\"CreateQCHold\":true }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "ML Anomaly Score (in Industrial Edge); related: EdgeAI, ML, AnomalyDetection",
   "destinationBusinessObjectsInScope": "NCR + QC Hold (in Opcenter 2601)",
   "meaning": "Edge AI Anomaly Detection to Opcenter Hold: AI-powered defect detection on Edge sends quality hold signals to Opcenter before end-of-line inspection finds defects.",
   "purpose": "Delivers 'Proactive Defect Prevention' (Quality Assurance). ",
   "functionPrimary": "Move/transform ML Anomaly Score → NCR + QC Hold (Push, Event-driven).",
   "subFunctions": [
    "ML Model Deployment",
    "Quality Hold + FP Management"
   ],
   "architecture": "Industrial Edge --[ML Inference → REST]--> Edge REST Webhook --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: Edge REST Webhook. INTRA-OT: harmonises shop-floor machine signal into the digital thread.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "The machine/Edge is source of truth for the raw signal; target aggregates it.",
   "idempotencyStrategy": "Telemetry keyed by machine+timestamp; at-least-once with dedup window at the Edge.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM. OT/IT segmentation + OPC-UA SignAndEncrypt.",
   "monitoringSignals": "Metrics: edge_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-021"
   ],
   "downstreamConsumers": [
    "IF-036"
   ],
   "criticalityScore": 7,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Model deployed, latency <500ms",
   "docSearchKeywords": [
    "Industrial Edge IEM-IED + OPC-UA / MQTT connectivity",
    "\"ML Anomaly Score\" mapping",
    "\"NCR + QC Hold\" configuration",
    "Edge REST Webhook",
    "EdgeAI",
    "ML",
    "AnomalyDetection",
    "QualityHold"
   ],
   "taskHours": 13,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-023",
  "seq": 23,
  "mvp": 2,
  "phase": 7,
  "grp": "HUB",
  "type": "BiSync",
  "freq": "Event",
  "name": "Hub Predictive Maintenance to SAP PM + Opcenter",
  "from": "Insights Hub",
  "to": "SAP S/4HANA + Opcenter 2601",
  "mid": "AIG + Hub Alert",
  "protocol": "REST → AIG → BAPI_ALM_ORDER_MAINTAIN",
  "bo": "RUL Prediction → PM Notification + Resource Lock",
  "complexity": 4,
  "effort": 10,
  "risk": 3,
  "team": "Cloud + ERP + MES + Maintenance",
  "outcome": "Downtime Reduction",
  "outcomeCat": "Asset Management",
  "deps": [
   "IF-021"
  ],
  "about": "Hub ML predicts machine failure from vibration, temperature, energy patterns. When RUL drops below threshold, creates SAP PM notification and locks Opcenter resource.",
  "tags": [
   "PredictiveMaintenance",
   "RUL",
   "SAP-PM"
  ],
  "triggers": [
   {
    "id": "TRG-023-01",
    "name": "RUL Below Threshold",
    "type": "STATE_CHANGE",
    "source": "Insights Hub",
    "sourceEvent": "RUL prediction < 72 hours",
    "condition": "Asset has active maintenance plan",
    "latency": "< 5 minutes",
    "description": "When Hub predicts failure, creates SAP PM notification and locks resource.",
    "recommendedMapping": [
     {
      "src": "Hub.AssetID",
      "dst": "SAP.EQUNR",
      "xform": "Asset→Equip",
      "mandatory": true,
      "note": "Equipment number"
     },
     {
      "src": "Hub.PredictedRUL",
      "dst": "SAP.PRIOK",
      "xform": "RUL→priority",
      "mandatory": true,
      "note": "Urgency"
     },
     {
      "src": "Hub.RecommendedAction",
      "dst": "SAP.QMTXT",
      "xform": "Direct",
      "mandatory": true,
      "note": "Action text"
     }
    ],
    "configSteps": [
     "Train Hub predictive model with 6+ months data",
     "Configure RUL threshold alerts",
     "Set up AIG to create SAP PM notifications",
     "Configure Opcenter resource lock on alert"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T023a",
    "name": "Predictive Model Training",
    "type": "Configure",
    "hours": 8,
    "cx": 4,
    "dod": [
     "6+ months data",
     "ML algorithm documented",
     "RMSE ≤10%",
     "Model deployed"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG + Hub Alert configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Predictive Model Training'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Predictive Model Training'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T023b",
    "name": "Alert → SAP PM + Lock",
    "type": "Validate",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Alert triggers within cycle",
     "PM notification <5 minutes",
     "All fields populated",
     "Resource locked",
     "Planner notified"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Alert → SAP PM + Lock'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Hub.AssetID",
    "dst": "SAP.EQUNR",
    "xform": "Asset→Equip",
    "category": "core"
   },
   {
    "src": "Hub.PredictedRUL",
    "dst": "SAP.PRIOK",
    "xform": "RUL→priority",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Hub Predictive Service",
    "method": "GET",
    "url": "https://gateway.mindsphere.io/api/predictivemaintenance/v3",
    "prereq": [
     "Model trained",
     "Asset connected"
    ],
    "purpose": "Get RUL prediction",
    "sample": "{ \"RUL_hours\":68.5,\"healthScore\":0.72,\"recommendation\":\"Replace bearing\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "RUL Prediction (in Insights Hub); related: PredictiveMaintenance, RUL, SAP-PM",
   "destinationBusinessObjectsInScope": "PM Notification + Resource Lock (in SAP S/4HANA + Opcenter 2601)",
   "meaning": "Hub Predictive Maintenance to SAP PM + Opcenter: Hub ML predicts machine failure from vibration, temperature, energy patterns.",
   "purpose": "Delivers 'Downtime Reduction' (Asset Management). When RUL drops below threshold, creates SAP PM notification and locks Opcenter resource.",
   "functionPrimary": "Move/transform RUL Prediction → PM Notification + Resource Lock (BiSync, Event-driven).",
   "subFunctions": [
    "Predictive Model Training",
    "Alert → SAP PM + Lock"
   ],
   "architecture": "Insights Hub --[REST → AIG → BAPI_ALM_ORDER_MAINTAIN]--> AIG + Hub Alert --> SAP S/4HANA + Opcenter 2601. Pattern: BiSync integration, Event trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG + Hub Alert. INTER-system (field↔enterprise): harmonises field telemetry with engineering/analytics.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Insights Hub is the authority for field/operating data; target receives feedback.",
   "idempotencyStrategy": "Asset+timestamp keyed; idempotent upsert on the asset model.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: hub_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-021"
   ],
   "downstreamConsumers": [
    "IF-040"
   ],
   "criticalityScore": 7,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "6+ months data",
   "docSearchKeywords": [
    "Insights Hub (MindSphere) Asset Model + connectivity",
    "\"RUL Prediction\" mapping",
    "\"PM Notification + Resource Lock\" configuration",
    "AIG + Hub Alert",
    "PredictiveMaintenance",
    "RUL",
    "SAP-PM"
   ],
   "taskHours": 14,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-024",
  "seq": 24,
  "mvp": 2,
  "phase": 7,
  "grp": "HUB",
  "type": "BiSync",
  "freq": "Event",
  "name": "TC to Hub Digital Twin Asset Model",
  "from": "Teamcenter 2512 + NX",
  "to": "Insights Hub",
  "mid": "REST + PLMXML + JT",
  "protocol": "PLMXML → Hub Asset API",
  "bo": "Product Structure + JT Geometry → Hub DT",
  "complexity": 3,
  "effort": 8,
  "risk": 2,
  "team": "PLM + Cloud",
  "outcome": "Digital Twin",
  "outcomeCat": "Digital Twin",
  "deps": [],
  "about": "TC product structure and NX JT geometry define Hub digital twin as-designed model. Hub correlates design intent with actual operational data.",
  "tags": [
   "DigitalTwin",
   "JT",
   "AssetAPI",
   "PLMXML"
  ],
  "triggers": [
   {
    "id": "TRG-024-01",
    "name": "Product Structure Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Product BOM released",
    "condition": "JT geometry available",
    "latency": "< 1 hour",
    "description": "When product structure released, creates/updates Hub Digital Twin asset.",
    "recommendedMapping": [
     {
      "src": "TC.Item.item_id",
      "dst": "Hub.Asset.ExternalID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Product ID"
     },
     {
      "src": "TC.BOM.structure",
      "dst": "Hub.DT.BOMHierarchy",
      "xform": "Parse",
      "mandatory": true,
      "note": "BOM structure"
     },
     {
      "src": "NX.JT.file",
      "dst": "Hub.DT.Geometry",
      "xform": "Upload",
      "mandatory": true,
      "note": "3D geometry"
     }
    ],
    "configSteps": [
     "Configure Hub tenant asset hierarchy",
     "Set up Asset Type templates",
     "Import TC PLMXML to Hub as DT asset",
     "Link NX JT geometry to Hub DT asset",
     "Configure planned vs actual dashboard"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T024a",
    "name": "Hub Asset Model Setup",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Asset hierarchy matches plant",
     "Asset Type templates created",
     "PLMXML imported",
     "JT geometry linked",
     "Performance parameters configured",
     "DT shows planned vs actual"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the REST + PLMXML + JT configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Hub Asset Model Setup'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Hub Asset Model Setup'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.Item.item_id",
    "dst": "Hub.Asset.ExternalID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.BOM.structure",
    "dst": "Hub.DT.BOMHierarchy",
    "xform": "Parse",
    "category": "core"
   },
   {
    "src": "NX.JT.file",
    "dst": "Hub.DT.Geometry",
    "xform": "Upload",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Hub Asset Management API",
    "method": "POST",
    "url": "https://gateway.mindsphere.io/api/assetmanagement/v3/assets",
    "prereq": [
     "Hub tenant",
     "Asset Type defined"
    ],
    "purpose": "Create DT asset",
    "sample": "{ \"name\":\"BV-3IN\",\"externalId\":\"BV-3IN\",\"typeId\":\"ValveAssembly\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Product Structure + JT Geometry (in Teamcenter 2512 + NX); related: DigitalTwin, JT, AssetAPI",
   "destinationBusinessObjectsInScope": "Hub DT (in Insights Hub)",
   "meaning": "TC to Hub Digital Twin Asset Model: TC product structure and NX JT geometry define Hub digital twin as-designed model.",
   "purpose": "Delivers 'Digital Twin' (Digital Twin). Hub correlates design intent with actual operational data.",
   "functionPrimary": "Move/transform Product Structure + JT Geometry → Hub DT (BiSync, Event-driven).",
   "subFunctions": [
    "Hub Asset Model Setup"
   ],
   "architecture": "Teamcenter 2512 + NX --[PLMXML → Hub Asset API]--> REST + PLMXML + JT --> Insights Hub. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: REST + PLMXML + JT. INTER-system (field↔enterprise): harmonises field telemetry with engineering/analytics.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Asset+timestamp keyed; idempotent upsert on the asset model.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: hub_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-028"
   ],
   "criticalityScore": 6,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Asset hierarchy matches plant",
   "docSearchKeywords": [
    "Insights Hub (MindSphere) Asset Model + connectivity",
    "\"Product Structure + JT Geometry\" mapping",
    "\"Hub DT\" configuration",
    "REST + PLMXML + JT",
    "DigitalTwin",
    "JT",
    "AssetAPI",
    "PLMXML"
   ],
   "taskHours": 8,
   "classificationSummary": {
    "ootb": 0,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 1
   }
  }
 },
 {
  "id": "IF-025",
  "seq": 25,
  "mvp": 1,
  "phase": 8,
  "grp": "QUAL",
  "type": "Push",
  "freq": "Event",
  "name": "CMM Q-DAS to Opcenter SPC + Hub",
  "from": "CMM / Gauging Stations",
  "to": "Opcenter 2601 + Insights Hub",
  "mid": "Q-DAS AQDEF + REST",
  "protocol": "AQDEF K-field → Opcenter DC",
  "bo": "CMM Measurements → SPC + Quality Analytics",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "Quality + MES + Cloud",
  "outcome": "Statistical Process Control",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-010"
  ],
  "about": "Automated CMM measurements transmitted in Q-DAS/AQDEF format to Opcenter for SPC. Western Electric rule violations trigger automatic Container hold.",
  "tags": [
   "CMM",
   "Q-DAS",
   "AQDEF",
   "SPC",
   "Cpk"
  ],
  "triggers": [
   {
    "id": "TRG-025-01",
    "name": "CMM Measurement Complete",
    "type": "COMPLETE",
    "source": "CMM Machine",
    "sourceEvent": "AQDEF file generation",
    "condition": "Inspection step active",
    "latency": "< 30 seconds",
    "description": "When CMM completes measurement, Q-DAS file triggers Opcenter DataCollection update.",
    "recommendedMapping": [
     {
      "src": "AQDEF.K0004",
      "dst": "Opcenter.DC.CharName",
      "xform": "Direct",
      "mandatory": true,
      "note": "Characteristic"
     },
     {
      "src": "AQDEF.K2000",
      "dst": "Opcenter.DC.MeasuredValue",
      "xform": "Direct",
      "mandatory": true,
      "note": "Measured value"
     },
     {
      "src": "AQDEF.K0007",
      "dst": "Opcenter.DC.UCL",
      "xform": "Direct",
      "mandatory": true,
      "note": "Upper limit"
     },
     {
      "src": "AQDEF.K0008",
      "dst": "Opcenter.DC.LCL",
      "xform": "Direct",
      "mandatory": true,
      "note": "Lower limit"
     }
    ],
    "optionalMapping": [
     {
      "src": "AQDEF.K0020",
      "dst": "Opcenter.DC.PassFail",
      "xform": "OK/NOK",
      "note": "Attribute result"
     },
     {
      "src": "Derived.Cpk",
      "dst": "Opcenter.SPC.Cpk",
      "xform": "Calculate",
      "note": "Capability index"
     }
    ],
    "configSteps": [
     "Configure Q-DAS AQDEF parser in Opcenter",
     "Set up SPC control chart configuration",
     "Configure Western Electric rules",
     "Test SPC hold and Hub integration"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T025a",
    "name": "AQDEF Parser + SPC Config",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "AQDEF adapter configured",
     "K-field parser reads correctly",
     "Attribute data handled",
     "Xbar-R charts configured",
     "Western Electric rules enabled"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Q-DAS AQDEF + REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AQDEF Parser + SPC Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AQDEF Parser + SPC Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T025b",
    "name": "SPC Hold + Hub Integration",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "OOC triggers hold within 30s",
     "Cpk calculated with thresholds",
     "Data streamed to Hub",
     "Predictive alert works"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'SPC Hold + Hub Integration'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "AQDEF.K0004",
    "dst": "Opcenter.DC.CharName",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "AQDEF.K2000",
    "dst": "Opcenter.DC.MeasuredValue",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "AQDEF.K0007",
    "dst": "Opcenter.DC.UCL",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Derived.Cpk",
    "dst": "Opcenter.SPC.Cpk",
    "xform": "Calculate",
    "category": "analytics"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST - DataCollection",
    "method": "POST",
    "url": "/opcenter/api/v1/containers/{name}/datacollection",
    "prereq": [
     "Container at step",
     "DC spec exists"
    ],
    "purpose": "Post CMM results",
    "sample": "{ \"StepName\":\"OP-010\",\"Characteristics\":[{\"Name\":\"HARDNESS\",\"Value\":18.5}] }"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "CMM Measurements (in CMM / Gauging Stations); related: CMM, Q-DAS, AQDEF",
   "destinationBusinessObjectsInScope": "SPC + Quality Analytics (in Opcenter 2601 + Insights Hub)",
   "meaning": "CMM Q-DAS to Opcenter SPC + Hub: Automated CMM measurements transmitted in Q-DAS/AQDEF format to Opcenter for SPC.",
   "purpose": "Delivers 'Statistical Process Control' (Quality Assurance). Western Electric rule violations trigger automatic Container hold.",
   "functionPrimary": "Move/transform CMM Measurements → SPC + Quality Analytics (Push, Event-driven).",
   "subFunctions": [
    "AQDEF Parser + SPC Config",
    "SPC Hold + Hub Integration"
   ],
   "architecture": "CMM / Gauging Stations --[AQDEF K-field → Opcenter DC]--> Q-DAS AQDEF + REST --> Opcenter 2601 + Insights Hub. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: Q-DAS AQDEF + REST. INTER-system (quality loop): harmonises quality data across MES/ERP/PLM.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Source system owns the object; target holds a projection.",
   "idempotencyStrategy": "Inspection lot/result keyed by lot number; replay-safe upsert.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: qual_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-010"
   ],
   "downstreamConsumers": [
    "IF-031",
    "IF-036",
    "IF-039",
    "IF-057"
   ],
   "criticalityScore": 14,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "AQDEF adapter configured",
   "docSearchKeywords": [
    "Opcenter Quality / Q-DAS AQDEF integration",
    "\"CMM Measurements\" mapping",
    "\"SPC + Quality Analytics\" configuration",
    "Q-DAS AQDEF + REST",
    "CMM",
    "Q-DAS",
    "AQDEF",
    "SPC"
   ],
   "taskHours": 13,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-026",
  "seq": 26,
  "mvp": 2,
  "phase": 4,
  "grp": "AIG",
  "type": "Push",
  "freq": "Batch (Daily)",
  "name": "SAP to TC Production Order Feedback",
  "from": "SAP S/4HANA",
  "to": "Teamcenter 2512",
  "mid": "AIG",
  "protocol": "SAP RFC → AIG → TC SOA",
  "bo": "Actual Costs & Times → BOP Feedback",
  "complexity": 3,
  "effort": 6,
  "risk": 3,
  "team": "ERP + PLM",
  "outcome": "Continuous Improvement",
  "outcomeCat": "Manufacturing Engineering",
  "deps": [
   "IF-009",
   "IF-013"
  ],
  "about": "CLOSING THE LOOP: Actual production data from SAP fed back to TC for continuous improvement. Enables MTM vs Actual variance analysis and auto-ECO generation.",
  "tags": [
   "Feedback",
   "Variance",
   "ContinuousImprovement",
   "ECO"
  ],
  "triggers": [
   {
    "id": "TRG-026-01",
    "name": "Order Completion (TECO)",
    "type": "STATE_CHANGE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Order status → TECO",
    "condition": "Actual costs and times recorded",
    "latency": "< 1 hour",
    "description": "When production order completes, actual performance data sent to TC for analysis.",
    "recommendedMapping": [
     {
      "src": "SAP.AUFNR",
      "dst": "TC.ActualOrderRef",
      "xform": "Direct",
      "mandatory": true,
      "note": "Order reference"
     },
     {
      "src": "SAP.ActualLaborHrs",
      "dst": "TC.ActualLaborHrs",
      "xform": "Sum",
      "mandatory": true,
      "note": "Actual labor"
     },
     {
      "src": "SAP.ActualMachineHrs",
      "dst": "TC.ActualMachineHrs",
      "xform": "Sum",
      "mandatory": true,
      "note": "Actual machine"
     },
     {
      "src": "SAP.VariancePercent",
      "dst": "TC.VariancePercent",
      "xform": "Direct",
      "mandatory": true,
      "note": "Variance vs MTM"
     }
    ],
    "configSteps": [
     "Configure SAP to capture actual times at TECO",
     "Set up AIG batch job daily",
     "Create TC attributes for feedback",
     "Configure variance dashboard",
     "Set up auto-ECO trigger for >15% variance"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T026a",
    "name": "SAP Actual Cost Capture",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "CO11N captures labor hours",
     "CO14 shows machine hours",
     "KSB1 shows costs",
     "KKS1 variance configured",
     "Test completes correctly"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Actual Cost Capture'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Actual Cost Capture'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T026b",
    "name": "AIG Batch Feedback",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Batch job extracts TECO orders",
     "Labor mapped to operations",
     "Machine hours mapped",
     "Variance calculated",
     "Data persisted 30 days"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Batch Feedback'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Batch Feedback'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T026c",
    "name": "Dashboard + ECO Trigger",
    "type": "Validate",
    "hours": 4,
    "cx": 3,
    "dod": [
     "Dashboard shows MTM vs Actual",
     "Monthly variance report",
     "Auto-ECO created for more than 15 percnt",
     "ECO contains variance data",
     "Review within 5 days"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Dashboard + ECO Trigger'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP.AUFNR",
    "dst": "TC.ActualOrderRef",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.ActualLaborHrs",
    "dst": "TC.ActualLaborHrs",
    "xform": "Sum",
    "category": "core"
   },
   {
    "src": "SAP.VariancePercent",
    "dst": "TC.VariancePercent",
    "xform": "Direct",
    "category": "analytics"
   }
  ],
  "apis": [
   {
    "name": "SAP RFC - CO_ORDER_READ_ACTUAL",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Order status TECO"
    ],
    "purpose": "Get actual data",
    "sample": "CALL FUNCTION 'CO_ORDER_READ_ACTUAL' EXPORTING AUFNR = '1000012345'"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Actual Costs & Times (in SAP S/4HANA); related: Feedback, Variance, ContinuousImprovement",
   "destinationBusinessObjectsInScope": "BOP Feedback (in Teamcenter 2512)",
   "meaning": "SAP to TC Production Order Feedback: CLOSING THE LOOP: Actual production data from SAP fed back to TC for continuous improvement.",
   "purpose": "Delivers 'Continuous Improvement' (Manufacturing Engineering). Enables MTM vs Actual variance analysis and auto-ECO generation.",
   "functionPrimary": "Move/transform Actual Costs & Times → BOP Feedback (Push, Batch (Daily)-driven).",
   "subFunctions": [
    "SAP Actual Cost Capture",
    "AIG Batch Feedback",
    "Dashboard + ECO Trigger"
   ],
   "architecture": "SAP S/4HANA --[SAP RFC → AIG → TC SOA]--> AIG --> Teamcenter 2512. Pattern: Push integration, Batch (Daily) trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Push · Batch (Daily)",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-009",
    "IF-013"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "CO11N captures labor hours",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"Actual Costs & Times\" mapping",
    "\"BOP Feedback\" configuration",
    "AIG",
    "Feedback",
    "Variance",
    "ContinuousImprovement",
    "ECO"
   ],
   "taskHours": 13,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-027",
  "seq": 27,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Event",
  "name": "Opcenter to TC As-Built BOM",
  "from": "Opcenter 2601",
  "to": "Teamcenter 2512",
  "mid": "CN4T/CN4S",
  "protocol": "Opcenter REST → CN4T → TC SOA",
  "bo": "Container Genealogy → As-Built BOM",
  "complexity": 4,
  "effort": 8,
  "risk": 4,
  "team": "MES + PLM",
  "outcome": "Product Traceability",
  "outcomeCat": "Digital Twin",
  "deps": [
   "IF-001",
   "IF-002",
   "IF-018"
  ],
  "about": "CRITICAL FOR REGULATORY COMPLIANCE: After production, Opcenter sends as-built BOM (actual components, serials, batches, test results) to TC for complete digital twin and recall management.",
  "tags": [
   "AsBuiltBOM",
   "Genealogy",
   "Traceability",
   "Recall"
  ],
  "triggers": [
   {
    "id": "TRG-027-01",
    "name": "Container Completion",
    "type": "COMPLETE",
    "source": "Opcenter 2601",
    "sourceEvent": "Container status → Finished",
    "condition": "All steps complete, quality passed",
    "latency": "< 30 seconds",
    "description": "When product completes production, as-built BOM sent to TC for digital twin.",
    "recommendedMapping": [
     {
      "src": "Container.SerialNumber",
      "dst": "TC.AsBuilt.SerialNumber",
      "xform": "Direct",
      "mandatory": true,
      "note": "Product serial"
     },
     {
      "src": "Container.LotNumber",
      "dst": "TC.AsBuilt.LotNumber",
      "xform": "Direct",
      "mandatory": true,
      "note": "Production batch"
     },
     {
      "src": "Container.ComponentList",
      "dst": "TC.AsBuilt.Components",
      "xform": "Array to BOM",
      "mandatory": true,
      "note": "Components used"
     },
     {
      "src": "Container.TestResults",
      "dst": "TC.AsBuilt.Attachments",
      "xform": "Link",
      "mandatory": true,
      "note": "Quality results"
     }
    ],
    "configSteps": [
     "Create TC data model for AsBuiltProduct",
     "Configure Opcenter to capture serials during kitting",
     "Set up CN4T as-built transformation",
     "Test multi-level BOM genealogy",
     "Validate recall query performance"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T027a",
    "name": "TC As-Built Model",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "AsBuiltProduct type created",
     "AsBuiltBOM with relationships",
     "AsBuiltComponent type",
     "Hierarchy defined",
     "BMIDE deployed"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T/CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC As-Built Model'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC As-Built Model'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T027b",
    "name": "Opcenter Capture Config",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Serials captured at issue",
     "Batch numbers captured",
     "Completion triggers export",
     "Test results attached",
     "3 records verified"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T/CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Opcenter Capture Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Opcenter Capture Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T027c",
    "name": "Recall Query Test",
    "type": "Validate",
    "hours": 5,
    "cx": 4,
    "dod": [
     "Serial query <5 seconds",
     "Batch query returns all",
     "Date range searchable",
     "NACE query shows hardness",
     "Drill-down works",
     "Signed by Quality"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Recall Query Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Container.SerialNumber",
    "dst": "TC.AsBuilt.SerialNumber",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Container.ComponentList",
    "dst": "TC.AsBuilt.Components",
    "xform": "Array to BOM",
    "category": "core"
   },
   {
    "src": "Container.TestResults",
    "dst": "TC.AsBuilt.Attachments",
    "xform": "Link",
    "category": "quality"
   }
  ],
  "apis": [
   {
    "name": "TC SOA - CreateAsBuiltProduct",
    "method": "POST",
    "url": "http://tc-host/tc/services/AsBuilt-2010-01-Service",
    "prereq": [
     "AsBuiltProduct type deployed"
    ],
    "purpose": "Create as-built record",
    "sample": "<CreateAsBuiltProduct><SerialNumber>SN-001</SerialNumber></CreateAsBuiltProduct>"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Container Genealogy (in Opcenter 2601); related: AsBuiltBOM, Genealogy, Traceability",
   "destinationBusinessObjectsInScope": "As-Built BOM (in Teamcenter 2512)",
   "meaning": "Opcenter to TC As-Built BOM: CRITICAL FOR REGULATORY COMPLIANCE: After production, Opcenter sends as-built BOM (actual components, serials, batches, test results) to TC for complete digital twin and recall management.",
   "purpose": "Delivers 'Product Traceability' (Digital Twin). ",
   "functionPrimary": "Move/transform Container Genealogy → As-Built BOM (Push, Event-driven).",
   "subFunctions": [
    "TC As-Built Model",
    "Opcenter Capture Config",
    "Recall Query Test"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST → CN4T → TC SOA]--> CN4T/CN4S --> Teamcenter 2512. Pattern: Push integration, Event trigger. Complexity 4/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: CN4T/CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-001",
    "IF-002",
    "IF-018"
   ],
   "downstreamConsumers": [
    "IF-059"
   ],
   "criticalityScore": 9,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "AsBuiltProduct type created",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"Container Genealogy\" mapping",
    "\"As-Built BOM\" configuration",
    "CN4T/CN4S",
    "AsBuiltBOM",
    "Genealogy",
    "Traceability",
    "Recall"
   ],
   "taskHours": 16,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-028",
  "seq": 28,
  "mvp": 3,
  "phase": 7,
  "grp": "HUB",
  "type": "BiSync",
  "freq": "Batch (Weekly)",
  "name": "Hub to TC Performance Feedback",
  "from": "Insights Hub",
  "to": "Teamcenter 2512",
  "mid": "AIG",
  "protocol": "Hub REST → AIG → TC SOA",
  "bo": "ML Recommendations → BOP Optimization",
  "complexity": 3,
  "effort": 6,
  "risk": 2,
  "team": "Cloud + PLM",
  "outcome": "AI-Driven Optimization",
  "outcomeCat": "Performance Analytics",
  "deps": [
   "IF-017",
   "IF-024"
  ],
  "about": "Hub ML analyzes production data and provides recommendations to TC for BOP optimization - bottleneck detection, cycle time adjustments, quality predictions.",
  "tags": [
   "ML",
   "Optimization",
   "Bottleneck",
   "AI"
  ],
  "triggers": [
   {
    "id": "TRG-028-01",
    "name": "Bottleneck Detection",
    "type": "STATE_CHANGE",
    "source": "Insights Hub",
    "sourceEvent": "Station utilization >95% for >25% of shift",
    "condition": "Bottleneck affecting OEE",
    "latency": "< 24 hours",
    "description": "Hub ML identifies bottleneck and suggests BOP re-balancing.",
    "recommendedMapping": [
     {
      "src": "Hub.BottleneckStation",
      "dst": "TC.BOP.BottleneckStation",
      "xform": "Direct",
      "mandatory": true,
      "note": "Station name"
     },
     {
      "src": "Hub.RecommendedTimeAdj",
      "dst": "TC.BOP.SuggestedStdTime",
      "xform": "Minutes",
      "mandatory": true,
      "note": "Time adjustment"
     },
     {
      "src": "Hub.ConfidenceScore",
      "dst": "TC.BOP.Confidence",
      "xform": "Percent",
      "mandatory": true,
      "note": "ML confidence"
     }
    ],
    "configSteps": [
     "Configure Hub ML for bottleneck detection",
     "Set up weekly batch job",
     "Configure TC dashboard for review",
     "Set up auto-ECO for high confidence"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T028a",
    "name": "Hub ML Model",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Model trained on 3+ months",
     "Precision >90%",
     "Weekly report generated",
     "Top 5 bottlenecks identified"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Hub ML Model'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Hub ML Model'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T028b",
    "name": "TC Integration",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "TC attributes created",
     "Weekly import succeeds",
     "Dashboard shows recommendations",
     "Auto-ECO for >95% confidence",
     "Manual review for others"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Integration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Integration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Hub.BottleneckStation",
    "dst": "TC.BOP.BottleneckStation",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Hub.RecommendedTimeAdj",
    "dst": "TC.BOP.SuggestedStdTime",
    "xform": "Minutes",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Hub Bottleneck API",
    "method": "GET",
    "url": "https://gateway.mindsphere.io/api/analytics/v3/bottlenecks",
    "prereq": [
     "Historical data",
     "Model trained"
    ],
    "purpose": "Get bottleneck recommendations",
    "sample": "GET /bottlenecks?line=LINE_01&days=7"
   }
  ],
  "enhanced": {
   "moscow": "Could Have",
   "sourceBusinessObjectsInScope": "ML Recommendations (in Insights Hub); related: ML, Optimization, Bottleneck",
   "destinationBusinessObjectsInScope": "BOP Optimization (in Teamcenter 2512)",
   "meaning": "Hub to TC Performance Feedback: Hub ML analyzes production data and provides recommendations to TC for BOP optimization - bottleneck detection, cycle time adjustments, quality predictions.",
   "purpose": "Delivers 'AI-Driven Optimization' (Performance Analytics). ",
   "functionPrimary": "Move/transform ML Recommendations → BOP Optimization (BiSync, Batch (Weekly)-driven).",
   "subFunctions": [
    "Hub ML Model",
    "TC Integration"
   ],
   "architecture": "Insights Hub --[Hub REST → AIG → TC SOA]--> AIG --> Teamcenter 2512. Pattern: BiSync integration, Batch (Weekly) trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (field↔enterprise): harmonises field telemetry with engineering/analytics.",
   "interfacePattern": "BiSync · Batch (Weekly)",
   "systemOfRecord": "Insights Hub is the authority for field/operating data; target receives feedback.",
   "idempotencyStrategy": "Asset+timestamp keyed; idempotent upsert on the asset model.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: hub_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-017",
    "IF-024"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 3,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Model trained on 3+ months",
   "docSearchKeywords": [
    "Insights Hub (MindSphere) Asset Model + connectivity",
    "\"ML Recommendations\" mapping",
    "\"BOP Optimization\" configuration",
    "AIG",
    "ML",
    "Optimization",
    "Bottleneck",
    "AI"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 0,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-029",
  "seq": 29,
  "mvp": 1,
  "phase": 3,
  "grp": "CN4S",
  "type": "BiSync",
  "freq": "Event",
  "name": "SAP to CN4S Material Master Validation",
  "from": "SAP S/4HANA",
  "to": "CN4S",
  "mid": "CN4S",
  "protocol": "SAP RFC → CN4S",
  "bo": "Material Master → Validation Cache",
  "complexity": 2,
  "effort": 4,
  "risk": 3,
  "team": "ERP + MES",
  "outcome": "Data Integrity",
  "outcomeCat": "Supply Chain",
  "deps": [
   "IF-007"
  ],
  "about": "Before creating Work Orders, CN4S validates SAP Material Master data completeness. Missing data is reported to SAP team. Prevents production failures.",
  "tags": [
   "Validation",
   "MaterialMaster",
   "DataQuality"
  ],
  "triggers": [
   {
    "id": "TRG-029-01",
    "name": "Material Master Change",
    "type": "UPDATE",
    "source": "SAP S/4HANA",
    "sourceEvent": "MM02/MM01 change",
    "condition": "Material used in production",
    "latency": "< 5 minutes",
    "description": "When Material Master changes, CN4S validates data completeness.",
    "recommendedMapping": [
     {
      "src": "SAP.MATNR",
      "dst": "CN4S.MaterialID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material number"
     },
     {
      "src": "SAP.MTART",
      "dst": "CN4S.MaterialType",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Type check"
     },
     {
      "src": "SAP.MEINS",
      "dst": "CN4S.BaseUOM",
      "xform": "Check",
      "mandatory": true,
      "note": "UOM validation"
     }
    ],
    "configSteps": [
     "Configure CN4S to subscribe to SAP changes",
     "Define validation rules for production",
     "Set up missing data alerting",
     "Test with incomplete materials"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T029a",
    "name": "Validation Rules",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "15 mandatory fields defined",
     "UOM validation configured",
     "MRP validation = PD",
     "Plant validation complete",
     "Routing validation"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Validation Rules'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Validation Rules'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T029b",
    "name": "Alerting Test",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Email within 5 minutes",
     "Log shows errors",
     "Weekly report shows rates",
     "Order blocked on error",
     "Pass rate >99%"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Alerting Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP.MATNR",
    "dst": "CN4S.MaterialID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.MTART",
    "dst": "CN4S.MaterialType",
    "xform": "Lookup",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_MATERIAL_GET_DETAIL",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Material exists"
    ],
    "purpose": "Get material data",
    "sample": "CALL FUNCTION 'BAPI_MATERIAL_GET_DETAIL' EXPORTING MATERIAL = 'BV-3IN'"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Material Master (in SAP S/4HANA); related: Validation, MaterialMaster, DataQuality",
   "destinationBusinessObjectsInScope": "Validation Cache (in CN4S)",
   "meaning": "SAP to CN4S Material Master Validation: Before creating Work Orders, CN4S validates SAP Material Master data completeness.",
   "purpose": "Delivers 'Data Integrity' (Supply Chain). Missing data is reported to SAP team.",
   "functionPrimary": "Move/transform Material Master → Validation Cache (BiSync, Event-driven).",
   "subFunctions": [
    "Validation Rules",
    "Alerting Test"
   ],
   "architecture": "SAP S/4HANA --[SAP RFC → CN4S]--> CN4S --> CN4S. Pattern: BiSync integration, Event trigger. Complexity 2/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 6,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "15 mandatory fields defined",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"Material Master\" mapping",
    "\"Validation Cache\" configuration",
    "CN4S",
    "Validation",
    "MaterialMaster",
    "DataQuality"
   ],
   "taskHours": 6,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-030",
  "seq": 30,
  "mvp": 2,
  "phase": 6,
  "grp": "EDGE",
  "type": "Push",
  "freq": "RT",
  "name": "IED to Hub Device Health",
  "from": "Industrial Edge Device",
  "to": "Insights Hub",
  "mid": "MQTT + IEM",
  "protocol": "MQTT/TLS",
  "bo": "Device Health Metrics → Hub Dashboard",
  "complexity": 2,
  "effort": 4,
  "risk": 2,
  "team": "OT + Cloud",
  "outcome": "Edge Infrastructure Reliability",
  "outcomeCat": "Asset Management",
  "deps": [
   "IF-021"
  ],
  "about": "Edge Devices report health metrics (CPU, memory, disk, OPC-UA status) to Hub for remote monitoring and proactive maintenance.",
  "tags": [
   "DeviceHealth",
   "Monitoring",
   "IED"
  ],
  "triggers": [
   {
    "id": "TRG-030-01",
    "name": "Health Heartbeat",
    "type": "STATE_CHANGE",
    "source": "Industrial Edge Device",
    "sourceEvent": "Periodic health check (60s)",
    "condition": "Device online",
    "latency": "< 60 seconds",
    "description": "IED sends health metrics to Hub for fleet monitoring.",
    "recommendedMapping": [
     {
      "src": "IED.DeviceID",
      "dst": "Hub.DeviceID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Device identifier"
     },
     {
      "src": "IED.CPU_Usage",
      "dst": "Hub.CPU_Usage",
      "xform": "Direct",
      "mandatory": true,
      "note": "CPU percentage"
     },
     {
      "src": "IED.OPCUA_Status",
      "dst": "Hub.OPCUA_Status",
      "xform": "Direct",
      "mandatory": true,
      "note": "Connected/Disconnected"
     }
    ],
    "configSteps": [
     "Configure IED to publish health metrics",
     "Set up IEM to aggregate health",
     "Configure Hub dashboard",
     "Set up alerts for degradation"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T030a",
    "name": "Health Monitoring",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Health agent installed",
     "Metrics published to MQTT",
     "Dashboard shows status",
     "Alerts for CPU >80%",
     "Alerts for OPC-UA disconnect"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the MQTT + IEM configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Health Monitoring'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Health Monitoring'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T030b",
    "name": "Remote Diagnostics",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Remote log retrieval",
     "Remote restart capability",
     "30-day retention",
     "Weekly report",
     "Proactive replacement"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Remote Diagnostics'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "IED.DeviceID",
    "dst": "Hub.DeviceID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "IED.CPU_Usage",
    "dst": "Hub.CPU_Usage",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "IED.OPCUA_Status",
    "dst": "Hub.OPCUA_Status",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "IED Health API",
    "method": "GET",
    "url": "https://{ied-ip}:8443/health",
    "prereq": [
     "IED online",
     "Certificate"
    ],
    "purpose": "Get health status",
    "sample": "{ \"status\":\"healthy\",\"cpu\":45,\"opcua\":\"connected\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Device Health Metrics (in Industrial Edge Device); related: DeviceHealth, Monitoring, IED",
   "destinationBusinessObjectsInScope": "Hub Dashboard (in Insights Hub)",
   "meaning": "IED to Hub Device Health: Edge Devices report health metrics (CPU, memory, disk, OPC-UA status) to Hub for remote monitoring and proactive maintenance.",
   "purpose": "Delivers 'Edge Infrastructure Reliability' (Asset Management). ",
   "functionPrimary": "Move/transform Device Health Metrics → Hub Dashboard (Push, RT-driven).",
   "subFunctions": [
    "Health Monitoring",
    "Remote Diagnostics"
   ],
   "architecture": "Industrial Edge Device --[MQTT/TLS]--> MQTT + IEM --> Insights Hub. Pattern: Push integration, RT trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: MQTT + IEM. INTRA-OT: harmonises shop-floor machine signal into the digital thread.",
   "interfacePattern": "Push · RT",
   "systemOfRecord": "The machine/Edge is source of truth for the raw signal; target aggregates it.",
   "idempotencyStrategy": "Telemetry keyed by machine+timestamp; at-least-once with dedup window at the Edge.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM. OT/IT segmentation + OPC-UA SignAndEncrypt.",
   "monitoringSignals": "Metrics: edge_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-021"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Health agent installed",
   "docSearchKeywords": [
    "Industrial Edge IEM-IED + OPC-UA / MQTT connectivity",
    "\"Device Health Metrics\" mapping",
    "\"Hub Dashboard\" configuration",
    "MQTT + IEM",
    "DeviceHealth",
    "Monitoring",
    "IED"
   ],
   "taskHours": 6,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-031",
  "seq": 31,
  "mvp": 1,
  "phase": 8,
  "grp": "QUAL",
  "type": "Push",
  "freq": "Event",
  "name": "LIMS to Opcenter Lab Results",
  "from": "Laboratory LIMS",
  "to": "Opcenter 2601",
  "mid": "REST + ASTM",
  "protocol": "ASTM E1381/E1394",
  "bo": "Lab Test Results → DataCollection",
  "complexity": 3,
  "effort": 7,
  "risk": 3,
  "team": "Quality + LIMS + MES",
  "outcome": "Material Certification",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-010",
   "IF-025"
  ],
  "about": "Laboratory test results (metallurgy, chemical, hardness) automatically populate Opcenter and trigger SAP QM decisions. Critical for NACE compliance.",
  "tags": [
   "LIMS",
   "Laboratory",
   "NACE",
   "ASTM"
  ],
  "triggers": [
   {
    "id": "TRG-031-01",
    "name": "LIMS Result Release",
    "type": "COMPLETE",
    "source": "LIMS",
    "sourceEvent": "Test result → Released",
    "condition": "Associated with production order",
    "latency": "< 1 minute",
    "description": "When lab results are released, sent to Opcenter and SAP QM.",
    "recommendedMapping": [
     {
      "src": "LIMS.MaterialBatch",
      "dst": "Opcenter.Container.Batch",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material batch"
     },
     {
      "src": "LIMS.TestParameter",
      "dst": "Opcenter.DC.CharName",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Test name"
     },
     {
      "src": "LIMS.MeasuredValue",
      "dst": "Opcenter.DC.Value",
      "xform": "Direct",
      "mandatory": true,
      "note": "Result"
     }
    ],
    "configSteps": [
     "Configure LIMS to export ASTM format",
     "Set up Opcenter ASTM parser",
     "Configure NACE hardness thresholds",
     "Test end-to-end to SAP QM"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T031a",
    "name": "LIMS ASTM Config",
    "type": "Configure",
    "hours": 5,
    "cx": 3,
    "dod": [
     "LIMS exports ASTM format",
     "Parser reads fields",
     "NACE hardness parsed",
     "Tensile parsed",
     "Chemistry parsed"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the REST + ASTM configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'LIMS ASTM Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'LIMS ASTM Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T031b",
    "name": "Opcenter DataCollection",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "DC spec created",
     "NACE hardness mapped",
     "USL=22 configured",
     "QC hold triggers",
     "COC stored"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the REST + ASTM configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Opcenter DataCollection'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Opcenter DataCollection'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T031c",
    "name": "SAP QM Integration",
    "type": "Validate",
    "hours": 4,
    "cx": 3,
    "dod": [
     "Results in QA32 <2 min",
     "Failed triggers notification",
     "Batch blocked",
     "Passed auto-release",
     "Audit trail complete"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'SAP QM Integration'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "LIMS.MaterialBatch",
    "dst": "Opcenter.Container.Batch",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "LIMS.TestParameter",
    "dst": "Opcenter.DC.CharName",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "LIMS.MeasuredValue",
    "dst": "Opcenter.DC.Value",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "ASTM E1381 Parser",
    "method": "TCP",
    "url": "TCP Port 3000",
    "prereq": [
     "LIMS configured",
     "Listener active"
    ],
    "purpose": "Receive lab results",
    "sample": "H|^&|||LIMS|||202503011200\rP|1|BATCH-001|||Hardness\rR|1|18.5|HRC"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Lab Test Results (in Laboratory LIMS); related: LIMS, Laboratory, NACE",
   "destinationBusinessObjectsInScope": "DataCollection (in Opcenter 2601)",
   "meaning": "LIMS to Opcenter Lab Results: Laboratory test results (metallurgy, chemical, hardness) automatically populate Opcenter and trigger SAP QM decisions.",
   "purpose": "Delivers 'Material Certification' (Quality Assurance). Critical for NACE compliance.",
   "functionPrimary": "Move/transform Lab Test Results → DataCollection (Push, Event-driven).",
   "subFunctions": [
    "LIMS ASTM Config",
    "Opcenter DataCollection",
    "SAP QM Integration"
   ],
   "architecture": "Laboratory LIMS --[ASTM E1381/E1394]--> REST + ASTM --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: REST + ASTM. INTER-system (quality loop): harmonises quality data across MES/ERP/PLM.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Source system owns the object; target holds a projection.",
   "idempotencyStrategy": "Inspection lot/result keyed by lot number; replay-safe upsert.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: qual_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-010",
    "IF-025"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 6,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "LIMS exports ASTM format",
   "docSearchKeywords": [
    "Opcenter Quality / Q-DAS AQDEF integration",
    "\"Lab Test Results\" mapping",
    "\"DataCollection\" configuration",
    "REST + ASTM",
    "LIMS",
    "Laboratory",
    "NACE",
    "ASTM"
   ],
   "taskHours": 13,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-032",
  "seq": 32,
  "mvp": 2,
  "phase": 7,
  "grp": "AIG",
  "type": "BiSync",
  "freq": "Event",
  "name": "TC to SAP Digital Thread Traceability",
  "from": "Teamcenter 2512",
  "to": "SAP S/4HANA",
  "mid": "AIG",
  "protocol": "TC Requirements → SAP DMS",
  "bo": "Requirements → Document Management",
  "complexity": 3,
  "effort": 6,
  "risk": 2,
  "team": "PLM + ERP",
  "outcome": "Requirement Traceability",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-012"
  ],
  "about": "Trace requirements from TC through manufacturing to quality results in SAP. Critical for NACE, API, ASME compliance audits.",
  "tags": [
   "DigitalThread",
   "Requirements",
   "Traceability"
  ],
  "triggers": [
   {
    "id": "TRG-032-01",
    "name": "Requirement Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Requirement → Released",
    "condition": "Linked to BOM/BOP",
    "latency": "< 1 hour",
    "description": "When requirement is released, traceability link sent to SAP.",
    "recommendedMapping": [
     {
      "src": "TC.Requirement.ID",
      "dst": "SAP.Document.DocNumber",
      "xform": "Direct",
      "mandatory": true,
      "note": "Requirement ID"
     },
     {
      "src": "TC.Requirement.Text",
      "dst": "SAP.Document.Description",
      "xform": "Direct",
      "mandatory": true,
      "note": "Text"
     },
     {
      "src": "TC.Requirement.LinkedItems",
      "dst": "SAP.Document.ObjectLinks",
      "xform": "Array",
      "mandatory": true,
      "note": "Links"
     }
    ],
    "configSteps": [
     "Configure TC Requirement Management",
     "Set up AIG to sync to SAP DMS",
     "Configure audit dashboard",
     "Test NACE requirement traceability"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T032a",
    "name": "TC Requirements",
    "type": "Configure",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Types created: Customer, Regulatory",
     "Traceability matrix functional",
     "Impact analysis works",
     "Coverage 100%"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Requirements'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Requirements'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T032b",
    "name": "SAP DMS Integration",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "DMS types created",
     "Linked to material masters",
     "Order shows requirements",
     "Quality verifies",
     "Audit report available"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP DMS Integration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP DMS Integration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.Requirement.ID",
    "dst": "SAP.Document.DocNumber",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.Requirement.Text",
    "dst": "SAP.Document.Description",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_DOCUMENT_CREATE2",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "SAP DMS configured"
    ],
    "purpose": "Create requirement doc",
    "sample": "CALL FUNCTION 'BAPI_DOCUMENT_CREATE2' EXPORTING DOCUMENTDATA = ls_doc"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Requirements (in Teamcenter 2512); related: DigitalThread, Requirements, Traceability",
   "destinationBusinessObjectsInScope": "Document Management (in SAP S/4HANA)",
   "meaning": "TC to SAP Digital Thread Traceability: Trace requirements from TC through manufacturing to quality results in SAP.",
   "purpose": "Delivers 'Requirement Traceability' (Quality Assurance). Critical for NACE, API, ASME compliance audits.",
   "functionPrimary": "Move/transform Requirements → Document Management (BiSync, Event-driven).",
   "subFunctions": [
    "TC Requirements",
    "SAP DMS Integration"
   ],
   "architecture": "Teamcenter 2512 --[TC Requirements → SAP DMS]--> AIG --> SAP S/4HANA. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-012"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Types created: Customer, Regulatory",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"Requirements\" mapping",
    "\"Document Management\" configuration",
    "AIG",
    "DigitalThread",
    "Requirements",
    "Traceability"
   ],
   "taskHours": 9,
   "classificationSummary": {
    "ootb": 0,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-033",
  "seq": 33,
  "mvp": 1,
  "phase": 5,
  "grp": "SFC",
  "type": "Push",
  "freq": "Event",
  "name": "SFC to SAP Operator Labor Time",
  "from": "SFC Terminal",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "SFC REST → CN4S → SAP CATS",
  "bo": "Operator Records → CATS",
  "complexity": 2,
  "effort": 5,
  "risk": 2,
  "team": "Shop Floor + ERP",
  "outcome": "Labor Costing",
  "outcomeCat": "Financial Accuracy",
  "deps": [
   "IF-007",
   "IF-009"
  ],
  "about": "Direct operator time recording from SFC to SAP CATS for payroll and cost accounting. Eliminates manual time sheets.",
  "tags": [
   "Labor",
   "CATS",
   "Payroll"
  ],
  "triggers": [
   {
    "id": "TRG-033-01",
    "name": "Step Start",
    "type": "STATE_CHANGE",
    "source": "SFC Terminal",
    "sourceEvent": "Operator starts step",
    "condition": "Requires operator",
    "latency": "< 5 seconds",
    "description": "When operator starts step, time recording begins in SAP CATS.",
    "recommendedMapping": [
     {
      "src": "SFC.OperatorID",
      "dst": "CATS.EmployeeNumber",
      "xform": "Badge map",
      "mandatory": true,
      "note": "Operator"
     },
     {
      "src": "SFC.StartTime",
      "dst": "CATS.StartDate",
      "xform": "ISO",
      "mandatory": true,
      "note": "Start time"
     },
     {
      "src": "SFC.WorkOrder",
      "dst": "CATS.OrderNumber",
      "xform": "Direct",
      "mandatory": true,
      "note": "Order"
     }
    ],
    "configSteps": [
     "Configure SAP CATS for production",
     "Set up badge to employee mapping",
     "Configure CN4S to send events",
     "Test time recording accuracy"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T033a",
    "name": "SAP CATS Config",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "CATS enabled",
     "Activity types mapped",
     "Cost center assigned",
     "Approval workflow",
     "Payroll interface confirmed"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP CATS Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP CATS Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T033b",
    "name": "Badge Mapping",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "All operators mapped",
     "Default cost center",
     "Multiple operators supported",
     "Supervisor override",
     "Unauthorized denied"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Badge Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Badge Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T033c",
    "name": "Accuracy Test",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Time accuracy ±5 seconds",
     "Breaks deducted",
     "Overtime flagged",
     "Payroll matches 100%",
     "Corrections logged"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Accuracy Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SFC.OperatorID",
    "dst": "CATS.EmployeeNumber",
    "xform": "Badge map",
    "category": "core"
   },
   {
    "src": "SFC.StartTime",
    "dst": "CATS.StartDate",
    "xform": "ISO",
    "category": "core"
   },
   {
    "src": "SFC.WorkOrder",
    "dst": "CATS.OrderNumber",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_CATIMESHEETMGR_CREATEMULTI",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "CATS active",
     "Employee valid"
    ],
    "purpose": "Record labor time",
    "sample": "CALL FUNCTION 'BAPI_CATIMESHEETMGR_CREATEMULTI' TABLES CATSDATA = lt_timesheet"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Operator Records (in SFC Terminal); related: Labor, CATS, Payroll",
   "destinationBusinessObjectsInScope": "CATS (in SAP S/4HANA)",
   "meaning": "SFC to SAP Operator Labor Time: Direct operator time recording from SFC to SAP CATS for payroll and cost accounting.",
   "purpose": "Delivers 'Labor Costing' (Financial Accuracy). Eliminates manual time sheets.",
   "functionPrimary": "Move/transform Operator Records → CATS (Push, Event-driven).",
   "subFunctions": [
    "SAP CATS Config",
    "Badge Mapping",
    "Accuracy Test"
   ],
   "architecture": "SFC Terminal --[SFC REST → CN4S → SAP CATS]--> CN4S --> SAP S/4HANA. Pattern: Push integration, Event trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTRA-shop-floor: harmonises content surfacing to the operator workplace.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Source system owns the object; target holds a projection.",
   "idempotencyStrategy": "Read-mostly surfacing; uploads keyed by container+step.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: sfc_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007",
    "IF-009"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "MEDIUM — workplace surfacing reusable; station layout varies by line.",
   "keyAcceptanceSignal": "CATS enabled",
   "docSearchKeywords": [
    "Opcenter Execution Shop Floor Connect / Active Workspace embed",
    "\"Operator Records\" mapping",
    "\"CATS\" configuration",
    "CN4S",
    "Labor",
    "CATS",
    "Payroll"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 3
   }
  }
 },
 {
  "id": "IF-034",
  "seq": 34,
  "mvp": 2,
  "phase": 3,
  "grp": "CN4S",
  "type": "Push",
  "freq": "Batch (Daily)",
  "name": "Opcenter to SAP Inventory Cycle Count",
  "from": "Opcenter 2601",
  "to": "SAP S/4HANA",
  "mid": "CN4S",
  "protocol": "Opcenter REST → CN4S → SAP BAPI",
  "bo": "Cycle Count → Inventory Adjustment",
  "complexity": 2,
  "effort": 4,
  "risk": 2,
  "team": "MES + ERP",
  "outcome": "Inventory Accuracy",
  "outcomeCat": "Material Control",
  "deps": [
   "IF-002",
   "IF-008"
  ],
  "about": "Cycle count results from Opcenter sent to SAP for inventory adjustment. Enables continuous inventory accuracy without physical counts.",
  "tags": [
   "CycleCount",
   "Inventory",
   "Reconciliation"
  ],
  "triggers": [
   {
    "id": "TRG-034-01",
    "name": "Cycle Count Complete",
    "type": "COMPLETE",
    "source": "Opcenter 2601",
    "sourceEvent": "Cycle count reconciled",
    "condition": "Count completed by supervisor",
    "latency": "< 5 minutes",
    "description": "When cycle count completed, inventory adjustment sent to SAP.",
    "recommendedMapping": [
     {
      "src": "Opcenter.CountedQty",
      "dst": "SAP.PhysicalInventory.Qty",
      "xform": "Direct",
      "mandatory": true,
      "note": "Actual count"
     },
     {
      "src": "Opcenter.ExpectedQty",
      "dst": "SAP.PhysicalInventory.BookQty",
      "xform": "Direct",
      "mandatory": true,
      "note": "System quantity"
     },
     {
      "src": "Opcenter.MaterialNumber",
      "dst": "SAP.PhysicalInventory.Material",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material"
     }
    ],
    "configSteps": [
     "Configure Opcenter cycle count process",
     "Set up SAP physical inventory doc",
     "Map storage bins to locations",
     "Test daily reconciliation"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T034a",
    "name": "Cycle Count Config",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Frequency by ABC class",
     "Schedules configured",
     "Bins mapped",
     "Approval workflow"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4S configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Cycle Count Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Cycle Count Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T034b",
    "name": "SAP Adjustment Test",
    "type": "Validate",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Doc created <5 min",
     "Positive variance increases stock",
     "Negative triggers loss",
     "Variance >5% requires approval",
     "Daily report shows counts"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'SAP Adjustment Test'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Opcenter.CountedQty",
    "dst": "SAP.PhysicalInventory.Qty",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.ExpectedQty",
    "dst": "SAP.PhysicalInventory.BookQty",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "BAPI_PHYSINV_CREATE",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Cycle count profile",
     "Storage location"
    ],
    "purpose": "Create inventory doc",
    "sample": "CALL FUNCTION 'BAPI_PHYSINV_CREATE' EXPORTING MATERIAL = 'BV-3IN' QUANTITY = 95"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Cycle Count (in Opcenter 2601); related: CycleCount, Inventory, Reconciliation",
   "destinationBusinessObjectsInScope": "Inventory Adjustment (in SAP S/4HANA)",
   "meaning": "Opcenter to SAP Inventory Cycle Count: Cycle count results from Opcenter sent to SAP for inventory adjustment.",
   "purpose": "Delivers 'Inventory Accuracy' (Material Control). Enables continuous inventory accuracy without physical counts.",
   "functionPrimary": "Move/transform Cycle Count → Inventory Adjustment (Push, Batch (Daily)-driven).",
   "subFunctions": [
    "Cycle Count Config",
    "SAP Adjustment Test"
   ],
   "architecture": "Opcenter 2601 --[Opcenter REST → CN4S → SAP BAPI]--> CN4S --> SAP S/4HANA. Pattern: Push integration, Batch (Daily) trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4S. INTER-system (MES↔ERP): harmonises Opcenter execution with SAP commercial/logistics.",
   "interfacePattern": "Push · Batch (Daily)",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via document/order reference key; SAP doc number stored in cross-ref; replay-safe.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4s_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-002",
    "IF-008"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Frequency by ABC class",
   "docSearchKeywords": [
    "SAP-Opcenter Connector (CN4S) Integration Guide",
    "\"Cycle Count\" mapping",
    "\"Inventory Adjustment\" configuration",
    "CN4S",
    "CycleCount",
    "Inventory",
    "Reconciliation"
   ],
   "taskHours": 7,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-035",
  "seq": 35,
  "mvp": 2,
  "phase": 5,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "TC to Opcenter Tooling Life Tracking",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC SOA → CN4T → Opcenter REST",
  "bo": "Tooling Definition → Life Tracking",
  "complexity": 3,
  "effort": 5,
  "risk": 3,
  "team": "PLM + MES + Maintenance",
  "outcome": "Predictive Tool Replacement",
  "outcomeCat": "Asset Management",
  "deps": [
   "IF-006"
  ],
  "about": "Tooling life limits from TC pushed to Opcenter. Opcenter tracks actual usage and triggers maintenance at 90% life.",
  "tags": [
   "Tooling",
   "ToolLife",
   "PredictiveMaintenance"
  ],
  "triggers": [
   {
    "id": "TRG-035-01",
    "name": "Tool Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Tooling revision released",
    "condition": "Life limits defined",
    "latency": "< 30 seconds",
    "description": "When tooling master released, life limits sent to Opcenter.",
    "recommendedMapping": [
     {
      "src": "TC.ToolID",
      "dst": "Opcenter.Tool.ResourceID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Tool ID"
     },
     {
      "src": "TC.ToolLife_LimitParts",
      "dst": "Opcenter.Tool.MaxParts",
      "xform": "Direct",
      "mandatory": true,
      "note": "Parts limit"
     },
     {
      "src": "TC.ToolLife_LimitHours",
      "dst": "Opcenter.Tool.MaxHours",
      "xform": "Direct",
      "mandatory": true,
      "note": "Hours limit"
     }
    ],
    "configSteps": [
     "Define tool life attributes in TC",
     "Configure CN4T tooling sync",
     "Set up Opcenter tracking counters",
     "Test 90% life alert"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T035a",
    "name": "TC Tool Life Attributes",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "MaxParts, MaxHours created",
     "Classification defined",
     "Tracking enabled",
     "Change workflow defined"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Tool Life Attributes'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Tool Life Attributes'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T035b",
    "name": "Opcenter Tracking",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Resources created",
     "Counters initialized",
     "Parts increment counter",
     "90% → yellow alert",
     "100% → red alert, stop",
     "Changes logged"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Opcenter Tracking'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Opcenter Tracking'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.ToolID",
    "dst": "Opcenter.Tool.ResourceID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ToolLife_LimitParts",
    "dst": "Opcenter.Tool.MaxParts",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST - Tool",
    "method": "POST",
    "url": "/opcenter/api/v1/tools",
    "prereq": [
     "Tool type exists",
     "ResourceGroup exists"
    ],
    "purpose": "Create tool resource",
    "sample": "{ \"ToolID\":\"ENDMILL-12MM\",\"MaxParts\":5000,\"ToolType\":\"EndMill\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Tooling Definition (in Teamcenter 2512); related: Tooling, ToolLife, PredictiveMaintenance",
   "destinationBusinessObjectsInScope": "Life Tracking (in Opcenter 2601)",
   "meaning": "TC to Opcenter Tooling Life Tracking: Tooling life limits from TC pushed to Opcenter.",
   "purpose": "Delivers 'Predictive Tool Replacement' (Asset Management). Opcenter tracks actual usage and triggers maintenance at 90% life.",
   "functionPrimary": "Move/transform Tooling Definition → Life Tracking (Push, Event-driven).",
   "subFunctions": [
    "TC Tool Life Attributes",
    "Opcenter Tracking"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → CN4T → Opcenter REST]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-006"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "MaxParts, MaxHours created",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"Tooling Definition\" mapping",
    "\"Life Tracking\" configuration",
    "CN4T 2510",
    "Tooling",
    "ToolLife",
    "PredictiveMaintenance"
   ],
   "taskHours": 7,
   "classificationSummary": {
    "ootb": 0,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-036",
  "seq": 36,
  "mvp": 3,
  "phase": 7,
  "grp": "HUB",
  "type": "Push",
  "freq": "Batch (Weekly)",
  "name": "Hub to Opcenter Predictive Quality",
  "from": "Insights Hub",
  "to": "Opcenter 2601",
  "mid": "REST + MQTT",
  "protocol": "ML Model Export → Opcenter Service",
  "bo": "Trained Models → Real-time Inference",
  "complexity": 4,
  "effort": 8,
  "risk": 3,
  "team": "Cloud + MES + Quality",
  "outcome": "AI-Powered Quality",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-010",
   "IF-022",
   "IF-025"
  ],
  "about": "ML models trained in Hub deployed to Opcenter for real-time quality prediction at each step.",
  "tags": [
   "PredictiveQuality",
   "ML",
   "RealTime"
  ],
  "triggers": [
   {
    "id": "TRG-036-01",
    "name": "Model Retraining Complete",
    "type": "STATE_CHANGE",
    "source": "Insights Hub",
    "sourceEvent": "ML model retrained",
    "condition": "Accuracy improved >2%",
    "latency": "< 24 hours",
    "description": "When Hub retrains quality model, updated model deployed to Opcenter.",
    "recommendedMapping": [
     {
      "src": "Hub.ModelID",
      "dst": "Opcenter.ModelID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Model ID"
     },
     {
      "src": "Hub.ModelWeights",
      "dst": "Opcenter.Inference",
      "xform": "Binary",
      "mandatory": true,
      "note": "Weights"
     },
     {
      "src": "Hub.FeaturesList",
      "dst": "Opcenter.InputFeatures",
      "xform": "JSON",
      "mandatory": true,
      "note": "Features"
     }
    ],
    "configSteps": [
     "Train quality model with 6+ months data",
     "Configure model export to Opcenter",
     "Set up A/B testing",
     "Test real-time prediction"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T036a",
    "name": "Hub Model Training",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Model trained on 1000+ defects",
     "Features: spindle load, temp, operator",
     "Precision ≥90%, recall ≥85%",
     "Retrained weekly",
     "Version history"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the REST + MQTT configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Hub Model Training'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Hub Model Training'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T036b",
    "name": "Opcenter Inference",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Inference at each step",
     "Latency <100ms",
     "Prediction displayed",
     "High-risk flagged",
     "False positive <5%",
     "Drift detection"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Opcenter Inference'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Hub.ModelID",
    "dst": "Opcenter.ModelID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Hub.ModelWeights",
    "dst": "Opcenter.Inference",
    "xform": "Binary",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Hub Model Export API",
    "method": "GET",
    "url": "https://gateway.mindsphere.io/api/ml/v3/models/{modelId}/export",
    "prereq": [
     "Model trained",
     "Export permission"
    ],
    "purpose": "Export ML model",
    "sample": "{ \"modelFormat\":\"ONNX\",\"weights\":\"base64encoded\" }"
   }
  ],
  "enhanced": {
   "moscow": "Could Have",
   "sourceBusinessObjectsInScope": "Trained Models (in Insights Hub); related: PredictiveQuality, ML, RealTime",
   "destinationBusinessObjectsInScope": "Real-time Inference (in Opcenter 2601)",
   "meaning": "Hub to Opcenter Predictive Quality: ML models trained in Hub deployed to Opcenter for real-time quality prediction at each step.",
   "purpose": "Delivers 'AI-Powered Quality' (Quality Assurance). ",
   "functionPrimary": "Move/transform Trained Models → Real-time Inference (Push, Batch (Weekly)-driven).",
   "subFunctions": [
    "Hub Model Training",
    "Opcenter Inference"
   ],
   "architecture": "Insights Hub --[ML Model Export → Opcenter Service]--> REST + MQTT --> Opcenter 2601. Pattern: Push integration, Batch (Weekly) trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: REST + MQTT. INTER-system (field↔enterprise): harmonises field telemetry with engineering/analytics.",
   "interfacePattern": "Push · Batch (Weekly)",
   "systemOfRecord": "Insights Hub is the authority for field/operating data; target receives feedback.",
   "idempotencyStrategy": "Asset+timestamp keyed; idempotent upsert on the asset model.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: hub_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-010",
    "IF-022",
    "IF-025"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Model trained on 1000+ defects",
   "docSearchKeywords": [
    "Insights Hub (MindSphere) Asset Model + connectivity",
    "\"Trained Models\" mapping",
    "\"Real-time Inference\" configuration",
    "REST + MQTT",
    "PredictiveQuality",
    "ML",
    "RealTime"
   ],
   "taskHours": 11,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-037",
  "seq": 37,
  "mvp": 3,
  "phase": 8,
  "grp": "AIG",
  "type": "Push",
  "freq": "Batch (Weekly)",
  "name": "SAP to TC Supplier Quality Scorecard",
  "from": "SAP S/4HANA",
  "to": "Teamcenter 2512",
  "mid": "AIG",
  "protocol": "SAP QM → AIG → TC",
  "bo": "Supplier Defects → Scorecard",
  "complexity": 3,
  "effort": 5,
  "risk": 2,
  "team": "ERP + PLM + Quality",
  "outcome": "Supplier Management",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-011",
   "IF-012"
  ],
  "about": "Supplier quality data from SAP sent to TC. Engineering sees supplier performance when designing new products.",
  "tags": [
   "SupplierQuality",
   "Scorecard",
   "PPM"
  ],
  "triggers": [
   {
    "id": "TRG-037-01",
    "name": "Scorecard Update",
    "type": "STATE_CHANGE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Monthly scorecard calculated",
    "condition": "Supplier has PO history",
    "latency": "< 24 hours",
    "description": "Monthly supplier quality scorecard sent to TC.",
    "recommendedMapping": [
     {
      "src": "SAP.SupplierNumber",
      "dst": "TC.Supplier.ID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Supplier ID"
     },
     {
      "src": "SAP.DefectRate_PPM",
      "dst": "TC.Supplier.PPM",
      "xform": "Direct",
      "mandatory": true,
      "note": "Defects per million"
     },
     {
      "src": "SAP.QualityScore",
      "dst": "TC.Supplier.QualityScore",
      "xform": "1-100",
      "mandatory": true,
      "note": "Quality score"
     }
    ],
    "configSteps": [
     "Configure SAP scorecard calculation",
     "Set up AIG weekly extraction",
     "Display in TC Supplier Management",
     "Alert for PPM > target"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T037a",
    "name": "SAP Scorecard",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "PPM calculated monthly",
     "OTD tracked",
     "Rating method defined",
     "Data in QS41"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Scorecard'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Scorecard'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T037b",
    "name": "TC Display",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Shows current score",
     "12-month trend",
     "PPM >5000 flagged red",
     "Engineering sees quality",
     "Monthly report emailed"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Display'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Display'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP.SupplierNumber",
    "dst": "TC.Supplier.ID",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.DefectRate_PPM",
    "dst": "TC.Supplier.PPM",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "QM_SCORECARD_GET",
    "method": "RFC",
    "url": "SAP RFC",
    "prereq": [
     "Scorecard configured",
     "Data exists"
    ],
    "purpose": "Get supplier scorecard",
    "sample": "CALL FUNCTION 'QM_SCORECARD_GET' EXPORTING SUPPLIER = '100001' PERIOD = '202503'"
   }
  ],
  "enhanced": {
   "moscow": "Could Have",
   "sourceBusinessObjectsInScope": "Supplier Defects (in SAP S/4HANA); related: SupplierQuality, Scorecard, PPM",
   "destinationBusinessObjectsInScope": "Scorecard (in Teamcenter 2512)",
   "meaning": "SAP to TC Supplier Quality Scorecard: Supplier quality data from SAP sent to TC.",
   "purpose": "Delivers 'Supplier Management' (Quality Assurance). Engineering sees supplier performance when designing new products.",
   "functionPrimary": "Move/transform Supplier Defects → Scorecard (Push, Batch (Weekly)-driven).",
   "subFunctions": [
    "SAP Scorecard",
    "TC Display"
   ],
   "architecture": "SAP S/4HANA --[SAP QM → AIG → TC]--> AIG --> Teamcenter 2512. Pattern: Push integration, Batch (Weekly) trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Push · Batch (Weekly)",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-011",
    "IF-012"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 3,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "PPM calculated monthly",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"Supplier Defects\" mapping",
    "\"Scorecard\" configuration",
    "AIG",
    "SupplierQuality",
    "Scorecard",
    "PPM"
   ],
   "taskHours": 7,
   "classificationSummary": {
    "ootb": 0,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-038",
  "seq": 38,
  "mvp": 2,
  "phase": 6,
  "grp": "EDGE",
  "type": "Push",
  "freq": "RT",
  "name": "IIoT Sensors to Edge Environmental",
  "from": "Environmental Sensors",
  "to": "Industrial Edge",
  "mid": "MQTT",
  "protocol": "Wireless Sensor → MQTT",
  "bo": "Sensor Data → Edge Aggregation",
  "complexity": 3,
  "effort": 6,
  "risk": 3,
  "team": "OT + Quality",
  "outcome": "Environmental Compliance",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-021"
  ],
  "about": "Environmental sensors (temperature, humidity, vibration, particle count) monitoring critical conditions for clean rooms and temperature-sensitive processes.",
  "tags": [
   "IIoT",
   "Environmental",
   "CleanRoom",
   "Temperature"
  ],
  "triggers": [
   {
    "id": "TRG-038-01",
    "name": "Sensor Reading",
    "type": "STATE_CHANGE",
    "source": "IIoT Sensor",
    "sourceEvent": "Value change",
    "condition": "Within configured range",
    "latency": "< 1 second",
    "description": "Continuous monitoring of environmental conditions.",
    "recommendedMapping": [
     {
      "src": "Sensor.Temperature_C",
      "dst": "Edge.Env.Temperature",
      "xform": "Direct",
      "mandatory": true,
      "note": "Temperature"
     },
     {
      "src": "Sensor.Humidity_Pct",
      "dst": "Edge.Env.Humidity",
      "xform": "Direct",
      "mandatory": true,
      "note": "Humidity"
     },
     {
      "src": "Sensor.ParticleCount",
      "dst": "Edge.Env.Particles",
      "xform": "ISO 14644",
      "mandatory": true,
      "note": "Cleanliness"
     }
    ],
    "configSteps": [
     "Deploy environmental sensors",
     "Configure MQTT gateway",
     "Set up alert thresholds",
     "Create compliance dashboard"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T038a",
    "name": "Sensor Deployment",
    "type": "Install",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Temp sensors installed (±0.5°C)",
     "Humidity sensors (±3% RH)",
     "Vibration sensors (±0.1mm/s²)",
     "Particle counters calibrated",
     "Connected to MQTT"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the MQTT component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Environmental Sensors and Industrial Edge",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T038b",
    "name": "Alerting & Reporting",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Temp out of spec → hold",
     "Humidity >60% → yellow, >70% → red",
     "Vibration >1.0 → stop",
     "Particles exceed → stop",
     "Weekly compliance report",
     "30-day trends"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Alerting & Reporting'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Sensor.Temperature_C",
    "dst": "Edge.Env.Temperature",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Sensor.Humidity_Pct",
    "dst": "Edge.Env.Humidity",
    "xform": "Direct",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "MQTT Sensor Ingest",
    "method": "MQTT",
    "url": "mqtts://edge-broker:8883",
    "prereq": [
     "MQTT client",
     "TLS cert"
    ],
    "purpose": "Ingest sensor data",
    "sample": "sensors/assembly_01/temperature { value:22.5, unit:'C' }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Sensor Data (in Environmental Sensors); related: IIoT, Environmental, CleanRoom",
   "destinationBusinessObjectsInScope": "Edge Aggregation (in Industrial Edge)",
   "meaning": "IIoT Sensors to Edge Environmental: Environmental sensors (temperature, humidity, vibration, particle count) monitoring critical conditions for clean rooms and temperature-sensitive processes.",
   "purpose": "Delivers 'Environmental Compliance' (Quality Assurance). ",
   "functionPrimary": "Move/transform Sensor Data → Edge Aggregation (Push, RT-driven).",
   "subFunctions": [
    "Sensor Deployment",
    "Alerting & Reporting"
   ],
   "architecture": "Environmental Sensors --[Wireless Sensor → MQTT]--> MQTT --> Industrial Edge. Pattern: Push integration, RT trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: MQTT. INTRA-OT: harmonises shop-floor machine signal into the digital thread.",
   "interfacePattern": "Push · RT",
   "systemOfRecord": "Source system owns the object; target holds a projection.",
   "idempotencyStrategy": "Telemetry keyed by machine+timestamp; at-least-once with dedup window at the Edge.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM. OT/IT segmentation + OPC-UA SignAndEncrypt.",
   "monitoringSignals": "Metrics: edge_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-021"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "MEDIUM-HIGH — signal/telemetry pattern reusable across asset classes.",
   "keyAcceptanceSignal": "Temp sensors installed (±0.5°C)",
   "docSearchKeywords": [
    "Industrial Edge IEM-IED + OPC-UA / MQTT connectivity",
    "\"Sensor Data\" mapping",
    "\"Edge Aggregation\" configuration",
    "MQTT",
    "IIoT",
    "Environmental",
    "CleanRoom",
    "Temperature"
   ],
   "taskHours": 10,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 0,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-039",
  "seq": 39,
  "mvp": 2,
  "phase": 8,
  "grp": "QUAL",
  "type": "Push",
  "freq": "Event",
  "name": "Vision System to Opcenter AOI Results",
  "from": "Machine Vision System",
  "to": "Opcenter 2601",
  "mid": "REST",
  "protocol": "Vision REST API",
  "bo": "AOI Inspection → DataCollection + Hold",
  "complexity": 3,
  "effort": 7,
  "risk": 3,
  "team": "Quality + MES",
  "outcome": "Zero-Defect Manufacturing",
  "outcomeCat": "Quality Assurance",
  "deps": [
   "IF-018",
   "IF-025"
  ],
  "about": "Automated Optical Inspection detects defects at key steps. Results automatically create Opcenter entries. Critical defects trigger immediate QC hold.",
  "tags": [
   "AOI",
   "Vision",
   "MachineVision",
   "DefectDetection"
  ],
  "triggers": [
   {
    "id": "TRG-039-01",
    "name": "AOI Complete",
    "type": "COMPLETE",
    "source": "Vision System",
    "sourceEvent": "Inspection cycle complete",
    "condition": "Part ID linked to order",
    "latency": "< 5 seconds",
    "description": "When AOI completes, results sent to Opcenter.",
    "recommendedMapping": [
     {
      "src": "AOI.PartSerial",
      "dst": "Opcenter.Container.Serial",
      "xform": "Direct",
      "mandatory": true,
      "note": "Part serial"
     },
     {
      "src": "AOI.PassFail",
      "dst": "Opcenter.DC.Result",
      "xform": "PASS/FAIL",
      "mandatory": true,
      "note": "Result"
     },
     {
      "src": "AOI.DefectType",
      "dst": "Opcenter.NCR.DefectCode",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Defect type"
     }
    ],
    "configSteps": [
     "Configure AOI export",
     "Set up Opcenter DC spec",
     "Configure defect classification",
     "Test critical defect hold"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T039a",
    "name": "AOI Config",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "AOI calibrated",
     "JSON export to REST",
     "Defects mapped",
     "False positive <1%",
     "Cycle time < takt"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AOI Config'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AOI Config'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T039b",
    "name": "Quality Integration",
    "type": "Validate",
    "hours": 5,
    "cx": 3,
    "dod": [
     "Results in DC <3s",
     "Critical defect → QC hold",
     "Non-critical → NCR",
     "Images attached",
     "Pareto chart weekly",
     "SPC tracks failure rate"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Quality Integration'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "AOI.PartSerial",
    "dst": "Opcenter.Container.Serial",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "AOI.PassFail",
    "dst": "Opcenter.DC.Result",
    "xform": "PASS/FAIL",
    "category": "core"
   },
   {
    "src": "AOI.DefectType",
    "dst": "Opcenter.NCR.DefectCode",
    "xform": "Lookup",
    "category": "quality"
   }
  ],
  "apis": [
   {
    "name": "AOI REST API",
    "method": "POST",
    "url": "http://vision-system:8080/api/v1/inspection",
    "prereq": [
     "AOI calibrated",
     "Part on fixture"
    ],
    "purpose": "Send AOI results",
    "sample": "{ \"serial\":\"SN-001\",\"result\":\"FAIL\",\"defectType\":\"MISSING_THREAD\" }"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "AOI Inspection (in Machine Vision System); related: AOI, Vision, MachineVision",
   "destinationBusinessObjectsInScope": "DataCollection + Hold (in Opcenter 2601)",
   "meaning": "Vision System to Opcenter AOI Results: Automated Optical Inspection detects defects at key steps.",
   "purpose": "Delivers 'Zero-Defect Manufacturing' (Quality Assurance). Results automatically create Opcenter entries.",
   "functionPrimary": "Move/transform AOI Inspection → DataCollection + Hold (Push, Event-driven).",
   "subFunctions": [
    "AOI Config",
    "Quality Integration"
   ],
   "architecture": "Machine Vision System --[Vision REST API]--> REST --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: REST. INTER-system (quality loop): harmonises quality data across MES/ERP/PLM.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "The machine/Edge is source of truth for the raw signal; target aggregates it.",
   "idempotencyStrategy": "Inspection lot/result keyed by lot number; replay-safe upsert.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: qual_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-018",
    "IF-025"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "AOI calibrated",
   "docSearchKeywords": [
    "Opcenter Quality / Q-DAS AQDEF integration",
    "\"AOI Inspection\" mapping",
    "\"DataCollection + Hold\" configuration",
    "REST",
    "AOI",
    "Vision",
    "MachineVision",
    "DefectDetection"
   ],
   "taskHours": 11,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-040",
  "seq": 40,
  "mvp": 3,
  "phase": 5,
  "grp": "CN4T",
  "type": "Push",
  "freq": "Event",
  "name": "TC to Opcenter Maintenance Work Orders",
  "from": "Teamcenter 2512",
  "to": "Opcenter 2601",
  "mid": "CN4T 2510",
  "protocol": "TC Maintenance → CN4T → Opcenter",
  "bo": "Maintenance Plan → Work Order",
  "complexity": 3,
  "effort": 5,
  "risk": 2,
  "team": "PLM + MES + Maintenance",
  "outcome": "Proactive Maintenance",
  "outcomeCat": "Asset Management",
  "deps": [
   "IF-006",
   "IF-023"
  ],
  "about": "Preventive maintenance plans from TC (calibration, PM intervals) sent to Opcenter. Creates work orders and locks resources during maintenance.",
  "tags": [
   "Maintenance",
   "PM",
   "Calibration"
  ],
  "triggers": [
   {
    "id": "TRG-040-01",
    "name": "Maintenance Plan Release",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Maintenance plan activated",
    "condition": "Plan linked to equipment",
    "latency": "< 1 minute",
    "description": "When maintenance plan released, Opcenter creates work orders.",
    "recommendedMapping": [
     {
      "src": "TC.MaintenancePlan.ID",
      "dst": "Opcenter.PlanRef",
      "xform": "Direct",
      "mandatory": true,
      "note": "Plan ID"
     },
     {
      "src": "TC.MaintenancePlan.Frequency",
      "dst": "Opcenter.Interval",
      "xform": "Days/Hours",
      "mandatory": true,
      "note": "Frequency"
     },
     {
      "src": "TC.Equipment.ID",
      "dst": "Opcenter.ResourceID",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Equipment"
     },
     {
      "src": "TC.MaintenanceTask",
      "dst": "Opcenter.Instructions",
      "xform": "Direct",
      "mandatory": true,
      "note": "Task description"
     }
    ],
    "configSteps": [
     "Create maintenance plans in TC",
     "Configure CN4T to sync plans",
     "Set up work order creation",
     "Test resource lock during maintenance"
    ]
   }
  ],
  "tasks": [
   {
    "id": "T040a",
    "name": "TC Maintenance Plans",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Plan types: Calibration, PM, Predictive",
     "Equipment linked",
     "Frequency set",
     "Tasks with instructions",
     "Spare parts attached"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the CN4T 2510 configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Maintenance Plans'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Maintenance Plans'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T040b",
    "name": "Opcenter Execution",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Work order created when due",
     "Resource locked",
     "Completion documented",
     "Certificates stored",
     "Missed alert",
     "History report"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Opcenter Execution'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.MaintenancePlan.ID",
    "dst": "Opcenter.PlanRef",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.MaintenancePlan.Frequency",
    "dst": "Opcenter.Interval",
    "xform": "Days/Hours",
    "category": "core"
   },
   {
    "src": "TC.Equipment.ID",
    "dst": "Opcenter.ResourceID",
    "xform": "Lookup",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST - Maintenance",
    "method": "POST",
    "url": "/opcenter/api/v1/maintenance/orders",
    "prereq": [
     "Resource exists",
     "Plan configured"
    ],
    "purpose": "Create maintenance order",
    "sample": "{ \"ResourceID\":\"PRESS-01\",\"Task\":\"Calibrate\",\"DueDate\":\"2025-03-15\",\"Priority\":\"HIGH\" }"
   }
  ],
  "enhanced": {
   "moscow": "Could Have",
   "sourceBusinessObjectsInScope": "Maintenance Plan (in Teamcenter 2512); related: Maintenance, PM, Calibration",
   "destinationBusinessObjectsInScope": "Work Order (in Opcenter 2601)",
   "meaning": "TC to Opcenter Maintenance Work Orders: Preventive maintenance plans from TC (calibration, PM intervals) sent to Opcenter.",
   "purpose": "Delivers 'Proactive Maintenance' (Asset Management). Creates work orders and locks resources during maintenance.",
   "functionPrimary": "Move/transform Maintenance Plan → Work Order (Push, Event-driven).",
   "subFunctions": [
    "TC Maintenance Plans",
    "Opcenter Execution"
   ],
   "architecture": "Teamcenter 2512 --[TC Maintenance → CN4T → Opcenter]--> CN4T 2510 --> Opcenter 2601. Pattern: Push integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: CN4T 2510. INTER-system (PLM↔MES): harmonises Teamcenter engineering intent with Opcenter execution.",
   "interfacePattern": "Push · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via ExternalKey = TC IUID; delta by content-hash; soft-delete only.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: cn4t_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-006",
    "IF-023"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 3,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Plan types: Calibration, PM, Predictive",
   "docSearchKeywords": [
    "Teamcenter Gateway for SIMATIC IT / CN4T 2510 Configuration Guide",
    "\"Maintenance Plan\" mapping",
    "\"Work Order\" configuration",
    "CN4T 2510",
    "Maintenance",
    "PM",
    "Calibration"
   ],
   "taskHours": 8,
   "classificationSummary": {
    "ootb": 1,
    "ootbConfig": 1,
    "customization": 0,
    "totalTasks": 2
   }
  }
 },
 {
  "id": "IF-041",
  "seq": 41,
  "mvp": 2,
  "phase": 3,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "TC Item Pre-Approval Request to SAP",
  "from": "Teamcenter 2512",
  "to": "SAP S/4HANA",
  "mid": "AIG Gateway",
  "protocol": "TC SOA → AIG → SAP BAPI_MATERIAL_SAVEDATA",
  "bo": "TC Item (draft) → SAP Material (status KA / Blocked for Approval)",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "PLM + ERP + AIG",
  "outcome": "Governed material introduction with cross-system approval",
  "outcomeCat": "Master Data Governance",
  "deps": [
   "IF-012"
  ],
  "about": "Phase 1 of the two-phase Item/Material approval handshake. TC engineer initiates Item release; TC EPM workflow pauses on a 'SAP Approval' task that calls this interface. AIG creates the SAP Material in blocked status KA carrying a TC-generated correlation ID. Material is invisible to MRP/procurement until SAP-side workflow approves it, at which point IF-042 returns the verdict and enriched attributes to TC.",
  "tags": [
   "Item",
   "Material",
   "Approval",
   "PreApproval",
   "AIG",
   "BAPI",
   "Governance",
   "TwoPhase"
  ],
  "triggers": [
   {
    "id": "TRG-041-01",
    "name": "TC Item Approval Submission",
    "type": "STATE_CHANGE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Item.release_status → 'Pending SAP Approval'",
    "condition": "EPM workflow task 'SAP-Material-Approval' reached",
    "latency": "< 30 seconds",
    "description": "When an engineer submits a TC Item for cross-system approval, the TC EPM workflow fires a SOA handler that publishes an Item shell (basic identification, engineering data, UOM, classification) to AIG. AIG transforms and calls BAPI_MATERIAL_SAVEDATA with MARA-MSTAE='KA' to create the SAP Material in blocked-for-all-usage status. The SAP material number, the TC item_id, and a workflow correlation ID are stored in the AIG correlation table so the IF-042 callback can match the approval verdict back.",
    "technicalDetails": {
     "protocol": "TC SOA TCCS v14 (SOAP) → AIG → SAP RFC",
     "bapi": "BAPI_MATERIAL_SAVEDATA",
     "messageFormat": "AIG IDoc envelope wrapping MATMAS BAPI structure",
     "authentication": "Mutual TLS (TC↔AIG); SAP RFC user with S_RFC + Z_AIG_MAT_CREATE",
     "sapMaterialStatus": "KA (Blocked for all functions until approval)",
     "correlationIdFormat": "${tc_item_id}::${tc_workflow_instance_id}::${epoch_ms}",
     "idempotencyKey": "correlation_id (AIG persists; duplicate submissions return cached SAP material number)"
    },
    "preConditions": [
     "TC EPM workflow template includes 'SAP-Material-Approval' EPM task",
     "TC user has TC_Submit_For_Approval role",
     "AIG correlation persistence (DB or Redis) configured with TTL ≥ approval window",
     "SAP material number range configured (internal vs. external assignment decision made)",
     "SAP material types (FERT/HALB/ROH/HAWA) have status profile that supports KA → 01 transition",
     "SAP RFC service user provisioned with required S_TCODE + S_RFC authorizations"
    ],
    "context": "Critical governance interface for greenfield material introduction. Prevents engineering from inadvertently triggering procurement/planning before commercial attributes (costing, MRP, valuation, profit center) are reviewed. Especially important in regulated industries and any environment with strict cost-center discipline.",
    "prerequisites": {
     "teamcenter": [
      "EPM workflow template 'TC_Item_With_SAP_Approval'",
      "Custom EPM handler 'IF-041-Outbound-Handler' deployed",
      "Item release_status LOV extended to include 'Pending SAP Approval'",
      "tc_workflow_correlation_id property on Item"
     ],
     "aig": [
      "Correlation persistence layer (recommend AIG-supplied DB)",
      "Field mapping 'TC-Item-to-SAP-MARA' configured",
      "Inbound SOA listener + outbound RFC channel",
      "DLQ + retry policy for transient SAP failures"
     ],
     "sap": [
      "Material types configured with status profile Z_MAT_APPROVAL (KA → 01)",
      "Custom field MARA-ZZ_TC_CORRELATION_ID via append structure",
      "Business workflow WS_Z_MAT_APPROVE configured (triggered by IF-041 inbound)",
      "Approver roles assigned (Materials Manager, Costing Owner, Plant Lead)"
     ]
    },
    "sla": {
     "latency": "TC submission to SAP material visible in MM03: < 30 seconds",
     "availability": "99.5% during business hours",
     "correlation": "100% (no SAP material may be created without correlation ID)",
     "retryPolicy": "Exponential backoff 5s, 30s, 2m, 10m; after 4 failures route to DLQ + email originator"
    },
    "errorHandling": {
     "sapDuplicateMaterial": "MARA exists with same material number → AIG reads correlation_id; if matches, treat as idempotent success; if differs, return error to TC with both correlation IDs for resolution",
     "sapValidationFail": "BAPI returns MARA_VALIDATION error (e.g., invalid material type) → AIG returns structured error to TC; TC workflow returns to engineer with error text and remains in 'Draft'",
     "aigUnavailable": "TC SOA call fails → TC workflow remains in 'Submitted' state; TC operator can manually retry from Active Workflow inbox; alarm to AIG support after 15min",
     "correlationCollision": "Should be impossible given correlation ID format includes epoch_ms; if detected, log P1 incident"
    },
    "monitoring": {
     "metrics": [
      "if041_submissions_total",
      "if041_sap_material_create_latency_seconds",
      "if041_failures_by_type{error_type}",
      "if041_pending_approvals_gauge (materials sitting in KA > 7 days)"
     ],
     "alerts": [
      "Pending approval >7 days → weekly digest email to originator + Materials Manager",
      "Failure rate >5% over 1h → PagerDuty AIG on-call",
      "AIG DLQ depth >10 → Slack #clm-integration-alerts"
     ],
     "dashboards": [
      "Grafana 'CLM/Approvals' showing submissions, in-flight, average TAT, rejects"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 end-to-end; SAP RFC over SNC (Secure Network Communication)",
     "authentication": "TC user identity propagated via AIG audit log; SAP RFC service account scoped to BAPI_MATERIAL_SAVEDATA only",
     "authorization": "TC role TC_Submit_For_Approval required; SAP role Z_AIG_MAT_CREATE",
     "auditLog": "Every submission persisted: tc_user, tc_item_id, correlation_id, sap_material_no, timestamp, payload_hash",
     "dataClassification": "Material master data: confidential (cost-sensitive attributes excluded from outbound payload — SAP enriches)"
    },
    "rollback": {
     "steps": [
      "Identify SAP material number from correlation table",
      "Call BAPI_MATERIAL_DELETE (only valid if material in KA and never released to MRP)",
      "Mark correlation as 'cancelled' in AIG",
      "Notify TC: workflow returns to 'Draft', engineer can resubmit"
     ],
     "estimatedTime": "5 minutes per material (operator-initiated)",
     "dataLoss": "None — TC Item retains all original data; SAP material can be recreated"
    },
    "recommendedMapping": [
     {
      "src": "Item.item_id",
      "dst": "MARA-MATNR",
      "xform": "Direct (or SAP-generated if internal numbering)",
      "mandatory": true,
      "note": "Material number"
     },
     {
      "src": "Item.object_name",
      "dst": "MAKT-MAKTX",
      "xform": "Truncate to 40 chars",
      "mandatory": true,
      "note": "Material description (language EN)"
     },
     {
      "src": "Item.object_type",
      "dst": "MARA-MTART",
      "xform": "Lookup table Z_TC_TYPE_TO_MTART",
      "mandatory": true,
      "note": "Material type FERT/HALB/ROH/HAWA"
     },
     {
      "src": "Item.uom",
      "dst": "MARA-MEINS",
      "xform": "ISO UOM → SAP UOM code (lookup T006)",
      "mandatory": true,
      "note": "Base unit of measure"
     },
     {
      "src": "Item.classification",
      "dst": "MARA-MATKL",
      "xform": "Lookup Z_CLASS_TO_MATKL",
      "mandatory": true,
      "note": "Material group"
     },
     {
      "src": "Item.gross_weight",
      "dst": "MARA-BRGEW",
      "xform": "Unit conversion (kg)",
      "mandatory": false,
      "note": "Gross weight if available"
     },
     {
      "src": "Item.weight_uom",
      "dst": "MARA-GEWEI",
      "xform": "Direct",
      "mandatory": false,
      "note": "Weight unit"
     },
     {
      "src": "AIG.constant",
      "dst": "MARA-MSTAE",
      "xform": "Constant 'KA'",
      "mandatory": true,
      "note": "Blocked status — gating attribute"
     },
     {
      "src": "AIG.correlation_id",
      "dst": "MARA-ZZ_TC_CORRELATION_ID",
      "xform": "Direct",
      "mandatory": true,
      "note": "Custom Z-field for callback match"
     },
     {
      "src": "Item.last_mod_user",
      "dst": "MARA-ERNAM",
      "xform": "TC user → SAP user mapping",
      "mandatory": true,
      "note": "Created by (audit)"
     }
    ],
    "configSteps": [
     "Define TC EPM workflow template with 'SAP-Material-Approval' EPM task",
     "Deploy IF-041-Outbound-Handler SOA service to TC",
     "Extend Item LOV: add 'Pending SAP Approval' to release_status",
     "Add property tc_workflow_correlation_id to Item",
     "Configure AIG inbound SOA endpoint and outbound SAP RFC channel",
     "Build AIG mapping 'TC-Item-to-SAP-MARA'",
     "Configure AIG correlation persistence (TTL 30 days)",
     "Add custom field MARA-ZZ_TC_CORRELATION_ID via append structure ZAMARA",
     "Configure SAP status profile Z_MAT_APPROVAL: KA → 01 transition allowed only by Z_APPROVER role",
     "Configure SAP business workflow WS_Z_MAT_APPROVE (triggered when material created in KA)",
     "Implement DLQ with manual replay UI in AIG admin console",
     "Build Grafana dashboard 'CLM/Approvals'",
     "Smoke test: submit 5 test materials; verify all reach SAP in KA within 30s",
     "Negative test: submit invalid material type; verify TC workflow returns to engineer with error",
     "Load test: 100 concurrent submissions; verify no correlation collisions"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "TC → AIG → SAP (synchronous BAPI call with async TC workflow wait)",
   "correlationStrategy": "Stable correlation ID stored on both sides; AIG owns the lookup table",
   "consistency": "Eventually consistent — SAP material exists in KA before TC EPM task moves forward",
   "failureSemantics": "At-most-once at the BAPI layer; idempotent retry via correlation key"
  },
  "implementationOrder": [
   "Phase 1: Design status profile, correlation ID format, error taxonomy",
   "Phase 2: SAP-side (append structure, status profile, business workflow)",
   "Phase 3: AIG configuration and mapping",
   "Phase 4: TC EPM workflow template and SOA handler",
   "Phase 5: End-to-end integration test in QA",
   "Phase 6: UAT with Materials Manager and lead engineer",
   "Phase 7: Production cutover with rollback plan rehearsed"
  ],
  "tasks": [
   {
    "id": "T041a",
    "name": "Status Profile + Append Structure (SAP)",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Z_MAT_APPROVAL status profile created (KA → 01 transition)",
     "Append structure ZAMARA with ZZ_TC_CORRELATION_ID added to MARA",
     "Material types FERT/HALB linked to Z_MAT_APPROVAL",
     "Z_APPROVER role can change MARA-MSTAE; standard users cannot",
     "MM03 displays correlation_id on Basic Data 1 screen"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Status Profile + Append Structure (SAP)'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Status Profile + Append Structure (SAP)'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T041b",
    "name": "SAP Business Workflow WS_Z_MAT_APPROVE",
    "type": "Configure",
    "hours": 12,
    "cx": 4,
    "dod": [
     "Workflow triggered automatically on material creation with MSTAE='KA'",
     "Approver determination rule: by material type → role-resolved agent",
     "Approver UBox displays material + TC-supplied attributes + commercial enrichment fields",
     "Approval routes through Materials Manager → Costing → Plant Lead (configurable)",
     "On approve: MARA-MSTAE set to '01' AND IF-042 outbound triggered",
     "On reject: MARA-MSTAE set to 'Z9' (rejected) AND IF-042 outbound triggered with reject reason",
     "Workflow log retained for 7 years per audit policy"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Business Workflow WS_Z_MAT_APPROVE'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Business Workflow WS_Z_MAT_APPROVE'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T041c",
    "name": "AIG Outbound Channel + Mapping",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "SOA inbound endpoint /aig/if041/submit returns 202 Accepted within 2s",
     "Mapping 'TC-Item-to-SAP-MARA' covers all 10 recommended fields",
     "Correlation table persists ≥ 30 days",
     "BAPI_MATERIAL_SAVEDATA invoked with TYPE=COMMIT-WORK",
     "Errors routed to DLQ with full payload + SAP return message",
     "Health endpoint /aig/if041/health returns status of dependencies"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Outbound Channel + Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Outbound Channel + Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T041d",
    "name": "TC EPM Workflow + SOA Handler",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "EPM template 'TC_Item_With_SAP_Approval' deployable to any Item type",
     "EPM task 'SAP-Material-Approval' generates correlation ID on entry",
     "SOA handler IF-041-Outbound-Handler retries up to 3x on AIG 5xx",
     "Workflow pauses indefinitely waiting for IF-042 callback",
     "Workflow displays 'Pending SAP Approval since {timestamp}' in inbox",
     "Cancel-submission button reverts to Draft (admin-only)"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC EPM Workflow + SOA Handler'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC EPM Workflow + SOA Handler'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T041e",
    "name": "Integration + Negative Tests",
    "type": "Test",
    "hours": 10,
    "cx": 4,
    "dod": [
     "Happy path: submit → SAP material visible in KA within 30s (10/10 runs)",
     "Idempotent: duplicate submission returns same SAP material no, no second create",
     "SAP-side rejection: invalid material type rejected; TC workflow returns to engineer",
     "AIG outage: TC retry queue holds; recovery on AIG restore",
     "SAP outage: AIG DLQ holds; recovery on SAP restore",
     "Concurrent load: 100 simultaneous submissions, 0 correlation collisions",
     "End-to-end with IF-042: approval cycle completes < 5 min in QA"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration + Negative Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→SAP S/4HANA)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at SAP S/4HANA"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T041f",
    "name": "UAT + Cutover Rehearsal",
    "type": "Validate",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Materials Manager runs 3 real approval scenarios with sign-off",
     "Rollback procedure executed in QA: material reversed within 5 min",
     "Approval TAT measured: average < 4h business time (target)",
     "Audit log review: all required fields captured",
     "Cutover runbook approved by IT Change Advisory Board"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Cutover Rehearsal'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Item.item_id",
    "dst": "MARA-MATNR",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Item.object_name",
    "dst": "MAKT-MAKTX",
    "xform": "Truncate 40 chars",
    "category": "core"
   },
   {
    "src": "Item.object_type",
    "dst": "MARA-MTART",
    "xform": "Lookup Z_TC_TYPE_TO_MTART",
    "category": "core"
   },
   {
    "src": "Item.uom",
    "dst": "MARA-MEINS",
    "xform": "Lookup T006",
    "category": "core"
   },
   {
    "src": "Item.classification",
    "dst": "MARA-MATKL",
    "xform": "Lookup Z_CLASS_TO_MATKL",
    "category": "core"
   },
   {
    "src": "Item.gross_weight",
    "dst": "MARA-BRGEW",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.weight_uom",
    "dst": "MARA-GEWEI",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Item.net_weight",
    "dst": "MARA-NTGEW",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.volume",
    "dst": "MARA-VOLUM",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.volume_uom",
    "dst": "MARA-VOLEH",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Item.dimension_length",
    "dst": "MARA-LAENG",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.dimension_width",
    "dst": "MARA-BREIT",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.dimension_height",
    "dst": "MARA-HOEHE",
    "xform": "Unit conversion",
    "category": "additional"
   },
   {
    "src": "Item.dim_uom",
    "dst": "MARA-MEABM",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Item.industry_sector",
    "dst": "MARA-MBRSH",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "AIG.constant",
    "dst": "MARA-MSTAE",
    "xform": "Constant 'KA'",
    "category": "core"
   },
   {
    "src": "AIG.correlation_id",
    "dst": "MARA-ZZ_TC_CORRELATION_ID",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "Item.last_mod_user",
    "dst": "MARA-ERNAM",
    "xform": "TC user → SAP user",
    "category": "audit"
   },
   {
    "src": "Item.creation_date",
    "dst": "MARA-ERSDA",
    "xform": "Date format YYYYMMDD",
    "category": "audit"
   },
   {
    "src": "Item.eccn",
    "dst": "MARA-EXPME",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Item.hazmat_class",
    "dst": "MARA-PROFL",
    "xform": "Lookup Z_HAZMAT",
    "category": "additional"
   },
   {
    "src": "Item.country_of_origin",
    "dst": "MARC-HERKL",
    "xform": "ISO 3166",
    "category": "additional"
   },
   {
    "src": "Item.environmental_class",
    "dst": "MARA-ZZ_ENV_CLASS",
    "xform": "Direct (custom Z-field)",
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "TC SOA — Item Workflow SOA Handler",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Workflow-2010-09-WorkflowTask/performAction",
    "prereq": [
     "SOA session",
     "TC_Submit_For_Approval role",
     "EPM task instance"
    ],
    "purpose": "Engineer submits Item for SAP approval; triggers IF-041 outbound",
    "sample": "<actionName>Submit-To-SAP</actionName><taskUid>...</taskUid>",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "AIG Inbound — Pre-Approval Submission",
    "method": "POST",
    "url": "https://aig-host/aig/if041/submit",
    "prereq": [
     "Mutual TLS",
     "AIG correlation persistence available"
    ],
    "purpose": "Receive TC submission; create SAP material in KA; return correlation ID",
    "sample": "{ \"tc_item_id\":\"BV-3IN-001\", \"workflow_id\":\"WF-12345\", \"payload\":{...} }",
    "rateLimit": "50 req/sec",
    "timeout": "60s"
   },
   {
    "name": "SAP BAPI_MATERIAL_SAVEDATA",
    "method": "RFC",
    "url": "SAP RFC connection (SNC)",
    "prereq": [
     "Material type configured",
     "Z_MAT_APPROVAL status profile linked",
     "ZAMARA append active"
    ],
    "purpose": "Create SAP material in blocked-for-approval status KA",
    "sample": "BAPI_MATERIAL_SAVEDATA( HEADDATA: { MATERIAL:'BV-3IN-001', IND_SECTOR:'M', MATL_TYPE:'FERT', BASIC_VIEW:'X' }, CLIENTDATA: { BASE_UOM:'EA', MATL_GROUP:'001', X_PLANT_MATL_STATUS:'KA' } )",
    "rateLimit": "10 req/sec (SAP dialog work process budget)",
    "timeout": "30s"
   },
   {
    "name": "AIG Correlation Lookup",
    "method": "GET",
    "url": "https://aig-host/aig/correlation/{correlation_id}",
    "prereq": [
     "AIG admin role"
    ],
    "purpose": "Operations: look up SAP material number from TC correlation ID",
    "sample": "GET /aig/correlation/BV-3IN-001%3A%3AWF-12345%3A%3A1731234567890",
    "rateLimit": "100 req/sec",
    "timeout": "5s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "TC Item (draft) (in Teamcenter 2512); related: Item, Material, Approval",
   "destinationBusinessObjectsInScope": "SAP Material (status KA / Blocked for Approval) (in SAP S/4HANA)",
   "meaning": "TC Item Pre-Approval Request to SAP: Phase 1 of the two-phase Item/Material approval handshake.",
   "purpose": "Delivers 'Governed material introduction with cross-system approval' (Master Data Governance). TC engineer initiates Item release; TC EPM workflow pauses on a 'SAP Approval' task that calls this interface.",
   "functionPrimary": "Move/transform TC Item (draft) → SAP Material (status KA / Blocked for Approval) (Sync, Event-driven).",
   "subFunctions": [
    "Status Profile + Append Structure (SAP)",
    "SAP Business Workflow WS_Z_MAT_APPROVE",
    "AIG Outbound Channel + Mapping",
    "TC EPM Workflow + SOA Handler",
    "Integration + Negative Tests",
    "UAT + Cutover Rehearsal"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → SAP BAPI_MATERIAL_SAVEDATA]--> AIG Gateway --> SAP S/4HANA. Pattern: Sync integration, Event trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-012"
   ],
   "downstreamConsumers": [
    "IF-042",
    "IF-064"
   ],
   "criticalityScore": 9,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Z_MAT_APPROVAL status profile created (KA → 01 transition)",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"TC Item (draft)\" mapping",
    "\"SAP Material (status KA / Blocked for Approval)\" configuration",
    "AIG Gateway",
    "Item",
    "Material",
    "Approval",
    "PreApproval"
   ],
   "taskHours": 50,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 4,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-042",
  "seq": 42,
  "mvp": 2,
  "phase": 3,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "SAP Material Approval Result to TC",
  "from": "SAP S/4HANA",
  "to": "Teamcenter 2512",
  "mid": "AIG Gateway",
  "protocol": "SAP Workflow → SAP RFC → AIG → TC SOA",
  "bo": "SAP Material Approval (verdict + enriched attrs) → TC Item state transition + ItemRevise",
  "complexity": 4,
  "effort": 9,
  "risk": 3,
  "team": "PLM + ERP + AIG",
  "outcome": "Closed-loop approval; revision rules enforced in TC after SAP enrichment",
  "outcomeCat": "Master Data Governance",
  "deps": [
   "IF-041"
  ],
  "about": "Phase 2 of the two-phase Item/Material approval handshake. SAP business workflow WS_Z_MAT_APPROVE completes; AIG receives the verdict via outbound RFC; AIG matches the correlation ID and invokes TC SOA to resume the paused EPM task. On APPROVE: TC auto- creates the ItemRevision (e.g., '-' → 'A'), records the SAP-enriched attributes, and the existing IF-012 fires to push the now-active Material Master back to SAP. On REJECT: the TC EPM task returns to the originator with the SAP reject reason. Critical to overall closed-loop integrity.",
  "tags": [
   "Approval",
   "Callback",
   "ItemRevise",
   "AIG",
   "BAPI",
   "Governance",
   "TwoPhase",
   "ClosedLoop"
  ],
  "triggers": [
   {
    "id": "TRG-042-01",
    "name": "SAP Material Approval Decision",
    "type": "APPROVE",
    "source": "SAP S/4HANA",
    "sourceEvent": "WS_Z_MAT_APPROVE workflow complete (verdict APPROVE or REJECT)",
    "condition": "MARA-MSTAE transitions KA → 01 (approve) or KA → Z9 (reject)",
    "latency": "< 60 seconds from SAP approver click to TC workflow advance",
    "description": "SAP business workflow WS_Z_MAT_APPROVE fires an outbound RFC to AIG when the final approver decides. AIG looks up the correlation ID, retrieves the original TC workflow instance, and calls a TC SOA service to either advance the EPM task (APPROVE) or return it to the originator (REJECT). On APPROVE, TC's post-approval logic automatically increments the Item to a new ItemRevision, populates the SAP-enriched attributes onto the new revision, and the existing IF-012 trigger fires to push the now-fully-active Material Master (MSTAE='01') back to SAP with the matched revision.",
    "technicalDetails": {
     "protocol": "SAP RFC → AIG → TC SOA TCCS v14 (SOAP)",
     "sapWorkflowMethod": "Z_MAT_APPROVAL_CALLBACK (custom workflow method)",
     "messageFormat": "AIG IDoc envelope; TC SOA performAction",
     "authentication": "SNC (SAP↔AIG); Mutual TLS (AIG↔TC)",
     "idempotencyKey": "correlation_id + verdict (replays produce no second revision)",
     "revisionStrategy": "TC auto-revise via Item Revise SOA (Item-2008-06-DataManagement)"
    },
    "preConditions": [
     "IF-041 successfully created the SAP material with correlation ID",
     "SAP workflow WS_Z_MAT_APPROVE configured and active",
     "AIG correlation entry still in TTL window (default 30 days)",
     "TC EPM task still in 'Pending SAP Approval' state (not cancelled by engineer)",
     "TC SOA service IF-042-Callback-Handler deployed",
     "TC revision naming rule defined (e.g., '-' → 'A', 'A' → 'B')"
    ],
    "context": "Closes the approval loop. Without this, materials would sit in SAP KA indefinitely and TC engineers would have no closure. The revision auto-bump preserves the engineering intent that a 'released' Item is always an ItemRevision, not a working Item. SAP- enriched attributes (valuation class, MRP type, profit center) flow onto the new revision so that IF-012's downstream sync carries the full picture.",
    "prerequisites": {
     "sap": [
      "WS_Z_MAT_APPROVE workflow with outbound RFC step on completion",
      "Custom workflow method Z_MAT_APPROVAL_CALLBACK on workflow container",
      "RFC destination AIG_CALLBACK configured with retry parameters",
      "SAP user/role permissions to update MARA-MSTAE"
     ],
     "aig": [
      "Inbound RFC listener for Z_MAT_APPROVAL_CALLBACK",
      "Correlation lookup against IF-041 persistence",
      "Outbound TC SOA channel with mutual TLS",
      "Mapping 'SAP-Approval-Result-to-TC'",
      "DLQ for TC SOA failures (TC outage scenario)"
     ],
     "teamcenter": [
      "SOA service IF-042-Callback-Handler",
      "TC EPM workflow handler 'Resume-On-SAP-Approval'",
      "Item Revise rule template Z_TC_Revise_Post_Approval",
      "Custom Item properties to store SAP-enriched attributes"
     ]
    },
    "sla": {
     "latency": "Approver click to TC workflow advance: < 60 seconds",
     "availability": "99.5%",
     "callbackGuarantee": "At-least-once delivery; TC idempotent on correlation_id + verdict",
     "rejectHandling": "100% of REJECT verdicts must return to TC originator within SLA"
    },
    "errorHandling": {
     "correlationNotFound": "AIG cannot locate correlation_id (TC workflow cancelled or correlation TTL expired) → log P2 incident, alert AIG ops, hold SAP material in KA pending manual resolution",
     "tcSoaFailure": "TC unavailable → AIG DLQ with retry policy (5s, 30s, 5m, 30m, 2h, 8h); after 8h escalate to PagerDuty",
     "revisionRuleViolation": "TC rejects revise call (e.g., Item already at max revision) → AIG returns error to SAP workflow; manual intervention required",
     "duplicateCallback": "Same correlation_id received twice → AIG returns 200 OK to SAP but skips TC call; idempotency preserved",
     "partialApproval": "Should not occur (workflow gives binary outcome) — if detected, treat as REJECT and route to originator"
    },
    "monitoring": {
     "metrics": [
      "if042_callbacks_total{verdict}",
      "if042_callback_latency_seconds",
      "if042_correlation_miss_total",
      "if042_revision_create_failures",
      "if042_approval_tat_hours (end-to-end IF-041 submission to IF-042 callback)"
     ],
     "alerts": [
      "Correlation miss → immediate PagerDuty AIG on-call",
      "TC SOA failure rate >2% over 1h → Slack #clm-integration-alerts",
      "Approval TAT P95 > 5 business days → weekly digest to Materials Manager"
     ],
     "dashboards": [
      "Grafana 'CLM/Approvals' (shared with IF-041)"
     ]
    },
    "security": {
     "encryption": "SNC (SAP↔AIG); TLS 1.3 (AIG↔TC)",
     "authentication": "RFC user scoped to single callback; TC service account scoped to Workflow + Item Revise",
     "authorization": "TC IF-042-Callback-Handler can only operate on Items with matching correlation_id",
     "auditLog": "verdict, approver_sap_user, sap_material_no, tc_item_id, new_revision_id, timestamp, enriched_attrs_diff",
     "dataClassification": "Approval verdicts: audit-grade; retain 7 years"
    },
    "rollback": {
     "steps": [
      "Identify TC ItemRevision created by callback (correlation_id property)",
      "If no downstream consumers: TC Revoke Release + delete revision",
      "If downstream consumers exist (Opcenter, etc.): create new revision with corrective data instead",
      "Update SAP material MSTAE back to KA (re-block); manual approver follow-up",
      "Mark correlation as 'rolled_back' in AIG"
     ],
     "estimatedTime": "10–30 minutes depending on downstream consumer state",
     "dataLoss": "Engineering intent preserved on TC; SAP enrichment captured in audit log"
    },
    "recommendedMapping": [
     {
      "src": "SAP.workflow.verdict",
      "dst": "TC.EPM.task.decision",
      "xform": "APPROVE → 'Approve'; REJECT → 'Reject'",
      "mandatory": true,
      "note": "Binary outcome"
     },
     {
      "src": "SAP.MARA-MSTAE",
      "dst": "AIG.validation.expected_status",
      "xform": "Must be '01' for APPROVE, 'Z9' for REJECT",
      "mandatory": true,
      "note": "Sanity check"
     },
     {
      "src": "SAP.workflow.approver",
      "dst": "TC.Item.zz_sap_approver",
      "xform": "SAP user → SAP user (recorded as-is)",
      "mandatory": true,
      "note": "Audit attribution"
     },
     {
      "src": "SAP.workflow.approval_timestamp",
      "dst": "TC.Item.zz_sap_approved_at",
      "xform": "SAP datetime → ISO 8601",
      "mandatory": true,
      "note": "Audit timestamp"
     },
     {
      "src": "SAP.workflow.reject_reason",
      "dst": "TC.EPM.task.comment",
      "xform": "Direct (used only on REJECT)",
      "mandatory": false,
      "note": "Reject reason text"
     },
     {
      "src": "SAP.MBEW-BKLAS",
      "dst": "TC.ItemRev.zz_valuation_class",
      "xform": "Direct",
      "mandatory": false,
      "note": "Valuation class (APPROVE only)"
     },
     {
      "src": "SAP.MARC-DISMM",
      "dst": "TC.ItemRev.zz_mrp_type",
      "xform": "Direct",
      "mandatory": false,
      "note": "MRP type (APPROVE only)"
     },
     {
      "src": "SAP.MARC-WERKS",
      "dst": "TC.ItemRev.zz_sap_plant",
      "xform": "Direct",
      "mandatory": false,
      "note": "Plant assignment (APPROVE only)"
     },
     {
      "src": "SAP.MARC-EKGRP",
      "dst": "TC.ItemRev.zz_purch_group",
      "xform": "Direct",
      "mandatory": false,
      "note": "Purchasing group (APPROVE only)"
     },
     {
      "src": "SAP.MARC-DISPO",
      "dst": "TC.ItemRev.zz_mrp_controller",
      "xform": "Direct",
      "mandatory": false,
      "note": "MRP controller (APPROVE only)"
     },
     {
      "src": "SAP.MBEW-VPRSV",
      "dst": "TC.ItemRev.zz_price_control",
      "xform": "Direct",
      "mandatory": false,
      "note": "Price control S/V (APPROVE only)"
     },
     {
      "src": "AIG.correlation_id",
      "dst": "TC.Item.tc_workflow_correlation_id",
      "xform": "Direct (verification)",
      "mandatory": true,
      "note": "Match lookup"
     }
    ],
    "configSteps": [
     "Build SAP workflow WS_Z_MAT_APPROVE with outbound RFC step (Z_MAT_APPROVAL_CALLBACK)",
     "Define workflow container fields: VERDICT, APPROVER, APPROVAL_TS, REJECT_REASON, MATERIAL_NO, CORRELATION_ID",
     "Configure RFC destination AIG_CALLBACK in SM59 with SNC",
     "Build AIG mapping 'SAP-Approval-Result-to-TC'",
     "Deploy IF-042-Callback-Handler SOA service to TC",
     "Configure TC EPM workflow handler 'Resume-On-SAP-Approval' to advance/reject EPM task",
     "Configure TC revision rule Z_TC_Revise_Post_Approval (e.g., '-' → 'A')",
     "Add custom properties zz_sap_approver, zz_sap_approved_at, zz_valuation_class, zz_mrp_type, zz_sap_plant on ItemRevision",
     "Wire TC post-revision hook to trigger IF-012 (Material Master full sync)",
     "Configure AIG idempotency table on (correlation_id, verdict)",
     "Implement DLQ replay UI in AIG admin console",
     "Smoke test: complete approval in SAP → TC revision created within 60s",
     "Negative test: reject in SAP → TC EPM task returns to originator with reason",
     "Negative test: replay same callback → no second revision created",
     "End-to-end test: IF-041 + IF-042 + IF-012 chain completes < 10 min in QA"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "SAP Workflow → SAP RFC outbound → AIG → TC SOA",
   "correlationStrategy": "Match by correlation_id from IF-041 persistence",
   "consistency": "Eventually consistent — TC revision created after SAP approval; IF-012 fires post-revision",
   "failureSemantics": "At-least-once at SAP → AIG; AIG enforces exactly-once on TC by (correlation_id, verdict)",
   "chainedTrigger": "On APPROVE, TC post-revision hook fires IF-012 (existing) to push full Material Master in active status"
  },
  "implementationOrder": [
   "Phase 1: Confirm correlation ID strategy with IF-041 team (shared design)",
   "Phase 2: SAP workflow with callback step (WS_Z_MAT_APPROVE)",
   "Phase 3: AIG inbound RFC + outbound TC SOA mapping",
   "Phase 4: TC SOA callback handler + revision rule + IF-012 chained trigger",
   "Phase 5: End-to-end chain test (IF-041 → SAP approve → IF-042 → IF-012)",
   "Phase 6: Reject-path UAT with Materials Manager and engineer roles",
   "Phase 7: Production cutover (paired with IF-041)"
  ],
  "tasks": [
   {
    "id": "T042a",
    "name": "SAP Workflow Callback Step",
    "type": "Configure",
    "hours": 10,
    "cx": 4,
    "dod": [
     "WS_Z_MAT_APPROVE configured with outbound RFC step",
     "Callback fires within 5s of approver click",
     "Reject reason captured in workflow container",
     "Audit log retains 7 years",
     "Workflow tested with 3 approver scenarios (single, multi-step, reject)"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Workflow Callback Step'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Workflow Callback Step'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T042b",
    "name": "AIG Callback Routing + Idempotency",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "RFC inbound listener Z_MAT_APPROVAL_CALLBACK active",
     "Correlation lookup against IF-041 store < 100ms",
     "Idempotency table prevents duplicate TC calls",
     "DLQ retains callbacks if TC down",
     "Replay UI in AIG admin console"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Callback Routing + Idempotency'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Callback Routing + Idempotency'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T042c",
    "name": "TC Revision Rule + Callback Handler",
    "type": "Configure",
    "hours": 10,
    "cx": 4,
    "dod": [
     "IF-042-Callback-Handler SOA deployed",
     "Revision rule Z_TC_Revise_Post_Approval auto-bumps '-' → 'A'",
     "SAP-enriched attrs landed on new revision",
     "EPM task advances on APPROVE, returns to originator on REJECT",
     "Custom properties (zz_sap_*) visible in TC AWC UI"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Development signal 'callback handler' implies bespoke build beyond supplied configuration.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify the bespoke logic for 'TC Revision Rule + Callback Handler'",
      "subSubTasks": [
       "Document why supplied config is insufficient",
       "Write the enhancement functional spec",
       "Obtain architecture-board approval"
      ]
     },
     {
      "step": 2,
      "title": "Develop using supplied extension hooks",
      "subSubTasks": [
       "Implement via BAdI/user-exit/callback (no core mod)",
       "Keep enhancement isolated + upgrade-safe",
       "Version the code in the repo"
      ]
     },
     {
      "step": 3,
      "title": "Review and test",
      "subSubTasks": [
       "Peer code review",
       "Unit test the logic",
       "Integration test against Teamcenter 2512"
      ]
     },
     {
      "step": 4,
      "title": "Promote with change advisory",
      "subSubTasks": [
       "Raise CHG flagging customization",
       "Document rollback",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T042d",
    "name": "Chained IF-012 Trigger",
    "type": "Configure",
    "hours": 4,
    "cx": 3,
    "dod": [
     "TC post-revision hook fires IF-012 outbound",
     "SAP material MSTAE confirmed '01' before IF-012 fires",
     "Full Material Master payload (TC + SAP-enriched fields) sent back to SAP",
     "No double-fire on replay"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Chained IF-012 Trigger'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Chained IF-012 Trigger'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T042e",
    "name": "End-to-End Chain Test",
    "type": "Test",
    "hours": 10,
    "cx": 4,
    "dod": [
     "IF-041 → SAP approve → IF-042 → IF-012 completes < 10 min in QA (5/5 runs)",
     "Reject path returns to originator with reason (3/3 runs)",
     "Replay callback: no duplicate revision (10/10 runs)",
     "Correlation TTL expiry: graceful failure with operator alert",
     "Audit log shows full chain with timestamps"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'End-to-End Chain Test'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (SAP S/4HANA→Teamcenter 2512)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Teamcenter 2512"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T042f",
    "name": "UAT + Production Cutover (paired with IF-041)",
    "type": "Validate",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Materials Manager + lead engineer sign off 5 real approval scenarios (approve + reject)",
     "Average end-to-end TAT measured (target < 8h business time)",
     "Rollback rehearsed (revoke revision; restore SAP KA)",
     "Cutover runbook approved by CAB",
     "Go-live with IF-041 (paired deployment)"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Production Cutover (paired with IF-041)'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP.workflow.verdict",
    "dst": "TC.EPM.task.decision",
    "xform": "Approve/Reject",
    "category": "core"
   },
   {
    "src": "SAP.MARA-MSTAE",
    "dst": "AIG.validation.expected_status",
    "xform": "Validation",
    "category": "core"
   },
   {
    "src": "SAP.workflow.approver",
    "dst": "TC.Item.zz_sap_approver",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SAP.workflow.approval_timestamp",
    "dst": "TC.Item.zz_sap_approved_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "SAP.workflow.approval_workflow_id",
    "dst": "TC.Item.zz_sap_workflow_id",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SAP.workflow.reject_reason",
    "dst": "TC.EPM.task.comment",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "AIG.correlation_id",
    "dst": "TC.Item.tc_workflow_correlation_id",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SAP.MBEW-BKLAS",
    "dst": "TC.ItemRev.zz_valuation_class",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MBEW-VPRSV",
    "dst": "TC.ItemRev.zz_price_control",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MBEW-STPRS",
    "dst": "TC.ItemRev.zz_standard_price",
    "xform": "Direct (sensitive — restrict TC visibility)",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-WERKS",
    "dst": "TC.ItemRev.zz_sap_plant",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-DISMM",
    "dst": "TC.ItemRev.zz_mrp_type",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-DISPO",
    "dst": "TC.ItemRev.zz_mrp_controller",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-EKGRP",
    "dst": "TC.ItemRev.zz_purch_group",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-BESKZ",
    "dst": "TC.ItemRev.zz_procurement_type",
    "xform": "Direct (E/F/X)",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-DZEIT",
    "dst": "TC.ItemRev.zz_inhouse_prod_time",
    "xform": "Days",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-PLIFZ",
    "dst": "TC.ItemRev.zz_planned_deliv_time",
    "xform": "Days",
    "category": "additional"
   },
   {
    "src": "SAP.MARC-LGORT",
    "dst": "TC.ItemRev.zz_storage_location",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARA-PRDHA",
    "dst": "TC.ItemRev.zz_product_hierarchy",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "SAP.MARC-PROFL",
    "dst": "TC.ItemRev.zz_serial_profile",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.MARA-LABOR",
    "dst": "TC.ItemRev.zz_lab_office",
    "xform": "Direct",
    "category": "metadata"
   }
  ],
  "apis": [
   {
    "name": "SAP Workflow Outbound — Z_MAT_APPROVAL_CALLBACK",
    "method": "RFC",
    "url": "RFC destination AIG_CALLBACK (SM59, SNC enabled)",
    "prereq": [
     "WS_Z_MAT_APPROVE active",
     "RFC user with S_RFC role"
    ],
    "purpose": "SAP workflow notifies AIG of approval verdict on completion",
    "sample": "CALL FUNCTION 'Z_MAT_APPROVAL_CALLBACK' DESTINATION 'AIG_CALLBACK' EXPORTING IV_VERDICT='APPROVE' IV_MATERIAL='BV-3IN-001' IV_CORRELATION='BV-3IN-001::WF-12345::1731234567890'",
    "rateLimit": "10 req/sec",
    "timeout": "30s"
   },
   {
    "name": "AIG Outbound — TC SOA Callback",
    "method": "POST",
    "url": "https://tc-host:4545/tc/services/Workflow-2010-09-WorkflowTask/performAction",
    "prereq": [
     "Mutual TLS",
     "TC service account configured"
    ],
    "purpose": "Advance or reject the TC EPM task based on SAP verdict",
    "sample": "<actionName>Approve</actionName><taskUid>...</taskUid><comments>SAP approval ID 12345</comments>",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "TC SOA — Item Revise (called by post-approval hook)",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Item-2008-06-DataManagement/reviseItems",
    "prereq": [
     "TC revision rule configured",
     "Item not at max revision"
    ],
    "purpose": "Auto-create the next ItemRevision after SAP approves",
    "sample": "<itemsAndDescs><items>...</items><deepCopyDatas>...</deepCopyDatas></itemsAndDescs>",
    "rateLimit": "10 req/sec",
    "timeout": "60s"
   },
   {
    "name": "AIG Inbound — SAP Callback Listener",
    "method": "RFC inbound",
    "url": "AIG RFC server (registered as program ID AIG_CALLBACK in SAP gateway)",
    "prereq": [
     "AIG RFC server running",
     "SAP gateway authorized"
    ],
    "purpose": "Receive verdict from SAP workflow; correlate; call TC",
    "sample": "RFC server function: Z_MAT_APPROVAL_CALLBACK (mirror of SAP outbound)",
    "rateLimit": "50 req/sec",
    "timeout": "60s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "SAP Material Approval (verdict + enriched attrs) (in SAP S/4HANA); related: Approval, Callback, ItemRevise",
   "destinationBusinessObjectsInScope": "TC Item state transition + ItemRevise (in Teamcenter 2512)",
   "meaning": "SAP Material Approval Result to TC: Phase 2 of the two-phase Item/Material approval handshake.",
   "purpose": "Delivers 'Closed-loop approval; revision rules enforced in TC after SAP enrichment' (Master Data Governance). SAP business workflow WS_Z_MAT_APPROVE completes; AIG receives the verdict via outbound RFC; AIG matches the correlation ID and invokes TC SOA to resume the paused EPM task.",
   "functionPrimary": "Move/transform SAP Material Approval (verdict + enriched attrs) → TC Item state transition + ItemRevise (Sync, Event-driven).",
   "subFunctions": [
    "SAP Workflow Callback Step",
    "AIG Callback Routing + Idempotency",
    "TC Revision Rule + Callback Handler",
    "Chained IF-012 Trigger",
    "End-to-End Chain Test",
    "UAT + Production Cutover (paired with IF-041)"
   ],
   "architecture": "SAP S/4HANA --[SAP Workflow → SAP RFC → AIG → TC SOA]--> AIG Gateway --> Teamcenter 2512. Pattern: Sync integration, Event trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-041"
   ],
   "downstreamConsumers": [
    "IF-064"
   ],
   "criticalityScore": 7,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "WS_Z_MAT_APPROVE configured with outbound RFC step",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"SAP Material Approval (verdict + enriched attrs)\" mapping",
    "\"TC Item state transition + ItemRevise\" configuration",
    "AIG Gateway",
    "Approval",
    "Callback",
    "ItemRevise",
    "AIG"
   ],
   "taskHours": 48,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 3,
    "customization": 1,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-043",
  "seq": 43,
  "mvp": 2,
  "phase": 2,
  "grp": "PLM",
  "type": "BiSync",
  "freq": "Event",
  "name": "Polarion Requirements to TC Item Requirement Link",
  "from": "Polarion ALM",
  "to": "Teamcenter 2512",
  "mid": "Polarion Connector for Teamcenter",
  "protocol": "Polarion REST API v1 → Polarion Connector → TC SOA TCCS v14",
  "bo": "Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink",
  "complexity": 3,
  "effort": 8,
  "risk": 2,
  "team": "Systems Engineering + PLM + ALM Admin",
  "outcome": "Requirement-to-design traceability for audit and impact analysis",
  "outcomeCat": "Engineering Governance",
  "deps": [],
  "about": "Connects Polarion ALM (where requirements are authored, versioned, and reviewed) with Teamcenter (where the engineering objects fulfilling those requirements live). On Polarion WorkItem approval, the requirement is published as a TC Requirement0Requirement object and linked to the satisfying TC Item via Trace0Trace links. Bidirectional: TC engineers can create coverage links from TC, and Polarion tracks coverage status. ASSUMES Polarion Connector for Teamcenter (Siemens-supported adapter); if using custom REST integration, transport changes but field mappings remain.",
  "tags": [
   "Requirements",
   "Traceability",
   "Polarion",
   "ALM",
   "Coverage",
   "Audit"
  ],
  "triggers": [
   {
    "id": "TRG-043-01",
    "name": "Polarion Requirement Approved",
    "type": "APPROVE",
    "source": "Polarion ALM",
    "sourceEvent": "WorkItem.status → 'approved' AND WorkItem.type IN ('requirement','systemrequirement')",
    "condition": "Polarion workflow 'Approve Requirement' completes",
    "latency": "< 60 seconds",
    "description": "When a requirement is approved in Polarion, the connector pushes the requirement to TC as a Requirement0Requirement object. The Polarion WorkItem ID is stored as the TC alternate ID for round-trip linking. If the requirement already exists in TC (same Polarion ID), the existing TC object is updated and a new TC revision is created if the Polarion revision incremented.",
    "technicalDetails": {
     "protocol": "Polarion REST API v1 (Bearer Token) → Connector → TC SOA TCCS v14 (SOAP, Mutual TLS)",
     "polarionApiVersion": "v1 (Polarion 21R1+)",
     "polarionEventMechanism": "Polarion Webhook → Connector inbound listener",
     "tcSoaService": "Requirement-2010-09-RequirementsManagement.createRequirements / updateRequirements",
     "authentication": "Polarion: Personal Access Token (service account); TC: Mutual TLS + svc account",
     "idempotencyKey": "polarion_workitem_id + polarion_revision"
    },
    "preConditions": [
     "Polarion Connector for Teamcenter installed and running",
     "Polarion project configured with workflow 'Approve Requirement'",
     "TC Requirement0Requirement type extended with custom property zz_polarion_id (unique)",
     "TC Requirement0Requirement type extended with custom property zz_polarion_revision",
     "Service accounts on both sides with appropriate roles",
     "Polarion webhook configured for WorkItem state transitions"
    ],
    "context": "Foundational for any regulated-industry CLM deployment. In automotive, ISO 26262 demands requirements traceability. In medical device, IEC 62304 and FDA Design Controls (21 CFR 820.30) require this. In aerospace, DO-178C / DO-254. Without the interface, traceability is a manual Excel exercise that breaks at audit time.",
    "prerequisites": {
     "polarion": [
      "Polarion 21R1+ with Connector enabled",
      "Project template with Requirement and SystemRequirement WorkItem types",
      "Custom field 'tc_item_id' on WorkItem (round-trip)",
      "Custom field 'tc_coverage_status' on WorkItem (calculated from TC links)",
      "Service account 'polarion_clm_svc' with Project Lead role"
     ],
     "connector": [
      "Connector v3.x or higher",
      "Mapping rules file 'polarion-to-tc-requirements.xml'",
      "Webhook receiver on /polarion-connector/webhook"
     ],
     "teamcenter": [
      "Requirement0Requirement BMIDE extension with zz_polarion_id (string, unique index)",
      "Requirement0Requirement BMIDE extension with zz_polarion_revision (string)",
      "Trace0Trace relation type configured (Satisfies, Verifies, Implements)",
      "Service account 'tc_polarion_svc' with Requirements Author role"
     ]
    },
    "sla": {
     "latency": "< 60s from Polarion approval to TC visibility",
     "availability": "99.5% during business hours",
     "completeness": "100% of approved Polarion requirements present in TC within 5 minutes"
    },
    "errorHandling": {
     "polarionWebhookFailure": "Connector logs and retries via Polarion polling job (every 15 minutes catches missed webhooks)",
     "tcCreateFail": "BMIDE validation error → connector DLQ, alert ALM admin; Polarion WorkItem stays approved but TC sync flagged in WorkItem custom field 'sync_status'",
     "duplicatePolarionId": "Two TC objects share same polarion_id (data corruption) → connector raises P2 incident, halts sync for that project",
     "polarionUnreachable": "Connector retries with exponential backoff; sync paused after 1h; resumes on Polarion availability"
    },
    "monitoring": {
     "metrics": [
      "if043_requirements_synced_total{direction,type}",
      "if043_sync_latency_seconds",
      "if043_dlq_depth",
      "if043_polling_misses_total (webhooks missed, caught by polling)"
     ],
     "alerts": [
      "DLQ depth > 5 → Slack #clm-alerts",
      "Polling misses > 10/h → investigate webhook health",
      "Sync latency P95 > 5min → operations review"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 end-to-end (Polarion → Connector → TC)",
     "authentication": "Mutual TLS on TC side; PAT on Polarion side (rotated 90 days)",
     "authorization": "Polarion svc account scoped to read WorkItems + write tc_item_id; TC svc account scoped to Requirement0Requirement CRUD only",
     "auditLog": "Every sync logged: polarion_workitem_id, polarion_rev, tc_uid, tc_revision, direction, timestamp, user_initiator"
    },
    "rollback": {
     "steps": [
      "Identify TC Requirement created by sync (filter on zz_polarion_id)",
      "If no downstream Trace links: delete TC Requirement",
      "If Trace links exist: mark as 'Obsolete' status, do not delete (audit trail)",
      "Polarion WorkItem custom field 'sync_status' set to 'rolled_back'"
     ],
     "estimatedTime": "5 minutes per requirement",
     "dataLoss": "None — Polarion remains authoritative; TC representation can be re-synced"
    },
    "recommendedMapping": [
     {
      "src": "Polarion.WorkItem.id",
      "dst": "TC.Requirement0Requirement.zz_polarion_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Round-trip key"
     },
     {
      "src": "Polarion.WorkItem.revision",
      "dst": "TC.Requirement0Requirement.zz_polarion_revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Revision tracking"
     },
     {
      "src": "Polarion.WorkItem.title",
      "dst": "TC.Requirement0Requirement.object_name",
      "xform": "Truncate 128 chars",
      "mandatory": true,
      "note": "Display name"
     },
     {
      "src": "Polarion.WorkItem.description",
      "dst": "TC.Requirement0Requirement.object_desc",
      "xform": "HTML → plain text",
      "mandatory": true,
      "note": "Description"
     },
     {
      "src": "Polarion.WorkItem.type",
      "dst": "TC.Requirement0Requirement.req_type",
      "xform": "Lookup table",
      "mandatory": true,
      "note": "requirement/systemrequirement/safetyrequirement"
     },
     {
      "src": "Polarion.WorkItem.priority",
      "dst": "TC.Requirement0Requirement.priority",
      "xform": "Polarion priority → TC LOV",
      "mandatory": true,
      "note": "Priority level"
     },
     {
      "src": "Polarion.WorkItem.severity",
      "dst": "TC.Requirement0Requirement.severity",
      "xform": "Direct",
      "mandatory": false,
      "note": "Safety severity (regulated industries)"
     },
     {
      "src": "Polarion.WorkItem.author",
      "dst": "TC.Requirement0Requirement.author_polarion",
      "xform": "Polarion user → SAP/AD user lookup",
      "mandatory": true,
      "note": "Original author"
     },
     {
      "src": "Polarion.WorkItem.status",
      "dst": "TC.Requirement0Requirement.lifecycle_status",
      "xform": "approved → 'Released'",
      "mandatory": true,
      "note": "Only approved sync'd"
     },
     {
      "src": "Polarion.WorkItem.approval_date",
      "dst": "TC.Requirement0Requirement.zz_approval_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Audit timestamp"
     },
     {
      "src": "Polarion.WorkItem.project_id",
      "dst": "TC.Requirement0Requirement.project_polarion",
      "xform": "Direct",
      "mandatory": true,
      "note": "Polarion project context"
     }
    ],
    "configSteps": [
     "Install Polarion Connector for Teamcenter on integration server",
     "Configure Polarion webhook → connector /webhook endpoint",
     "Extend TC Requirement0Requirement BMIDE: zz_polarion_id (unique), zz_polarion_revision, zz_approval_date",
     "Create TC service account tc_polarion_svc with Requirements Author role",
     "Create Polarion service account polarion_clm_svc with Project Lead role per applicable projects",
     "Build mapping file polarion-to-tc-requirements.xml from recommended fields",
     "Configure connector DLQ with admin UI access",
     "Implement reconciliation job (every 15min) to catch webhook misses",
     "Configure Splunk forwarder on connector host (HEC token)",
     "Smoke test: approve 5 Polarion requirements; verify TC visibility < 60s",
     "Negative test: malformed Polarion data → DLQ, alert raised",
     "Negative test: TC down → connector retry queue holds, recovers on restore",
     "Load test: 200 simultaneous approvals; verify no missed records",
     "Bidirectional test: create Trace link in TC; verify Polarion coverage status updates"
    ]
   },
   {
    "id": "TRG-043-02",
    "name": "TC Trace Link Created (Coverage Update)",
    "type": "CREATE",
    "source": "Teamcenter 2512",
    "sourceEvent": "Trace0Trace relation created from TC Requirement0Requirement to TC Item",
    "condition": "Source requirement has zz_polarion_id (linked to Polarion)",
    "latency": "< 90 seconds",
    "description": "When a TC engineer creates a Trace link from a synced requirement to an Item, the connector pushes the coverage information back to Polarion. Polarion's tc_coverage_status custom field is updated to 'covered' and the linked TC Item ID is recorded. This enables Polarion's standard requirement coverage reports to show real coverage from engineering.",
    "technicalDetails": {
     "protocol": "TC SOA event subscription → Connector → Polarion REST API",
     "tcEventMechanism": "TC Subscription Manager listening for Trace0Trace.create",
     "polarionEndpoint": "PATCH /polarion/rest/v1/projects/{projectId}/workitems/{workitemId}",
     "authentication": "Mutual TLS (TC↔Connector); PAT (Connector→Polarion)",
     "idempotencyKey": "tc_trace_uid (TC trace link UID)"
    },
    "preConditions": [
     "TC Subscription Manager active",
     "Trace0Trace relation exists between Requirement and Item",
     "Source Requirement has zz_polarion_id populated"
    ],
    "sla": {
     "latency": "< 90s from TC trace creation to Polarion coverage update",
     "availability": "99.5%"
    },
    "recommendedMapping": [
     {
      "src": "TC.Trace0Trace.uid",
      "dst": "Polarion.WorkItem.linked_tc_uids",
      "xform": "Append to multi-value field",
      "mandatory": true,
      "note": "Coverage proof"
     },
     {
      "src": "TC.Trace0Trace.targetItem.item_id",
      "dst": "Polarion.WorkItem.tc_item_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Covering Item"
     },
     {
      "src": "TC.Trace0Trace.relation_type",
      "dst": "Polarion.WorkItem.coverage_relation",
      "xform": "Satisfies/Verifies/Implements",
      "mandatory": true,
      "note": "Trace semantics"
     },
     {
      "src": "AIG.constant",
      "dst": "Polarion.WorkItem.tc_coverage_status",
      "xform": "Constant 'covered'",
      "mandatory": true,
      "note": "Coverage flag"
     }
    ],
    "configSteps": [
     "Configure TC Subscription Manager to listen for Trace0Trace.create events",
     "Connector subscribes to TC event stream via SOA",
     "Add custom Polarion fields: tc_item_id, tc_coverage_status, linked_tc_uids, coverage_relation",
     "Test: create TC trace; verify Polarion field updates < 90s"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Polarion (authoring) ↔ Connector ↔ TC (engineering objects)",
   "correlationStrategy": "Stable polarion_workitem_id stored on TC; tc_item_id stored on Polarion",
   "consistency": "Eventually consistent; reconciliation job every 15min catches drift",
   "failureSemantics": "At-least-once delivery; idempotent by polarion_workitem_id+revision"
  },
  "implementationOrder": [
   "Phase 1: BMIDE extensions on TC (zz_polarion_id, zz_polarion_revision)",
   "Phase 2: Polarion custom fields and service account",
   "Phase 3: Connector install and mapping configuration",
   "Phase 4: One-way (Polarion → TC) flow tested",
   "Phase 5: Bidirectional flow (TC trace → Polarion coverage)",
   "Phase 6: Reconciliation job and monitoring",
   "Phase 7: UAT with Systems Engineering and Quality teams",
   "Phase 8: Production cutover"
  ],
  "tasks": [
   {
    "id": "T043a",
    "name": "BMIDE Extensions on TC",
    "type": "Configure",
    "hours": 6,
    "cx": 2,
    "dod": [
     "zz_polarion_id property added to Requirement0Requirement with unique index",
     "zz_polarion_revision property added",
     "zz_approval_date property added",
     "BMIDE deployed to all environments (DEV/QA/PROD plan)",
     "AWC UI shows new properties on Requirement details view"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Polarion Connector for Teamcenter configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'BMIDE Extensions on TC'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'BMIDE Extensions on TC'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T043b",
    "name": "Polarion Configuration",
    "type": "Configure",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Custom fields tc_item_id, tc_coverage_status, linked_tc_uids, coverage_relation added",
     "Service account polarion_clm_svc created with Project Lead role",
     "Webhook configured on WorkItem state transitions",
     "Workflow 'Approve Requirement' triggers webhook firing"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Polarion Connector for Teamcenter configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Polarion Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Polarion Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T043c",
    "name": "Connector Installation + Mapping",
    "type": "Install",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Polarion Connector for Teamcenter installed on integration host",
     "TC and Polarion service accounts validated (connectivity test passes)",
     "Mapping file polarion-to-tc-requirements.xml deployed",
     "Webhook receiver /webhook returns 200 OK on test event",
     "DLQ admin UI accessible",
     "Health endpoint /health returns status of TC + Polarion connections"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the Polarion Connector for Teamcenter component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Polarion ALM and Teamcenter 2512",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T043d",
    "name": "Reconciliation Job",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Every-15-minute job queries Polarion for WorkItems modified since last run",
     "Job compares Polarion state with TC state; pushes missing/stale items",
     "Reconciliation events logged separately from real-time syncs",
     "Job runs cleanly for 24h with 0 errors in QA"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Polarion Connector for Teamcenter configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Reconciliation Job'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Reconciliation Job'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T043e",
    "name": "Integration + Negative Tests",
    "type": "Test",
    "hours": 12,
    "cx": 3,
    "dod": [
     "Happy path: 20 Polarion approvals → TC visibility < 60s (20/20)",
     "Bidirectional: TC trace → Polarion coverage update < 90s (10/10)",
     "Webhook miss: kill webhook receiver, approve in Polarion, restore — reconciliation catches within 15min",
     "Concurrent load: 100 simultaneous approvals, 0 lost records",
     "Polarion outage: connector retries; recovery on Polarion restore",
     "TC outage: connector DLQ; manual replay UI works"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration + Negative Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Polarion ALM→Teamcenter 2512)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through Polarion Connector for Teamcenter",
       "Confirm arrival + correctness at Teamcenter 2512"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T043f",
    "name": "UAT + Cutover",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Systems Engineering + Quality sign off on 3 real requirement scenarios",
     "Audit log review confirms all sync events captured",
     "Coverage report in Polarion shows realistic data",
     "Cutover plan approved by CAB"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Cutover'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Polarion.WorkItem.id",
    "dst": "TC.Requirement0Requirement.zz_polarion_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.revision",
    "dst": "TC.Requirement0Requirement.zz_polarion_revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.title",
    "dst": "TC.Requirement0Requirement.object_name",
    "xform": "Truncate 128 chars",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.description",
    "dst": "TC.Requirement0Requirement.object_desc",
    "xform": "HTML → plain text",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.type",
    "dst": "TC.Requirement0Requirement.req_type",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.priority",
    "dst": "TC.Requirement0Requirement.priority",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Polarion.WorkItem.severity",
    "dst": "TC.Requirement0Requirement.severity",
    "xform": "Direct",
    "category": "quality"
   },
   {
    "src": "Polarion.WorkItem.author",
    "dst": "TC.Requirement0Requirement.author_polarion",
    "xform": "User lookup",
    "category": "audit"
   },
   {
    "src": "Polarion.WorkItem.approval_date",
    "dst": "TC.Requirement0Requirement.zz_approval_date",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "Polarion.WorkItem.approver",
    "dst": "TC.Requirement0Requirement.zz_polarion_approver",
    "xform": "User lookup",
    "category": "audit"
   },
   {
    "src": "Polarion.WorkItem.project_id",
    "dst": "TC.Requirement0Requirement.project_polarion",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "Polarion.WorkItem.created_date",
    "dst": "TC.Requirement0Requirement.creation_date",
    "xform": "ISO 8601",
    "category": "metadata"
   },
   {
    "src": "Polarion.WorkItem.iteration",
    "dst": "TC.Requirement0Requirement.zz_iteration",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Polarion.WorkItem.module",
    "dst": "TC.Requirement0Requirement.zz_polarion_module",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "TC.Trace0Trace.uid",
    "dst": "Polarion.WorkItem.linked_tc_uids",
    "xform": "Append multi-value",
    "category": "core"
   },
   {
    "src": "TC.Trace0Trace.targetItem.item_id",
    "dst": "Polarion.WorkItem.tc_item_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.Trace0Trace.relation_type",
    "dst": "Polarion.WorkItem.coverage_relation",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "AIG.constant",
    "dst": "Polarion.WorkItem.tc_coverage_status",
    "xform": "Constant 'covered'",
    "category": "core"
   }
  ],
  "apis": [
   {
    "name": "Polarion REST — Get WorkItem",
    "method": "GET",
    "url": "https://polarion-host/polarion/rest/v1/projects/{projectId}/workitems/{workitemId}",
    "prereq": [
     "Personal Access Token",
     "Project read access"
    ],
    "purpose": "Retrieve WorkItem details for sync",
    "sample": "GET /polarion/rest/v1/projects/MyProject/workitems/MyProject-1234",
    "rateLimit": "100 req/min per token",
    "timeout": "30s"
   },
   {
    "name": "Polarion REST — Patch WorkItem (coverage update)",
    "method": "PATCH",
    "url": "https://polarion-host/polarion/rest/v1/projects/{projectId}/workitems/{workitemId}",
    "prereq": [
     "Personal Access Token",
     "Project write access"
    ],
    "purpose": "Update tc_item_id, tc_coverage_status, linked_tc_uids on Polarion side",
    "sample": "{ \"data\": { \"type\": \"workitems\", \"attributes\": { \"tc_coverage_status\": \"covered\" } } }",
    "rateLimit": "100 req/min per token",
    "timeout": "30s"
   },
   {
    "name": "TC SOA — Create Requirements",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Requirement-2010-09-RequirementsManagement/createRequirements",
    "prereq": [
     "SOA session",
     "Requirements Author role"
    ],
    "purpose": "Create TC Requirement0Requirement from Polarion data",
    "sample": "<createInputs><name>REQ-001</name><type>Requirement0Requirement</type><props>...</props></createInputs>",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Connector Health",
    "method": "GET",
    "url": "https://connector-host/health",
    "prereq": [
     "Admin role"
    ],
    "purpose": "Verify upstream/downstream connectivity",
    "sample": "GET /health → 200 { polarion: ok, tc: ok, dlq_depth: 0 }",
    "rateLimit": "60 req/min",
    "timeout": "5s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink (in Polarion ALM); related: Requirements, Traceability, Polarion",
   "destinationBusinessObjectsInScope": "Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink (in Teamcenter 2512)",
   "meaning": "Polarion Requirements to TC Item Requirement Link: Connects Polarion ALM (where requirements are authored, versioned, and reviewed) with Teamcenter (where the engineering objects fulfilling those requirements live).",
   "purpose": "Delivers 'Requirement-to-design traceability for audit and impact analysis' (Engineering Governance). On Polarion WorkItem approval, the requirement is published as a TC Requirement0Requirement object and linked to the satisfying TC Item via Trace0Trace links.",
   "functionPrimary": "Move/transform Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink → Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink (BiSync, Event-driven).",
   "subFunctions": [
    "BMIDE Extensions on TC",
    "Polarion Configuration",
    "Connector Installation + Mapping",
    "Reconciliation Job",
    "Integration + Negative Tests",
    "UAT + Cutover"
   ],
   "architecture": "Polarion ALM --[Polarion REST API v1 → Polarion Connector → TC SOA TCCS v14]--> Polarion Connector for Teamcenter --> Teamcenter 2512. Pattern: BiSync integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: Polarion Connector for Teamcenter. INTRA-PLM with inter-system consumers.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "Polarion is system-of-record for requirements; Teamcenter holds linked traceability.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: plm_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "zz_polarion_id property added to Requirement0Requirement with unique index",
   "docSearchKeywords": [
    "Teamcenter BMIDE + SOA reference",
    "\"Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink\" mapping",
    "\"Polarion WorkItem (Requirement) ↔ TC Requirement0Requirement + TraceLink\" configuration",
    "Polarion Connector for Teamcenter",
    "Requirements",
    "Traceability",
    "Polarion",
    "ALM"
   ],
   "taskHours": 42,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-045",
  "seq": 45,
  "mvp": 3,
  "phase": 4,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "TC Classification to SAP Classification Sync",
  "from": "Teamcenter 2512",
  "to": "SAP S/4HANA",
  "mid": "AIG Gateway",
  "protocol": "TC SOA → AIG → SAP BAPI_CLASS_CREATE / BAPI_OBJCL_CHANGE",
  "bo": "TC Classification class + values → SAP Class (KLAH) + Object Classification (AUSP)",
  "complexity": 3,
  "effort": 5,
  "risk": 2,
  "team": "PLM + ERP + AIG",
  "outcome": "Cross-system classification search and characteristic-based picking",
  "outcomeCat": "Master Data Governance",
  "deps": [
   "IF-012"
  ],
  "about": "When a TC Item is classified (assigned class and characteristic values in TC Classification), AIG propagates the classification to SAP, creating/updating the SAP class hierarchy and assigning the material to the class with characteristic values (AUSP table entries). Enables CL30N material search by characteristics in SAP and characteristic-based picking in warehouse management. ASSUMES SAP standard CA-CL classification.",
  "tags": [
   "Classification",
   "Characteristics",
   "CL4N",
   "AUSP",
   "Search",
   "MasterData"
  ],
  "triggers": [
   {
    "id": "TRG-045-01",
    "name": "TC Item Classification Applied",
    "type": "ATTRIBUTE_CHANGE",
    "source": "Teamcenter 2512",
    "sourceEvent": "ICO (ICM Classification Object) created or modified on Item/ItemRevision",
    "condition": "Source class hierarchy mapped in AIG to SAP class hierarchy",
    "latency": "< 30 seconds",
    "description": "When an engineer classifies a TC Item (assigns a class and characteristic values), the TC Subscription Manager fires an event. AIG retrieves the full ICO, transforms class and characteristics to SAP equivalents (creating the SAP class hierarchy on first use), then calls BAPI_OBJCL_CHANGE to assign the material to the SAP class with characteristic values. Subsequent characteristic value changes also trigger this sync.",
    "technicalDetails": {
     "protocol": "TC SOA TCCS v14 → AIG → SAP RFC (SNC)",
     "tcSoaService": "Classification-2007-01-Classification.getClassificationObjects",
     "sapBapis": [
      "BAPI_CLASS_CREATE",
      "BAPI_CLASS_CHANGE",
      "BAPI_CHARACT_CREATE",
      "BAPI_OBJCL_CHANGE",
      "BAPI_OBJCL_GETDETAIL"
     ],
     "sapClassType": "001 (Material Class) — most common; can vary by use case",
     "authentication": "Mutual TLS (TC↔AIG); SAP RFC over SNC",
     "idempotencyKey": "tc_ico_uid + tc_revision"
    },
    "preConditions": [
     "TC Classification module configured with class hierarchy",
     "SAP class hierarchy (CT04) mapped to TC class hierarchy in AIG",
     "Characteristics (CT04) on SAP side defined with data types matching TC",
     "Material exists in SAP (typically post-IF-012)",
     "AIG class-mapping registry populated"
    ],
    "context": "Common gap in CLM implementations. TC engineers spend effort classifying parts; that classification disappears at the SAP boundary. With this interface, SAP procurement uses CL30N to find 'all hex bolts M8 stainless 80mm long' — the same characteristic values the engineer set in TC.",
    "prerequisites": {
     "teamcenter": [
      "TC Classification module licensed and configured",
      "Class hierarchy aligned with downstream consumer needs (procurement, warehouse)",
      "Characteristics defined with data types (numeric, string, enum, date)",
      "ICOs created on Items as part of release workflow"
     ],
     "aig": [
      "Class-mapping registry (TC class ID ↔ SAP class number)",
      "Characteristic-mapping registry (TC char ID ↔ SAP char internal number)",
      "UOM lookup for numeric characteristics with units",
      "Auto-create SAP class on first use (configurable)"
     ],
     "sap": [
      "Cross-Application Component CA-CL activated",
      "Class type 001 (Material) configured",
      "Characteristics created via CT04 or auto-created by AIG",
      "RFC service user with S_CLASS_CT + S_RFC roles"
     ]
    },
    "sla": {
     "latency": "< 30s for sync to SAP",
     "availability": "99% (non-critical; tolerate brief outages)",
     "consistency": "100% characteristic value match between TC and SAP within 5min"
    },
    "errorHandling": {
     "sapClassMissing": "AIG auto-creates SAP class via BAPI_CLASS_CREATE; if disabled in config, error to DLQ",
     "characteristicTypeMismatch": "TC numeric vs. SAP string → log error, alert AIG admin, sync skipped for that characteristic",
     "materialNotInSap": "AIG buffers ICO; retries on IF-012 confirmation of material creation",
     "uomConversionFail": "Numeric characteristic with incompatible UOM → log warning, sync raw value"
    },
    "monitoring": {
     "metrics": [
      "if045_classifications_synced_total",
      "if045_sync_latency_seconds",
      "if045_classes_auto_created_total",
      "if045_characteristic_mismatches_total"
     ],
     "alerts": [
      "Characteristic mismatch > 5/h → AIG admin investigation",
      "Sync latency P95 > 2min → operations review"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 (TC↔AIG); SNC (AIG↔SAP)",
     "authentication": "Mutual TLS; SAP RFC service account",
     "authorization": "AIG svc account scoped to classification BAPIs only",
     "auditLog": "tc_ico_uid, tc_item_id, sap_class_no, sap_material_no, characteristic_diff, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify SAP class assignment via AUSP query on material number",
      "BAPI_OBJCL_CHANGE with delete flag to remove characteristic values",
      "If SAP class was auto-created and has no other materials: optional BAPI_CLASS_DELETE",
      "Mark AIG sync record as 'rolled_back'"
     ],
     "estimatedTime": "10 minutes per material",
     "dataLoss": "None — TC ICO remains authoritative"
    },
    "recommendedMapping": [
     {
      "src": "TC.ICO.classId",
      "dst": "SAP.KLAH-CLASS",
      "xform": "Class-mapping registry lookup",
      "mandatory": true,
      "note": "SAP class number"
     },
     {
      "src": "TC.ICO.parentItem.item_id",
      "dst": "SAP.AUSP-OBJEK",
      "xform": "Direct (material number)",
      "mandatory": true,
      "note": "Object being classified"
     },
     {
      "src": "AIG.constant",
      "dst": "SAP.KSSK-KLART",
      "xform": "Constant '001' (Material Class)",
      "mandatory": true,
      "note": "Class type"
     },
     {
      "src": "TC.ICO.characteristic.id",
      "dst": "SAP.AUSP-ATINN",
      "xform": "Char-mapping registry lookup",
      "mandatory": true,
      "note": "Characteristic internal number"
     },
     {
      "src": "TC.ICO.characteristic.value",
      "dst": "SAP.AUSP-ATWRT",
      "xform": "Direct (string chars) or numeric conversion",
      "mandatory": true,
      "note": "Characteristic value"
     },
     {
      "src": "TC.ICO.characteristic.uom",
      "dst": "SAP.AUSP-ATFLB",
      "xform": "UOM lookup T006",
      "mandatory": false,
      "note": "Unit for numeric chars"
     },
     {
      "src": "TC.ICO.lastModifiedDate",
      "dst": "SAP.AUSP-ZAEHL",
      "xform": "Counter increment",
      "mandatory": false,
      "note": "Version tracking"
     }
    ],
    "configSteps": [
     "Activate CA-CL component in SAP",
     "Build class-mapping registry in AIG (TC class hierarchy → SAP class numbers)",
     "Build characteristic-mapping registry (TC char IDs → SAP char internal numbers)",
     "Decide on auto-create-class policy (recommended: ON in DEV, OFF in PROD)",
     "Configure AIG TC SOA subscription for ICO events",
     "Configure SAP RFC user with S_CLASS_CT + S_RFC roles",
     "Smoke test: classify 5 TC items; verify SAP CL30N search works",
     "Negative test: TC char type incompatible with SAP — verify DLQ alert",
     "Round-trip test: change TC char value; verify SAP updates within 30s"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "TC → AIG → SAP (one-way, TC authoritative)",
   "correlationStrategy": "Material number as anchor; ICO UID for change detection",
   "consistency": "Eventually consistent within 30s under normal load",
   "failureSemantics": "At-least-once at BAPI layer; idempotent by ICO UID + revision"
  },
  "implementationOrder": [
   "Phase 1: Class hierarchy alignment review (TC ↔ SAP)",
   "Phase 2: SAP class + characteristic creation (CT04)",
   "Phase 3: AIG mapping registries",
   "Phase 4: Subscription + sync logic",
   "Phase 5: UAT with Procurement + Warehouse teams"
  ],
  "tasks": [
   {
    "id": "T045a",
    "name": "Class Hierarchy Alignment",
    "type": "Analyze",
    "hours": 8,
    "cx": 3,
    "dod": [
     "TC class hierarchy mapped to SAP class hierarchy",
     "Mismatches documented and resolved",
     "Sign-off from PLM + Procurement leads",
     "Mapping document published"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Analyze' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Gather source data for 'Class Hierarchy Alignment'",
      "subSubTasks": [
       "Extract from Teamcenter 2512",
       "Extract from SAP S/4HANA"
      ]
     },
     {
      "step": 2,
      "title": "Compare and find gaps",
      "subSubTasks": [
       "Align structures/hierarchies",
       "Identify mismatches",
       "Quantify the gap"
      ]
     },
     {
      "step": 3,
      "title": "Produce alignment report",
      "subSubTasks": [
       "Document findings",
       "Agree remediation actions",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T045b",
    "name": "SAP Classes + Characteristics",
    "type": "Configure",
    "hours": 8,
    "cx": 2,
    "dod": [
     "Classes created in CT04 matching TC hierarchy",
     "Characteristics created with correct data types",
     "Class type 001 confirmed for all classes",
     "Test CL30N search returns expected results"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Classes + Characteristics'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Classes + Characteristics'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T045c",
    "name": "AIG Mapping Registries + Sync",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Class-mapping registry populated",
     "Characteristic-mapping registry populated",
     "TC SOA subscription active",
     "BAPI calls validated with correct authorization",
     "Auto-create-class policy implemented per environment"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Mapping Registries + Sync'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Mapping Registries + Sync'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T045d",
    "name": "Integration Tests",
    "type": "Test",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Happy path: 10 classifications synced; SAP CL30N search confirms",
     "Update path: change TC char value; SAP updates < 30s",
     "Delete path: remove TC ICO; SAP characteristic value cleared",
     "Negative: incompatible char type → DLQ + alert",
     "Performance: 100 ICO changes/min sustained for 10min"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→SAP S/4HANA)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at SAP S/4HANA"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T045e",
    "name": "UAT",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Procurement Manager confirms CL30N search returns engineering-classified materials",
     "Warehouse confirms characteristic-based picking lists generate",
     "Engineering confirms TC ICO changes propagate within SLA",
     "Sign-off documented"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.ICO.classId",
    "dst": "SAP.KLAH-CLASS",
    "xform": "Class registry lookup",
    "category": "core"
   },
   {
    "src": "TC.ICO.parentItem.item_id",
    "dst": "SAP.AUSP-OBJEK",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "AIG.constant",
    "dst": "SAP.KSSK-KLART",
    "xform": "Constant '001'",
    "category": "core"
   },
   {
    "src": "TC.ICO.characteristic.id",
    "dst": "SAP.AUSP-ATINN",
    "xform": "Char registry lookup",
    "category": "core"
   },
   {
    "src": "TC.ICO.characteristic.value",
    "dst": "SAP.AUSP-ATWRT",
    "xform": "Type-aware conversion",
    "category": "core"
   },
   {
    "src": "TC.ICO.characteristic.uom",
    "dst": "SAP.AUSP-ATFLB",
    "xform": "UOM lookup",
    "category": "additional"
   },
   {
    "src": "TC.ICO.lastModifiedUser",
    "dst": "SAP.AUSP-CHANGED_BY",
    "xform": "TC user → SAP user",
    "category": "audit"
   },
   {
    "src": "TC.ICO.lastModifiedDate",
    "dst": "SAP.AUSP-CHANGED_AT",
    "xform": "ISO 8601 → SAP datetime",
    "category": "audit"
   },
   {
    "src": "TC.ICO.classDescription",
    "dst": "SAP.KLAT-KSCHL",
    "xform": "Direct",
    "category": "metadata"
   }
  ],
  "apis": [
   {
    "name": "TC SOA — Classification",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Classification-2007-01-Classification/getClassificationObjects",
    "prereq": [
     "SOA session",
     "Classification View role"
    ],
    "purpose": "Retrieve ICO data for sync",
    "sample": "<targets><uid>...</uid></targets>",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   },
   {
    "name": "SAP BAPI_OBJCL_CHANGE",
    "method": "RFC",
    "url": "SAP RFC connection (SNC)",
    "prereq": [
     "Material exists",
     "Class assigned to class type 001"
    ],
    "purpose": "Assign characteristic values to material in SAP class",
    "sample": "BAPI_OBJCL_CHANGE( OBJECTKEY:'BV-3IN-001', OBJECTTABLE:'MARA', CLASSNUM:'GRP-BOLTS', CLASSTYPE:'001', VALUES:[...] )",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "SAP BAPI_CLASS_CREATE",
    "method": "RFC",
    "url": "SAP RFC connection (SNC)",
    "prereq": [
     "Class type 001 active",
     "S_CLASS_CT role"
    ],
    "purpose": "Auto-create SAP class on first use (if policy allows)",
    "sample": "BAPI_CLASS_CREATE( CLASSNUM:'GRP-BOLTS', CLASSTYPE:'001', DESCRIPTION:'Bolt Group' )",
    "rateLimit": "5 req/sec",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Could Have",
   "sourceBusinessObjectsInScope": "TC Classification class + values (in Teamcenter 2512); related: Classification, Characteristics, CL4N",
   "destinationBusinessObjectsInScope": "SAP Class (KLAH) + Object Classification (AUSP) (in SAP S/4HANA)",
   "meaning": "TC Classification to SAP Classification Sync: When a TC Item is classified (assigned class and characteristic values in TC Classification), AIG propagates the classification to SAP, creating/updating the SAP class hierarchy and assigning the material to the class with characteristic values (AUSP table entries).",
   "purpose": "Delivers 'Cross-system classification search and characteristic-based picking' (Master Data Governance). Enables CL30N material search by characteristics in SAP and characteristic-based picking in warehouse management.",
   "functionPrimary": "Move/transform TC Classification class + values → SAP Class (KLAH) + Object Classification (AUSP) (Sync, Event-driven).",
   "subFunctions": [
    "Class Hierarchy Alignment",
    "SAP Classes + Characteristics",
    "AIG Mapping Registries + Sync",
    "Integration Tests",
    "UAT"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → SAP BAPI_CLASS_CREATE / BAPI_OBJCL_CHANGE]--> AIG Gateway --> SAP S/4HANA. Pattern: Sync integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-012"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 3,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "TC class hierarchy mapped to SAP class hierarchy",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"TC Classification class + values\" mapping",
    "\"SAP Class (KLAH) + Object Classification (AUSP)\" configuration",
    "AIG Gateway",
    "Classification",
    "Characteristics",
    "CL4N",
    "AUSP"
   ],
   "taskHours": 35,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 5
   }
  }
 },
 {
  "id": "IF-047",
  "seq": 47,
  "mvp": 2,
  "phase": 3,
  "grp": "MES",
  "type": "Sync",
  "freq": "Event + Batch (4× daily)",
  "name": "Opcenter APS Detailed Schedule to Opcenter EX",
  "from": "Opcenter APS 2024",
  "to": "Opcenter 2601",
  "mid": "Direct REST",
  "protocol": "Opcenter APS REST API → Opcenter EX REST API (no middleware)",
  "bo": "APS ScheduledWorkOrder → EX WorkOrder dispatch sequence + planned start",
  "complexity": 3,
  "effort": 7,
  "risk": 2,
  "team": "Planning + MES Admin",
  "outcome": "Finite, optimized schedule executed on shop floor instead of FIFO",
  "outcomeCat": "Production Planning",
  "deps": [
   "IF-007",
   "IF-016",
   "IF-018"
  ],
  "about": "Opcenter APS produces a finite schedule (which order on which resource at which time). Without this interface, EX dispatches Work Orders FIFO and the APS schedule is decorative. Push happens on schedule publish from APS planner AND on a periodic batch (every 6h) to catch in-day re-planning. EX honors sequence and planned start; deviation is flagged for next planning cycle via APS feedback. ASSUMES Opcenter APS 2024 + Opcenter EX 2601.",
  "tags": [
   "APS",
   "Scheduling",
   "Finite",
   "Dispatch",
   "Planning"
  ],
  "triggers": [
   {
    "id": "TRG-047-01",
    "name": "APS Schedule Published",
    "type": "RELEASE",
    "source": "Opcenter APS 2024",
    "sourceEvent": "Planner clicks 'Publish Schedule' in APS UI; APS workflow 'PublishSchedule' completes",
    "condition": "Schedule version > previous published version",
    "latency": "< 60 seconds for visibility in EX",
    "description": "Planner publishes a new schedule version in APS. APS REST endpoint /aps/api/v1/schedules/{id}/publish fires a webhook. A lightweight forwarder reads the schedule (work orders, resources, sequence numbers, planned start/end) and pushes to EX via POST /opcenter/api/v1/dispatch/schedule. EX updates WorkOrder.SequenceNumber and PlannedStartTime; dispatch to SFC (IF-018) follows the new sequence.",
    "technicalDetails": {
     "protocol": "Opcenter APS REST API v1 → Opcenter EX REST API v1",
     "apsEndpoint": "GET /aps/api/v1/schedules/{scheduleId}/workorders",
     "exEndpoint": "POST /opcenter/api/v1/dispatch/schedule",
     "webhookMechanism": "APS publish event → custom forwarder (Node.js or Python service)",
     "authentication": "Mutual TLS or shared service account with OAuth2 client_credentials",
     "idempotencyKey": "aps_schedule_id + aps_schedule_version"
    },
    "preConditions": [
     "APS schedule contains only WorkOrders with valid EX SpecName (per IF-007)",
     "APS resources map 1:1 to EX WorkCenters (validated by IF-066)",
     "EX WorkOrder.SequenceNumber field exposed via REST API",
     "Forwarder service running with TLS termination",
     "Maximum schedule horizon defined (typical: 14 days; older orders ignored)"
    ],
    "context": "APS optimization without this interface is technical theater — the team buys APS, runs optimization, then dispatches FIFO. With this interface, the actual sequence flowing to operators reflects setup-time minimization, due-date adherence, and resource bottleneck avoidance. ROI typically shows in 4–8 weeks of operation.",
    "prerequisites": {
     "aps": [
      "Opcenter APS 2024 with REST API enabled",
      "Publish workflow configured to trigger webhook",
      "Resource model aligned with EX WorkCenter model",
      "Schedule horizon parameter set (default 14 days)"
     ],
     "forwarder": [
      "Lightweight service (Node.js or Python) on integration host",
      "Webhook receiver at /aps-forwarder/publish",
      "Idempotency table (Redis recommended)",
      "DLQ with admin replay UI"
     ],
     "ex": [
      "WorkOrder REST endpoints support SequenceNumber and PlannedStartTime fields",
      "Custom property zz_aps_schedule_version on WorkOrder",
      "Dispatch rule honors SequenceNumber > FIFO (config flag in EX)"
     ]
    },
    "sla": {
     "latency": "< 60s from APS publish to EX visibility",
     "availability": "99% (planning is critical but tolerant of brief outages)",
     "completeness": "100% of published WorkOrders updated in EX within 5min"
    },
    "errorHandling": {
     "exWorkOrderMissing": "APS schedule references WorkOrder not in EX → log warning, skip; assumes IF-007 will create it",
     "exDown": "Forwarder DLQs schedule; retry every 5min; alert after 15min",
     "apsDown": "Periodic batch (6h) is missed; planner notified; next publish triggers full sync",
     "partialPublish": "Some WorkOrders accepted, some rejected → record per-order status; planner sees mixed state in APS"
    },
    "monitoring": {
     "metrics": [
      "if047_publishes_total",
      "if047_workorders_updated_total",
      "if047_publish_latency_seconds",
      "if047_dispatch_sequence_violations_total (operator overrode APS sequence)"
     ],
     "alerts": [
      "Forwarder down > 5min → PagerDuty Planning on-call",
      "Sequence violations > 10/day → review with planner (may indicate APS schedule unrealistic)"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 end-to-end",
     "authentication": "OAuth2 client_credentials with 1h tokens; mutual TLS optional",
     "authorization": "Forwarder svc account scoped to APS-read + EX-WorkOrder-update only",
     "auditLog": "schedule_id, schedule_version, workorders_updated, planner_user, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify previous schedule version from APS",
      "Trigger re-publish of previous version (APS UI: 'Republish version N')",
      "Confirm EX reflects previous sequence within 60s",
      "Log incident for planning team review"
     ],
     "estimatedTime": "5 minutes for planner-driven rollback",
     "dataLoss": "None — APS retains all published versions; previous always re-publishable"
    },
    "recommendedMapping": [
     {
      "src": "APS.ScheduledWorkOrder.workOrderId",
      "dst": "EX.WorkOrder.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "WorkOrder identifier"
     },
     {
      "src": "APS.ScheduledWorkOrder.sequenceNumber",
      "dst": "EX.WorkOrder.SequenceNumber",
      "xform": "Direct (integer)",
      "mandatory": true,
      "note": "Dispatch order"
     },
     {
      "src": "APS.ScheduledWorkOrder.resourceId",
      "dst": "EX.WorkOrder.AssignedResource",
      "xform": "Resource→WorkCenter lookup",
      "mandatory": true,
      "note": "Assigned WC"
     },
     {
      "src": "APS.ScheduledWorkOrder.plannedStart",
      "dst": "EX.WorkOrder.PlannedStartTime",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Planned start"
     },
     {
      "src": "APS.ScheduledWorkOrder.plannedEnd",
      "dst": "EX.WorkOrder.PlannedEndTime",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Planned end"
     },
     {
      "src": "APS.ScheduledWorkOrder.setupStart",
      "dst": "EX.WorkOrder.SetupStartTime",
      "xform": "ISO 8601",
      "mandatory": false,
      "note": "Setup start (if separate)"
     },
     {
      "src": "APS.Schedule.version",
      "dst": "EX.WorkOrder.zz_aps_schedule_version",
      "xform": "Direct",
      "mandatory": true,
      "note": "Traceability"
     },
     {
      "src": "APS.Schedule.publishedAt",
      "dst": "EX.WorkOrder.zz_aps_published_at",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Audit"
     },
     {
      "src": "APS.Schedule.publishedBy",
      "dst": "EX.WorkOrder.zz_aps_planner",
      "xform": "User lookup",
      "mandatory": true,
      "note": "Audit"
     }
    ],
    "configSteps": [
     "Enable Opcenter APS REST API and create service account",
     "Configure APS publish workflow to fire webhook to forwarder",
     "Deploy forwarder service with TLS",
     "Add EX custom properties zz_aps_schedule_version, zz_aps_published_at, zz_aps_planner",
     "Configure EX dispatch rule to honor SequenceNumber > FIFO",
     "Build resource → WorkCenter lookup table in forwarder",
     "Configure idempotency table (Redis, TTL 30 days)",
     "Schedule periodic batch (every 6h) as backup to event-driven publish",
     "Smoke test: publish 20-order schedule; verify EX dispatch in correct sequence",
     "Negative test: stop forwarder, publish in APS, restore — batch catches it",
     "Concurrency test: two near-simultaneous publishes — second supersedes first cleanly",
     "Operator override test: shop floor dispatches out of sequence; APS receives feedback (deferred to IF-018 feedback enhancement)"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "APS (planner) → Forwarder → EX (dispatch)",
   "correlationStrategy": "schedule_id + schedule_version on EX WorkOrder for traceability",
   "consistency": "Strong within 60s; eventual consistency for batch fallback",
   "failureSemantics": "At-least-once; idempotent by (schedule_id, schedule_version, workorder_id)"
  },
  "implementationOrder": [
   "Phase 1: APS workflow + REST API enablement",
   "Phase 2: Forwarder service deployment",
   "Phase 3: EX dispatch rule configuration",
   "Phase 4: Resource model alignment validation",
   "Phase 5: UAT with planner + shop floor lead",
   "Phase 6: Cutover during low-volume window"
  ],
  "tasks": [
   {
    "id": "T047a",
    "name": "APS Configuration + Workflow",
    "type": "Configure",
    "hours": 6,
    "cx": 3,
    "dod": [
     "APS REST API enabled and authenticated",
     "Publish workflow fires webhook on every publish",
     "Service account scoped to schedule-read only",
     "Resource model verified against EX WorkCenter list"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Direct REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'APS Configuration + Workflow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'APS Configuration + Workflow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T047b",
    "name": "Forwarder Service",
    "type": "Install",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Forwarder receives webhooks at /publish",
     "Forwarder retrieves full schedule from APS REST",
     "Forwarder transforms and posts to EX",
     "Idempotency table prevents duplicate processing",
     "DLQ admin UI accessible",
     "Health endpoint reports APS + EX connectivity",
     "Splunk forwarder configured"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the Direct REST component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Opcenter APS 2024 and Opcenter 2601",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T047c",
    "name": "EX Dispatch Rule",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "WorkOrder custom properties added",
     "Dispatch rule honors SequenceNumber when populated",
     "FIFO fallback when SequenceNumber null",
     "Test: dispatch with SequenceNumber=5,3,1 → operator sees 1,3,5 order"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Direct REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'EX Dispatch Rule'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'EX Dispatch Rule'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T047d",
    "name": "Periodic Batch Job",
    "type": "Configure",
    "hours": 3,
    "cx": 2,
    "dod": [
     "Cron every 6h: query APS for latest published version; push to EX",
     "Idempotency prevents duplicate updates if event-driven path already covered",
     "Audit log distinguishes event vs. batch path"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Direct REST configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Periodic Batch Job'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Periodic Batch Job'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T047e",
    "name": "Integration Tests",
    "type": "Test",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Happy path: 30-order schedule, all sequenced correctly in EX within 60s",
     "Re-publish: new version supersedes old; EX reflects within 60s",
     "Forwarder outage: publish in APS, restore forwarder, batch catches it < 6h",
     "EX outage: forwarder DLQs; on EX restore, DLQ replay succeeds",
     "Load: 5 publishes in 10min, each with 50 orders, all consistent",
     "Resource missing: order references unmapped resource → warning, skip, alert"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Opcenter APS 2024→Opcenter 2601)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through Direct REST",
       "Confirm arrival + correctness at Opcenter 2601"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T047f",
    "name": "UAT + Cutover",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Planner publishes 3 real schedules; shop floor confirms dispatch follows APS sequence",
     "Shop floor lead signs off on sequence honoring",
     "Override-tracking metric live in Grafana",
     "Cutover runbook approved"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Cutover'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "APS.ScheduledWorkOrder.workOrderId",
    "dst": "EX.WorkOrder.Name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "APS.ScheduledWorkOrder.sequenceNumber",
    "dst": "EX.WorkOrder.SequenceNumber",
    "xform": "Integer",
    "category": "core"
   },
   {
    "src": "APS.ScheduledWorkOrder.resourceId",
    "dst": "EX.WorkOrder.AssignedResource",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "APS.ScheduledWorkOrder.plannedStart",
    "dst": "EX.WorkOrder.PlannedStartTime",
    "xform": "ISO 8601",
    "category": "core"
   },
   {
    "src": "APS.ScheduledWorkOrder.plannedEnd",
    "dst": "EX.WorkOrder.PlannedEndTime",
    "xform": "ISO 8601",
    "category": "core"
   },
   {
    "src": "APS.ScheduledWorkOrder.setupStart",
    "dst": "EX.WorkOrder.SetupStartTime",
    "xform": "ISO 8601",
    "category": "additional"
   },
   {
    "src": "APS.ScheduledWorkOrder.setupEnd",
    "dst": "EX.WorkOrder.SetupEndTime",
    "xform": "ISO 8601",
    "category": "additional"
   },
   {
    "src": "APS.ScheduledWorkOrder.priority",
    "dst": "EX.WorkOrder.Priority",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "APS.ScheduledWorkOrder.dueDate",
    "dst": "EX.WorkOrder.DueDate",
    "xform": "ISO 8601",
    "category": "additional"
   },
   {
    "src": "APS.Schedule.version",
    "dst": "EX.WorkOrder.zz_aps_schedule_version",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "APS.Schedule.publishedAt",
    "dst": "EX.WorkOrder.zz_aps_published_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "APS.Schedule.publishedBy",
    "dst": "EX.WorkOrder.zz_aps_planner",
    "xform": "User",
    "category": "audit"
   },
   {
    "src": "APS.ScheduledWorkOrder.optimizationScore",
    "dst": "EX.WorkOrder.zz_aps_opt_score",
    "xform": "Float",
    "category": "metadata"
   }
  ],
  "apis": [
   {
    "name": "APS REST — Get Schedule",
    "method": "GET",
    "url": "https://aps-host/aps/api/v1/schedules/{scheduleId}/workorders",
    "prereq": [
     "OAuth2 token",
     "schedule:read scope"
    ],
    "purpose": "Retrieve full scheduled order list",
    "sample": "GET /aps/api/v1/schedules/SCH-2025-04-001/workorders",
    "rateLimit": "30 req/min",
    "timeout": "60s"
   },
   {
    "name": "EX REST — Dispatch Schedule",
    "method": "POST",
    "url": "https://opcenter-host/opcenter/api/v1/dispatch/schedule",
    "prereq": [
     "WorkOrder write scope",
     "WorkOrders exist"
    ],
    "purpose": "Update sequence + planned times in bulk",
    "sample": "{ \"schedule_version\":\"v17\", \"workorders\":[{\"name\":\"WO-001\",\"sequence\":1,\"planned_start\":\"2025-04-15T07:00:00Z\"}] }",
    "rateLimit": "10 req/sec (bulk-friendly)",
    "timeout": "120s"
   },
   {
    "name": "Forwarder Webhook Receiver",
    "method": "POST",
    "url": "https://forwarder-host/aps-forwarder/publish",
    "prereq": [
     "TLS termination",
     "APS as trusted source"
    ],
    "purpose": "Receive APS publish event",
    "sample": "{ \"schedule_id\":\"SCH-2025-04-001\", \"version\":17, \"published_at\":\"...\", \"published_by\":\"jane.planner\" }",
    "rateLimit": "10 req/min",
    "timeout": "5s (event acknowledgment only — full sync async)"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "APS ScheduledWorkOrder (in Opcenter APS 2024); related: APS, Scheduling, Finite",
   "destinationBusinessObjectsInScope": "EX WorkOrder dispatch sequence + planned start (in Opcenter 2601)",
   "meaning": "Opcenter APS Detailed Schedule to Opcenter EX: Opcenter APS produces a finite schedule (which order on which resource at which time).",
   "purpose": "Delivers 'Finite, optimized schedule executed on shop floor instead of FIFO' (Production Planning). Without this interface, EX dispatches Work Orders FIFO and the APS schedule is decorative.",
   "functionPrimary": "Move/transform APS ScheduledWorkOrder → EX WorkOrder dispatch sequence + planned start (Sync, Event + Batch (4× daily)-driven).",
   "subFunctions": [
    "APS Configuration + Workflow",
    "Forwarder Service",
    "EX Dispatch Rule",
    "Periodic Batch Job",
    "Integration Tests",
    "UAT + Cutover"
   ],
   "architecture": "Opcenter APS 2024 --[Opcenter APS REST API → Opcenter EX REST API (no middleware)]--> Direct REST --> Opcenter 2601. Pattern: Sync integration, Event + Batch (4× daily) trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: Direct REST. INTRA-MES with inter-system consumers.",
   "interfacePattern": "Sync · Event + Batch (4× daily)",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mes_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-007",
    "IF-016",
    "IF-018"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "APS REST API enabled and authenticated",
   "docSearchKeywords": [
    "Opcenter Execution REST API v1 reference",
    "\"APS ScheduledWorkOrder\" mapping",
    "\"EX WorkOrder dispatch sequence + planned start\" configuration",
    "Direct REST",
    "APS",
    "Scheduling",
    "Finite",
    "Dispatch"
   ],
   "taskHours": 36,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-048",
  "seq": 48,
  "mvp": 2,
  "phase": 4,
  "grp": "PLM",
  "type": "Sync",
  "freq": "Event",
  "name": "TC Tool Specification to Tool Pre-setter (TDM)",
  "from": "Teamcenter 2512",
  "to": "Tool Management System (Zoller/Walter/Coscom)",
  "mid": "AIG Gateway",
  "protocol": "TC SOA → AIG → TDM REST or File Export",
  "bo": "TC ToolAssembly + CuttingTool → TDM Tool record with geometry, presets, materials",
  "complexity": 3,
  "effort": 6,
  "risk": 2,
  "team": "PLM + Tooling + Shop Floor",
  "outcome": "Tools pre-set with engineering specs before they reach the machine",
  "outcomeCat": "Manufacturing Process Engineering",
  "deps": [],
  "about": "When TC releases a ToolAssembly (cutting tool + holder + adapter combination), AIG pushes the engineering specification to the tool management system. Tool pre-setter operator can now load the spec, pre-set the assembly, measure the actual offset, and certify the tool before it reaches the machine. Without this, pre-setter operators key in dimensions manually from drawings — slow and error-prone. ASSUMES generic TDM via REST; vendor-specific adapter (e.g., Zoller TMS Connect) may wrap the same data.",
  "tags": [
   "Tools",
   "ToolManagement",
   "Pre-setter",
   "TDM",
   "Zoller",
   "Walter"
  ],
  "triggers": [
   {
    "id": "TRG-048-01",
    "name": "TC Tool Assembly Released",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "ToolAssembly object status transitions to 'Released'",
    "condition": "ToolAssembly has all required child objects (cutter, holder, adapter)",
    "latency": "< 60 seconds",
    "description": "Engineer releases a ToolAssembly in TC. TC Subscription Manager fires; AIG retrieves the full assembly structure (cutting parameters, geometry, materials, coolant requirements) and transforms to TDM format. Push goes to TDM as a 'pending' tool record; pre-setter operator promotes to 'active' after pre-setting and measurement.",
    "technicalDetails": {
     "protocol": "TC SOA → AIG → TDM REST (or DEXPI XML file drop, vendor-dependent)",
     "tcSoaService": "DataManagement-2006-03-DataManagement.getProperties (deep structure)",
     "tdmRestEndpoint": "POST /tdm/api/v1/tools (vendor-specific URL)",
     "fileExportFormat": "DEXPI XML or vendor-specific (e.g., Zoller XML, Walter CSV)",
     "authentication": "Mutual TLS (TC↔AIG); vendor-specific (TDM)",
     "idempotencyKey": "tc_toolassembly_uid + tc_revision"
    },
    "preConditions": [
     "ToolAssembly definition complete (cutter, holder, adapter, parameters)",
     "TDM accepts API or file-watch input",
     "Tool numbering scheme aligned between TC and TDM",
     "Material codes (e.g., 'P30 carbide') aligned between TC and TDM"
    ],
    "context": "In CNC machining shops, tool changeover is a common bottleneck. Pre-setting reduces machine downtime by preparing tools offline. The interface lets engineering's tool decisions flow directly to the pre-setter without manual re-entry. ROI is high in shops with frequent tool changes.",
    "prerequisites": {
     "teamcenter": [
      "ToolAssembly object type configured with required structure",
      "CuttingTool, ToolHolder, ToolAdapter sub-types",
      "Tool material library aligned with shop's actual inventory",
      "Subscription Manager active for ToolAssembly release"
     ],
     "aig": [
      "Tool data transformation mapping",
      "Vendor adapter (REST client or file writer)",
      "Idempotency table",
      "DLQ for TDM failures"
     ],
     "tdm": [
      "API endpoint or file watch folder configured",
      "Tool numbering scheme aligned with TC",
      "Material codes aligned (or lookup table provided)"
     ]
    },
    "sla": {
     "latency": "< 60s from TC release to TDM visibility",
     "availability": "99% (tools planned ahead; brief outages tolerable)"
    },
    "errorHandling": {
     "tdmUnavailable": "AIG DLQs; retry 5min, 30min, 2h; alert tooling lead after 4h",
     "materialCodeMismatch": "TC material not in TDM lookup → log warning, push with raw code, alert tooling admin",
     "toolAlreadyExists": "TDM record exists with same number, different definition → P2 incident; manual resolution required"
    },
    "monitoring": {
     "metrics": [
      "if048_tool_releases_total",
      "if048_sync_latency_seconds",
      "if048_material_mismatches_total",
      "if048_pending_pre_setting_gauge (tools released but not yet pre-set)"
     ],
     "alerts": [
      "Pending > 48h → email tooling lead",
      "DLQ depth > 5 → Slack #clm-alerts"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 (TC↔AIG); vendor-dependent (AIG↔TDM)",
     "authentication": "Mutual TLS; TDM service account",
     "authorization": "AIG svc account scoped to tool resource only",
     "auditLog": "tc_toolassembly_uid, tc_rev, tdm_tool_no, sync_user_initiator, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify TDM tool record by tc_toolassembly_uid",
      "If not yet pre-set: delete TDM record",
      "If pre-set: mark TDM record 'obsolete' (preserve measurement history)",
      "TC remains authoritative"
     ],
     "estimatedTime": "5 minutes per tool",
     "dataLoss": "None — TC is authoritative; TDM operational history preserved"
    },
    "recommendedMapping": [
     {
      "src": "TC.ToolAssembly.toolNumber",
      "dst": "TDM.Tool.number",
      "xform": "Direct",
      "mandatory": true,
      "note": "Tool number — round-trip key"
     },
     {
      "src": "TC.ToolAssembly.description",
      "dst": "TDM.Tool.description",
      "xform": "Direct",
      "mandatory": true,
      "note": "Description"
     },
     {
      "src": "TC.CuttingTool.diameter",
      "dst": "TDM.Tool.cutting_diameter_mm",
      "xform": "Unit (mm)",
      "mandatory": true,
      "note": "Cutting diameter"
     },
     {
      "src": "TC.CuttingTool.length",
      "dst": "TDM.Tool.cutting_length_mm",
      "xform": "Unit (mm)",
      "mandatory": true,
      "note": "Cutting edge length"
     },
     {
      "src": "TC.CuttingTool.flutes",
      "dst": "TDM.Tool.flute_count",
      "xform": "Integer",
      "mandatory": true,
      "note": "Number of flutes"
     },
     {
      "src": "TC.CuttingTool.material",
      "dst": "TDM.Tool.cutting_material",
      "xform": "Material code lookup",
      "mandatory": true,
      "note": "Carbide/HSS/ceramic"
     },
     {
      "src": "TC.CuttingTool.coating",
      "dst": "TDM.Tool.coating",
      "xform": "Direct",
      "mandatory": false,
      "note": "TiAlN/AlCrN/etc."
     },
     {
      "src": "TC.ToolAssembly.totalLength",
      "dst": "TDM.Tool.total_length_mm",
      "xform": "Unit (mm)",
      "mandatory": true,
      "note": "Assembly total length"
     },
     {
      "src": "TC.ToolHolder.taperType",
      "dst": "TDM.Tool.holder_taper",
      "xform": "Lookup (HSK63A/CAT40/BT40)",
      "mandatory": true,
      "note": "Spindle interface"
     },
     {
      "src": "TC.CuttingParameters.recommendedRPM",
      "dst": "TDM.Tool.rec_rpm",
      "xform": "Integer",
      "mandatory": false,
      "note": "Recommended spindle speed"
     },
     {
      "src": "TC.CuttingParameters.recommendedFeed",
      "dst": "TDM.Tool.rec_feed_mm_min",
      "xform": "Integer",
      "mandatory": false,
      "note": "Recommended feed rate"
     },
     {
      "src": "TC.CuttingParameters.coolantRequired",
      "dst": "TDM.Tool.coolant_required",
      "xform": "Boolean",
      "mandatory": false,
      "note": "Coolant on/off"
     }
    ],
    "configSteps": [
     "Align tool numbering scheme between TC and TDM (one-time mapping if not 1:1)",
     "Build material code lookup table",
     "Configure TC Subscription Manager for ToolAssembly release events",
     "Configure AIG transformation to TDM format (REST JSON or vendor XML)",
     "Configure TDM endpoint or file-watch folder",
     "Configure DLQ with replay UI",
     "Smoke test: release 5 tools; verify TDM visibility < 60s",
     "Negative test: invalid material code → warning + manual review",
     "Pre-setter UAT: tool record loads cleanly into pre-setter UI"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "TC (authoritative) → AIG → TDM (pending → active after pre-set)",
   "correlationStrategy": "tool_number as primary key; tc_toolassembly_uid for revision tracking",
   "consistency": "Eventually consistent within 60s",
   "failureSemantics": "At-least-once; idempotent by (tc_uid, revision)"
  },
  "implementationOrder": [
   "Phase 1: Tool numbering and material code alignment",
   "Phase 2: TDM vendor adapter selection (REST vs. file)",
   "Phase 3: AIG mapping + transformation",
   "Phase 4: TC subscription setup",
   "Phase 5: Pre-setter UAT"
  ],
  "tasks": [
   {
    "id": "T048a",
    "name": "Tool + Material Alignment",
    "type": "Analyze",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Tool numbering scheme aligned (or mapping table built)",
     "Material codes aligned (or lookup table built)",
     "Tooling lead sign-off on alignment doc"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Analyze' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Gather source data for 'Tool + Material Alignment'",
      "subSubTasks": [
       "Extract from Teamcenter 2512",
       "Extract from Tool Management System (Zoller/Walter/Coscom)"
      ]
     },
     {
      "step": 2,
      "title": "Compare and find gaps",
      "subSubTasks": [
       "Align structures/hierarchies",
       "Identify mismatches",
       "Quantify the gap"
      ]
     },
     {
      "step": 3,
      "title": "Produce alignment report",
      "subSubTasks": [
       "Document findings",
       "Agree remediation actions",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T048b",
    "name": "AIG Mapping + TDM Adapter",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Mapping covers all mandatory fields",
     "TDM adapter (REST or file) tested end-to-end",
     "Idempotency table active",
     "DLQ admin UI functional",
     "Health endpoint reports TC + TDM connectivity"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Mapping + TDM Adapter'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Mapping + TDM Adapter'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T048c",
    "name": "TC Subscription + Release Trigger",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Subscription Manager fires on ToolAssembly release",
     "AIG receives event with full assembly UID",
     "Deep-property retrieval pulls all child object data"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Subscription + Release Trigger'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Subscription + Release Trigger'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T048d",
    "name": "Integration + Pre-setter UAT",
    "type": "Test",
    "hours": 8,
    "cx": 2,
    "dod": [
     "10 tools released in TC, all visible in TDM within 60s",
     "Pre-setter operator loads spec and runs pre-set successfully",
     "Re-release: revision update flows correctly",
     "TDM outage: AIG DLQ holds, recovers on TDM restore"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration + Pre-setter UAT'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→Tool Management System (Zoller/Walter/Coscom))",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Tool Management System (Zoller/Walter/Coscom)"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T048e",
    "name": "Cutover + Adoption Window",
    "type": "Validate",
    "hours": 4,
    "cx": 1,
    "dod": [
     "30-day window: pre-setter time-per-tool reduces measurably",
     "Manual data entry incidents tracked and decreasing",
     "Tooling lead sign-off"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Cutover + Adoption Window'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.ToolAssembly.toolNumber",
    "dst": "TDM.Tool.number",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ToolAssembly.description",
    "dst": "TDM.Tool.description",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ToolAssembly.revision",
    "dst": "TDM.Tool.revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.CuttingTool.diameter",
    "dst": "TDM.Tool.cutting_diameter_mm",
    "xform": "Unit",
    "category": "core"
   },
   {
    "src": "TC.CuttingTool.length",
    "dst": "TDM.Tool.cutting_length_mm",
    "xform": "Unit",
    "category": "core"
   },
   {
    "src": "TC.CuttingTool.flutes",
    "dst": "TDM.Tool.flute_count",
    "xform": "Integer",
    "category": "core"
   },
   {
    "src": "TC.CuttingTool.material",
    "dst": "TDM.Tool.cutting_material",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "TC.CuttingTool.coating",
    "dst": "TDM.Tool.coating",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "TC.CuttingTool.helixAngle",
    "dst": "TDM.Tool.helix_angle_deg",
    "xform": "Numeric",
    "category": "additional"
   },
   {
    "src": "TC.CuttingTool.rakeAngle",
    "dst": "TDM.Tool.rake_angle_deg",
    "xform": "Numeric",
    "category": "additional"
   },
   {
    "src": "TC.ToolAssembly.totalLength",
    "dst": "TDM.Tool.total_length_mm",
    "xform": "Unit",
    "category": "core"
   },
   {
    "src": "TC.ToolAssembly.totalWeight",
    "dst": "TDM.Tool.total_weight_kg",
    "xform": "Unit",
    "category": "additional"
   },
   {
    "src": "TC.ToolHolder.taperType",
    "dst": "TDM.Tool.holder_taper",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "TC.ToolHolder.partNumber",
    "dst": "TDM.Tool.holder_part_no",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "TC.CuttingParameters.recommendedRPM",
    "dst": "TDM.Tool.rec_rpm",
    "xform": "Integer",
    "category": "additional"
   },
   {
    "src": "TC.CuttingParameters.recommendedFeed",
    "dst": "TDM.Tool.rec_feed_mm_min",
    "xform": "Integer",
    "category": "additional"
   },
   {
    "src": "TC.CuttingParameters.recommendedDOC",
    "dst": "TDM.Tool.rec_doc_mm",
    "xform": "Numeric",
    "category": "additional"
   },
   {
    "src": "TC.CuttingParameters.coolantRequired",
    "dst": "TDM.Tool.coolant_required",
    "xform": "Boolean",
    "category": "additional"
   },
   {
    "src": "TC.ToolAssembly.expectedLife",
    "dst": "TDM.Tool.expected_life_min",
    "xform": "Integer",
    "category": "metadata"
   }
  ],
  "apis": [
   {
    "name": "TC SOA — Deep Property Retrieval",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/DataManagement-2006-03-DataManagement/getProperties",
    "prereq": [
     "SOA session",
     "Tool Designer role"
    ],
    "purpose": "Retrieve ToolAssembly with all children (deep)",
    "sample": "<objects>...</objects><attributes>...</attributes>",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "TDM REST — Create Tool",
    "method": "POST",
    "url": "https://tdm-host/tdm/api/v1/tools (vendor-specific)",
    "prereq": [
     "API token",
     "Tool create scope"
    ],
    "purpose": "Create pending tool record in TDM",
    "sample": "{ \"number\":\"T-4521\",\"diameter\":12.0,\"flutes\":4,\"material\":\"CARBIDE-P30\",\"status\":\"pending\" }",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "TDM File Watch (fallback)",
    "method": "File drop",
    "url": "//tdm-server/import/incoming/",
    "prereq": [
     "SMB or SFTP access",
     "Watch service running"
    ],
    "purpose": "Alternative to REST for older TDM versions",
    "sample": "Tool-T-4521-revA.xml (DEXPI or vendor format)",
    "rateLimit": "n/a",
    "timeout": "n/a"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "TC ToolAssembly + CuttingTool (in Teamcenter 2512); related: Tools, ToolManagement, Pre-setter",
   "destinationBusinessObjectsInScope": "TDM Tool record with geometry, presets, materials (in Tool Management System (Zoller/Walter/Coscom))",
   "meaning": "TC Tool Specification to Tool Pre-setter (TDM): When TC releases a ToolAssembly (cutting tool + holder + adapter combination), AIG pushes the engineering specification to the tool management system.",
   "purpose": "Delivers 'Tools pre-set with engineering specs before they reach the machine' (Manufacturing Process Engineering). Tool pre-setter operator can now load the spec, pre-set the assembly, measure the actual offset, and certify the tool before it reaches the machine.",
   "functionPrimary": "Move/transform TC ToolAssembly + CuttingTool → TDM Tool record with geometry, presets, materials (Sync, Event-driven).",
   "subFunctions": [
    "Tool + Material Alignment",
    "AIG Mapping + TDM Adapter",
    "TC Subscription + Release Trigger",
    "Integration + Pre-setter UAT",
    "Cutover + Adoption Window"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → TDM REST or File Export]--> AIG Gateway --> Tool Management System (Zoller/Walter/Coscom). Pattern: Sync integration, Event trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTRA-PLM with inter-system consumers.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: plm_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Tool numbering scheme aligned (or mapping table built)",
   "docSearchKeywords": [
    "Teamcenter BMIDE + SOA reference",
    "\"TC ToolAssembly + CuttingTool\" mapping",
    "\"TDM Tool record with geometry, presets, materials\" configuration",
    "AIG Gateway",
    "Tools",
    "ToolManagement",
    "Pre-setter",
    "TDM"
   ],
   "taskHours": 30,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 5
   }
  }
 },
 {
  "id": "IF-051",
  "seq": 51,
  "mvp": 2,
  "phase": 5,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "Supplier PPAP/FAI Submission to TC + Opcenter QMS",
  "from": "Opcenter QMS Supplier Portal",
  "to": "Teamcenter 2512 + Opcenter QMS",
  "mid": "AIG Gateway",
  "protocol": "Opcenter QMS Supplier REST → AIG → TC SOA + Opcenter REST",
  "bo": "PPAP/AS9102 Package → TC Dataset (released) + QMS InspectionPlan + SupplierApprovalStatus",
  "complexity": 4,
  "effort": 10,
  "risk": 3,
  "team": "Supplier Quality + PLM + QMS Admin",
  "outcome": "Documented supplier qualification; first-time-right inbound inspection setup",
  "outcomeCat": "Supplier Quality",
  "deps": [
   "IF-014"
  ],
  "about": "When a supplier submits a PPAP package (automotive AIAG standard) or AS9102 FAI (aerospace) or equivalent qualification artifacts via the portal, this interface routes the package to TC (as released, signed datasets linked to the part revision) and to Opcenter QMS (where inspection plans are configured from the supplier's submitted characteristics). PPAP approval status (PPAP Level 1-5) flows back to ERP/Procurement so the supplier-part combination is unlocked for production POs. ASSUMES Opcenter QMS Supplier portal; for SupplyOn/Ariba, inbound transport changes but field mappings remain.",
  "tags": [
   "PPAP",
   "FAI",
   "AS9102",
   "SupplierQuality",
   "Qualification",
   "AIAG",
   "PortalIntegration"
  ],
  "triggers": [
   {
    "id": "TRG-051-01",
    "name": "Supplier Submits PPAP/FAI Package",
    "type": "RELEASE",
    "source": "Opcenter QMS Supplier Portal",
    "sourceEvent": "Supplier user completes 'Submit PPAP' or 'Submit FAI' workflow in portal",
    "condition": "All required documents attached; supplier signature present",
    "latency": "< 5 minutes from supplier submit to internal visibility",
    "description": "Supplier completes the portal submission workflow. Portal validates all required documents are attached (control plan, FMEA, MSA, dimensional results, material certs, etc. per PPAP Level), captures supplier e-signature, and fires webhook to AIG. AIG splits the package: documents go to TC as Dataset objects (linked to part revision and supplier), characteristic data goes to Opcenter QMS as an inspection plan, and an overall SupplierApprovalStatus record is created in TC for the part-supplier combination. Supplier Quality Engineer is notified for review.",
    "technicalDetails": {
     "protocol": "Opcenter QMS Supplier webhook → AIG → TC SOA + Opcenter REST",
     "portalApi": "Opcenter QMS Supplier REST API v1",
     "tcSoaServices": [
      "Dataset-2008-06-DatasetManagement.createDataset",
      "DataManagement-2006-03-DataManagement.createRelations"
     ],
     "opcenterApi": "POST /opcenter/api/v1/qms/inspection-plans",
     "artifactFormats": [
      "PPAP Level 1-5 (AIAG)",
      "AS9102 (SAE)",
      "ISO 16949 (custom)"
     ],
     "authentication": "Mutual TLS (Portal↔AIG); SAP cert + svc accounts downstream",
     "idempotencyKey": "portal_submission_id",
     "documentChecksum": "SHA-256 stored on each Dataset for tamper evidence"
    },
    "preConditions": [
     "Opcenter QMS Supplier portal deployed and accessible to suppliers",
     "Supplier accounts created and assigned to part-supplier combinations",
     "TC ItemRevision exists for the part being qualified",
     "Vendor master in SAP linked to portal supplier account (via IF-014 vendor sync)",
     "PPAP level required defined per part (Level 3 standard; Level 5 for safety-critical)",
     "AIG correlation table maps portal_submission_id → tc_item_rev_uid + vendor_no"
    ],
    "context": "PPAP / FAI is mandatory in automotive (IATF 16949), aerospace (AS9100), and increasingly medical device. Without an interface, packages arrive via email or are uploaded to a shared drive, then manually rekeyed into TC and QMS. This is slow (typical TAT 2-3 weeks), error-prone, and impossible to audit reliably. With the interface, TAT drops to days, every submission has an audit trail, and inspection plans match what the supplier actually committed to deliver.",
    "prerequisites": {
     "portal": [
      "Opcenter QMS Supplier portal with PPAP/FAI submission workflows",
      "Supplier onboarding completed (accounts, e-signature certs, parts assigned)",
      "Webhook configured to AIG on submission events",
      "Document requirements per PPAP Level configured"
     ],
     "aig": [
      "Webhook receiver /aig/if051/submission",
      "Document splitter (separates ZIP/multi-doc packages into individual files)",
      "Characteristic data parser (PPAP Element 9: Dimensional Results)",
      "Correlation table: portal_submission_id ↔ tc_item_rev + vendor",
      "Virus scan integration for inbound documents",
      "DLQ with replay UI"
     ],
     "teamcenter": [
      "Dataset type SupplierQualPackage (sub-type of Dataset)",
      "Dataset properties: zz_ppap_level, zz_ppap_status, zz_supplier_vendor_no, zz_signed_by, zz_signature_date",
      "Custom relation type Z_SupplierQualifies (ItemRev → SupplierQualPackage)",
      "Custom object SupplierApprovalStatus (one per ItemRev × Vendor)"
     ],
     "opcenter_qms": [
      "InspectionPlan creation API accepts external characteristic definition",
      "Characteristic library aligned with PPAP characteristic categories",
      "InspectionPlan auto-link to incoming material per vendor"
     ]
    },
    "sla": {
     "latency": "< 5min from supplier submit to internal visibility",
     "availability": "99% during business hours",
     "documentIntegrity": "100% (checksum match required for sign-off)"
    },
    "errorHandling": {
     "missingDocuments": "Portal validates at submit time; AIG re-validates as defense-in-depth → reject submission with reason; supplier sees rejection in portal",
     "virusDetected": "Block submission; quarantine document; alert Security; supplier notified",
     "tcDown": "AIG DLQ; portal shows 'received, processing'; retry on TC restore",
     "opcenterDown": "Documents proceed to TC; InspectionPlan creation deferred; Supplier Quality alerted",
     "signatureInvalid": "Reject submission; supplier must re-sign; audit log retained"
    },
    "monitoring": {
     "metrics": [
      "if051_submissions_total{ppap_level,outcome}",
      "if051_submission_latency_seconds",
      "if051_pending_review_gauge (submitted but not yet approved by SQE)",
      "if051_document_validation_failures_total"
     ],
     "alerts": [
      "Pending review > 5 business days → email Supplier Quality lead",
      "Virus detection → immediate Security alert",
      "Signature invalid > 3/week → portal admin review"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 end-to-end; documents encrypted at rest on TC volume",
     "authentication": "Supplier e-signature with X.509 cert; AIG validates cert chain",
     "authorization": "Supplier account scoped to assigned parts only",
     "auditLog": "submission_id, vendor, part, level, documents (checksums), supplier_user, sqe_reviewer, timestamps",
     "dataClassification": "Supplier qualification data: confidential; retain 10 years (audit requirement)"
    },
    "rollback": {
     "steps": [
      "Identify TC Datasets and SupplierApprovalStatus by submission_id",
      "If not yet reviewed by SQE: delete artifacts",
      "If reviewed: mark as 'superseded' (preserve audit trail)",
      "InspectionPlan in QMS: deactivate (do not delete)",
      "Notify supplier via portal: 'resubmission required'"
     ],
     "estimatedTime": "20 minutes per submission",
     "dataLoss": "Portal submission preserved (authoritative); internal artifacts can be re-created"
    },
    "recommendedMapping": [
     {
      "src": "Portal.Submission.id",
      "dst": "TC.SupplierQualPackage.zz_submission_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Round-trip key"
     },
     {
      "src": "Portal.Submission.partNumber",
      "dst": "TC.SupplierQualPackage.zz_part_number",
      "xform": "Direct (lookup to ItemRev)",
      "mandatory": true,
      "note": "Part qualified"
     },
     {
      "src": "Portal.Submission.partRevision",
      "dst": "TC.SupplierQualPackage.zz_part_revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "Specific revision"
     },
     {
      "src": "Portal.Submission.vendorNumber",
      "dst": "TC.SupplierQualPackage.zz_vendor_no",
      "xform": "Direct",
      "mandatory": true,
      "note": "SAP vendor number"
     },
     {
      "src": "Portal.Submission.ppapLevel",
      "dst": "TC.SupplierQualPackage.zz_ppap_level",
      "xform": "Integer 1-5",
      "mandatory": true,
      "note": "AIAG level"
     },
     {
      "src": "Portal.Submission.submittedBy",
      "dst": "TC.SupplierQualPackage.zz_signed_by",
      "xform": "Direct (supplier user)",
      "mandatory": true,
      "note": "Supplier signer"
     },
     {
      "src": "Portal.Submission.submittedAt",
      "dst": "TC.SupplierQualPackage.zz_signature_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Submission timestamp"
     },
     {
      "src": "Portal.Submission.signatureCert",
      "dst": "TC.SupplierQualPackage.zz_cert_thumbprint",
      "xform": "Cert thumbprint",
      "mandatory": true,
      "note": "E-signature cert"
     },
     {
      "src": "Portal.Document.checksum",
      "dst": "TC.Dataset.zz_sha256",
      "xform": "Direct",
      "mandatory": true,
      "note": "Tamper-evidence"
     },
     {
      "src": "Portal.Characteristic.nominal",
      "dst": "Opcenter.InspectionPlan.Char.nominal",
      "xform": "Numeric",
      "mandatory": false,
      "note": "PPAP dimensional"
     },
     {
      "src": "Portal.Characteristic.tolerance",
      "dst": "Opcenter.InspectionPlan.Char.tolerance",
      "xform": "Numeric",
      "mandatory": false,
      "note": "PPAP dimensional"
     },
     {
      "src": "Portal.Characteristic.cpk",
      "dst": "Opcenter.InspectionPlan.Char.required_cpk",
      "xform": "Numeric (≥1.33 typical)",
      "mandatory": false,
      "note": "Capability requirement"
     }
    ],
    "configSteps": [
     "Deploy Opcenter QMS Supplier portal with PPAP/FAI workflows",
     "Onboard initial suppliers (accounts, e-sig certs, part assignments)",
     "Configure portal webhook to AIG on submission",
     "Add TC Dataset sub-type SupplierQualPackage with required properties",
     "Add TC custom object SupplierApprovalStatus + relation Z_SupplierQualifies",
     "Deploy AIG webhook receiver with virus scan integration",
     "Build characteristic parser for PPAP Element 9 dimensional data",
     "Configure Opcenter QMS InspectionPlan creation API",
     "Build correlation table population (submission ↔ ItemRev + vendor)",
     "Implement DLQ replay UI",
     "Smoke test: supplier submits Level 3 PPAP; verify TC + QMS artifacts within 5min",
     "Negative test: missing required doc → portal rejects at submit",
     "Negative test: malformed signature → AIG rejects, audit logged",
     "Audit test: trace from supplier submission through SQE approval to PO unlock"
    ]
   },
   {
    "id": "TRG-051-02",
    "name": "SQE Approves Supplier Qualification",
    "type": "APPROVE",
    "source": "Teamcenter 2512",
    "sourceEvent": "SupplierApprovalStatus workflow completes with verdict 'Approved'",
    "condition": "All Dataset attachments reviewed; SQE signature recorded",
    "latency": "< 60 seconds",
    "description": "Supplier Quality Engineer reviews the submission in TC, validates each artifact, and approves the supplier-part combination. The SupplierApprovalStatus.status transitions to 'Approved'; AIG fires outbound to SAP (vendor info record unlocked for PO creation) and to the portal (supplier sees 'Approved' status with effective dates).",
    "technicalDetails": {
     "protocol": "TC Subscription → AIG → SAP BAPI_PO_INFOREC_GETLIST/CREATE + Portal REST",
     "sapBapis": [
      "BAPI_INFORECORD_CREATE (creates info record if first-time)",
      "BAPI_INFORECORD_CHANGE (updates qualification flag)"
     ],
     "portalEndpoint": "PATCH /portal/api/v1/submissions/{id}/status",
     "authentication": "Mutual TLS; SAP RFC svc account",
     "idempotencyKey": "tc_supplier_approval_uid + decision_timestamp"
    },
    "preConditions": [
     "SupplierApprovalStatus exists for the part-vendor combination",
     "SQE has 'Supplier Quality Engineer' role in TC",
     "Vendor info record path defined in SAP (combination of vendor + material + plant + purch org)"
    ],
    "sla": {
     "latency": "< 60s from SQE approval to SAP unlock + portal notification",
     "availability": "99%"
    },
    "recommendedMapping": [
     {
      "src": "TC.SupplierApprovalStatus.vendor",
      "dst": "SAP.EINA-LIFNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Vendor number"
     },
     {
      "src": "TC.SupplierApprovalStatus.material",
      "dst": "SAP.EINA-MATNR",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material"
     },
     {
      "src": "TC.SupplierApprovalStatus.plant",
      "dst": "SAP.EINE-WERKS",
      "xform": "Direct",
      "mandatory": true,
      "note": "Plant"
     },
     {
      "src": "AIG.constant",
      "dst": "SAP.EINA-ZZ_QUALIFIED",
      "xform": "Constant 'X'",
      "mandatory": true,
      "note": "Custom flag — qualified"
     },
     {
      "src": "TC.SupplierApprovalStatus.effectiveFrom",
      "dst": "SAP.EINE-ZZ_QUAL_FROM",
      "xform": "Date",
      "mandatory": true,
      "note": "Qualification start"
     },
     {
      "src": "TC.SupplierApprovalStatus.effectiveTo",
      "dst": "SAP.EINE-ZZ_QUAL_TO",
      "xform": "Date",
      "mandatory": true,
      "note": "Qualification end (typical 2 years)"
     },
     {
      "src": "TC.SupplierApprovalStatus.sqeApprover",
      "dst": "Portal.Submission.sqe_approver",
      "xform": "Direct",
      "mandatory": true,
      "note": "SQE attribution"
     }
    ],
    "configSteps": [
     "Add custom fields to SAP EINA/EINE (ZZ_QUALIFIED, ZZ_QUAL_FROM, ZZ_QUAL_TO)",
     "Configure SAP PO creation logic to block if ZZ_QUALIFIED ≠ 'X' (or warn, per policy)",
     "Build AIG outbound to SAP on TC approval",
     "Build AIG outbound to portal for supplier visibility",
     "Test: SQE approves → SAP unlocks within 60s",
     "Test: Procurement attempts PO before qualification → blocked"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Portal (supplier) → AIG → TC (review) + QMS (inspection setup); approval → SAP unlock",
   "correlationStrategy": "portal_submission_id everywhere; SAP vendor_no + material as PO-side key",
   "consistency": "Eventually consistent; SQE review can take days (business process, not technical)",
   "failureSemantics": "At-least-once; idempotent by submission_id; documents tamper-evident via checksum"
  },
  "implementationOrder": [
   "Phase 1: Portal deployment + supplier onboarding pilot (3-5 suppliers)",
   "Phase 2: TC object model (SupplierQualPackage, SupplierApprovalStatus)",
   "Phase 3: AIG submission flow (portal → TC + QMS)",
   "Phase 4: SQE review workflow in TC",
   "Phase 5: Approval-to-SAP-unlock flow",
   "Phase 6: Pilot with 1-2 part-supplier combos",
   "Phase 7: Wider rollout"
  ],
  "tasks": [
   {
    "id": "T051a",
    "name": "Portal Deployment + Supplier Onboarding",
    "type": "Install",
    "hours": 20,
    "cx": 3,
    "dod": [
     "Opcenter QMS Supplier portal deployed",
     "5 pilot suppliers onboarded with e-sig certs",
     "PPAP/FAI workflows configured per industry",
     "Webhook to AIG fires on submission"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the AIG Gateway component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to Opcenter QMS Supplier Portal and Teamcenter 2512 + Opcenter QMS",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T051b",
    "name": "TC Object Model + Workflow",
    "type": "Configure",
    "hours": 10,
    "cx": 3,
    "dod": [
     "SupplierQualPackage Dataset sub-type with all custom properties",
     "SupplierApprovalStatus custom object with workflow",
     "Z_SupplierQualifies relation type",
     "SQE review workflow with approval gates",
     "Document viewer integrated for PPAP packages"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Object Model + Workflow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Object Model + Workflow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T051c",
    "name": "AIG Submission Flow",
    "type": "Configure",
    "hours": 12,
    "cx": 4,
    "dod": [
     "Webhook receiver validates submission",
     "Virus scan integrated (and tested with EICAR test file)",
     "Document splitter handles ZIP and multi-doc submissions",
     "Characteristic parser extracts PPAP Element 9 data",
     "TC Datasets created and linked to ItemRev",
     "Opcenter InspectionPlan created from characteristics",
     "Correlation table populated",
     "DLQ replay UI functional"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Submission Flow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Submission Flow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T051d",
    "name": "Approval-to-SAP-Unlock Flow",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "SAP custom fields ZZ_QUALIFIED, ZZ_QUAL_FROM/TO added to EINA/EINE",
     "PO creation logic respects qualification flag",
     "AIG outbound on SQE approval working",
     "Portal status update on approval working",
     "Test: full cycle from submission to PO-ready < 5 business days in QA"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Approval-to-SAP-Unlock Flow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Approval-to-SAP-Unlock Flow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T051e",
    "name": "Integration + Audit Tests",
    "type": "Test",
    "hours": 12,
    "cx": 4,
    "dod": [
     "Happy path: 5 PPAP submissions processed end-to-end",
     "Negative: missing doc rejected at portal",
     "Negative: invalid signature rejected at AIG",
     "Audit trace: full lineage from supplier submit to PO unlock",
     "Re-submission after reject works correctly",
     "Multi-part submission (one package, 3 parts) handled"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration + Audit Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Opcenter QMS Supplier Portal→Teamcenter 2512 + Opcenter QMS)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Teamcenter 2512 + Opcenter QMS"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T051f",
    "name": "Pilot + Production Rollout",
    "type": "Validate",
    "hours": 10,
    "cx": 3,
    "dod": [
     "2-week pilot with 5 suppliers, 10 submissions",
     "SQE sign-off on review experience",
     "Audit team sign-off on traceability",
     "Procurement sign-off on PO unlock behavior",
     "Production rollout plan approved"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Pilot + Production Rollout'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Portal.Submission.id",
    "dst": "TC.SupplierQualPackage.zz_submission_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Submission.partNumber",
    "dst": "TC.SupplierQualPackage.zz_part_number",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Submission.partRevision",
    "dst": "TC.SupplierQualPackage.zz_part_revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Submission.vendorNumber",
    "dst": "TC.SupplierQualPackage.zz_vendor_no",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Submission.ppapLevel",
    "dst": "TC.SupplierQualPackage.zz_ppap_level",
    "xform": "Integer",
    "category": "core"
   },
   {
    "src": "Portal.Submission.submittedBy",
    "dst": "TC.SupplierQualPackage.zz_signed_by",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "Portal.Submission.submittedAt",
    "dst": "TC.SupplierQualPackage.zz_signature_date",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "Portal.Submission.signatureCert",
    "dst": "TC.SupplierQualPackage.zz_cert_thumbprint",
    "xform": "Thumbprint",
    "category": "audit"
   },
   {
    "src": "Portal.Document.checksum",
    "dst": "TC.Dataset.zz_sha256",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "Portal.Document.filename",
    "dst": "TC.Dataset.object_name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Document.type",
    "dst": "TC.Dataset.zz_doc_type",
    "xform": "Lookup",
    "category": "metadata"
   },
   {
    "src": "Portal.Characteristic.id",
    "dst": "Opcenter.InspectionPlan.Char.id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Characteristic.description",
    "dst": "Opcenter.InspectionPlan.Char.description",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Portal.Characteristic.nominal",
    "dst": "Opcenter.InspectionPlan.Char.nominal",
    "xform": "Numeric",
    "category": "core"
   },
   {
    "src": "Portal.Characteristic.upperTolerance",
    "dst": "Opcenter.InspectionPlan.Char.upper_tol",
    "xform": "Numeric",
    "category": "core"
   },
   {
    "src": "Portal.Characteristic.lowerTolerance",
    "dst": "Opcenter.InspectionPlan.Char.lower_tol",
    "xform": "Numeric",
    "category": "core"
   },
   {
    "src": "Portal.Characteristic.cpk",
    "dst": "Opcenter.InspectionPlan.Char.required_cpk",
    "xform": "Numeric",
    "category": "quality"
   },
   {
    "src": "Portal.Characteristic.measurementMethod",
    "dst": "Opcenter.InspectionPlan.Char.method",
    "xform": "Direct",
    "category": "quality"
   },
   {
    "src": "TC.SupplierApprovalStatus.effectiveFrom",
    "dst": "SAP.EINE-ZZ_QUAL_FROM",
    "xform": "Date",
    "category": "core"
   },
   {
    "src": "TC.SupplierApprovalStatus.effectiveTo",
    "dst": "SAP.EINE-ZZ_QUAL_TO",
    "xform": "Date",
    "category": "core"
   },
   {
    "src": "TC.SupplierApprovalStatus.sqeApprover",
    "dst": "TC.SupplierApprovalStatus.zz_sqe_approver",
    "xform": "User",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "Portal Webhook → AIG",
    "method": "POST",
    "url": "https://aig-host/aig/if051/submission",
    "prereq": [
     "Portal webhook secret",
     "TLS"
    ],
    "purpose": "Notify AIG of supplier submission",
    "sample": "{ \"submission_id\":\"SUB-12345\", \"vendor\":\"VEN-001\", \"part\":\"BV-3IN-001\", \"level\":3, \"documents\":[...], \"characteristics\":[...] }",
    "rateLimit": "30 req/min",
    "timeout": "30s"
   },
   {
    "name": "Portal REST — Get Submission",
    "method": "GET",
    "url": "https://portal-host/portal/api/v1/submissions/{id}",
    "prereq": [
     "API token"
    ],
    "purpose": "Retrieve full submission detail for review",
    "sample": "GET /portal/api/v1/submissions/SUB-12345",
    "rateLimit": "60 req/min",
    "timeout": "30s"
   },
   {
    "name": "TC SOA — Create Dataset",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Dataset-2008-06-DatasetManagement/createDataset",
    "prereq": [
     "SOA session",
     "Document Author role"
    ],
    "purpose": "Create SupplierQualPackage Dataset in TC",
    "sample": "<input><name>...</name><type>SupplierQualPackage</type><attachments>...</attachments></input>",
    "rateLimit": "10 req/sec",
    "timeout": "60s"
   },
   {
    "name": "Opcenter REST — Create Inspection Plan",
    "method": "POST",
    "url": "https://opcenter-host/opcenter/api/v1/qms/inspection-plans",
    "prereq": [
     "QMS configured",
     "Material exists"
    ],
    "purpose": "Create inspection plan from PPAP characteristics",
    "sample": "{ \"material\":\"BV-3IN-001\", \"vendor\":\"VEN-001\", \"characteristics\":[{...}] }",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "SAP BAPI_INFORECORD_CHANGE",
    "method": "RFC",
    "url": "SAP RFC connection (SNC)",
    "prereq": [
     "EINA/EINE custom fields",
     "Info record exists"
    ],
    "purpose": "Set qualification flag on vendor info record",
    "sample": "BAPI_INFORECORD_CHANGE( INFRECNUM:'...', ZZ_QUALIFIED:'X', ZZ_QUAL_FROM:'20250501', ZZ_QUAL_TO:'20270501' )",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "PPAP/AS9102 Package (in Opcenter QMS Supplier Portal); related: PPAP, FAI, AS9102",
   "destinationBusinessObjectsInScope": "TC Dataset (released) + QMS InspectionPlan + SupplierApprovalStatus (in Teamcenter 2512 + Opcenter QMS)",
   "meaning": "Supplier PPAP/FAI Submission to TC + Opcenter QMS: When a supplier submits a PPAP package (automotive AIAG standard) or AS9102 FAI (aerospace) or equivalent qualification artifacts via the portal, this interface routes the package to TC (as released, signed datasets linked to the part revision) and to Opcenter QMS (where inspection plans are configured from the supplier's submitted characteristics).",
   "purpose": "Delivers 'Documented supplier qualification; first-time-right inbound inspection setup' (Supplier Quality). PPAP approval status (PPAP Level 1-5) flows back to ERP/Procurement so the supplier-part combination is unlocked for production POs.",
   "functionPrimary": "Move/transform PPAP/AS9102 Package → TC Dataset (released) + QMS InspectionPlan + SupplierApprovalStatus (Sync, Event-driven).",
   "subFunctions": [
    "Portal Deployment + Supplier Onboarding",
    "TC Object Model + Workflow",
    "AIG Submission Flow",
    "Approval-to-SAP-Unlock Flow",
    "Integration + Audit Tests",
    "Pilot + Production Rollout"
   ],
   "architecture": "Opcenter QMS Supplier Portal --[Opcenter QMS Supplier REST → AIG → TC SOA + Opcenter REST]--> AIG Gateway --> Teamcenter 2512 + Opcenter QMS. Pattern: Sync integration, Event trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-014"
   ],
   "downstreamConsumers": [
    "IF-052",
    "IF-055"
   ],
   "criticalityScore": 9,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Opcenter QMS Supplier portal deployed",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"PPAP/AS9102 Package\" mapping",
    "\"TC Dataset (released) + QMS InspectionPlan + SupplierApprovalStatus\" configuration",
    "AIG Gateway",
    "PPAP",
    "FAI",
    "AS9102",
    "SupplierQuality"
   ],
   "taskHours": 72,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-052",
  "seq": 52,
  "mvp": 2,
  "phase": 5,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "TC ECO Notification to Supplier Portal",
  "from": "Teamcenter 2512",
  "to": "Opcenter QMS Supplier Portal",
  "mid": "AIG Gateway",
  "protocol": "TC SOA → AIG → Portal REST",
  "bo": "TC ECO → Supplier Notification (new rev + drawing + effective date + ack required)",
  "complexity": 2,
  "effort": 5,
  "risk": 2,
  "team": "PLM + Supplier Quality + Portal Admin",
  "outcome": "Suppliers notified of design changes in time to adjust production",
  "outcomeCat": "Supplier Quality",
  "deps": [
   "IF-014",
   "IF-051"
  ],
  "about": "When TC releases an Engineering Change Order (ECO) that affects a purchased part, this interface notifies the relevant suppliers via the portal. Notification includes the new ItemRevision, attached current drawing(s), effective date, change reason, and a required acknowledgment from supplier. Acknowledgment status flows back so Procurement knows whether suppliers have seen the change. Critical for change control in regulated industries. ASSUMES Opcenter QMS Supplier portal.",
  "tags": [
   "ECO",
   "ChangeControl",
   "SupplierNotification",
   "Portal",
   "Acknowledgment"
  ],
  "triggers": [
   {
    "id": "TRG-052-01",
    "name": "TC ECO Released with Purchased Parts",
    "type": "RELEASE",
    "source": "Teamcenter 2512",
    "sourceEvent": "ECO object status transitions to 'Released' AND ECO contains at least one Item with procurement_type='Purchased'",
    "condition": "At least one affected part has active supplier (PPAP-qualified vendor exists per IF-051)",
    "latency": "< 10 minutes from ECO release to supplier notification",
    "description": "TC ECO releases. AIG retrieves the ECO impact list, filters to purchased parts, queries the qualified-supplier list per part (from SupplierApprovalStatus per IF-051), and creates one notification per part-supplier combination in the portal. Supplier sees notification in their portal dashboard with new drawing, revision, effective date, and must acknowledge to continue receiving production POs. Acknowledgment timestamp and user flow back to TC for audit.",
    "technicalDetails": {
     "protocol": "TC SOA event → AIG → Portal REST",
     "tcSoaServices": [
      "ChangeManagement-2007-01-ChangeManagement.getECOImpactedObjects"
     ],
     "portalEndpoint": "POST /portal/api/v1/notifications",
     "attachmentTransfer": "TC Dataset download + portal upload (or signed URL pattern)",
     "authentication": "Mutual TLS",
     "idempotencyKey": "tc_eco_id + part_number + vendor_no"
    },
    "preConditions": [
     "ECO contains affected Items (impact list populated by engineering)",
     "Items have procurement_type property indicating Purchased",
     "SupplierApprovalStatus records exist (from IF-051)",
     "Current drawings released as TC Datasets",
     "Portal has supplier accounts configured (from IF-051 onboarding)"
    ],
    "context": "Change control under audit: when ECO release results in supplier change requirement, the manufacturer must prove the supplier was notified, by when, and that they acknowledged. Without this interface, the proof is in email — slow to retrieve in audit, may be missing for some recipients, no acknowledgment tracking. With this interface, the audit trail is structured and queryable.",
    "prerequisites": {
     "teamcenter": [
      "ECO workflow configured with proper Release transition",
      "Item.procurement_type property populated (Make/Buy/Service)",
      "Drawing Datasets linked to ItemRevisions",
      "ECO description property used for change reason (or separate field)"
     ],
     "aig": [
      "TC SOA subscription on ECO release",
      "Impact list retrieval and supplier resolution logic",
      "Document transfer mechanism (typically signed URL with TTL)",
      "Per-part-supplier notification fan-out",
      "Acknowledgment-receipt webhook listener"
     ],
     "portal": [
      "Notification module with attachment display",
      "Supplier acknowledgment workflow with e-signature",
      "Webhook on ack to AIG for callback"
     ]
    },
    "sla": {
     "latency": "< 10min from ECO release to portal visibility",
     "availability": "99%"
    },
    "errorHandling": {
     "noQualifiedSupplier": "Part has no SupplierApprovalStatus → log warning, alert Sourcing (need to qualify a supplier)",
     "portalDown": "AIG DLQ; ECO marked 'Notification Pending' in TC; retry on portal restore",
     "attachmentTooLarge": "Drawing > 50MB → use signed URL pattern; portal fetches on demand",
     "supplierAccountInactive": "Vendor flagged inactive in portal → skip notification, alert Sourcing"
    },
    "monitoring": {
     "metrics": [
      "if052_notifications_sent_total",
      "if052_pending_ack_gauge",
      "if052_ack_received_total",
      "if052_avg_time_to_ack_hours"
     ],
     "alerts": [
      "Pending ack > 5 business days → email Sourcing",
      "Acknowledgment rate < 90% over 30 days → process review with Supplier Quality"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 + signed URLs with 24h TTL for attachments",
     "authentication": "Supplier portal account (per IF-051)",
     "authorization": "Supplier only sees notifications for parts they are qualified for",
     "auditLog": "tc_eco_id, part, vendor, supplier_user, ack_timestamp, ack_signature"
    },
    "rollback": {
     "steps": [
      "Identify notifications by tc_eco_id",
      "Portal: mark notifications as 'withdrawn' (preserve audit trail)",
      "Suppliers notified of withdrawal via separate notification",
      "TC ECO status updated to 'Notification Withdrawn' for visibility"
     ],
     "estimatedTime": "10 minutes per ECO",
     "dataLoss": "None — all notifications and acks preserved in audit log"
    },
    "recommendedMapping": [
     {
      "src": "TC.ECO.eco_id",
      "dst": "Portal.Notification.zz_eco_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "ECO identifier"
     },
     {
      "src": "TC.ECO.title",
      "dst": "Portal.Notification.subject",
      "xform": "Truncate 200 chars",
      "mandatory": true,
      "note": "Notification subject"
     },
     {
      "src": "TC.ECO.reason",
      "dst": "Portal.Notification.change_reason",
      "xform": "Direct",
      "mandatory": true,
      "note": "Why the change"
     },
     {
      "src": "TC.ECO.effective_date",
      "dst": "Portal.Notification.effective_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "When change takes effect"
     },
     {
      "src": "TC.ECO.released_by",
      "dst": "Portal.Notification.released_by",
      "xform": "TC user → display name",
      "mandatory": true,
      "note": "Audit"
     },
     {
      "src": "TC.ECO.released_at",
      "dst": "Portal.Notification.released_at",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Audit timestamp"
     },
     {
      "src": "TC.ItemRevision.item_id",
      "dst": "Portal.Notification.part_number",
      "xform": "Direct",
      "mandatory": true,
      "note": "Affected part"
     },
     {
      "src": "TC.ItemRevision.revision",
      "dst": "Portal.Notification.new_revision",
      "xform": "Direct",
      "mandatory": true,
      "note": "New rev"
     },
     {
      "src": "TC.ItemRevision.previous_revision",
      "dst": "Portal.Notification.previous_revision",
      "xform": "Direct",
      "mandatory": false,
      "note": "Old rev for comparison"
     },
     {
      "src": "TC.Dataset.drawing_url",
      "dst": "Portal.Notification.attachment_url",
      "xform": "Signed URL TTL 24h",
      "mandatory": true,
      "note": "Current drawing"
     },
     {
      "src": "AIG.constant",
      "dst": "Portal.Notification.ack_required",
      "xform": "Constant true",
      "mandatory": true,
      "note": "Force acknowledgment"
     }
    ],
    "configSteps": [
     "Verify Item.procurement_type populated for all relevant parts",
     "Configure TC SOA subscription for ECO release",
     "Build AIG impact-list-to-supplier-resolution logic",
     "Configure signed URL service for drawing attachments",
     "Add portal notification module configuration",
     "Configure portal ack webhook → AIG callback receiver",
     "Add TC custom property on ECO: zz_notifications_status (pending/sent/all_ack/some_pending)",
     "Smoke test: release ECO affecting 3 purchased parts; verify 3 supplier notifications within 10min",
     "Ack flow test: supplier acks → TC updates within 60s",
     "Edge case: ECO affects 1 part with 3 qualified suppliers → 3 notifications",
     "Edge case: ECO affects part with no qualified supplier → warning + alert"
    ]
   },
   {
    "id": "TRG-052-02",
    "name": "Supplier Acknowledgment Received",
    "type": "APPROVE",
    "source": "Opcenter QMS Supplier Portal",
    "sourceEvent": "Supplier completes 'Acknowledge ECO' workflow in portal with e-signature",
    "condition": "Notification status is 'pending_ack'",
    "latency": "< 60 seconds",
    "description": "Supplier reviews the ECO notification, signs acknowledgment, and submits. Portal fires webhook to AIG. AIG updates the TC ECO custom property zz_notifications_status (aggregate view across all suppliers per ECO) and stores the per-supplier ack record on the ECO object for audit. Procurement dashboard shows real-time ack status.",
    "technicalDetails": {
     "protocol": "Portal webhook → AIG → TC SOA",
     "portalWebhook": "POST /aig/if052/ack",
     "tcSoaService": "DataManagement-2006-03-DataManagement.updateProperties",
     "authentication": "Webhook HMAC + Mutual TLS to TC",
     "idempotencyKey": "notification_id"
    },
    "sla": {
     "latency": "< 60s from supplier ack to TC visibility",
     "availability": "99%"
    },
    "recommendedMapping": [
     {
      "src": "Portal.Ack.notification_id",
      "dst": "TC.ECO.ack_log.notification_id",
      "xform": "Append to log",
      "mandatory": true,
      "note": "Match"
     },
     {
      "src": "Portal.Ack.supplier_user",
      "dst": "TC.ECO.ack_log.acked_by",
      "xform": "Direct",
      "mandatory": true,
      "note": "Who acked"
     },
     {
      "src": "Portal.Ack.ack_timestamp",
      "dst": "TC.ECO.ack_log.acked_at",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "When"
     },
     {
      "src": "Portal.Ack.signature_cert",
      "dst": "TC.ECO.ack_log.cert_thumbprint",
      "xform": "Thumbprint",
      "mandatory": true,
      "note": "E-sig proof"
     },
     {
      "src": "Portal.Ack.comments",
      "dst": "TC.ECO.ack_log.comments",
      "xform": "Direct",
      "mandatory": false,
      "note": "Supplier note (e.g., 'will require 2-week lead time')"
     }
    ],
    "configSteps": [
     "Configure portal ack webhook → /aig/if052/ack",
     "Build AIG ack receiver and TC update logic",
     "Add TC ECO ack_log custom property (multi-value)",
     "Test: ack → TC log updated < 60s"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "TC ECO → AIG (fan-out to suppliers) → Portal notifications → ack callback → TC log",
   "correlationStrategy": "tc_eco_id + part + vendor as composite key",
   "consistency": "Eventually consistent < 10min for outbound, < 60s for ack callback",
   "failureSemantics": "At-least-once; idempotent by (eco_id, part, vendor)"
  },
  "implementationOrder": [
   "Phase 1: Verify Item.procurement_type data quality",
   "Phase 2: AIG impact list + supplier resolution",
   "Phase 3: Portal notification module",
   "Phase 4: Ack callback flow",
   "Phase 5: UAT with Sourcing + 3 pilot suppliers"
  ],
  "tasks": [
   {
    "id": "T052a",
    "name": "Data Quality + procurement_type",
    "type": "Analyze",
    "hours": 4,
    "cx": 2,
    "dod": [
     "All TC Items reviewed for procurement_type accuracy",
     "Missing values populated or marked for review",
     "Sourcing sign-off on Make/Buy classification"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Analyze' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Gather source data for 'Data Quality + procurement_type'",
      "subSubTasks": [
       "Extract from Teamcenter 2512",
       "Extract from Opcenter QMS Supplier Portal"
      ]
     },
     {
      "step": 2,
      "title": "Compare and find gaps",
      "subSubTasks": [
       "Align structures/hierarchies",
       "Identify mismatches",
       "Quantify the gap"
      ]
     },
     {
      "step": 3,
      "title": "Produce alignment report",
      "subSubTasks": [
       "Document findings",
       "Agree remediation actions",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T052b",
    "name": "AIG Notification Fan-Out Logic",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "ECO release event handled",
     "Impact list filtered to purchased parts",
     "Per-part supplier resolution from IF-051 data",
     "Signed URL generation for attachments",
     "Fan-out to portal with correct payload per supplier",
     "Errors logged with full diagnostics"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Notification Fan-Out Logic'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Notification Fan-Out Logic'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T052c",
    "name": "Portal Notification Module",
    "type": "Configure",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Notification displays in supplier dashboard",
     "Attachment downloadable via signed URL",
     "Ack workflow with e-signature",
     "Ack webhook fires to AIG",
     "Supplier email notification on new notification"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Portal Notification Module'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Portal Notification Module'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T052d",
    "name": "TC Ack Log",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "ECO.zz_notifications_status custom property added",
     "ECO.ack_log multi-value property added",
     "AIG update logic working",
     "Procurement dashboard view of ack status"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Ack Log'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Ack Log'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T052e",
    "name": "Integration Tests",
    "type": "Test",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Single-part single-supplier: full flow < 10min outbound + < 60s ack",
     "Multi-part multi-supplier: fan-out correct",
     "Part with no qualified supplier: warning + alert",
     "Portal down: AIG DLQ, recovery on restore",
     "Supplier resubmits ack (idempotency): no double-log"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Teamcenter 2512→Opcenter QMS Supplier Portal)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Opcenter QMS Supplier Portal"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T052f",
    "name": "UAT + Rollout",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Sourcing + 3 pilot suppliers UAT",
     "Ack tracking dashboard validated",
     "Production rollout to all qualified suppliers"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Rollout'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "TC.ECO.eco_id",
    "dst": "Portal.Notification.zz_eco_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ECO.title",
    "dst": "Portal.Notification.subject",
    "xform": "Truncate 200",
    "category": "core"
   },
   {
    "src": "TC.ECO.reason",
    "dst": "Portal.Notification.change_reason",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ECO.effective_date",
    "dst": "Portal.Notification.effective_date",
    "xform": "ISO 8601",
    "category": "core"
   },
   {
    "src": "TC.ECO.released_by",
    "dst": "Portal.Notification.released_by",
    "xform": "User",
    "category": "audit"
   },
   {
    "src": "TC.ECO.released_at",
    "dst": "Portal.Notification.released_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "TC.ECO.priority",
    "dst": "Portal.Notification.priority",
    "xform": "Lookup",
    "category": "additional"
   },
   {
    "src": "TC.ItemRevision.item_id",
    "dst": "Portal.Notification.part_number",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ItemRevision.revision",
    "dst": "Portal.Notification.new_revision",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "TC.ItemRevision.previous_revision",
    "dst": "Portal.Notification.previous_revision",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "TC.Dataset.drawing_url",
    "dst": "Portal.Notification.attachment_url",
    "xform": "Signed URL",
    "category": "core"
   },
   {
    "src": "TC.Dataset.checksum",
    "dst": "Portal.Notification.attachment_sha256",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "AIG.constant",
    "dst": "Portal.Notification.ack_required",
    "xform": "Constant true",
    "category": "core"
   },
   {
    "src": "TC.ECO.affected_processes",
    "dst": "Portal.Notification.process_impact",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Portal.Ack.notification_id",
    "dst": "TC.ECO.ack_log.notification_id",
    "xform": "Append",
    "category": "core"
   },
   {
    "src": "Portal.Ack.supplier_user",
    "dst": "TC.ECO.ack_log.acked_by",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "Portal.Ack.ack_timestamp",
    "dst": "TC.ECO.ack_log.acked_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "Portal.Ack.signature_cert",
    "dst": "TC.ECO.ack_log.cert_thumbprint",
    "xform": "Thumbprint",
    "category": "audit"
   },
   {
    "src": "Portal.Ack.comments",
    "dst": "TC.ECO.ack_log.comments",
    "xform": "Direct",
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "TC SOA — Get ECO Impact",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/ChangeManagement-2007-01-ChangeManagement/getECOImpactedObjects",
    "prereq": [
     "SOA session",
     "Change Admin role"
    ],
    "purpose": "Retrieve impact list of an ECO",
    "sample": "<input><eco_uid>...</eco_uid></input>",
    "rateLimit": "20 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Portal REST — Create Notification",
    "method": "POST",
    "url": "https://portal-host/portal/api/v1/notifications",
    "prereq": [
     "API token",
     "Supplier accounts exist"
    ],
    "purpose": "Create supplier-facing notification",
    "sample": "{ \"supplier\":\"VEN-001\", \"subject\":\"ECO-12345\", \"attachment_url\":\"https://...\", \"ack_required\":true }",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Portal Webhook — Ack Received",
    "method": "POST",
    "url": "https://aig-host/aig/if052/ack",
    "prereq": [
     "HMAC secret"
    ],
    "purpose": "Notify AIG of supplier acknowledgment",
    "sample": "{ \"notification_id\":\"NTF-12345\", \"supplier_user\":\"...\", \"ack_timestamp\":\"...\", \"signature_cert\":\"...\" }",
    "rateLimit": "20 req/sec",
    "timeout": "10s"
   },
   {
    "name": "Signed URL Service",
    "method": "POST",
    "url": "https://aig-host/aig/signed-urls",
    "prereq": [
     "AIG signing key"
    ],
    "purpose": "Generate time-limited URL for drawing access",
    "sample": "{ \"dataset_uid\":\"...\", \"ttl_hours\":24 }",
    "rateLimit": "100 req/sec",
    "timeout": "5s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "TC ECO (in Teamcenter 2512); related: ECO, ChangeControl, SupplierNotification",
   "destinationBusinessObjectsInScope": "Supplier Notification (new rev + drawing + effective date + ack required) (in Opcenter QMS Supplier Portal)",
   "meaning": "TC ECO Notification to Supplier Portal: When TC releases an Engineering Change Order (ECO) that affects a purchased part, this interface notifies the relevant suppliers via the portal.",
   "purpose": "Delivers 'Suppliers notified of design changes in time to adjust production' (Supplier Quality). Notification includes the new ItemRevision, attached current drawing(s), effective date, change reason, and a required acknowledgment from supplier.",
   "functionPrimary": "Move/transform TC ECO → Supplier Notification (new rev + drawing + effective date + ack required) (Sync, Event-driven).",
   "subFunctions": [
    "Data Quality + procurement_type",
    "AIG Notification Fan-Out Logic",
    "Portal Notification Module",
    "TC Ack Log",
    "Integration Tests",
    "UAT + Rollout"
   ],
   "architecture": "Teamcenter 2512 --[TC SOA → AIG → Portal REST]--> AIG Gateway --> Opcenter QMS Supplier Portal. Pattern: Sync integration, Event trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Teamcenter is system-of-record for the engineering definition; target holds a controlled projection.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-014",
    "IF-051"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "All TC Items reviewed for procurement_type accuracy",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"TC ECO\" mapping",
    "\"Supplier Notification (new rev + drawing + effective date + ack required)\" configuration",
    "AIG Gateway",
    "ECO",
    "ChangeControl",
    "SupplierNotification",
    "Portal"
   ],
   "taskHours": 32,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-055",
  "seq": 55,
  "mvp": 2,
  "phase": 6,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event + Batch (Weekly)",
  "name": "REACH/RoHS Substance Compliance Sync",
  "from": "3E Company / iPoint Compliance Hub",
  "to": "Teamcenter 2512 + SAP S/4HANA",
  "mid": "AIG Gateway",
  "protocol": "Compliance Tool REST API → AIG → TC SOA + SAP BAPI",
  "bo": "Substance Declaration per part → TC Item compliance flag + SAP MARA-EXPME / Z_REACH",
  "complexity": 3,
  "effort": 8,
  "risk": 3,
  "team": "Compliance + PLM + ERP + AIG",
  "outcome": "Auditable substance compliance with procurement gating",
  "outcomeCat": "Regulatory Compliance",
  "deps": [
   "IF-051"
  ],
  "about": "Pulls full material disclosure (FMD), REACH SVHC declarations, RoHS exemption statements from the compliance tool into TC (as compliance status on each ItemRevision) and SAP (for procurement gating — non-compliant materials blocked from PO release). Event-driven on declaration approval; weekly full sync as reconciliation. Critical for EU/global manufacturers selling into regulated markets. ASSUMES 3E Company SaaS via REST; for iPoint/Assent the endpoint URLs change but the data model (substance, CAS number, concentration, exemption) is industry-standardized.",
  "tags": [
   "REACH",
   "RoHS",
   "Substance",
   "Compliance",
   "FMD",
   "SVHC",
   "Regulatory"
  ],
  "triggers": [
   {
    "id": "TRG-055-01",
    "name": "Compliance Declaration Approved",
    "type": "APPROVE",
    "source": "3E Company / iPoint Compliance Hub",
    "sourceEvent": "Substance declaration workflow completes with verdict 'Compliant' or 'Non-Compliant'",
    "condition": "Declaration is for active material; covers all applicable regulations (REACH, RoHS, etc.)",
    "latency": "< 5 minutes from declaration approval to TC + SAP visibility",
    "description": "Compliance team or supplier (via supplier portal flow inside the compliance tool) submits a substance declaration. Internal compliance officer reviews and approves. Tool fires webhook to AIG with the full declaration: substances present, concentrations, applicable exemptions, regulation coverage, and effective dates. AIG updates the TC ItemRevision compliance status, attaches the signed declaration as a Dataset, and updates the SAP material with the appropriate flags. SAP MM01/MM02 procurement view shows compliance status; PO creation blocked for non-compliant materials.",
    "technicalDetails": {
     "protocol": "Compliance tool webhook → AIG → TC SOA + SAP RFC",
     "complianceToolApi": "3E Company REST API v2 (or iPoint REST API v3)",
     "tcSoaService": "DataManagement-2006-03-DataManagement.updateProperties + createDataset",
     "sapBapis": [
      "BAPI_MATERIAL_SAVEDATA (custom Z fields)"
     ],
     "authentication": "Mutual TLS + API key (compliance tool); standard svc accounts downstream",
     "idempotencyKey": "declaration_id + declaration_version"
    },
    "preConditions": [
     "Compliance tool deployed with REACH + RoHS modules",
     "Material disclosure (FMD) data collected from suppliers",
     "TC ItemRevision has compliance properties extended (zz_reach_status, zz_rohs_status, etc.)",
     "SAP MARA extended with Z_COMPLIANCE_STATUS, Z_REACH_REVIEW_DATE, Z_RESTRICTED_SUBSTANCES",
     "PO release validation in SAP respects compliance status (custom enhancement)",
     "AIG receives webhook with proper auth"
    ],
    "context": "REACH Article 33 requires manufacturers to inform customers of SVHC presence > 0.1% w/w. RoHS restricts 10 substances in electrical/electronic equipment. China RoHS, California Prop 65, EU POP add additional constraints. Manual tracking via spreadsheets is impossible at scale and fails audits. The compliance tool aggregates declarations from supply chain; this interface makes that data actionable in TC (design decisions) and SAP (procurement decisions).",
    "prerequisites": {
     "complianceTool": [
      "3E Company / iPoint subscription active",
      "Material master loaded from SAP into compliance tool",
      "Supplier portal collecting FMD declarations",
      "Internal review workflow approving declarations",
      "Webhook configured to AIG endpoint"
     ],
     "aig": [
      "Webhook receiver /aig/if055/declaration",
      "Compliance data transformation (CAS numbers, substance names, regulation codes)",
      "Dataset upload service for declaration PDFs",
      "Idempotency table",
      "DLQ with replay UI"
     ],
     "teamcenter": [
      "ItemRevision BMIDE extensions: zz_reach_status, zz_rohs_status, zz_svhc_substances (multi-value), zz_compliance_review_date, zz_compliance_evidence_dataset",
      "Compliance Officer role for review override",
      "Dataset sub-type ComplianceDeclaration with cert thumbprint property"
     ],
     "sap": [
      "Append structure ZAMARA with Z_COMPLIANCE_STATUS, Z_REACH_REVIEW_DATE, Z_RESTRICTED_SUBSTANCES",
      "User exit on PO release (EXIT_SAPLEKPO_001) blocking non-compliant materials",
      "RFC service user with BAPI_MATERIAL_SAVEDATA + S_TABU_DIS for ZA_*"
     ]
    },
    "sla": {
     "latency": "< 5min for declaration → TC + SAP visibility",
     "availability": "99% (compliance updates are not minute-critical)",
     "completeness": "100% of active material declarations sync'd; weekly full sync catches drift"
    },
    "errorHandling": {
     "unknownCasNumber": "Compliance tool reports CAS not in TC lookup → log warning, store raw CAS, flag for compliance officer review",
     "materialNotInTc": "Declaration for material not yet in TC → buffer for 7 days; retry on IF-041/042 completion",
     "sapPoBlock": "User exit blocks PO; procurement gets clear error message with mitigation path (compliance officer review)",
     "regulationGap": "Declaration covers REACH but not RoHS while material is electronic → log gap, alert compliance team"
    },
    "monitoring": {
     "metrics": [
      "if055_declarations_synced_total{regulation,status}",
      "if055_materials_blocked_for_compliance_gauge",
      "if055_declaration_age_days_p95 (oldest active declaration)",
      "if055_weekly_reconciliation_diff_count"
     ],
     "alerts": [
      "Materials blocked > 50 → email procurement + compliance",
      "Declaration age > 365 days → review (REACH SVHC list updates twice yearly)",
      "Weekly diff > 10 → reconciliation investigation"
     ],
     "dashboards": [
      "Grafana 'CLM/Compliance' — REACH/RoHS coverage, expiring declarations, blocked POs"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 + API key in vault",
     "authentication": "Mutual TLS or signed JWT per compliance tool standard",
     "authorization": "AIG svc account scoped to material updates only",
     "auditLog": "declaration_id, material, regulation, status, reviewer, evidence_dataset, timestamp",
     "dataClassification": "Substance data: confidential; supplier-source-of-truth must remain in compliance tool"
    },
    "rollback": {
     "steps": [
      "Identify TC + SAP records updated by sync_id",
      "Revert TC compliance status to previous value",
      "Revert SAP Z_COMPLIANCE_STATUS to previous",
      "Mark sync record 'rolled_back' in audit log",
      "Compliance officer manually re-approves correct status"
     ],
     "estimatedTime": "30 minutes per material (manual review required)",
     "dataLoss": "Compliance tool retains authoritative declaration history"
    },
    "recommendedMapping": [
     {
      "src": "ComplianceTool.Declaration.materialId",
      "dst": "TC.ItemRevision.item_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Material number"
     },
     {
      "src": "ComplianceTool.Declaration.regulationCode",
      "dst": "TC.ItemRevision.zz_regulation",
      "xform": "Lookup REACH/RoHS/POP",
      "mandatory": true,
      "note": "Applicable regulation"
     },
     {
      "src": "ComplianceTool.Declaration.complianceStatus",
      "dst": "TC.ItemRevision.zz_reach_status / zz_rohs_status",
      "xform": "Map by regulation",
      "mandatory": true,
      "note": "Compliant/Non-Compliant/Exempted"
     },
     {
      "src": "ComplianceTool.Declaration.substances[]",
      "dst": "TC.ItemRevision.zz_svhc_substances",
      "xform": "Multi-value array",
      "mandatory": false,
      "note": "SVHC list above 0.1% w/w"
     },
     {
      "src": "ComplianceTool.Declaration.exemptions[]",
      "dst": "TC.ItemRevision.zz_rohs_exemptions",
      "xform": "Multi-value array",
      "mandatory": false,
      "note": "RoHS exemptions (e.g., 7c-I lead in solder)"
     },
     {
      "src": "ComplianceTool.Declaration.reviewDate",
      "dst": "TC.ItemRevision.zz_compliance_review_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Last review timestamp"
     },
     {
      "src": "ComplianceTool.Declaration.effectiveTo",
      "dst": "TC.ItemRevision.zz_compliance_valid_to",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "When this declaration expires"
     },
     {
      "src": "ComplianceTool.Declaration.evidencePdf",
      "dst": "TC.Dataset.ComplianceDeclaration.file",
      "xform": "Upload + cert thumbprint",
      "mandatory": true,
      "note": "Signed evidence"
     },
     {
      "src": "ComplianceTool.Declaration.materialId",
      "dst": "SAP.MARA-MATNR (key)",
      "xform": "Direct",
      "mandatory": true,
      "note": "SAP material key"
     },
     {
      "src": "ComplianceTool.Declaration.complianceStatus",
      "dst": "SAP.MARA-Z_COMPLIANCE_STATUS",
      "xform": "Compliant→'C' Non→'N' Exempt→'E'",
      "mandatory": true,
      "note": "Procurement gating flag"
     },
     {
      "src": "ComplianceTool.Declaration.reviewDate",
      "dst": "SAP.MARA-Z_REACH_REVIEW_DATE",
      "xform": "Date YYYYMMDD",
      "mandatory": true,
      "note": "Audit timestamp"
     },
     {
      "src": "ComplianceTool.Declaration.substances[]",
      "dst": "SAP.MARA-Z_RESTRICTED_SUBSTANCES",
      "xform": "Concatenated CAS list",
      "mandatory": false,
      "note": "SVHC summary on material master"
     }
    ],
    "configSteps": [
     "Subscribe to 3E Company / iPoint with appropriate regulation modules",
     "Load TC material master into compliance tool (one-time + delta)",
     "Onboard suppliers to FMD submission flow in compliance tool",
     "Add TC BMIDE extensions for compliance properties",
     "Add SAP append structure ZAMARA fields",
     "Implement SAP user exit on PO release",
     "Configure compliance tool webhook to AIG",
     "Build AIG transformation and DLQ",
     "Configure weekly batch reconciliation job",
     "Configure Grafana 'CLM/Compliance' dashboard",
     "Smoke test: approve declaration; verify TC + SAP within 5min",
     "Negative test: PO for non-compliant material → blocked with clear error",
     "Audit test: trace from supplier FMD to PO decision (full lineage)",
     "Reconciliation test: deliberately desync; verify weekly batch catches"
    ]
   },
   {
    "id": "TRG-055-02",
    "name": "Weekly Reconciliation Batch",
    "type": "SCHEDULE",
    "source": "AIG Scheduler",
    "sourceEvent": "Weekly cron Sunday 02:00 local",
    "condition": "Always runs (no preconditions)",
    "latency": "Batch (typically 1-2h)",
    "description": "Full reconciliation between compliance tool and TC + SAP. Catches any drift from missed webhooks or manual edits. Differences are logged and synced. Material with expired declarations (validTo < today) flagged for compliance review.",
    "technicalDetails": {
     "protocol": "Compliance tool REST batch query → AIG → diff engine → TC/SAP updates",
     "scheduling": "Cron weekly Sunday 02:00 local time",
     "idempotencyKey": "batch_run_id + material_id"
    },
    "sla": {
     "latency": "Batch completes within 4h",
     "availability": "Best-effort; missed batch alerts but no data loss (next run catches)"
    },
    "configSteps": [
     "Schedule cron job in AIG scheduler",
     "Implement diff engine (compliance tool state vs. TC + SAP state)",
     "Generate diff report to compliance team",
     "Auto-sync identified deltas",
     "Flag expired declarations for review"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Compliance tool (supplier source) → AIG → TC (engineering) + SAP (procurement)",
   "correlationStrategy": "material_id as primary key everywhere; declaration_id for version tracking",
   "consistency": "Eventually consistent within 5min for events; weekly reconciliation catches drift",
   "failureSemantics": "At-least-once; idempotent by (declaration_id, declaration_version)"
  },
  "implementationOrder": [
   "Phase 1: Compliance tool subscription + material loading",
   "Phase 2: Supplier FMD collection (months of supplier engagement)",
   "Phase 3: TC + SAP schema extensions",
   "Phase 4: AIG sync flow",
   "Phase 5: SAP user exit on PO release",
   "Phase 6: Weekly reconciliation batch",
   "Phase 7: Compliance officer training",
   "Phase 8: Gradual procurement enforcement (warning → block)"
  ],
  "tasks": [
   {
    "id": "T055a",
    "name": "Compliance Tool Onboarding",
    "type": "Install",
    "hours": 30,
    "cx": 3,
    "dod": [
     "Subscription active with REACH + RoHS modules",
     "Material master loaded (initial + delta sync)",
     "10 pilot suppliers onboarded to FMD submission",
     "Internal review workflow active",
     "Webhook configured and tested"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the AIG Gateway component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to 3E Company / iPoint Compliance Hub and Teamcenter 2512 + SAP S/4HANA",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T055b",
    "name": "TC + SAP Schema Extensions",
    "type": "Configure",
    "hours": 12,
    "cx": 3,
    "dod": [
     "TC BMIDE extensions deployed",
     "Dataset sub-type ComplianceDeclaration active",
     "SAP append structure ZAMARA fields active",
     "MM03 displays compliance status",
     "TC Active Workspace shows compliance widget"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC + SAP Schema Extensions'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC + SAP Schema Extensions'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T055c",
    "name": "AIG Sync Flow",
    "type": "Configure",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Webhook receiver validates and transforms declarations",
     "TC and SAP updates synchronized within transaction",
     "Dataset upload with checksum",
     "DLQ replay UI functional",
     "Audit log captures full declaration chain"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Sync Flow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Sync Flow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T055d",
    "name": "SAP PO User Exit",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "EXIT_SAPLEKPO_001 implemented",
     "Non-compliant material blocked from PO with clear error",
     "Exempted materials proceed with audit note",
     "Compliance officer can override with documented reason",
     "Tested with 20 scenarios (compliant/non-compliant/exempt/unknown)"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Development signal 'user exit' implies bespoke build beyond supplied configuration.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify the bespoke logic for 'SAP PO User Exit'",
      "subSubTasks": [
       "Document why supplied config is insufficient",
       "Write the enhancement functional spec",
       "Obtain architecture-board approval"
      ]
     },
     {
      "step": 2,
      "title": "Develop using supplied extension hooks",
      "subSubTasks": [
       "Implement via BAdI/user-exit/callback (no core mod)",
       "Keep enhancement isolated + upgrade-safe",
       "Version the code in the repo"
      ]
     },
     {
      "step": 3,
      "title": "Review and test",
      "subSubTasks": [
       "Peer code review",
       "Unit test the logic",
       "Integration test against Teamcenter 2512 + SAP S/4HANA"
      ]
     },
     {
      "step": 4,
      "title": "Promote with change advisory",
      "subSubTasks": [
       "Raise CHG flagging customization",
       "Document rollback",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T055e",
    "name": "Reconciliation Batch + Dashboard",
    "type": "Configure",
    "hours": 8,
    "cx": 2,
    "dod": [
     "Weekly batch runs cleanly for 4 weeks",
     "Diff report emailed to compliance team",
     "Grafana dashboard live",
     "Alerts tested and tuned"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Reconciliation Batch + Dashboard'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Reconciliation Batch + Dashboard'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T055f",
    "name": "Phased Rollout",
    "type": "Validate",
    "hours": 12,
    "cx": 3,
    "dod": [
     "Phase A: Warning-only PO check for 2 weeks (no blocking)",
     "Phase B: Block POs for unambiguous non-compliance",
     "Phase C: Block POs for expired declarations",
     "Compliance officer trained on review workflow",
     "Procurement trained on error resolution",
     "30-day stability with < 5 manual interventions/week"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Phased Rollout'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "ComplianceTool.Declaration.id",
    "dst": "TC.ItemRevision.zz_declaration_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.materialId",
    "dst": "TC.ItemRevision.item_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.regulationCode",
    "dst": "TC.ItemRevision.zz_regulation",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.complianceStatus",
    "dst": "TC.ItemRevision.zz_reach_status",
    "xform": "Status map",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.rohsStatus",
    "dst": "TC.ItemRevision.zz_rohs_status",
    "xform": "Status map",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.substances[].cas",
    "dst": "TC.ItemRevision.zz_svhc_substances",
    "xform": "Multi-value",
    "category": "additional"
   },
   {
    "src": "ComplianceTool.Declaration.substances[].concentration",
    "dst": "TC.ItemRevision.zz_substance_concentrations",
    "xform": "Multi-value numeric",
    "category": "additional"
   },
   {
    "src": "ComplianceTool.Declaration.exemptions[]",
    "dst": "TC.ItemRevision.zz_rohs_exemptions",
    "xform": "Multi-value",
    "category": "additional"
   },
   {
    "src": "ComplianceTool.Declaration.reviewDate",
    "dst": "TC.ItemRevision.zz_compliance_review_date",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "ComplianceTool.Declaration.effectiveTo",
    "dst": "TC.ItemRevision.zz_compliance_valid_to",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "ComplianceTool.Declaration.reviewer",
    "dst": "TC.ItemRevision.zz_compliance_reviewer",
    "xform": "User",
    "category": "audit"
   },
   {
    "src": "ComplianceTool.Declaration.evidencePdf",
    "dst": "TC.Dataset.ComplianceDeclaration.file",
    "xform": "Upload",
    "category": "audit"
   },
   {
    "src": "ComplianceTool.Declaration.complianceStatus",
    "dst": "SAP.MARA-Z_COMPLIANCE_STATUS",
    "xform": "Status code",
    "category": "core"
   },
   {
    "src": "ComplianceTool.Declaration.reviewDate",
    "dst": "SAP.MARA-Z_REACH_REVIEW_DATE",
    "xform": "Date",
    "category": "audit"
   },
   {
    "src": "ComplianceTool.Declaration.substances[].cas",
    "dst": "SAP.MARA-Z_RESTRICTED_SUBSTANCES",
    "xform": "Concat",
    "category": "additional"
   },
   {
    "src": "ComplianceTool.Declaration.exemptions[]",
    "dst": "SAP.MARA-Z_ROHS_EXEMPTIONS",
    "xform": "Concat",
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "3E Company REST — Get Declaration",
    "method": "GET",
    "url": "https://api.3ecompany.com/v2/declarations/{declarationId}",
    "prereq": [
     "API key in vault"
    ],
    "purpose": "Retrieve full declaration details",
    "sample": "GET /v2/declarations/DECL-12345",
    "rateLimit": "100 req/min",
    "timeout": "30s"
   },
   {
    "name": "Compliance Tool Webhook → AIG",
    "method": "POST",
    "url": "https://aig-host/aig/if055/declaration",
    "prereq": [
     "HMAC validation"
    ],
    "purpose": "Receive declaration approval event",
    "sample": "{ \"declaration_id\":\"DECL-12345\", \"material\":\"BV-3IN-001\", \"status\":\"Compliant\", \"regulation\":\"REACH\" }",
    "rateLimit": "60 req/min",
    "timeout": "30s"
   },
   {
    "name": "TC SOA — Update Properties",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/DataManagement-2006-03-DataManagement/updateProperties",
    "prereq": [
     "SOA session"
    ],
    "purpose": "Update compliance status on ItemRevision",
    "sample": "<info>...</info>",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   },
   {
    "name": "SAP BAPI_MATERIAL_SAVEDATA (compliance fields)",
    "method": "RFC",
    "url": "SAP RFC connection (SNC)",
    "prereq": [
     "ZAMARA append active"
    ],
    "purpose": "Update compliance fields on MARA",
    "sample": "BAPI_MATERIAL_SAVEDATA( HEADDATA:{...}, EXTENSIONIN:[{ STRUCTURE:'ZAMARA', VALUEPART1:'C20250501...' }] )",
    "rateLimit": "10 req/sec",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Substance Declaration per part (in 3E Company / iPoint Compliance Hub); related: REACH, RoHS, Substance",
   "destinationBusinessObjectsInScope": "TC Item compliance flag + SAP MARA-EXPME / Z_REACH (in Teamcenter 2512 + SAP S/4HANA)",
   "meaning": "REACH/RoHS Substance Compliance Sync: Pulls full material disclosure (FMD), REACH SVHC declarations, RoHS exemption statements from the compliance tool into TC (as compliance status on each ItemRevision) and SAP (for procurement gating — non-compliant materials blocked from PO release).",
   "purpose": "Delivers 'Auditable substance compliance with procurement gating' (Regulatory Compliance). Event-driven on declaration approval; weekly full sync as reconciliation.",
   "functionPrimary": "Move/transform Substance Declaration per part → TC Item compliance flag + SAP MARA-EXPME / Z_REACH (Sync, Event + Batch (Weekly)-driven).",
   "subFunctions": [
    "Compliance Tool Onboarding",
    "TC + SAP Schema Extensions",
    "AIG Sync Flow",
    "SAP PO User Exit",
    "Reconciliation Batch + Dashboard",
    "Phased Rollout"
   ],
   "architecture": "3E Company / iPoint Compliance Hub --[Compliance Tool REST API → AIG → TC SOA + SAP BAPI]--> AIG Gateway --> Teamcenter 2512 + SAP S/4HANA. Pattern: Sync integration, Event + Batch (Weekly) trigger. Complexity 3/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event + Batch (Weekly)",
   "systemOfRecord": "External compliance provider is authority for substance/declaration data; TC and SAP receive a controlled copy.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-051"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Subscription active with REACH + RoHS modules",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"Substance Declaration per part\" mapping",
    "\"TC Item compliance flag + SAP MARA-EXPME / Z_REACH\" configuration",
    "AIG Gateway",
    "REACH",
    "RoHS",
    "Substance",
    "Compliance"
   ],
   "taskHours": 80,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 3,
    "customization": 1,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-057",
  "seq": 57,
  "mvp": 1,
  "phase": 5,
  "grp": "MES",
  "type": "Sync",
  "freq": "Event + Batch (Daily)",
  "name": "Calibration Management Sync to Opcenter QMS",
  "from": "Opcenter QMS Calibration",
  "to": "Opcenter 2601 (Quality module)",
  "mid": "Direct REST (intra-Opcenter)",
  "protocol": "Opcenter QMS Calibration REST → Opcenter Quality REST",
  "bo": "Calibration Certificate → Inspection Instrument validity flag",
  "complexity": 2,
  "effort": 6,
  "risk": 2,
  "team": "Quality + MES Admin",
  "outcome": "Quality data validity automatically tied to instrument calibration status",
  "outcomeCat": "Quality Management",
  "deps": [
   "IF-025",
   "IF-066"
  ],
  "about": "Calibration data — when an instrument was last calibrated, when next calibration is due, and the cert PDF — flows from the calibration management system into Opcenter QMS so quality records taken with that instrument carry calibration provenance. On overdue calibration, the instrument is flagged 'out of service' and inspection plans referencing it raise warnings. Closes a common audit finding: 'this measurement was taken with an instrument that was overdue for calibration.' ASSUMES Opcenter QMS Calibration module.",
  "tags": [
   "Calibration",
   "Quality",
   "Instruments",
   "Audit",
   "ISO9001",
   "MSA"
  ],
  "triggers": [
   {
    "id": "TRG-057-01",
    "name": "Calibration Certificate Issued",
    "type": "RELEASE",
    "source": "Opcenter QMS Calibration",
    "sourceEvent": "Calibration workflow completes with verdict 'Pass' and certificate generated",
    "condition": "Instrument is registered in Opcenter QMS Quality module",
    "latency": "< 60 seconds",
    "description": "Calibration technician completes a calibration, attaches certificate PDF, and submits. Calibration module fires event. AIG-equivalent service (intra-Opcenter integration) updates the Inspection Instrument record in Quality module with new calibration date, next due date, cert reference, and validity flag. Any active InspectionPlan referencing this instrument re-checks validity.",
    "technicalDetails": {
     "protocol": "Opcenter QMS Calibration REST event → Opcenter Quality REST",
     "calibrationEndpoint": "GET /opcenter/qms/api/v1/calibrations/{id}",
     "qualityEndpoint": "PUT /opcenter/api/v1/quality/instruments/{instrumentId}",
     "eventBus": "Opcenter internal event bus or webhook to local service",
     "idempotencyKey": "calibration_id + cert_version"
    },
    "preConditions": [
     "Opcenter QMS Calibration module configured and licensed",
     "Instruments registered in both modules with consistent IDs",
     "Calibration procedures defined per instrument type",
     "Certificate template configured",
     "Quality InspectionPlan references instruments by ID"
    ],
    "context": "ISO 9001 §7.1.5.2 requires monitoring and measuring resources to be calibrated at specified intervals. ISO 17025 (testing labs) is stricter. Audit finding: 'we found a measurement on 2024-03-15 taken with caliper SN-12345; calibration was due 2024-02-28; this measurement's validity is in question.' This interface prevents that finding structurally — the instrument is flagged out-of-service when due date passes, and Opcenter Quality refuses to record measurements with it.",
    "prerequisites": {
     "calibration_module": [
      "Opcenter QMS Calibration v2024.5+ deployed",
      "Calibration procedures per instrument type configured",
      "Calibration technicians trained and certified",
      "Certificate template with required fields"
     ],
     "quality_module": [
      "InspectionInstrument records keyed by ID matching calibration module",
      "Custom fields: zz_last_calibration_date, zz_next_calibration_date, zz_calibration_cert_url, zz_calibration_valid (boolean)",
      "InspectionPlan validation logic respects zz_calibration_valid"
     ],
     "intra_opcenter_service": [
      "Lightweight service in same security zone as Opcenter",
      "Webhook receiver for calibration events",
      "Idempotency table",
      "Daily reconciliation job"
     ]
    },
    "sla": {
     "latency": "< 60s for cert → instrument validity",
     "availability": "99.5%"
    },
    "errorHandling": {
     "instrumentNotFound": "Calibration for instrument ID not in Quality module → log warning, auto-create instrument with minimal fields if policy allows",
     "certUploadFail": "PDF too large or storage error → calibration record updated without cert URL; alert quality team",
     "clockSkew": "next_calibration_date in past at issue time → still accept but flag for review (likely a tracking error)"
    },
    "monitoring": {
     "metrics": [
      "if057_calibrations_synced_total",
      "if057_overdue_instruments_gauge",
      "if057_measurements_with_invalid_instrument_total (should be 0)"
     ],
     "alerts": [
      "Overdue instruments > 5 → email quality lead",
      "Measurement with invalid instrument > 0 → immediate quality investigation",
      "Reconciliation diff > 3 → daily review"
     ]
    },
    "security": {
     "encryption": "TLS within Opcenter security zone",
     "authentication": "Intra-Opcenter service account; mutual TLS to external SIEM",
     "authorization": "Quality svc account scoped to InspectionInstrument updates",
     "auditLog": "calibration_id, instrument_id, calibrated_by, due_date, cert_url, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify instrument records updated by calibration_id",
      "Revert validity flag and dates to previous state",
      "Mark calibration as 'rolled_back' in calibration module",
      "Quality records taken since update reviewed"
     ],
     "estimatedTime": "15 minutes per instrument",
     "dataLoss": "Calibration module retains all certificate history"
    },
    "recommendedMapping": [
     {
      "src": "Calibration.cert.instrumentId",
      "dst": "Quality.InspectionInstrument.id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Round-trip key"
     },
     {
      "src": "Calibration.cert.calibratedAt",
      "dst": "Quality.InspectionInstrument.zz_last_calibration_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Last cal date"
     },
     {
      "src": "Calibration.cert.nextDueAt",
      "dst": "Quality.InspectionInstrument.zz_next_calibration_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Due date"
     },
     {
      "src": "Calibration.cert.calibratedBy",
      "dst": "Quality.InspectionInstrument.zz_last_calibrated_by",
      "xform": "User",
      "mandatory": true,
      "note": "Technician"
     },
     {
      "src": "Calibration.cert.procedureUsed",
      "dst": "Quality.InspectionInstrument.zz_calibration_procedure",
      "xform": "Direct",
      "mandatory": true,
      "note": "Procedure ID"
     },
     {
      "src": "Calibration.cert.url",
      "dst": "Quality.InspectionInstrument.zz_calibration_cert_url",
      "xform": "Direct",
      "mandatory": true,
      "note": "Cert PDF"
     },
     {
      "src": "Calibration.cert.verdict",
      "dst": "Quality.InspectionInstrument.zz_calibration_valid",
      "xform": "Pass→true",
      "mandatory": true,
      "note": "Validity flag"
     },
     {
      "src": "Calibration.cert.uncertainty",
      "dst": "Quality.InspectionInstrument.zz_measurement_uncertainty",
      "xform": "Numeric",
      "mandatory": false,
      "note": "MSA-relevant"
     }
    ],
    "configSteps": [
     "Confirm Opcenter QMS Calibration module deployment",
     "Sync instrument inventory across modules (one-time)",
     "Add custom fields to InspectionInstrument",
     "Configure calibration event subscription in intra-Opcenter service",
     "Configure InspectionPlan validation to check zz_calibration_valid",
     "Configure measurement entry validation to block on invalid instrument",
     "Configure daily reconciliation batch",
     "Configure Splunk forwarder for audit log",
     "Smoke test: complete calibration; verify instrument updated < 60s",
     "Overdue test: simulate clock advance past due date; verify validity flips to false",
     "Block test: attempt measurement with invalid instrument; verify blocked with clear error"
    ]
   },
   {
    "id": "TRG-057-02",
    "name": "Daily Instrument Status Refresh",
    "type": "SCHEDULE",
    "source": "Intra-Opcenter Scheduler",
    "sourceEvent": "Daily cron 03:00 local",
    "condition": "Always runs",
    "latency": "Batch (typically < 30 min)",
    "description": "Daily scan of all instruments to flag those with due date < today as out-of-service. Handles cases where an instrument simply expired without a new calibration. Emails quality lead with list of overdue instruments.",
    "sla": {
     "latency": "Completes within 30 min"
    },
    "configSteps": [
     "Schedule cron job",
     "Query all instruments where due_date < today AND validity=true",
     "Update validity to false for each",
     "Generate overdue report",
     "Email to quality lead distribution"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Calibration module (authoritative) → intra-Opcenter service → Quality module",
   "correlationStrategy": "instrument_id as primary key",
   "consistency": "Eventually consistent within 60s",
   "failureSemantics": "At-least-once; idempotent by (calibration_id, cert_version)"
  },
  "implementationOrder": [
   "Phase 1: Instrument inventory reconciliation",
   "Phase 2: Schema extensions",
   "Phase 3: Event subscription + sync logic",
   "Phase 4: InspectionPlan validation",
   "Phase 5: Daily refresh batch",
   "Phase 6: Audit-driven rollout"
  ],
  "tasks": [
   {
    "id": "T057a",
    "name": "Instrument Inventory Reconciliation",
    "type": "Analyze",
    "hours": 8,
    "cx": 2,
    "dod": [
     "All instruments in both modules reconciled (same IDs)",
     "Missing instruments created in either module",
     "Master inventory list signed off by quality lead"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Analyze' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Gather source data for 'Instrument Inventory Reconciliation'",
      "subSubTasks": [
       "Extract from Opcenter QMS Calibration",
       "Extract from Opcenter 2601 (Quality module)"
      ]
     },
     {
      "step": 2,
      "title": "Compare and find gaps",
      "subSubTasks": [
       "Align structures/hierarchies",
       "Identify mismatches",
       "Quantify the gap"
      ]
     },
     {
      "step": 3,
      "title": "Produce alignment report",
      "subSubTasks": [
       "Document findings",
       "Agree remediation actions",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T057b",
    "name": "Schema Extensions",
    "type": "Configure",
    "hours": 4,
    "cx": 1,
    "dod": [
     "Custom fields added to InspectionInstrument",
     "InspectionPlan validation logic updated",
     "Measurement entry validation updated"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Direct REST (intra-Opcenter) configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Schema Extensions'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Schema Extensions'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T057c",
    "name": "Sync Service + Event Wiring",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Event subscription active",
     "Real-time sync working < 60s",
     "Daily refresh job scheduled",
     "Reconciliation report generated"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Direct REST (intra-Opcenter) configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Sync Service + Event Wiring'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Sync Service + Event Wiring'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T057d",
    "name": "Integration Tests",
    "type": "Test",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Happy path: calibration → instrument valid",
     "Overdue path: due date passes → instrument invalid",
     "Block path: measurement with invalid instrument → blocked",
     "Override path: quality lead can document-with-justification (audit retained)",
     "Reconciliation: deliberate desync caught by daily batch"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Opcenter QMS Calibration→Opcenter 2601 (Quality module))",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through Direct REST (intra-Opcenter)",
       "Confirm arrival + correctness at Opcenter 2601 (Quality module)"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T057e",
    "name": "Audit Rollout",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Internal audit team validates trace from measurement → instrument → calibration cert",
     "External audit team simulation",
     "Quality lead sign-off"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Audit Rollout'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Calibration.cert.instrumentId",
    "dst": "Quality.InspectionInstrument.id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Calibration.cert.calibratedAt",
    "dst": "Quality.InspectionInstrument.zz_last_calibration_date",
    "xform": "ISO 8601",
    "category": "core"
   },
   {
    "src": "Calibration.cert.nextDueAt",
    "dst": "Quality.InspectionInstrument.zz_next_calibration_date",
    "xform": "ISO 8601",
    "category": "core"
   },
   {
    "src": "Calibration.cert.calibratedBy",
    "dst": "Quality.InspectionInstrument.zz_last_calibrated_by",
    "xform": "User",
    "category": "audit"
   },
   {
    "src": "Calibration.cert.procedureUsed",
    "dst": "Quality.InspectionInstrument.zz_calibration_procedure",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Calibration.cert.url",
    "dst": "Quality.InspectionInstrument.zz_calibration_cert_url",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "Calibration.cert.verdict",
    "dst": "Quality.InspectionInstrument.zz_calibration_valid",
    "xform": "Boolean",
    "category": "core"
   },
   {
    "src": "Calibration.cert.uncertainty",
    "dst": "Quality.InspectionInstrument.zz_measurement_uncertainty",
    "xform": "Numeric",
    "category": "quality"
   },
   {
    "src": "Calibration.cert.standards",
    "dst": "Quality.InspectionInstrument.zz_traceability_standards",
    "xform": "Multi-value",
    "category": "audit"
   },
   {
    "src": "Calibration.cert.environmentTemp",
    "dst": "Quality.InspectionInstrument.zz_cal_env_temp_c",
    "xform": "Numeric",
    "category": "additional"
   },
   {
    "src": "Calibration.cert.environmentHumidity",
    "dst": "Quality.InspectionInstrument.zz_cal_env_humidity_pct",
    "xform": "Numeric",
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "Calibration REST — Get Cert",
    "method": "GET",
    "url": "https://opcenter-host/opcenter/qms/api/v1/calibrations/{id}",
    "prereq": [
     "Calibration read scope"
    ],
    "purpose": "Retrieve certificate details",
    "sample": "GET /opcenter/qms/api/v1/calibrations/CAL-12345",
    "rateLimit": "60 req/min",
    "timeout": "10s"
   },
   {
    "name": "Quality REST — Update Instrument",
    "method": "PUT",
    "url": "https://opcenter-host/opcenter/api/v1/quality/instruments/{instrumentId}",
    "prereq": [
     "InspectionInstrument write scope"
    ],
    "purpose": "Update validity and calibration fields",
    "sample": "{ \"zz_last_calibration_date\":\"2025-04-15\", \"zz_next_calibration_date\":\"2025-10-15\", \"zz_calibration_valid\":true }",
    "rateLimit": "30 req/sec",
    "timeout": "10s"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "Calibration Certificate (in Opcenter QMS Calibration); related: Calibration, Quality, Instruments",
   "destinationBusinessObjectsInScope": "Inspection Instrument validity flag (in Opcenter 2601 (Quality module))",
   "meaning": "Calibration Management Sync to Opcenter QMS: Calibration data — when an instrument was last calibrated, when next calibration is due, and the cert PDF — flows from the calibration management system into Opcenter QMS so quality records taken with that instrument carry calibration provenance.",
   "purpose": "Delivers 'Quality data validity automatically tied to instrument calibration status' (Quality Management). On overdue calibration, the instrument is flagged 'out of service' and inspection plans referencing it raise warnings.",
   "functionPrimary": "Move/transform Calibration Certificate → Inspection Instrument validity flag (Sync, Event + Batch (Daily)-driven).",
   "subFunctions": [
    "Instrument Inventory Reconciliation",
    "Schema Extensions",
    "Sync Service + Event Wiring",
    "Integration Tests",
    "Audit Rollout"
   ],
   "architecture": "Opcenter QMS Calibration --[Opcenter QMS Calibration REST → Opcenter Quality REST]--> Direct REST (intra-Opcenter) --> Opcenter 2601 (Quality module). Pattern: Sync integration, Event + Batch (Daily) trigger. Complexity 2/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: Direct REST (intra-Opcenter). INTRA-MES with inter-system consumers.",
   "interfacePattern": "Sync · Event + Batch (Daily)",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mes_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-025",
    "IF-066"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "All instruments in both modules reconciled (same IDs)",
   "docSearchKeywords": [
    "Opcenter Execution REST API v1 reference",
    "\"Calibration Certificate\" mapping",
    "\"Inspection Instrument validity flag\" configuration",
    "Direct REST (intra-Opcenter)",
    "Calibration",
    "Quality",
    "Instruments",
    "Audit"
   ],
   "taskHours": 30,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 2,
    "customization": 0,
    "totalTasks": 5
   }
  }
 },
 {
  "id": "IF-058",
  "seq": 58,
  "mvp": 2,
  "phase": 6,
  "grp": "MDG",
  "type": "Sync",
  "freq": "Event (real-time)",
  "name": "21 CFR Part 11 e-Signature Service",
  "from": "All CLM Systems (TC, SAP, Opcenter, Hub, SFC)",
  "to": "Central e-Signature Service + Tamper-evident Ledger",
  "mid": "Azure AD + Signature Service",
  "protocol": "OIDC + Custom REST signing service",
  "bo": "State-change event → Signed ledger entry with cert + meaning",
  "complexity": 4,
  "effort": 8,
  "risk": 4,
  "team": "Security + Compliance + System Admins (all CLM)",
  "outcome": "FDA-compliant e-signatures across CLM landscape with tamper-evident audit trail",
  "outcomeCat": "Regulatory Compliance",
  "deps": [
   "IF-067"
  ],
  "about": "Centralized e-signature service for 21 CFR Part 11 compliance. Every state-changing action in TC, SAP, Opcenter, Hub, and SFC routes through this service before commit. User authenticates via Azure AD (already SSO'd per IF-067), is challenged for a secondary credential (password or hardware token), confirms signature meaning ('I approve this ECO'), and the service signs the event payload with the user's cert and appends to ledger. The calling system commits only after receiving a valid signature ID. ASSUMES Azure AD with user certs distributed; for Okta/Ping the OIDC flow stays valid with adjusted endpoints.",
  "tags": [
   "CFR21Part11",
   "eSignature",
   "AzureAD",
   "Compliance",
   "AuditTrail",
   "Tamper-evident"
  ],
  "triggers": [
   {
    "id": "TRG-058-01",
    "name": "State-Changing Action Initiated",
    "type": "STATE_CHANGE",
    "source": "TC / SAP / Opcenter / Hub / SFC",
    "sourceEvent": "User clicks 'Approve', 'Release', 'Reject', 'Submit for Manufacturing', or similar gated action",
    "condition": "Action is configured as 'requires Part 11 signature' per system",
    "latency": "< 5 seconds for signature challenge + commit",
    "description": "Calling system intercepts the action, calls the signature service /sign endpoint with the action context (object, action, system, user_session). Service validates Azure AD session, prompts user for secondary credential, displays signature meaning text ('I am approving this Engineering Change Order, version 3, effective 2025-06-01'), user confirms. Service signs the SHA-256 hash of the canonical event payload with the user's cert, appends the signed entry to the ledger, and returns signature_id. Calling system records signature_id on the affected object and commits the state change. Without signature_id, the commit is rejected.",
    "technicalDetails": {
     "protocol": "OIDC re-auth + Custom REST (POST /sign) + Append Blob",
     "signingService": "Custom service (Node.js or .NET) backed by Azure Key Vault for cert storage",
     "secondaryAuth": "Configurable: password re-entry, FIDO2 hardware key, or smart card",
     "ledgerStorage": "Azure Append Blob with WORM (Write Once Read Many) policy; daily SHA-256 hash anchors to immutable storage",
     "signingAlgorithm": "RSA-PSS or ECDSA per Azure Key Vault policy",
     "idempotencyKey": "system + object_uid + action + user_session_id"
    },
    "preConditions": [
     "Azure AD tenant with user certificates issued (typically via Intune)",
     "Azure Key Vault for cert storage",
     "Azure Append Blob storage with WORM policy",
     "Signature Service deployed (load-balanced for HA)",
     "Each calling system has integration SDK or REST client",
     "Each calling system has 'requires Part 11 signature' config per action"
    ],
    "context": "21 CFR Part 11 (FDA) defines requirements for electronic records and signatures in FDA-regulated industries (pharma, medical device, food). EU Annex 11 is the European equivalent. Key requirements: (a) unique to individual, (b) verified identity, (c) signature meaning documented, (d) tamper-evident record, (e) all signed records available for audit. This service provides all five in a way each CLM system can consume uniformly. Without it, each system implements its own signature flow with inconsistent compliance posture.",
    "prerequisites": {
     "azure_ad": [
      "Tenant with conditional access policies for high-risk actions",
      "User certificates issued via Intune (or AD CS)",
      "FIDO2 keys distributed for users requiring strong auth",
      "Audit log forwarding to Azure Sentinel or external SIEM"
     ],
     "signature_service": [
      "Service deployed on isolated VNet (no direct internet)",
      "Azure Key Vault integration for cert operations",
      "Append Blob with daily Merkle tree anchor",
      "REST API: POST /sign, GET /verify/{id}, GET /audit (filtered)",
      "Idempotency table",
      "Health and metrics endpoints"
     ],
     "calling_systems": [
      "TC: SOA pre-action handler intercepting Release/Approve",
      "SAP: BAdI on critical transactions (MM02 mass change, etc.)",
      "Opcenter: pre-commit hook on quality decisions",
      "Hub: webhook on alert dispositions",
      "SFC: on operator step completion (gated by recipe)"
     ]
    },
    "sla": {
     "latency": "< 5s end-to-end (95th percentile)",
     "availability": "99.9% (gating; outages block production)",
     "ledgerIntegrity": "100% — daily Merkle anchor proves no tampering"
    },
    "errorHandling": {
     "userAuthFail": "Wrong credential → reject signature, log attempt; lock after 3 attempts",
     "certExpired": "User cert expired → reject signature with clear error; user contacts IT for renewal",
     "serviceUnavailable": "Calling system blocks action with retry guidance; falls back to manual paper signature only with documented exception",
     "ledgerWriteFail": "Service refuses to return signature_id; calling system does not commit",
     "clockSkew": "Service timestamp vs. calling system timestamp drift > 30s → reject; NTP issue alerts"
    },
    "monitoring": {
     "metrics": [
      "if058_signatures_total{system,action,outcome}",
      "if058_signature_latency_seconds",
      "if058_failed_auth_attempts_total",
      "if058_ledger_size_bytes",
      "if058_daily_merkle_anchors_total (should be 1/day)"
     ],
     "alerts": [
      "Failed auth > 10/hour → Security investigation",
      "Service unavailability > 1min → PagerDuty Critical",
      "Daily anchor missing → Compliance lead immediate alert",
      "Ledger growth anomalous → investigation"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 + cert-based mTLS to ledger storage",
     "authentication": "Azure AD with conditional access; secondary auth per action",
     "authorization": "User must have role/permission for the action in the calling system",
     "auditLog": "Full signature ledger is itself the audit trail; separate access log for ledger reads",
     "dataClassification": "Highest — signatures + ledger retain 25+ years per FDA"
    },
    "rollback": {
     "steps": [
      "Signatures themselves cannot be 'rolled back' — that would violate Part 11",
      "If signature was issued in error: leave ledger entry, issue compensating signed action ('I am voiding signature SIG-12345 for reason X')",
      "Both original and compensation visible in audit trail"
     ],
     "estimatedTime": "10 minutes per correction (manual compliance officer task)",
     "dataLoss": "None — ledger is append-only"
    },
    "recommendedMapping": [
     {
      "src": "CallingSystem.action.context",
      "dst": "SignatureService.request.action_context",
      "xform": "Canonical JSON",
      "mandatory": true,
      "note": "What is being signed"
     },
     {
      "src": "CallingSystem.action.object_uid",
      "dst": "SignatureService.request.object_uid",
      "xform": "Direct",
      "mandatory": true,
      "note": "Object identifier"
     },
     {
      "src": "CallingSystem.user.azure_ad_oid",
      "dst": "SignatureService.request.user_oid",
      "xform": "Direct",
      "mandatory": true,
      "note": "Azure AD user ObjectID"
     },
     {
      "src": "CallingSystem.user.session_token",
      "dst": "SignatureService.request.session_token",
      "xform": "Direct (verified)",
      "mandatory": true,
      "note": "Active session"
     },
     {
      "src": "CallingSystem.action.meaning_text",
      "dst": "SignatureService.request.signature_meaning",
      "xform": "Direct",
      "mandatory": true,
      "note": "What signature signifies"
     },
     {
      "src": "SignatureService.signature_id",
      "dst": "CallingSystem.object.zz_signature_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Returned signature ID"
     },
     {
      "src": "SignatureService.signed_at",
      "dst": "CallingSystem.object.zz_signed_at",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "When signed"
     },
     {
      "src": "SignatureService.signer_cert_thumbprint",
      "dst": "CallingSystem.object.zz_cert_thumbprint",
      "xform": "Direct",
      "mandatory": true,
      "note": "Signer cert"
     }
    ],
    "configSteps": [
     "Deploy Azure infrastructure (Key Vault, Append Blob, signature service VMs)",
     "Configure Azure AD conditional access for high-risk actions",
     "Issue user certificates via Intune (or AD CS)",
     "Distribute FIDO2 keys for users requiring strong auth",
     "Develop and deploy signature service (REST API + ledger + verification)",
     "Develop calling-system SDKs (TC SOA handler, SAP BAdI, etc.)",
     "Configure each system's gated actions (which require signature)",
     "Configure ledger Merkle anchor daily job",
     "Configure SIEM forwarding (overlap with IF-068)",
     "Smoke test: sign a TC Release action; verify ledger entry and TC commit",
     "Tamper test: attempt to modify ledger entry; verify daily anchor catches",
     "Performance test: 100 signatures/min sustained for 1h",
     "Failure test: ledger write fails; calling system does not commit",
     "Validation per FDA Part 11: documented validation suite"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Calling system (action) → Signature Service (sign) → Ledger (append) → return ID → Calling system (commit)",
   "correlationStrategy": "signature_id as primary key in ledger; (system, object_uid, action) for idempotency",
   "consistency": "Strong consistency required — service is in commit path",
   "failureSemantics": "If service unavailable, calling action does not commit (fail-safe)"
  },
  "implementationOrder": [
   "Phase 1: Azure infrastructure + cert distribution (IT lead)",
   "Phase 2: Signature service development and security review",
   "Phase 3: Validation per FDA Part 11 (compliance lead)",
   "Phase 4: First calling system integration (typically TC)",
   "Phase 5: Other systems in priority order (SAP, Opcenter, etc.)",
   "Phase 6: Compliance officer training",
   "Phase 7: Gradual enforcement (warn → block)"
  ],
  "tasks": [
   {
    "id": "T058a",
    "name": "Azure Infrastructure + Cert Distribution",
    "type": "Install",
    "hours": 30,
    "cx": 3,
    "dod": [
     "Azure Key Vault deployed with appropriate policies",
     "Append Blob with WORM policy configured",
     "Conditional access policies active",
     "User certs issued to all in-scope users",
     "FIDO2 keys distributed to key users",
     "Service VMs deployed on isolated VNet"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the Azure AD + Signature Service component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to All CLM Systems (TC, SAP, Opcenter, Hub, SFC) and Central e-Signature Service + Tamper-evident Ledger",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T058b",
    "name": "Signature Service Development",
    "type": "Build",
    "hours": 40,
    "cx": 4,
    "dod": [
     "POST /sign endpoint with full flow",
     "GET /verify/{id} for signature verification",
     "GET /audit with role-based filtering",
     "Health, metrics, ready endpoints",
     "Append Blob writes with retry",
     "Daily Merkle anchor job",
     "Comprehensive unit + integration tests",
     "Security review sign-off"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Task type 'Build' denotes bespoke development.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify requirements for 'Signature Service Development'",
      "subSubTasks": [
       "Capture functional + NFRs",
       "Define API contract",
       "Get architecture approval"
      ]
     },
     {
      "step": 2,
      "title": "Design and develop",
      "subSubTasks": [
       "Design the component",
       "Develop the code",
       "Instrument logging + metrics"
      ]
     },
     {
      "step": 3,
      "title": "Test the build",
      "subSubTasks": [
       "Unit test",
       "Integration test",
       "Security review"
      ]
     },
     {
      "step": 4,
      "title": "Document and promote",
      "subSubTasks": [
       "Write ops + API docs",
       "Raise change advisory",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T058c",
    "name": "FDA Part 11 Validation Suite",
    "type": "Validate",
    "hours": 40,
    "cx": 4,
    "dod": [
     "URS (User Requirements Spec) document",
     "FRS (Functional Requirements Spec)",
     "DS (Design Spec)",
     "IQ (Installation Qualification) executed",
     "OQ (Operational Qualification) executed",
     "PQ (Performance Qualification) executed",
     "Validation report signed by Compliance"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'FDA Part 11 Validation Suite'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T058d",
    "name": "TC Integration (first system)",
    "type": "Configure",
    "hours": 16,
    "cx": 3,
    "dod": [
     "TC SOA pre-action handler intercepting Release + Approve",
     "Signature meaning text configured per action type",
     "Custom properties zz_signature_id, zz_signed_at, zz_cert_thumbprint",
     "TC AWC UI shows signature ID on signed objects",
     "Full flow tested with 20 actions"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Azure AD + Signature Service configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Integration (first system)'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Integration (first system)'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T058e",
    "name": "Other CLM Systems",
    "type": "Configure",
    "hours": 30,
    "cx": 4,
    "dod": [
     "SAP BAdI on critical transactions",
     "Opcenter pre-commit hooks",
     "Hub webhook integration",
     "SFC step completion gating (where applicable)",
     "All systems display signature ID for audit"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Development signal 'badi' implies bespoke build beyond supplied configuration.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify the bespoke logic for 'Other CLM Systems'",
      "subSubTasks": [
       "Document why supplied config is insufficient",
       "Write the enhancement functional spec",
       "Obtain architecture-board approval"
      ]
     },
     {
      "step": 2,
      "title": "Develop using supplied extension hooks",
      "subSubTasks": [
       "Implement via BAdI/user-exit/callback (no core mod)",
       "Keep enhancement isolated + upgrade-safe",
       "Version the code in the repo"
      ]
     },
     {
      "step": 3,
      "title": "Review and test",
      "subSubTasks": [
       "Peer code review",
       "Unit test the logic",
       "Integration test against Central e-Signature Service + Tamper-evident Ledger"
      ]
     },
     {
      "step": 4,
      "title": "Promote with change advisory",
      "subSubTasks": [
       "Raise CHG flagging customization",
       "Document rollback",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T058f",
    "name": "Production Cutover",
    "type": "Validate",
    "hours": 12,
    "cx": 4,
    "dod": [
     "30-day pilot with TC only",
     "Phased addition of other systems",
     "Compliance officer training complete",
     "Help desk runbook for cert/auth issues",
     "Compliance audit simulation passed"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Production Cutover'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "CallingSystem.action.context",
    "dst": "SignatureService.request.action_context",
    "xform": "Canonical JSON",
    "category": "core"
   },
   {
    "src": "CallingSystem.action.object_uid",
    "dst": "SignatureService.request.object_uid",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "CallingSystem.action.action_type",
    "dst": "SignatureService.request.action_type",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "CallingSystem.user.azure_ad_oid",
    "dst": "SignatureService.request.user_oid",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "CallingSystem.user.session_token",
    "dst": "SignatureService.request.session_token",
    "xform": "Verified",
    "category": "core"
   },
   {
    "src": "CallingSystem.action.meaning_text",
    "dst": "SignatureService.request.signature_meaning",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SignatureService.signature_id",
    "dst": "CallingSystem.object.zz_signature_id",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SignatureService.signed_at",
    "dst": "CallingSystem.object.zz_signed_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "SignatureService.signer_cert_thumbprint",
    "dst": "CallingSystem.object.zz_cert_thumbprint",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SignatureService.payload_sha256",
    "dst": "CallingSystem.object.zz_payload_sha256",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "SignatureService.ledger_position",
    "dst": "CallingSystem.object.zz_ledger_position",
    "xform": "Integer",
    "category": "audit"
   },
   {
    "src": "SignatureService.merkle_anchor_id",
    "dst": "CallingSystem.object.zz_merkle_anchor_id",
    "xform": "Direct (deferred)",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "Signature Service — Sign",
    "method": "POST",
    "url": "https://signature-svc.internal/api/v1/sign",
    "prereq": [
     "Valid Azure AD session",
     "Calling system authenticated"
    ],
    "purpose": "Sign an action and receive signature ID",
    "sample": "{ \"system\":\"TC\", \"object_uid\":\"...\", \"action\":\"Release\", \"meaning\":\"I approve ECO-12345\", \"secondary_auth\":\"...\" }",
    "rateLimit": "100 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Signature Service — Verify",
    "method": "GET",
    "url": "https://signature-svc.internal/api/v1/verify/{signatureId}",
    "prereq": [
     "Authenticated session"
    ],
    "purpose": "Verify a signature is valid and in ledger",
    "sample": "GET /api/v1/verify/SIG-12345",
    "rateLimit": "200 req/sec",
    "timeout": "5s"
   },
   {
    "name": "Azure AD OIDC Token",
    "method": "POST",
    "url": "https://login.microsoftonline.com/{tenant}/oauth2/v2.0/token",
    "prereq": [
     "Client registration"
    ],
    "purpose": "Get user access token for service calls",
    "sample": "Standard OAuth2 client_credentials or auth_code flow",
    "rateLimit": "Per Azure AD limits",
    "timeout": "30s"
   },
   {
    "name": "Azure Key Vault — Sign",
    "method": "POST",
    "url": "https://{vault}.vault.azure.net/keys/{key}/sign",
    "prereq": [
     "Service identity with Key Vault access"
    ],
    "purpose": "Cryptographic sign of payload hash",
    "sample": "{ \"alg\":\"PS256\", \"value\":\"<sha256-base64>\" }",
    "rateLimit": "Per Key Vault tier",
    "timeout": "10s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "State-change event (in All CLM Systems (TC, SAP, Opcenter, Hub, SFC)); related: CFR21Part11, AzureAD, Compliance",
   "destinationBusinessObjectsInScope": "Signed ledger entry with cert + meaning (in Central e-Signature Service + Tamper-evident Ledger)",
   "meaning": "21 CFR Part 11 e-Signature Service: Centralized e-signature service for 21 CFR Part 11 compliance.",
   "purpose": "Delivers 'FDA-compliant e-signatures across CLM landscape with tamper-evident audit trail' (Regulatory Compliance). Every state-changing action in TC, SAP, Opcenter, Hub, and SFC routes through this service before commit.",
   "functionPrimary": "Move/transform State-change event → Signed ledger entry with cert + meaning (Sync, Event (real-time)-driven).",
   "subFunctions": [
    "Azure Infrastructure + Cert Distribution",
    "Signature Service Development",
    "FDA Part 11 Validation Suite",
    "TC Integration (first system)",
    "Other CLM Systems",
    "Production Cutover"
   ],
   "architecture": "All CLM Systems (TC, SAP, Opcenter, Hub, SFC) --[OIDC + Custom REST signing service]--> Azure AD + Signature Service --> Central e-Signature Service + Tamper-evident Ledger. Pattern: Sync integration, Event (real-time) trigger. Complexity 4/4, Risk 4/4.",
   "harmoniousFlowChannel": "Channel: Azure AD + Signature Service. INTER-system (governance): harmonises master-data governance across PLM/ERP.",
   "interfacePattern": "Sync · Event (real-time)",
   "systemOfRecord": "Aggregating interface — each contributing system remains system-of-record for its own data; this interface federates/forwards.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mdg_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-067"
   ],
   "downstreamConsumers": [
    "IF-068"
   ],
   "criticalityScore": 8,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Azure Key Vault deployed with appropriate policies",
   "docSearchKeywords": [
    "SAP MDG-M + AIG inbound governance",
    "\"State-change event\" mapping",
    "\"Signed ledger entry with cert + meaning\" configuration",
    "Azure AD + Signature Service",
    "CFR21Part11",
    "eSignature",
    "AzureAD",
    "Compliance"
   ],
   "taskHours": 168,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 1,
    "customization": 2,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-059",
  "seq": 59,
  "mvp": 2,
  "phase": 6,
  "grp": "AIG",
  "type": "Sync",
  "freq": "Event",
  "name": "CAPA → ECR Closed Loop",
  "from": "Opcenter NCR/CAPA",
  "to": "Teamcenter 2512 (ECR/ECO)",
  "mid": "AIG Gateway",
  "protocol": "Opcenter REST event → AIG → TC SOA",
  "bo": "CAPA root cause → TC Engineering Change Request linked to affected ItemRevisions",
  "complexity": 4,
  "effort": 7,
  "risk": 2,
  "team": "Quality + PLM + AIG",
  "outcome": "True closed-loop: shop floor quality patterns drive engineering changes",
  "outcomeCat": "Quality Management",
  "deps": [
   "IF-011",
   "IF-027"
  ],
  "about": "The highest-leverage CLM interface in Profile 2. When Opcenter NCR/CAPA closes a CAPA with root cause indicating a design or process issue, this interface auto-opens an Engineering Change Request in TC, linking the CAPA evidence (NCR history, root cause analysis, affected containers/lots, customer impact if any) to the affected ItemRevisions. The ECR then runs through TC's normal change workflow; on ECO release, IF-052 notifies suppliers, IF-012 syncs material changes, and the loop closes when shop floor sees the design fix in production. Without this interface, IF-011 (NCR → SAP) is a dead end — engineering never learns. ASSUMES Opcenter NCR/CAPA module.",
  "tags": [
   "CAPA",
   "ECR",
   "ClosedLoop",
   "RootCause",
   "Quality",
   "Engineering"
  ],
  "triggers": [
   {
    "id": "TRG-059-01",
    "name": "CAPA Closure with Design Root Cause",
    "type": "APPROVE",
    "source": "Opcenter NCR/CAPA",
    "sourceEvent": "CAPA workflow closes with verdict 'Effective' AND root_cause_category IN ('Design','Specification','Drawing','Material Spec')",
    "condition": "Affected materials identified; quality engineer signs off",
    "latency": "< 5 minutes for ECR creation",
    "description": "Quality engineer completes CAPA root cause analysis. If RCA points to design/spec issue (not operator error, not equipment failure), CAPA closure fires this interface. AIG pulls the full CAPA: linked NCRs, affected lots/containers, root cause, corrective actions taken, preventive actions recommended. Creates TC Engineering Change Request with all evidence attached (CAPA report PDF, NCR list, photos if any). ECR is routed to the responsible engineer (based on TC Item ownership) for analysis. Quality engineer receives notification with TC ECR link for tracking.",
    "technicalDetails": {
     "protocol": "Opcenter REST event → AIG → TC SOA",
     "opcenterEndpoint": "GET /opcenter/api/v1/capa/{id}",
     "tcSoaService": "ChangeManagement-2010-09-ChangeManagement.createChangeItem",
     "ecrType": "Engineering Change Request (per TC config)",
     "authentication": "Mutual TLS + svc accounts",
     "idempotencyKey": "capa_id (one CAPA → one ECR)"
    },
    "preConditions": [
     "Opcenter NCR/CAPA module deployed with workflow",
     "Root cause category taxonomy includes design/spec categories",
     "Quality engineer role configured",
     "TC Change Management module licensed",
     "TC ECR type configured with proper workflow",
     "ItemRevision ownership records (who is responsible engineer per part)"
    ],
    "context": "True closed-loop manufacturing in CLM. Most implementations stop at MES → SAP for quality notifications, leaving engineering blind to repeated shop-floor issues. With this interface, the same NCR appearing 3+ times triggers a CAPA, which triggers an ECR, which (after engineering analysis) may result in a drawing change, BOM revision, or spec tightening. The fix flows back through TC → SAP → Opcenter via existing interfaces. Closes the loop in days/weeks instead of waiting for customer complaint or warranty claim.",
    "prerequisites": {
     "opcenter": [
      "Opcenter NCR/CAPA module v2024+",
      "Auto-CAPA-creation rule: same NCR pattern 3 times in 30 days → CAPA",
      "Root cause category taxonomy aligned with engineering vs. operations",
      "CAPA closure workflow with quality engineer sign-off",
      "Webhook to AIG on closure"
     ],
     "aig": [
      "Webhook receiver /aig/if059/capa-closed",
      "CAPA detail retrieval and document assembly",
      "Affected ItemRevision resolution from CAPA → NCR → material → ItemRev",
      "Engineer ownership lookup from TC",
      "DLQ replay UI"
     ],
     "teamcenter": [
      "ECR type 'Quality-Driven Change' configured",
      "ECR custom properties: zz_capa_id, zz_capa_evidence_dataset, zz_quality_engineer",
      "ECR routing rule to responsible engineer based on ItemRev ownership",
      "ECR workflow includes 'Quality Review' gate before engineering analysis"
     ]
    },
    "sla": {
     "latency": "< 5min from CAPA closure to TC ECR visibility",
     "availability": "99% (closed-loop value but not minute-critical)",
     "completeness": "100% of design-RC CAPAs create ECR (operations RC don't)"
    },
    "errorHandling": {
     "noResponsibleEngineer": "Part has no owner in TC → route ECR to PLM admin for triage",
     "capaEvidenceTooLarge": "CAPA report + attachments > 100MB → use signed URLs; ECR references URLs",
     "tcEcrCreateFail": "TC validation error → AIG DLQ; quality engineer notified of delay",
     "nonDesignRootCause": "Closure event arrives but RC is operations (training, calibration, etc.) → ignore; log decision for audit"
    },
    "monitoring": {
     "metrics": [
      "if059_ecrs_created_total",
      "if059_avg_time_capa_close_to_ecr_create_seconds",
      "if059_ecrs_resolved_to_eco_total (closes the loop)",
      "if059_loop_time_capa_to_eco_days (key business metric)"
     ],
     "alerts": [
      "ECR aged > 14 days without engineering response → email engineering manager",
      "Loop time > 60 days → quarterly review with quality + engineering leads"
     ],
     "dashboards": [
      "Grafana 'CLM/ClosedLoop' — key business value visualization"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 end-to-end",
     "authentication": "Mutual TLS + svc accounts",
     "authorization": "AIG svc account scoped to CAPA read + ECR create",
     "auditLog": "capa_id, ecr_id, affected_items, root_cause, quality_engineer, responsible_engineer, timestamps",
     "dataClassification": "Quality data: confidential; retain per quality records policy (typically 10+ years)"
    },
    "rollback": {
     "steps": [
      "Identify ECR by capa_id",
      "If no engineering work done: cancel ECR with reason 'Created in error'",
      "If engineering analysis in progress: leave ECR (engineer can close as 'No change needed' with documented reasoning)",
      "CAPA in Opcenter retains all original data"
     ],
     "estimatedTime": "10 minutes per ECR",
     "dataLoss": "None — CAPA is authoritative source"
    },
    "recommendedMapping": [
     {
      "src": "Opcenter.CAPA.id",
      "dst": "TC.ECR.zz_capa_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Round-trip key"
     },
     {
      "src": "Opcenter.CAPA.title",
      "dst": "TC.ECR.object_name",
      "xform": "Prefix 'CAPA-' + title",
      "mandatory": true,
      "note": "ECR name"
     },
     {
      "src": "Opcenter.CAPA.description",
      "dst": "TC.ECR.object_desc",
      "xform": "Direct",
      "mandatory": true,
      "note": "Problem description"
     },
     {
      "src": "Opcenter.CAPA.rootCause",
      "dst": "TC.ECR.zz_root_cause",
      "xform": "Direct",
      "mandatory": true,
      "note": "RCA conclusion"
     },
     {
      "src": "Opcenter.CAPA.rootCauseCategory",
      "dst": "TC.ECR.zz_rc_category",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Design/Spec/Drawing/Material"
     },
     {
      "src": "Opcenter.CAPA.correctiveActionsTaken",
      "dst": "TC.ECR.zz_corrective_actions",
      "xform": "Direct (multi-line)",
      "mandatory": true,
      "note": "What was done immediately"
     },
     {
      "src": "Opcenter.CAPA.preventiveActionsRecommended",
      "dst": "TC.ECR.zz_preventive_actions",
      "xform": "Direct (multi-line)",
      "mandatory": true,
      "note": "Recommended engineering changes"
     },
     {
      "src": "Opcenter.CAPA.closedBy",
      "dst": "TC.ECR.zz_quality_engineer",
      "xform": "User lookup",
      "mandatory": true,
      "note": "Quality engineer"
     },
     {
      "src": "Opcenter.CAPA.closedAt",
      "dst": "TC.ECR.zz_capa_closed_at",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Closure timestamp"
     },
     {
      "src": "Opcenter.CAPA.affectedMaterials[]",
      "dst": "TC.ECR.affectedItems",
      "xform": "Material → ItemRev lookup",
      "mandatory": true,
      "note": "Affected parts"
     },
     {
      "src": "Opcenter.CAPA.linkedNcrs[]",
      "dst": "TC.ECR.zz_linked_ncrs",
      "xform": "Multi-value",
      "mandatory": true,
      "note": "NCR evidence"
     },
     {
      "src": "Opcenter.CAPA.ncrFrequency",
      "dst": "TC.ECR.zz_ncr_frequency",
      "xform": "Integer (occurrences)",
      "mandatory": true,
      "note": "How often this happened"
     },
     {
      "src": "Opcenter.CAPA.customerImpact",
      "dst": "TC.ECR.priority",
      "xform": "Map to priority",
      "mandatory": true,
      "note": "Customer-impacting → High priority"
     },
     {
      "src": "Opcenter.CAPA.evidencePdf",
      "dst": "TC.Dataset.CAPAEvidence.file",
      "xform": "Upload",
      "mandatory": true,
      "note": "Full CAPA report"
     }
    ],
    "configSteps": [
     "Verify Opcenter NCR/CAPA module configuration",
     "Configure auto-CAPA-creation rule (e.g., same NCR 3× in 30 days)",
     "Align root cause taxonomy: which categories are engineering-relevant",
     "Configure CAPA closure workflow with quality engineer sign-off",
     "Configure CAPA webhook → AIG on closure",
     "Configure TC ECR type 'Quality-Driven Change' with custom properties",
     "Configure ECR routing rule based on ItemRevision ownership",
     "Configure ECR workflow with Quality Review gate",
     "Build AIG flow: CAPA detail → affected items → engineer ownership → ECR creation",
     "Configure DLQ replay UI",
     "Configure Grafana 'CLM/ClosedLoop' dashboard",
     "Smoke test: close a CAPA with design RC; verify ECR in TC < 5min",
     "Negative test: close CAPA with operations RC; verify no ECR created",
     "Loop test: ECR → ECO → IF-012 → IF-052 → shop floor sees change",
     "Metric test: measure CAPA-to-ECO time over 30 days"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Opcenter NCR (multiple) → Opcenter CAPA → AIG → TC ECR → TC ECO → other interfaces close the loop",
   "correlationStrategy": "capa_id as primary key; affected_items resolved via material → ItemRev",
   "consistency": "Eventually consistent within 5min",
   "failureSemantics": "At-least-once; idempotent by capa_id (one CAPA → one ECR; replay is no-op)",
   "businessLoopTime": "CAPA closure → ECO release: target < 60 days; actual measurable via metrics"
  },
  "implementationOrder": [
   "Phase 1: Verify CAPA module + workflow + taxonomy alignment",
   "Phase 2: TC ECR type + routing rules",
   "Phase 3: AIG flow development",
   "Phase 4: Pilot with 2-3 historical CAPAs (manual replay)",
   "Phase 5: Live with monitoring",
   "Phase 6: 30-day stability + loop-time metric baseline",
   "Phase 7: Quarterly review for continuous improvement"
  ],
  "tasks": [
   {
    "id": "T059a",
    "name": "CAPA Module Alignment",
    "type": "Analyze",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Auto-CAPA rules configured (3× in 30 days standard)",
     "Root cause taxonomy aligned with engineering relevance",
     "Closure workflow includes engineering vs. operations split decision",
     "Quality engineer training material on RC categorization"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Analyze' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Gather source data for 'CAPA Module Alignment'",
      "subSubTasks": [
       "Extract from Opcenter NCR/CAPA",
       "Extract from Teamcenter 2512 (ECR/ECO)"
      ]
     },
     {
      "step": 2,
      "title": "Compare and find gaps",
      "subSubTasks": [
       "Align structures/hierarchies",
       "Identify mismatches",
       "Quantify the gap"
      ]
     },
     {
      "step": 3,
      "title": "Produce alignment report",
      "subSubTasks": [
       "Document findings",
       "Agree remediation actions",
       "Sign off"
      ]
     }
    ]
   },
   {
    "id": "T059b",
    "name": "TC ECR Configuration",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Quality-Driven Change ECR type configured",
     "Custom properties added",
     "Routing rule based on ItemRev ownership working",
     "Quality Review gate in workflow",
     "ECR dashboard for engineering managers"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC ECR Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC ECR Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T059c",
    "name": "AIG Flow",
    "type": "Configure",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Webhook receiver active",
     "CAPA detail retrieval with all evidence",
     "Affected items resolution",
     "Engineer ownership lookup",
     "ECR creation with full payload",
     "Idempotency table prevents duplicate ECRs",
     "DLQ replay UI"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Flow'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Flow'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T059d",
    "name": "Loop-Time Metrics + Dashboard",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Loop time metric calculated (CAPA close → ECO release)",
     "Grafana 'CLM/ClosedLoop' dashboard live",
     "Weekly executive report"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Loop-Time Metrics + Dashboard'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Loop-Time Metrics + Dashboard'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T059e",
    "name": "Pilot + Live",
    "type": "Test",
    "hours": 8,
    "cx": 3,
    "dod": [
     "3 historical CAPAs manually replayed; ECRs created correctly",
     "Quality + engineering UAT sign-off",
     "Live with monitoring for 30 days",
     "Initial loop-time baseline measured"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Pilot + Live'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Opcenter NCR/CAPA→Teamcenter 2512 (ECR/ECO))",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Teamcenter 2512 (ECR/ECO)"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T059f",
    "name": "Continuous Improvement Cadence",
    "type": "Validate",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Quarterly review meeting scheduled with quality + engineering leads",
     "Loop-time trending tracked",
     "RC taxonomy refinement based on patterns observed",
     "Reduction in repeat NCRs quantified"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Continuous Improvement Cadence'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Opcenter.CAPA.id",
    "dst": "TC.ECR.zz_capa_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.title",
    "dst": "TC.ECR.object_name",
    "xform": "Prefix",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.description",
    "dst": "TC.ECR.object_desc",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.rootCause",
    "dst": "TC.ECR.zz_root_cause",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.rootCauseCategory",
    "dst": "TC.ECR.zz_rc_category",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.correctiveActionsTaken",
    "dst": "TC.ECR.zz_corrective_actions",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.preventiveActionsRecommended",
    "dst": "TC.ECR.zz_preventive_actions",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.closedBy",
    "dst": "TC.ECR.zz_quality_engineer",
    "xform": "User",
    "category": "audit"
   },
   {
    "src": "Opcenter.CAPA.closedAt",
    "dst": "TC.ECR.zz_capa_closed_at",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "Opcenter.CAPA.affectedMaterials[]",
    "dst": "TC.ECR.affectedItems",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.linkedNcrs[]",
    "dst": "TC.ECR.zz_linked_ncrs",
    "xform": "Multi-value",
    "category": "additional"
   },
   {
    "src": "Opcenter.CAPA.ncrFrequency",
    "dst": "TC.ECR.zz_ncr_frequency",
    "xform": "Integer",
    "category": "additional"
   },
   {
    "src": "Opcenter.CAPA.ncrFirstOccurrence",
    "dst": "TC.ECR.zz_first_occurrence",
    "xform": "ISO 8601",
    "category": "additional"
   },
   {
    "src": "Opcenter.CAPA.customerImpact",
    "dst": "TC.ECR.priority",
    "xform": "Map",
    "category": "core"
   },
   {
    "src": "Opcenter.CAPA.estimatedCostOfIssue",
    "dst": "TC.ECR.zz_estimated_cost",
    "xform": "Numeric",
    "category": "additional"
   },
   {
    "src": "Opcenter.CAPA.evidencePdf",
    "dst": "TC.Dataset.CAPAEvidence.file",
    "xform": "Upload",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "Opcenter REST — Get CAPA",
    "method": "GET",
    "url": "https://opcenter-host/opcenter/api/v1/capa/{capaId}",
    "prereq": [
     "CAPA read scope"
    ],
    "purpose": "Retrieve full CAPA details",
    "sample": "GET /opcenter/api/v1/capa/CAPA-12345",
    "rateLimit": "30 req/min",
    "timeout": "30s"
   },
   {
    "name": "Opcenter Webhook → AIG",
    "method": "POST",
    "url": "https://aig-host/aig/if059/capa-closed",
    "prereq": [
     "HMAC validation"
    ],
    "purpose": "Notify AIG of CAPA closure",
    "sample": "{ \"capa_id\":\"CAPA-12345\", \"root_cause_category\":\"Design\" }",
    "rateLimit": "30 req/min",
    "timeout": "10s"
   },
   {
    "name": "TC SOA — Create Change Item (ECR)",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/ChangeManagement-2010-09-ChangeManagement/createChangeItem",
    "prereq": [
     "Change Author role"
    ],
    "purpose": "Create ECR with full evidence",
    "sample": "<input><type>QualityDrivenChange</type><name>...</name><attachments>...</attachments></input>",
    "rateLimit": "10 req/sec",
    "timeout": "60s"
   },
   {
    "name": "TC SOA — Get Item Owner",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/DataManagement-2006-03-DataManagement/getProperties",
    "prereq": [
     "Read access"
    ],
    "purpose": "Find responsible engineer for routing",
    "sample": "<objects>...</objects><attributes>owning_user, project_owner</attributes>",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "CAPA root cause (in Opcenter NCR/CAPA); related: CAPA, ECR, ClosedLoop",
   "destinationBusinessObjectsInScope": "TC Engineering Change Request linked to affected ItemRevisions (in Teamcenter 2512 (ECR/ECO))",
   "meaning": "CAPA → ECR Closed Loop: The highest-leverage CLM interface in Profile 2.",
   "purpose": "Delivers 'True closed-loop: shop floor quality patterns drive engineering changes' (Quality Management). When Opcenter NCR/CAPA closes a CAPA with root cause indicating a design or process issue, this interface auto-opens an Engineering Change Request in TC, linking the CAPA evidence (NCR history, root cause analysis, affected containers/lots, customer impact if any) to the affected ItemRevisions.",
   "functionPrimary": "Move/transform CAPA root cause → TC Engineering Change Request linked to affected ItemRevisions (Sync, Event-driven).",
   "subFunctions": [
    "CAPA Module Alignment",
    "TC ECR Configuration",
    "AIG Flow",
    "Loop-Time Metrics + Dashboard",
    "Pilot + Live",
    "Continuous Improvement Cadence"
   ],
   "architecture": "Opcenter NCR/CAPA --[Opcenter REST event → AIG → TC SOA]--> AIG Gateway --> Teamcenter 2512 (ECR/ECO). Pattern: Sync integration, Event trigger. Complexity 4/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "Sync · Event",
   "systemOfRecord": "Opcenter is system-of-record for execution/genealogy; target receives actuals/feedback.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-011",
    "IF-027"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "Auto-CAPA rules configured (3× in 30 days standard)",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"CAPA root cause\" mapping",
    "\"TC Engineering Change Request linked to affected ItemRevisions\" configuration",
    "AIG Gateway",
    "CAPA",
    "ECR",
    "ClosedLoop",
    "RootCause"
   ],
   "taskHours": 42,
   "classificationSummary": {
    "ootb": 3,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-064",
  "seq": 64,
  "mvp": 2,
  "phase": 3,
  "grp": "AIG",
  "type": "BiSync",
  "freq": "Event",
  "name": "SAP MDG-M to Teamcenter Material Lifecycle Sync",
  "from": "SAP MDG-M",
  "to": "Teamcenter 2512",
  "mid": "AIG Gateway",
  "protocol": "SAP MDG Change Request → AIG → TC SOA",
  "bo": "MDG Change Request (material) ↔ TC Item lifecycle + revision",
  "complexity": 4,
  "effort": 12,
  "risk": 3,
  "team": "MDG + PLM + AIG",
  "outcome": "Material governance centralized in MDG; TC and SAP stay aligned via MDG-driven flow",
  "outcomeCat": "Master Data Governance",
  "deps": [
   "IF-041",
   "IF-042"
  ],
  "about": "If SAP MDG-M is deployed, it owns the material approval lifecycle and IF-041/042 must defer to MDG instead of going direct SAP MM ↔ TC. This interface routes change requests through MDG: TC submission creates an MDG Change Request; MDG runs its multi-step approval; on approval, MDG creates/updates the SAP material AND notifies TC via this interface. Architecturally this is *the* MDG-aware version of IF-041/042 — for shops with MDG, IF-041/042 either route through MDG (recommended) or are replaced by this interface entirely. ASSUMES SAP MDG-M 8.0+ with standard BAPIs.",
  "tags": [
   "MDG",
   "Governance",
   "MaterialMaster",
   "ChangeRequest",
   "Approval"
  ],
  "triggers": [
   {
    "id": "TRG-064-01",
    "name": "MDG Change Request Approved",
    "type": "APPROVE",
    "source": "SAP MDG-M",
    "sourceEvent": "MDG Change Request (material) workflow completes with verdict 'Approved'",
    "condition": "CR type is material create or material change",
    "latency": "< 90 seconds from MDG approval to TC visibility",
    "description": "MDG-M's workflow completes for a material Change Request. MDG publishes the CR result to its outbound interface (typically SOAP web service or RFC). AIG receives the result, looks up the originating TC correlation (if CR came from TC via IF-041), and either advances the TC workflow (similar to IF-042) or creates a new TC Item if the CR originated in MDG. For CR-driven changes to existing materials, the TC Item is updated with the new MDG-approved attributes.",
    "technicalDetails": {
     "protocol": "MDG SOAP outbound → AIG → TC SOA TCCS v14",
     "mdgWebService": "Z_MDG_MATERIAL_RESULT (custom MDG outbound)",
     "tcSoaService": "Item-2008-06-DataManagement.createItems / reviseItems / updateProperties",
     "authentication": "SOAP-WS Security; Mutual TLS to TC",
     "idempotencyKey": "mdg_cr_id + cr_version"
    },
    "preConditions": [
     "SAP MDG-M 8.0+ deployed",
     "Material data model in MDG aligned with TC + SAP MM",
     "MDG outbound web service configured (Z_MDG_MATERIAL_RESULT)",
     "TC Item revision rules support MDG-driven attribute updates",
     "Correlation strategy resolved: MDG CR can carry tc_correlation_id from IF-041"
    ],
    "context": "MDG-driven CLM is the gold standard for material governance — workflow, audit, and lineage all in one tool. The trade-off is complexity: MDG workflows are heavyweight, and the integration must respect MDG as the system of truth for the approval lifecycle. Done right: clean, auditable, supports cross-system data quality. Done wrong: MDG is bypassed by 'urgent' direct edits and the governance value evaporates.",
    "prerequisites": {
     "sap_mdg": [
      "MDG-M 8.0+ active with Material Governance scope configured",
      "Custom CR types: TC-Initiated-Material (linked to IF-041 origin) and Direct-MDG-Material",
      "Outbound web service Z_MDG_MATERIAL_RESULT publishing to AIG",
      "Approval roles defined (Materials Manager, Costing, Plant Lead)"
     ],
     "aig": [
      "Inbound web service listener for MDG callback",
      "Correlation logic: match MDG CR to TC origin (if TC-Initiated)",
      "Distinction between create vs. update vs. mass change flows",
      "DLQ with replay UI"
     ],
     "teamcenter": [
      "Item Revise rule supports MDG-driven attribute payloads",
      "Custom properties for MDG-enriched attributes (zz_mdg_cr_id, zz_mdg_approver, etc.)",
      "TC service account scoped to Item CRUD + Revise"
     ]
    },
    "sla": {
     "latency": "< 90s for MDG approval → TC visibility",
     "availability": "99.5%"
    },
    "errorHandling": {
     "correlationMismatch": "MDG CR claims to be TC-Initiated but tc_correlation_id not found → log P2 incident",
     "tcReviseRuleViolation": "MDG attempts revision but TC rule rejects (e.g., max revision reached) → return error to MDG; MDG marks CR as 'failed downstream sync'",
     "directMdgCrNotFromTc": "MDG CR has no tc_correlation_id (direct MDG origin) → AIG creates new TC Item with MDG attributes",
     "massChange": "MDG mass-change CR with hundreds of materials → AIG processes in batches; partial success tracked per material"
    },
    "monitoring": {
     "metrics": [
      "if064_mdg_callbacks_total{cr_type,verdict}",
      "if064_callback_latency_seconds",
      "if064_correlation_match_rate",
      "if064_tc_revise_failures_total"
     ],
     "alerts": [
      "Correlation mismatch → immediate PagerDuty MDG on-call",
      "TC revise failure > 2/day → MDG admin review"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 + WS-Security on MDG side",
     "authentication": "SOAP-WS Security with X.509; Mutual TLS to TC",
     "authorization": "AIG svc account scoped to receive MDG outbound + push to TC Item",
     "auditLog": "mdg_cr_id, cr_type, verdict, tc_item_id, tc_revision, mdg_approver, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify TC ItemRevision created by callback (zz_mdg_cr_id property)",
      "If no downstream refs: delete revision",
      "If downstream refs exist: create corrective revision with admin override",
      "Update MDG CR status to 'rolled-back' (manual MDG admin task)"
     ],
     "estimatedTime": "15 minutes per material",
     "dataLoss": "MDG audit log preserved; TC retains all history"
    },
    "recommendedMapping": [
     {
      "src": "MDG.CR.id",
      "dst": "TC.Item.zz_mdg_cr_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "MDG CR identifier"
     },
     {
      "src": "MDG.CR.verdict",
      "dst": "TC.EPM.decision",
      "xform": "APPROVE→'Approve'/REJECT→'Reject'",
      "mandatory": true,
      "note": "If TC-initiated"
     },
     {
      "src": "MDG.CR.approver",
      "dst": "TC.Item.zz_mdg_approver",
      "xform": "MDG user → AD user",
      "mandatory": true,
      "note": "Approver attribution"
     },
     {
      "src": "MDG.CR.approval_date",
      "dst": "TC.Item.zz_mdg_approval_date",
      "xform": "ISO 8601",
      "mandatory": true,
      "note": "Audit timestamp"
     },
     {
      "src": "MDG.Material.material_number",
      "dst": "TC.Item.item_id",
      "xform": "Direct (or correlation lookup)",
      "mandatory": true,
      "note": "SAP material"
     },
     {
      "src": "MDG.Material.material_type",
      "dst": "TC.Item.object_type_secondary",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Material type"
     },
     {
      "src": "MDG.Material.valuation_class",
      "dst": "TC.ItemRev.zz_valuation_class",
      "xform": "Direct",
      "mandatory": false,
      "note": "Commercial attr"
     },
     {
      "src": "MDG.Material.mrp_type",
      "dst": "TC.ItemRev.zz_mrp_type",
      "xform": "Direct",
      "mandatory": false,
      "note": "MRP planning attr"
     },
     {
      "src": "MDG.Material.profit_center",
      "dst": "TC.ItemRev.zz_profit_center",
      "xform": "Direct",
      "mandatory": false,
      "note": "Costing assignment"
     },
     {
      "src": "MDG.Material.purchasing_group",
      "dst": "TC.ItemRev.zz_purch_group",
      "xform": "Direct",
      "mandatory": false,
      "note": "Procurement"
     },
     {
      "src": "AIG.correlation_id",
      "dst": "TC.Item.tc_workflow_correlation_id",
      "xform": "Direct (verification)",
      "mandatory": false,
      "note": "Match to IF-041 origin"
     }
    ],
    "configSteps": [
     "Confirm MDG-M deployment status and CR type configuration",
     "Build MDG outbound web service Z_MDG_MATERIAL_RESULT",
     "Configure AIG inbound listener with WS-Security",
     "Build mapping for create vs. update vs. mass change",
     "Configure TC service account and revise rule",
     "Add TC custom properties: zz_mdg_cr_id, zz_mdg_approver, zz_mdg_approval_date, zz_mdg_cr_type",
     "Coordinate with IF-041/042 team: which CR types route via MDG vs. direct",
     "Configure DLQ with replay UI",
     "Smoke test: complete 3 MDG CRs (TC-initiated, MDG-initiated, update); verify TC visibility < 90s",
     "Reject path test: MDG rejects CR; TC EPM workflow returns to originator",
     "Mass change test: 50-material MDG CR processed in batches",
     "Audit trail review: all required fields captured"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "MDG (authoritative for governance) → AIG → TC (engineering data alignment)",
   "correlationStrategy": "mdg_cr_id is primary; tc_correlation_id used when CR is TC-initiated",
   "consistency": "Eventually consistent within 90s under normal load",
   "failureSemantics": "At-least-once at MDG; AIG enforces exactly-once by (mdg_cr_id, cr_version)",
   "relationToOtherInterfaces": "Supersedes IF-041/042 direct path when MDG is present; IF-012 still fires post-revision"
  },
  "implementationOrder": [
   "Phase 1: Confirm MDG presence and scope; decide MDG-routing strategy with IF-041/042 team",
   "Phase 2: MDG outbound web service development (ABAP)",
   "Phase 3: AIG inbound listener and mapping",
   "Phase 4: TC custom properties and revise rule extension",
   "Phase 5: Coordinated test with IF-041/042 (chained scenarios)",
   "Phase 6: UAT with Materials Manager (now MDG-driven)",
   "Phase 7: Cutover with rollback plan rehearsed"
  ],
  "tasks": [
   {
    "id": "T064a",
    "name": "MDG CR Type + Outbound Web Service",
    "type": "Configure",
    "hours": 16,
    "cx": 4,
    "dod": [
     "CR types TC-Initiated-Material and Direct-MDG-Material configured",
     "Z_MDG_MATERIAL_RESULT outbound web service published",
     "Test CR workflow completes and fires outbound message",
     "Reject path also fires outbound message",
     "Mass-change CR supported"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'MDG CR Type + Outbound Web Service'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'MDG CR Type + Outbound Web Service'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T064b",
    "name": "AIG Inbound + Mapping",
    "type": "Configure",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Inbound listener accepts MDG SOAP with WS-Security",
     "Mapping handles create, update, mass-change flows",
     "Correlation lookup against IF-041 store",
     "Idempotency by (mdg_cr_id, cr_version)",
     "DLQ replay UI"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Inbound + Mapping'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Inbound + Mapping'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T064c",
    "name": "TC Properties + Revise Rule",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Custom properties zz_mdg_* added to Item/ItemRev",
     "Revise rule extended to accept MDG-driven attribute payloads",
     "TC service account scoped correctly",
     "TC EPM workflow handler accepts both IF-042 and IF-064 callbacks"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC Properties + Revise Rule'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC Properties + Revise Rule'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T064d",
    "name": "Coordinated Test with IF-041/042",
    "type": "Test",
    "hours": 12,
    "cx": 4,
    "dod": [
     "TC-initiated → MDG CR → MDG approve → IF-064 callback → TC revision → IF-012 sync (full chain < 15min)",
     "MDG-initiated CR creates new TC Item (no IF-041 origin)",
     "Update CR modifies existing TC Item",
     "Mass-change CR processes 50 materials with per-material status",
     "MDG reject path returns to TC originator"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Coordinated Test with IF-041/042'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (SAP MDG-M→Teamcenter 2512)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Teamcenter 2512"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T064e",
    "name": "UAT + Cutover",
    "type": "Validate",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Materials Manager + MDG admin sign off on 5 real scenarios",
     "Rollback rehearsed in QA",
     "Cutover runbook approved by CAB",
     "Coordinated cutover with IF-041/042 team"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'UAT + Cutover'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "MDG.CR.id",
    "dst": "TC.Item.zz_mdg_cr_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "MDG.CR.type",
    "dst": "TC.Item.zz_mdg_cr_type",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "MDG.CR.verdict",
    "dst": "TC.EPM.decision",
    "xform": "Verdict map",
    "category": "core"
   },
   {
    "src": "MDG.CR.approver",
    "dst": "TC.Item.zz_mdg_approver",
    "xform": "User lookup",
    "category": "audit"
   },
   {
    "src": "MDG.CR.approval_date",
    "dst": "TC.Item.zz_mdg_approval_date",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "MDG.CR.requestor",
    "dst": "TC.Item.zz_mdg_requestor",
    "xform": "User lookup",
    "category": "audit"
   },
   {
    "src": "MDG.CR.reason",
    "dst": "TC.Item.zz_mdg_reason",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "MDG.Material.material_number",
    "dst": "TC.Item.item_id",
    "xform": "Direct or lookup",
    "category": "core"
   },
   {
    "src": "MDG.Material.material_type",
    "dst": "TC.Item.object_type_secondary",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "MDG.Material.description",
    "dst": "TC.Item.object_desc",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "MDG.Material.base_uom",
    "dst": "TC.Item.uom",
    "xform": "UOM lookup",
    "category": "core"
   },
   {
    "src": "MDG.Material.material_group",
    "dst": "TC.Item.classification_group",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "MDG.Material.valuation_class",
    "dst": "TC.ItemRev.zz_valuation_class",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "MDG.Material.standard_price",
    "dst": "TC.ItemRev.zz_standard_price",
    "xform": "Direct (restrict visibility)",
    "category": "additional"
   },
   {
    "src": "MDG.Material.mrp_type",
    "dst": "TC.ItemRev.zz_mrp_type",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "MDG.Material.mrp_controller",
    "dst": "TC.ItemRev.zz_mrp_controller",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "MDG.Material.purchasing_group",
    "dst": "TC.ItemRev.zz_purch_group",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "MDG.Material.profit_center",
    "dst": "TC.ItemRev.zz_profit_center",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "MDG.Material.plant",
    "dst": "TC.ItemRev.zz_sap_plant",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "AIG.correlation_id",
    "dst": "TC.Item.tc_workflow_correlation_id",
    "xform": "Direct",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "MDG Outbound Web Service",
    "method": "SOAP",
    "url": "https://mdg-host/sap/bc/srt/wsdl/srvc_Z_MDG_MATERIAL_RESULT/wsdl11/allinone/standard/document",
    "prereq": [
     "MDG CR type configured",
     "Outbound binding active"
    ],
    "purpose": "MDG publishes approval verdict to AIG",
    "sample": "<MdgMaterialResult><crId>CR-12345</crId><verdict>APPROVED</verdict><material>...</material></MdgMaterialResult>",
    "rateLimit": "10 req/sec",
    "timeout": "30s"
   },
   {
    "name": "AIG Inbound Listener",
    "method": "POST",
    "url": "https://aig-host/aig/if064/mdg-callback",
    "prereq": [
     "WS-Security cert",
     "MDG as trusted source"
    ],
    "purpose": "Receive MDG approval result",
    "sample": "WS-Security SOAP envelope with MDG payload",
    "rateLimit": "20 req/sec",
    "timeout": "60s"
   },
   {
    "name": "TC SOA — Item Revise",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/Item-2008-06-DataManagement/reviseItems",
    "prereq": [
     "Revise rule active",
     "Service account configured"
    ],
    "purpose": "Create new ItemRevision with MDG-enriched attrs",
    "sample": "<itemsAndDescs>...</itemsAndDescs>",
    "rateLimit": "10 req/sec",
    "timeout": "60s"
   },
   {
    "name": "MDG REST — Get CR Detail (optional)",
    "method": "GET",
    "url": "https://mdg-host/sap/opu/odata/mdg/MaterialCRService/CRSet('CR-12345')",
    "prereq": [
     "MDG OData service active",
     "OAuth2 token"
    ],
    "purpose": "Retrieve full CR details when payload truncated",
    "sample": "GET CRSet('CR-12345')?$expand=Materials",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "MDG Change Request (material) ↔ TC Item lifecycle + revision (in SAP MDG-M); related: MDG, Governance, MaterialMaster",
   "destinationBusinessObjectsInScope": "MDG Change Request (material) ↔ TC Item lifecycle + revision (in Teamcenter 2512)",
   "meaning": "SAP MDG-M to Teamcenter Material Lifecycle Sync: If SAP MDG-M is deployed, it owns the material approval lifecycle and IF-041/042 must defer to MDG instead of going direct SAP MM ↔ TC.",
   "purpose": "Delivers 'Material governance centralized in MDG; TC and SAP stay aligned via MDG-driven flow' (Master Data Governance). This interface routes change requests through MDG: TC submission creates an MDG Change Request; MDG runs its multi-step approval; on approval, MDG creates/updates the SAP material AND notifies TC via this interface.",
   "functionPrimary": "Move/transform MDG Change Request (material) ↔ TC Item lifecycle + revision → MDG Change Request (material) ↔ TC Item lifecycle + revision (BiSync, Event-driven).",
   "subFunctions": [
    "MDG CR Type + Outbound Web Service",
    "AIG Inbound + Mapping",
    "TC Properties + Revise Rule",
    "Coordinated Test with IF-041/042",
    "UAT + Cutover"
   ],
   "architecture": "SAP MDG-M --[SAP MDG Change Request → AIG → TC SOA]--> AIG Gateway --> Teamcenter 2512. Pattern: BiSync integration, Event trigger. Complexity 4/4, Risk 3/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (PLM↔ERP): harmonises Teamcenter engineering with SAP master data.",
   "interfacePattern": "BiSync · Event",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotent via TC IUID ↔ SAP MATNR/AENR cross-reference; leading change-master prevents duplicate effectivity.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: aig_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-041",
    "IF-042"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 5,
   "reusability": "HIGH — core engine channel; re-skins across discrete-mfg verticals config-only.",
   "keyAcceptanceSignal": "CR types TC-Initiated-Material and Direct-MDG-Material configured",
   "docSearchKeywords": [
    "Teamcenter Gateway for SAP (AIG/T4S) Administration Guide",
    "\"MDG Change Request (material) ↔ TC Item lifecycle + revision\" mapping",
    "\"MDG Change Request (material) ↔ TC Item lifecycle + revision\" configuration",
    "AIG Gateway",
    "MDG",
    "Governance",
    "MaterialMaster",
    "ChangeRequest"
   ],
   "taskHours": 52,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 3,
    "customization": 0,
    "totalTasks": 5
   }
  }
 },
 {
  "id": "IF-066",
  "seq": 66,
  "mvp": 1,
  "phase": 1,
  "grp": "MDG",
  "type": "Sync",
  "freq": "Batch (Daily) + Event (delta)",
  "name": "Plant / Work Center / Cost Center Master Data Sync",
  "from": "SAP S/4HANA",
  "to": "Opcenter 2601 + Teamcenter 2512 + Insights Hub",
  "mid": "AIG Gateway",
  "protocol": "SAP iDoc CLFMAS + Custom outbound → AIG → REST APIs",
  "bo": "SAP T001K/T024/CSKS → Opcenter Site/WorkCenter, TC Plant/Center attrs, Hub asset tags",
  "complexity": 2,
  "effort": 5,
  "risk": 1,
  "team": "ERP + MDG + AIG + downstream system owners",
  "outcome": "Single source of truth for plant/WC/CC codes across CLM landscape",
  "outcomeCat": "Master Data Governance",
  "deps": [],
  "about": "Foundational sync of plant, work center, and cost center master data from SAP (authoritative) to Opcenter, TC, and Insights Hub. Daily full sync plus event-driven delta on changes. Every production order, WIP transaction, and analytics record references these codes — drift between systems causes integration failures that are hard to diagnose. This interface is unglamorous but should be among the first deployed.",
  "tags": [
   "MasterData",
   "Plant",
   "WorkCenter",
   "CostCenter",
   "Foundational",
   "MDG"
  ],
  "triggers": [
   {
    "id": "TRG-066-01",
    "name": "SAP Master Data Change Event",
    "type": "ATTRIBUTE_CHANGE",
    "source": "SAP S/4HANA",
    "sourceEvent": "Change document on T001K / T024 / CSKS (transaction OX10, CR02, KS02)",
    "condition": "Plant/WC/CC marked 'active' (not flagged for deletion)",
    "latency": "< 5 minutes from SAP save to downstream visibility",
    "description": "When a plant, work center, or cost center is created or modified in SAP, change documents trigger an outbound iDoc (CLFMAS or custom message). AIG receives the iDoc, normalizes the data into a canonical master data envelope, and pushes it to Opcenter (REST), TC (SOA), and Hub (REST). Each downstream system maintains its own representation but keyed on the SAP code as authoritative.",
    "technicalDetails": {
     "protocol": "SAP ALE (iDoc) → AIG → REST APIs (Opcenter, TC SOA, Hub)",
     "sapMessageTypes": [
      "CLFMAS (classification)",
      "CRELOC (work center)",
      "COSMAS (cost center)"
     ],
     "sapBapis": [
      "BAPI_COSTCENTER_CREATEMULTIPLE (validation)",
      "BAPI_BUS1148_GETDETAIL (read WC)"
     ],
     "idDocType": "Standard SAP iDoc with custom Z-segment for cross-reference fields",
     "opcenterEndpoint": "POST /opcenter/api/v1/masterdata/sync",
     "tcSoaService": "DataManagement-2006-03-DataManagement.updateProperties (on Plant org)",
     "hubEndpoint": "PUT /hub/api/v2/assets/tags",
     "authentication": "Mutual TLS to all downstream; SAP SNC inbound",
     "idempotencyKey": "sap_object_type + sap_object_id + change_timestamp"
    },
    "preConditions": [
     "SAP ALE configured for outbound CLFMAS, CRELOC, COSMAS messages",
     "Logical system 'AIG_MDG' defined in SAP (WE21)",
     "Partner profile for AIG_MDG with outbound messages configured",
     "Opcenter Site/WorkCenter objects exist or are auto-created by sync",
     "TC Plant organizational units exist",
     "Hub asset taxonomy includes plant/WC tags",
     "AIG MDG distribution registry populated (which downstream gets what)"
    ],
    "context": "Often skipped in early CLM phases because it 'isn't visible to users.' Then 6 months in, the team discovers that Opcenter WorkCenter 'PRESS-01' is 'PRSS01' in SAP and 'press_01' in Hub, breaking every downstream report. Building this on day 1 prevents weeks of reconciliation work later.",
    "prerequisites": {
     "sap": [
      "ALE distribution model with logical system AIG_MDG",
      "Change pointer activation for message types (BD61)",
      "Job BD21 scheduled every 5 minutes to process change pointers",
      "RFC destination to AIG configured (SM59 with SNC)"
     ],
     "aig": [
      "iDoc inbound listener (ALE port)",
      "Canonical master data model definition",
      "Distribution registry: which downstream systems receive which object types",
      "Idempotency table on (object_type, object_id, change_timestamp)",
      "DLQ for downstream failures with manual replay UI"
     ],
     "opcenter": [
      "POST /opcenter/api/v1/masterdata/sync endpoint exists (custom service)",
      "Site, WorkCenter objects with sap_code property",
      "Cost center stored as custom property on WorkCenter"
     ],
     "teamcenter": [
      "Plant org objects with sap_plant_code property",
      "Cost center custom property on Item for charge-out"
     ],
     "hub": [
      "Asset taxonomy includes plant_code, work_center_code, cost_center_code tags",
      "PUT /hub/api/v2/assets/tags endpoint accessible"
     ]
    },
    "sla": {
     "latency": "< 5min from SAP change to downstream visibility (95th percentile)",
     "availability": "99.9% (foundational — high SLA)",
     "completeness": "Daily full sync catches any deltas missed by event stream"
    },
    "errorHandling": {
     "downstreamUnavailable": "AIG retains in DLQ; retry policy 30s, 2m, 10m, 30m, 2h; manual replay UI",
     "partialDistributionFailure": "If Opcenter accepts but TC rejects: success logged for Opcenter, failure for TC, sync record marked 'partial'",
     "idocParseFail": "Malformed iDoc → SAP-side ALE error queue (BD87); ops alert",
     "codeCollision": "Same code already exists with different meaning → halt sync for that object, raise P2 incident"
    },
    "monitoring": {
     "metrics": [
      "if066_objects_synced_total{type,target}",
      "if066_sync_latency_seconds",
      "if066_dlq_depth{target}",
      "if066_daily_reconciliation_diff_count"
     ],
     "alerts": [
      "DLQ depth > 20 → PagerDuty MDG on-call",
      "Daily reconciliation diff > 5 → email MDG owner",
      "Sync latency P95 > 10min → operations review"
     ],
     "dashboards": [
      "Grafana 'CLM/MDG' — sync rates, latency, drift counts"
     ]
    },
    "security": {
     "encryption": "SNC (SAP↔AIG); TLS 1.3 to all downstream",
     "authentication": "SAP RFC user (limited to MDG BAPIs); AIG service accounts on each downstream",
     "authorization": "AIG read-only on SAP; write-scope-limited on downstream (no other tables)",
     "auditLog": "object_type, object_id, change_field, old_value, new_value, sap_user, downstream_status, timestamp"
    },
    "rollback": {
     "steps": [
      "Identify last-known-good state from AIG sync audit log",
      "On downstream system: revert via API to previous values",
      "Mark AIG sync record as 'rolled_back'",
      "Investigate root cause (SAP data error vs. AIG mapping error)"
     ],
     "estimatedTime": "15 minutes per object; full reconciliation 1 hour",
     "dataLoss": "None — SAP remains authoritative; all changes traceable"
    },
    "recommendedMapping": [
     {
      "src": "SAP.T001K-WERKS",
      "dst": "Opcenter.Site.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Plant code → Opcenter Site name"
     },
     {
      "src": "SAP.T001K-NAME1",
      "dst": "Opcenter.Site.Description",
      "xform": "Direct",
      "mandatory": true,
      "note": "Plant description"
     },
     {
      "src": "SAP.T001K-ORT01",
      "dst": "Opcenter.Site.City",
      "xform": "Direct",
      "mandatory": false,
      "note": "City"
     },
     {
      "src": "SAP.T001K-LAND1",
      "dst": "Opcenter.Site.Country",
      "xform": "ISO 3166",
      "mandatory": false,
      "note": "Country"
     },
     {
      "src": "SAP.T024-ARBPL",
      "dst": "Opcenter.WorkCenter.Name",
      "xform": "Direct",
      "mandatory": true,
      "note": "Work center code"
     },
     {
      "src": "SAP.T024-KTEXT",
      "dst": "Opcenter.WorkCenter.Description",
      "xform": "Direct",
      "mandatory": true,
      "note": "WC description"
     },
     {
      "src": "SAP.T024-VERWE",
      "dst": "Opcenter.WorkCenter.Usage",
      "xform": "Lookup",
      "mandatory": false,
      "note": "WC category"
     },
     {
      "src": "SAP.T024-WERKS",
      "dst": "Opcenter.WorkCenter.SiteName",
      "xform": "Direct (FK)",
      "mandatory": true,
      "note": "Parent site"
     },
     {
      "src": "SAP.T024-COSTCENTER",
      "dst": "Opcenter.WorkCenter.zz_cost_center",
      "xform": "Direct",
      "mandatory": true,
      "note": "Cost center linkage"
     },
     {
      "src": "SAP.CSKS-KOSTL",
      "dst": "Opcenter.CostCenter.Code",
      "xform": "Direct",
      "mandatory": true,
      "note": "Cost center code"
     },
     {
      "src": "SAP.CSKS-KTEXT",
      "dst": "Opcenter.CostCenter.Description",
      "xform": "Direct",
      "mandatory": true,
      "note": "CC description"
     },
     {
      "src": "SAP.CSKS-KOKRS",
      "dst": "Opcenter.CostCenter.ControllingArea",
      "xform": "Direct",
      "mandatory": true,
      "note": "Controlling area"
     },
     {
      "src": "SAP.CSKS-VERAK",
      "dst": "Opcenter.CostCenter.Manager",
      "xform": "SAP user → user",
      "mandatory": false,
      "note": "Responsible person"
     }
    ],
    "configSteps": [
     "Activate ALE change pointers for CLFMAS, CRELOC, COSMAS (BD50)",
     "Configure outbound partner profile to AIG_MDG (WE20)",
     "Schedule job BD21 every 5 minutes for change pointer processing",
     "Schedule job BD52 weekly to reorganize change pointers (delete completed)",
     "Build canonical master data model in AIG",
     "Build distribution registry (object_type → [downstream_targets])",
     "Implement Opcenter custom endpoint /opcenter/api/v1/masterdata/sync",
     "Configure TC custom property updates (Plant, Center)",
     "Configure Hub asset tag PUT endpoint with appropriate auth",
     "Schedule daily full sync (3 AM local) for reconciliation",
     "Schedule daily diff report (compare SAP source vs. each downstream)",
     "Implement DLQ replay UI in AIG admin",
     "Smoke test: change WC description in SAP; verify all downstream within 5min",
     "Negative test: stop Opcenter; verify DLQ holds; resume → catches up",
     "Failover test: kill change pointer job; verify daily full sync catches"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "SAP (authoritative) → AIG → Opcenter + TC + Hub (fan-out)",
   "correlationStrategy": "SAP codes as primary keys; downstream stores SAP code as cross-ref",
   "consistency": "Eventually consistent within 5min; daily full sync handles drift",
   "failureSemantics": "At-least-once per downstream; idempotent by (object_type, object_id, change_ts)"
  },
  "implementationOrder": [
   "Phase 1: SAP ALE setup + change pointer activation",
   "Phase 2: AIG canonical model + distribution registry",
   "Phase 3: Opcenter endpoint (most critical downstream)",
   "Phase 4: TC + Hub endpoints",
   "Phase 5: Daily reconciliation job",
   "Phase 6: 30-day monitoring before declaring stable"
  ],
  "tasks": [
   {
    "id": "T066a",
    "name": "SAP ALE Configuration",
    "type": "Configure",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Logical system AIG_MDG defined",
     "Distribution model + partner profile configured",
     "Change pointers active for CLFMAS, CRELOC, COSMAS",
     "BD21 scheduled every 5 minutes",
     "Test iDoc successfully delivered to AIG"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP ALE Configuration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP ALE Configuration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T066b",
    "name": "AIG Canonical Model + Distribution",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "Canonical envelope schema defined",
     "Distribution registry populated for plant/WC/CC",
     "Idempotency table active",
     "DLQ replay UI functional",
     "Audit log captures all required fields"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'AIG Canonical Model + Distribution'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'AIG Canonical Model + Distribution'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T066c",
    "name": "Downstream Endpoints",
    "type": "Configure",
    "hours": 8,
    "cx": 2,
    "dod": [
     "Opcenter /opcenter/api/v1/masterdata/sync deployed and tested",
     "TC SOA property update working for Plant + Center",
     "Hub asset tag PUT verified",
     "Cross-system check: same plant code appears identically everywhere"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Downstream Endpoints'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Downstream Endpoints'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T066d",
    "name": "Reconciliation + Monitoring",
    "type": "Configure",
    "hours": 4,
    "cx": 2,
    "dod": [
     "Daily full sync job runs at 3 AM, completes < 30min",
     "Daily diff report generated and emailed to MDG owner",
     "Grafana dashboard 'CLM/MDG' live",
     "Alerts firing correctly in DEV (deliberate-failure test)"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the AIG Gateway configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Reconciliation + Monitoring'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Reconciliation + Monitoring'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T066e",
    "name": "Integration Tests",
    "type": "Test",
    "hours": 6,
    "cx": 2,
    "dod": [
     "Create WC in SAP → visible in Opcenter, TC, Hub within 5min",
     "Modify CC description → all downstream updated",
     "Mark plant inactive → downstream marks inactive (no delete)",
     "Stop Opcenter, change 10 WCs in SAP, resume — all 10 sync from DLQ",
     "Daily reconciliation diff = 0 after week of normal ops"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Integration Tests'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (SAP S/4HANA→Opcenter 2601 + Teamcenter 2512 + Insights Hub)",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through AIG Gateway",
       "Confirm arrival + correctness at Opcenter 2601 + Teamcenter 2512 + Insights Hub"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T066f",
    "name": "Cutover + 30-day Stability Window",
    "type": "Validate",
    "hours": 5,
    "cx": 2,
    "dod": [
     "Production cutover during low-traffic window",
     "First 7 days: zero unplanned reconciliation diffs",
     "30-day window: < 3 manual interventions",
     "MDG owner sign-off"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Cutover + 30-day Stability Window'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "SAP.T001K-WERKS",
    "dst": "Downstream.Plant.code",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.T001K-NAME1",
    "dst": "Downstream.Plant.name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.T001K-ORT01",
    "dst": "Downstream.Plant.city",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.T001K-LAND1",
    "dst": "Downstream.Plant.country",
    "xform": "ISO 3166",
    "category": "additional"
   },
   {
    "src": "SAP.T001K-REGIO",
    "dst": "Downstream.Plant.region",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.T001K-PSTLZ",
    "dst": "Downstream.Plant.postal_code",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.T024-ARBPL",
    "dst": "Downstream.WorkCenter.code",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.T024-KTEXT",
    "dst": "Downstream.WorkCenter.name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.T024-VERWE",
    "dst": "Downstream.WorkCenter.category",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "SAP.T024-WERKS",
    "dst": "Downstream.WorkCenter.plant",
    "xform": "Direct (FK)",
    "category": "core"
   },
   {
    "src": "SAP.T024-COSTCENTER",
    "dst": "Downstream.WorkCenter.cost_center",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.T024-LEISTEINH",
    "dst": "Downstream.WorkCenter.capacity_uom",
    "xform": "Lookup",
    "category": "additional"
   },
   {
    "src": "SAP.T024-KAPAZNR",
    "dst": "Downstream.WorkCenter.capacity_id",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.CSKS-KOSTL",
    "dst": "Downstream.CostCenter.code",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.CSKS-KTEXT",
    "dst": "Downstream.CostCenter.name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.CSKS-KOKRS",
    "dst": "Downstream.CostCenter.controlling_area",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "SAP.CSKS-VERAK",
    "dst": "Downstream.CostCenter.manager",
    "xform": "User",
    "category": "additional"
   },
   {
    "src": "SAP.CSKS-ABTEI",
    "dst": "Downstream.CostCenter.department",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "SAP.CSKS-DATBI",
    "dst": "Downstream.CostCenter.valid_to",
    "xform": "Date",
    "category": "audit"
   },
   {
    "src": "SAP.CSKS-DATAB",
    "dst": "Downstream.CostCenter.valid_from",
    "xform": "Date",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "SAP iDoc Outbound — CRELOC",
    "method": "ALE/iDoc",
    "url": "Logical system AIG_MDG",
    "prereq": [
     "Distribution model active",
     "Change pointers enabled"
    ],
    "purpose": "Outbound work center master data",
    "sample": "WE20 → Partner Type LS, Outbound message CRELOC, Process code WMCH",
    "rateLimit": "Bulk-friendly (1000 iDocs/batch)",
    "timeout": "Async"
   },
   {
    "name": "Opcenter REST — Master Data Sync",
    "method": "POST",
    "url": "https://opcenter-host/opcenter/api/v1/masterdata/sync",
    "prereq": [
     "Custom service deployed",
     "Service account with master data write"
    ],
    "purpose": "Receive canonical master data envelope from AIG",
    "sample": "{ \"object_type\":\"work_center\", \"code\":\"PRESS-01\", \"name\":\"50T Press 01\", \"plant\":\"PLANT-A\", \"cost_center\":\"CC-1234\" }",
    "rateLimit": "100 req/sec",
    "timeout": "10s"
   },
   {
    "name": "TC SOA — Update Properties",
    "method": "SOAP/POST",
    "url": "https://tc-host:4545/tc/services/DataManagement-2006-03-DataManagement/updateProperties",
    "prereq": [
     "SOA session",
     "Org Admin role"
    ],
    "purpose": "Update Plant/Center properties from SAP",
    "sample": "<info><object>...</object><props>plant_code, name, country</props></info>",
    "rateLimit": "30 req/sec",
    "timeout": "30s"
   },
   {
    "name": "Hub REST — Asset Tags",
    "method": "PUT",
    "url": "https://hub-host/hub/api/v2/assets/tags",
    "prereq": [
     "OAuth2 client_credentials",
     "Asset Admin scope"
    ],
    "purpose": "Update plant/WC/CC tags on Hub assets",
    "sample": "{ \"tags\": [{\"key\":\"plant_code\",\"value\":\"PLANT-A\"}, {\"key\":\"work_center\",\"value\":\"PRESS-01\"}] }",
    "rateLimit": "60 req/min",
    "timeout": "15s"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "SAP T001K/T024/CSKS (in SAP S/4HANA); related: MasterData, Plant, WorkCenter",
   "destinationBusinessObjectsInScope": "Opcenter Site/WorkCenter, TC Plant/Center attrs, Hub asset tags (in Opcenter 2601 + Teamcenter 2512 + Insights Hub)",
   "meaning": "Plant / Work Center / Cost Center Master Data Sync: Foundational sync of plant, work center, and cost center master data from SAP (authoritative) to Opcenter, TC, and Insights Hub.",
   "purpose": "Delivers 'Single source of truth for plant/WC/CC codes across CLM landscape' (Master Data Governance). Daily full sync plus event-driven delta on changes.",
   "functionPrimary": "Move/transform SAP T001K/T024/CSKS → Opcenter Site/WorkCenter, TC Plant/Center attrs, Hub asset tags (Sync, Batch (Daily) + Event (delta)-driven).",
   "subFunctions": [
    "SAP ALE Configuration",
    "AIG Canonical Model + Distribution",
    "Downstream Endpoints",
    "Reconciliation + Monitoring",
    "Integration Tests",
    "Cutover + 30-day Stability Window"
   ],
   "architecture": "SAP S/4HANA --[SAP iDoc CLFMAS + Custom outbound → AIG → REST APIs]--> AIG Gateway --> Opcenter 2601 + Teamcenter 2512 + Insights Hub. Pattern: Sync integration, Batch (Daily) + Event (delta) trigger. Complexity 2/4, Risk 1/4.",
   "harmoniousFlowChannel": "Channel: AIG Gateway. INTER-system (governance): harmonises master-data governance across PLM/ERP.",
   "interfacePattern": "Sync · Batch (Daily) + Event (delta)",
   "systemOfRecord": "SAP is system-of-record for the commercial/logistics object; target consumes it.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mdg_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-057"
   ],
   "criticalityScore": 6,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Logical system AIG_MDG defined",
   "docSearchKeywords": [
    "SAP MDG-M + AIG inbound governance",
    "\"SAP T001K/T024/CSKS\" mapping",
    "\"Opcenter Site/WorkCenter, TC Plant/Center attrs, Hub asset tags\" configuration",
    "AIG Gateway",
    "MasterData",
    "Plant",
    "WorkCenter",
    "CostCenter"
   ],
   "taskHours": 37,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 4,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-067",
  "seq": 67,
  "mvp": 1,
  "phase": 1,
  "grp": "MDG",
  "type": "Sync",
  "freq": "Event (per login)",
  "name": "Cross-System SSO via Azure AD",
  "from": "Azure AD (Identity Provider)",
  "to": "Teamcenter + SAP + Opcenter + Hub + SFC + AIG (Service Providers)",
  "mid": "Azure AD as central IdP",
  "protocol": "SAML 2.0 + OIDC (per system)",
  "bo": "User identity + group membership → application access with role mapping",
  "complexity": 3,
  "effort": 12,
  "risk": 2,
  "team": "Security + IT Infrastructure + each CLM system admin",
  "outcome": "Single sign-on across CLM landscape; centralized provisioning and deprovisioning",
  "outcomeCat": "Identity & Access Management",
  "deps": [],
  "about": "Configures Azure AD as the central identity provider for all CLM systems. Users authenticate once at Azure AD; subsequent access to TC, SAP, Opcenter, Hub, SFC is via SAML 2.0 (preferred) or OIDC tokens. Group membership in Azure AD maps to roles in each CLM system. Deprovisioning is centralized — disabling a user in Azure AD revokes access everywhere. This is foundational infrastructure that every other interface (especially IF-058 e-signature and IF-068 audit) depends on. ASSUMES Azure AD; for Okta/Ping the SAML/OIDC patterns hold but tenant URLs differ.",
  "tags": [
   "SSO",
   "AzureAD",
   "SAML",
   "OIDC",
   "Identity",
   "Foundational",
   "Provisioning"
  ],
  "triggers": [
   {
    "id": "TRG-067-01",
    "name": "User Login to CLM System",
    "type": "STATE_CHANGE",
    "source": "Azure AD",
    "sourceEvent": "User authenticates at Azure AD and accesses a CLM application",
    "condition": "User has appropriate Azure AD group membership for the target system",
    "latency": "< 2 seconds (typical for SAML SSO)",
    "description": "User opens a CLM system URL. System (Service Provider) redirects to Azure AD with SAML AuthnRequest. Azure AD authenticates user (with MFA if conditional access requires), issues SAML assertion with user identity + group claims. Service Provider validates assertion, maps Azure AD groups to internal roles, and establishes session. Subsequent access to other CLM systems uses the existing Azure AD session (no re-login).",
    "technicalDetails": {
     "primaryProtocol": "SAML 2.0 (for TC, SAP, Opcenter)",
     "secondaryProtocol": "OIDC (for newer apps and APIs)",
     "signingCert": "Azure AD signing cert rotates per Microsoft policy",
     "groupClaim": "groups claim with security group IDs (or names per app config)",
     "sessionLifetime": "Typically 8h with sliding renewal",
     "mfaPolicy": "Conditional access: MFA required for privileged roles and risky logins"
    },
    "preConditions": [
     "Azure AD tenant active and synchronized with on-prem AD (if hybrid)",
     "User provisioned in Azure AD with proper UPN",
     "User in required security groups for target CLM system",
     "Each CLM system configured as SAML/OIDC Service Provider in Azure AD",
     "Conditional access policies defined for high-privilege roles"
    ],
    "context": "SSO is rarely scoped to a CLM project — it's enterprise infrastructure. However, the specific configuration of each CLM system as an SP, the group-to-role mapping, and the deprovisioning workflow are project responsibilities. Done right: users barely notice they're logging into different systems. Done wrong: random SSO failures, users with stale roles, deprovisioning gaps that create audit findings.",
    "prerequisites": {
     "azure_ad": [
      "Azure AD tenant with synchronized identities",
      "Security groups defined per CLM system per role (e.g., 'CLM-TC-Engineer', 'CLM-SAP-MaterialsManager')",
      "Conditional access policies for MFA",
      "App registrations or Enterprise Applications for each CLM system",
      "Audit log forwarding to SIEM (overlap with IF-068)"
     ],
     "teamcenter": [
      "TC SSO module configured as SAML SP",
      "SAML cert from Azure AD imported",
      "Group-to-role mapping in TC (e.g., 'CLM-TC-Engineer' → tc_engineer role)",
      "User auto-provisioning on first login (JIT)"
     ],
     "sap": [
      "SAP NetWeaver SSO 3.0+ configured as SAML SP",
      "Trust relationship with Azure AD",
      "User mapping table (UPN → SAP user)",
      "Backup local authentication for emergency access"
     ],
     "opcenter": [
      "Opcenter SSO via SAML or OIDC (version-dependent)",
      "Group-to-role mapping in Opcenter security model"
     ],
     "hub": [
      "Insights Hub OAuth2/OIDC with Azure AD",
      "Tenant isolation maintained"
     ],
     "sfc": [
      "SFC SSO (less common — many SFCs use badge auth)",
      "Operator-friendly fallback (e.g., badge → AD user mapping)"
     ],
     "aig": [
      "AIG admin console SSO",
      "Service accounts continue using cert/secret auth (not SSO)"
     ]
    },
    "sla": {
     "latency": "< 2s for SSO redirect + login",
     "availability": "99.9% (Azure AD SLA + each SP SLA)",
     "sessionTimeout": "8h sliding (configurable per app)"
    },
    "errorHandling": {
     "azureAdDown": "Each CLM system can fall back to local authentication for break-glass admin access only; normal users see Azure AD error",
     "groupNotMapped": "User in unmapped Azure AD group → login succeeds but no permissions; clear error 'Contact your admin'",
     "userNotProvisioned": "First-time login with valid Azure AD identity but no CLM user → JIT provisioning if configured, else error",
     "certExpiringSoon": "Azure AD signing cert rotation → automated cert update job in each SP",
     "clockSkew": "SAML assertion time-skew → NTP sync issue alert"
    },
    "monitoring": {
     "metrics": [
      "if067_sso_logins_total{system,result}",
      "if067_sso_latency_seconds",
      "if067_failed_logins_total{system,reason}",
      "if067_active_sessions_gauge{system}"
     ],
     "alerts": [
      "Failed login rate > 5% over 15min → Security investigation",
      "Azure AD unreachable from any SP > 1min → PagerDuty",
      "Cert expiring in < 30 days → IT renewal task"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 + SAML assertion encryption with SP cert",
     "authentication": "Azure AD with MFA per conditional access policy",
     "authorization": "Group-based access control; least-privilege per role",
     "auditLog": "All login attempts logged in Azure AD + each SP; forwarded to SIEM (IF-068)",
     "dataClassification": "Identity data: confidential"
    },
    "rollback": {
     "steps": [
      "If SSO fails site-wide: revert affected SP to local authentication (break-glass)",
      "Document the incident with timeline",
      "Re-configure SP with corrected SAML/OIDC settings",
      "Test with low-impact user before re-enabling for all"
     ],
     "estimatedTime": "15-30 minutes per system",
     "dataLoss": "None — users retain access via local auth during rollback"
    },
    "recommendedMapping": [
     {
      "src": "Azure AD.User.userPrincipalName",
      "dst": "CLM_System.user.email",
      "xform": "Direct",
      "mandatory": true,
      "note": "Username key"
     },
     {
      "src": "Azure AD.User.objectId",
      "dst": "CLM_System.user.azure_oid",
      "xform": "Direct (immutable ID)",
      "mandatory": true,
      "note": "Immutable identifier"
     },
     {
      "src": "Azure AD.User.displayName",
      "dst": "CLM_System.user.display_name",
      "xform": "Direct",
      "mandatory": true,
      "note": "UI display"
     },
     {
      "src": "Azure AD.User.mail",
      "dst": "CLM_System.user.email_notification",
      "xform": "Direct",
      "mandatory": false,
      "note": "Notifications"
     },
     {
      "src": "Azure AD.User.givenName + surname",
      "dst": "CLM_System.user.full_name",
      "xform": "Concat",
      "mandatory": false,
      "note": "Full name"
     },
     {
      "src": "Azure AD.User.department",
      "dst": "CLM_System.user.department",
      "xform": "Direct",
      "mandatory": false,
      "note": "Org metadata"
     },
     {
      "src": "Azure AD.User.groups[]",
      "dst": "CLM_System.user.roles[]",
      "xform": "Group→role mapping table",
      "mandatory": true,
      "note": "Authorization"
     },
     {
      "src": "Azure AD.User.accountEnabled",
      "dst": "CLM_System.user.is_active",
      "xform": "Boolean",
      "mandatory": true,
      "note": "Deprovisioning"
     }
    ],
    "configSteps": [
     "Define security group naming convention (e.g., 'CLM-{System}-{Role}')",
     "Create security groups in Azure AD per system per role",
     "Configure conditional access policies (MFA for privileged roles)",
     "For each CLM system:",
     "  a. Register as Enterprise Application in Azure AD",
     "  b. Configure SAML 2.0 (preferred) or OIDC",
     "  c. Export Azure AD signing cert and federation metadata",
     "  d. Import metadata into CLM system SSO config",
     "  e. Define group-to-role mapping in CLM system",
     "  f. Configure JIT user provisioning",
     "  g. Test login with sample users from each role",
     "  h. Document break-glass local auth for emergencies",
     "Configure Azure AD audit log forwarding to Splunk (overlap with IF-068)",
     "Define cert rotation procedure",
     "Test deprovisioning: disable user in Azure AD; verify access revoked everywhere within 4h",
     "Document help desk runbook for SSO issues",
     "User training: what changes (one login instead of five)"
    ]
   },
   {
    "id": "TRG-067-02",
    "name": "User Deprovisioning",
    "type": "STATE_CHANGE",
    "source": "Azure AD",
    "sourceEvent": "User.accountEnabled set to false, OR user removed from required group",
    "condition": "User had active access to one or more CLM systems",
    "latency": "< 4 hours for full deprovisioning across all systems",
    "description": "When HR triggers user offboarding in Azure AD (disable account or remove group memberships), the change replicates to each CLM system on next token refresh or via Microsoft Graph change notifications (configurable). User's active sessions are invalidated on next request. Audit log captures the deprovisioning event in each system for compliance.",
    "technicalDetails": {
     "replicationMechanism": "Microsoft Graph change notifications (webhook) → per-system handler",
     "sessionInvalidation": "Each SP checks token validity on each request; tokens revoked",
     "gracePeriod": "Active sessions terminated on next token refresh (typically < 1h)",
     "idempotencyKey": "azure_oid + system + action"
    },
    "sla": {
     "latency": "< 4h end-to-end deprovisioning",
     "completeness": "100% — no orphan access permitted"
    },
    "configSteps": [
     "Configure Microsoft Graph change notification subscription for user updates",
     "Build per-system handler to revoke local sessions",
     "Configure session token short lifetimes (1h) so revocation is fast",
     "Test offboarding: disable test user; verify revocation in each system within 4h",
     "Audit log all deprovisioning events"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Azure AD (IdP) ← → Each CLM system (SP) via SAML/OIDC",
   "correlationStrategy": "azure_oid as immutable user identifier across systems",
   "consistency": "Strong on login; eventual on deprovisioning (within 4h)",
   "failureSemantics": "Fail-safe — if IdP unreachable, login blocked (except break-glass admin)"
  },
  "implementationOrder": [
   "Phase 1: Azure AD group taxonomy + conditional access",
   "Phase 2: One system at a time (start with TC — most users)",
   "Phase 3: Other systems incrementally",
   "Phase 4: Deprovisioning test and audit",
   "Phase 5: User training and cutover"
  ],
  "tasks": [
   {
    "id": "T067a",
    "name": "Azure AD Foundation",
    "type": "Configure",
    "hours": 12,
    "cx": 2,
    "dod": [
     "Group naming convention defined and documented",
     "Security groups created for all CLM-system × role combinations",
     "Conditional access policies active for privileged roles",
     "MFA enrollment campaign complete",
     "Audit log forwarding configured"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Azure AD as central IdP configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Azure AD Foundation'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Azure AD Foundation'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T067b",
    "name": "TC SSO Integration",
    "type": "Configure",
    "hours": 8,
    "cx": 3,
    "dod": [
     "TC registered as Enterprise App in Azure AD",
     "SAML 2.0 configured end-to-end",
     "Group-to-role mapping for 8+ TC roles",
     "JIT provisioning working",
     "Test users from each role log in successfully",
     "Break-glass local auth documented and tested"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Azure AD as central IdP configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'TC SSO Integration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'TC SSO Integration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T067c",
    "name": "SAP SSO Integration",
    "type": "Configure",
    "hours": 12,
    "cx": 4,
    "dod": [
     "SAP NetWeaver SSO configured",
     "UPN-to-SAP-user mapping table populated",
     "Critical SAP transactions tested with SSO users",
     "Break-glass DDIC/SAP* preserved"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Azure AD as central IdP configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP SSO Integration'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP SSO Integration'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T067d",
    "name": "Opcenter + Hub + SFC SSO",
    "type": "Configure",
    "hours": 10,
    "cx": 3,
    "dod": [
     "Opcenter SSO configured (SAML or OIDC per version)",
     "Hub OIDC working",
     "SFC SSO or badge mapping configured",
     "AIG admin console SSO",
     "All systems tested with sample users"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Azure AD as central IdP configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Opcenter + Hub + SFC SSO'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Opcenter + Hub + SFC SSO'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T067e",
    "name": "Deprovisioning + Audit",
    "type": "Test",
    "hours": 6,
    "cx": 3,
    "dod": [
     "Microsoft Graph change notifications subscribed",
     "Per-system deprovisioning handlers active",
     "Test: disable user → verify access revoked in all systems within 4h",
     "Audit log review confirms all events captured",
     "Quarterly access review process documented"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Test' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Build the test scenario for 'Deprovisioning + Audit'",
      "subSubTasks": [
       "Define scope + pass/fail criteria",
       "Prepare representative test data",
       "Identify prerequisite interfaces"
      ]
     },
     {
      "step": 2,
      "title": "Execute end-to-end (Azure AD (Identity Provider)→Teamcenter + SAP + Opcenter + Hub + SFC + AIG (Service Providers))",
      "subSubTasks": [
       "Trigger the source event",
       "Observe propagation through Azure AD as central IdP",
       "Confirm arrival + correctness at Teamcenter + SAP + Opcenter + Hub + SFC + AIG (Service Providers)"
      ]
     },
     {
      "step": 3,
      "title": "Capture and sign off",
      "subSubTasks": [
       "Capture evidence/logs/screenshots",
       "Log results in test-mgmt tool",
       "Sign off the test pack"
      ]
     }
    ]
   },
   {
    "id": "T067f",
    "name": "Cutover + User Training",
    "type": "Validate",
    "hours": 8,
    "cx": 2,
    "dod": [
     "Help desk runbook for SSO issues",
     "User-facing documentation",
     "Pilot group cutover (50 users)",
     "Full cutover after 2-week pilot",
     "Post-cutover SSO incident rate < 1% of logins"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'Cutover + User Training'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "Azure AD.User.userPrincipalName",
    "dst": "CLM_System.user.email",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.objectId",
    "dst": "CLM_System.user.azure_oid",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.displayName",
    "dst": "CLM_System.user.display_name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.mail",
    "dst": "CLM_System.user.email_notification",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.givenName",
    "dst": "CLM_System.user.first_name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.surname",
    "dst": "CLM_System.user.last_name",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "Azure AD.User.department",
    "dst": "CLM_System.user.department",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "Azure AD.User.jobTitle",
    "dst": "CLM_System.user.job_title",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "Azure AD.User.officeLocation",
    "dst": "CLM_System.user.office",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "Azure AD.User.companyName",
    "dst": "CLM_System.user.company",
    "xform": "Direct",
    "category": "metadata"
   },
   {
    "src": "Azure AD.User.groups[]",
    "dst": "CLM_System.user.roles[]",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "Azure AD.User.manager.id",
    "dst": "CLM_System.user.manager_oid",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "Azure AD.User.accountEnabled",
    "dst": "CLM_System.user.is_active",
    "xform": "Boolean",
    "category": "core"
   },
   {
    "src": "Azure AD.User.lastSignInDateTime",
    "dst": "CLM_System.user.last_login",
    "xform": "ISO 8601",
    "category": "audit"
   },
   {
    "src": "Azure AD.User.mobilePhone",
    "dst": "CLM_System.user.phone",
    "xform": "Direct",
    "category": "additional"
   }
  ],
  "apis": [
   {
    "name": "Azure AD SAML Federation Metadata",
    "method": "GET",
    "url": "https://login.microsoftonline.com/{tenant}/federationmetadata/2007-06/federationmetadata.xml",
    "prereq": [
     "Tenant ID known"
    ],
    "purpose": "Retrieve federation metadata for SP configuration",
    "sample": "GET ...federationmetadata.xml",
    "rateLimit": "Per Azure AD",
    "timeout": "10s"
   },
   {
    "name": "Azure AD OIDC Discovery",
    "method": "GET",
    "url": "https://login.microsoftonline.com/{tenant}/v2.0/.well-known/openid-configuration",
    "prereq": [
     "Tenant ID"
    ],
    "purpose": "Retrieve OIDC configuration",
    "sample": "GET .../.well-known/openid-configuration",
    "rateLimit": "Per Azure AD",
    "timeout": "10s"
   },
   {
    "name": "Microsoft Graph — User",
    "method": "GET",
    "url": "https://graph.microsoft.com/v1.0/users/{userId}",
    "prereq": [
     "App with User.Read.All permission"
    ],
    "purpose": "Retrieve user details for provisioning/deprovisioning",
    "sample": "GET /v1.0/users/12345678-...",
    "rateLimit": "Per Microsoft Graph",
    "timeout": "30s"
   },
   {
    "name": "Microsoft Graph — Change Notification",
    "method": "POST",
    "url": "https://graph.microsoft.com/v1.0/subscriptions",
    "prereq": [
     "App with appropriate permissions",
     "Webhook receiver endpoint"
    ],
    "purpose": "Subscribe to user change events",
    "sample": "{ \"changeType\":\"updated\", \"resource\":\"users\", \"notificationUrl\":\"https://...\" }",
    "rateLimit": "Per Microsoft Graph",
    "timeout": "30s"
   }
  ],
  "enhanced": {
   "moscow": "Must Have",
   "sourceBusinessObjectsInScope": "User identity + group membership (in Azure AD (Identity Provider)); related: SSO, AzureAD, SAML",
   "destinationBusinessObjectsInScope": "application access with role mapping (in Teamcenter + SAP + Opcenter + Hub + SFC + AIG (Service Providers))",
   "meaning": "Cross-System SSO via Azure AD: Configures Azure AD as the central identity provider for all CLM systems.",
   "purpose": "Delivers 'Single sign-on across CLM landscape; centralized provisioning and deprovisioning' (Identity & Access Management). Users authenticate once at Azure AD; subsequent access to TC, SAP, Opcenter, Hub, SFC is via SAML 2.0 (preferred) or OIDC tokens.",
   "functionPrimary": "Move/transform User identity + group membership → application access with role mapping (Sync, Event (per login)-driven).",
   "subFunctions": [
    "Azure AD Foundation",
    "TC SSO Integration",
    "SAP SSO Integration",
    "Opcenter + Hub + SFC SSO",
    "Deprovisioning + Audit",
    "Cutover + User Training"
   ],
   "architecture": "Azure AD (Identity Provider) --[SAML 2.0 + OIDC (per system)]--> Azure AD as central IdP --> Teamcenter + SAP + Opcenter + Hub + SFC + AIG (Service Providers). Pattern: Sync integration, Event (per login) trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: Azure AD as central IdP. INTER-system (governance): harmonises master-data governance across PLM/ERP.",
   "interfacePattern": "Sync · Event (per login)",
   "systemOfRecord": "Azure AD/Entra ID is the central identity authority; consumers federate to it.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mdg_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [],
   "downstreamConsumers": [
    "IF-058",
    "IF-068"
   ],
   "criticalityScore": 9,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Group naming convention defined and documented",
   "docSearchKeywords": [
    "SAP MDG-M + AIG inbound governance",
    "\"User identity + group membership\" mapping",
    "\"application access with role mapping\" configuration",
    "Azure AD as central IdP",
    "SSO",
    "AzureAD",
    "SAML",
    "OIDC"
   ],
   "taskHours": 56,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 4,
    "customization": 0,
    "totalTasks": 6
   }
  }
 },
 {
  "id": "IF-068",
  "seq": 68,
  "mvp": 2,
  "phase": 7,
  "grp": "MDG",
  "type": "Sync",
  "freq": "Event (real-time)",
  "name": "Centralized Audit Trail Aggregation to Splunk",
  "from": "All CLM Systems (TC, SAP, Opcenter, Hub, SFC, AIG, Signature Service)",
  "to": "Splunk Enterprise",
  "mid": "Splunk HEC + Universal Forwarders",
  "protocol": "HTTPS to Splunk HEC + Universal Forwarder (where applicable)",
  "bo": "Per-system audit event → Normalized Splunk event with common schema",
  "complexity": 3,
  "effort": 10,
  "risk": 2,
  "team": "Security + Compliance + each CLM system admin",
  "outcome": "Cross-system audit trail; incident investigation in minutes; compliance reporting automated",
  "outcomeCat": "Security & Compliance",
  "deps": [
   "IF-058",
   "IF-067"
  ],
  "about": "Forwards audit, security, and compliance-relevant events from every CLM system to Splunk. Events are normalized to a common schema (event_id, system, user, action, object, timestamp, outcome) so cross-system queries work. Splunk dashboards provide real-time visibility into user activity, signature events (from IF-058), and anomalies. Compliance reports for audits are generated from Splunk queries instead of manual log review. ASSUMES Splunk Enterprise; for Sentinel/Elastic the ingestion mechanism changes but the event schema and dashboards transfer.",
  "tags": [
   "Audit",
   "SIEM",
   "Splunk",
   "Compliance",
   "Security",
   "Logging"
  ],
  "triggers": [
   {
    "id": "TRG-068-01",
    "name": "Auditable Event Occurs",
    "type": "STATE_CHANGE",
    "source": "TC / SAP / Opcenter / Hub / SFC / AIG / Signature Service",
    "sourceEvent": "Configured auditable action: login, state change, approval, data export, role change, etc.",
    "condition": "Event matches audit policy for that system",
    "latency": "< 30 seconds from event to Splunk visibility",
    "description": "Each CLM system has its own audit configuration. Events of compliance interest (logins, data access, state changes, approvals, exports, role assignments) are forwarded to Splunk via HEC (for app-level events) or Universal Forwarder (for OS/file-level logs). Events are tagged with sourcetype, normalized to common fields, and indexed. Splunk dashboards show activity patterns; alerts fire on anomalies.",
    "technicalDetails": {
     "protocol": "Splunk HEC (HTTPS) for application events; Universal Forwarder for OS/syslog",
     "commonSchema": "Splunk CIM (Common Information Model) + custom CLM fields",
     "sourcetypes": [
      "clm:tc:audit",
      "clm:sap:slg1",
      "clm:opcenter:audit",
      "clm:hub:audit",
      "clm:sfc:audit",
      "clm:aig:audit",
      "clm:signature:ledger"
     ],
     "retentionPolicy": "Hot 30d, warm 90d, cold 7yr (compliance requirement)",
     "authentication": "HEC token per system (rotated 90 days)",
     "idempotencyKey": "system + event_id (each system generates unique event IDs)"
    },
    "preConditions": [
     "Splunk Enterprise deployed with appropriate indexer capacity",
     "HEC tokens generated per system",
     "Network connectivity from each CLM system to Splunk HEC endpoint",
     "Splunk indexes created with retention policies",
     "Search role permissions defined (least-privilege)"
    ],
    "context": "Audit logs scattered across 6+ systems make incident investigation a manual joining exercise across grep, kibana, SAP transaction SLG1, TC log files, etc. SOC analysts and auditors need a single pane. Splunk (or equivalent SIEM) provides that. Also required by most security certifications (SOC 2, ISO 27001) and increasingly by industry regulations.",
    "prerequisites": {
     "splunk": [
      "Enterprise deployment with indexer cluster",
      "Search head(s) accessible by SOC + compliance team",
      "Indexes: clm_app, clm_sec, clm_audit with retention",
      "Common schema (CIM) extensions for CLM events",
      "HEC tokens issued per source system",
      "Splunk dashboards: 'CLM Audit Overview', 'User Activity', 'Signature Events', 'Anomaly Detection'"
     ],
     "teamcenter": [
      "TC audit trail configured for in-scope events",
      "Custom audit forwarder (REST agent or file-based + Universal Forwarder)",
      "TC audit log retention aligned with Splunk"
     ],
     "sap": [
      "Security Audit Log (SAL) configured via SM19/SM20",
      "Splunk Add-on for SAP (or custom RFC-to-HEC bridge)",
      "Audit policy covers: login, role changes, sensitive transactions"
     ],
     "opcenter": [
      "Audit Trail module enabled",
      "REST event forwarder to Splunk HEC"
     ],
     "hub": [
      "Hub audit log API or webhook subscription",
      "Forwarder service to Splunk"
     ],
     "sfc": [
      "Operator login + step completion forwarded",
      "Less verbose than other systems (high event volume potential)"
     ],
     "aig": [
      "AIG admin console + service operation events",
      "Built-in Splunk forwarder (HEC)"
     ],
     "signature_service": [
      "Direct forwarding of signature ledger entries (high audit value)"
     ]
    },
    "sla": {
     "latency": "< 30s for event → Splunk visibility (P95)",
     "availability": "99.5% for forwarding (Splunk itself has separate SLA)",
     "completeness": "100% — lost events require investigation"
    },
    "errorHandling": {
     "splunkHecDown": "Forwarder buffers locally; replays on recovery; alert after 5min unavailability",
     "networkPartition": "Universal Forwarder queues to disk (default 5GB); resume on connectivity",
     "tokenRevoked": "Forwarder logs error; ops alert; events buffered until token replacement",
     "eventTooLarge": "Splunk HEC default 1MB limit → forwarder truncates with marker; large events go to fallback file log"
    },
    "monitoring": {
     "metrics": [
      "if068_events_forwarded_total{system,sourcetype}",
      "if068_forwarding_latency_seconds",
      "if068_forwarder_queue_depth{system}",
      "if068_dropped_events_total (should be 0)"
     ],
     "alerts": [
      "Forwarder queue depth > 10000 → SOC alert",
      "Dropped events > 0 → immediate compliance review",
      "Splunk HEC unavailable from any forwarder > 5min → SOC + PagerDuty",
      "Audit-relevant event types missing for > 1h → investigate forwarder"
     ]
    },
    "security": {
     "encryption": "TLS 1.3 to HEC; UF uses Splunk's certificate-based protocol",
     "authentication": "HEC tokens with appropriate scope per source",
     "authorization": "Splunk role-based access; SOC + compliance + system-specific admin views",
     "auditLog": "Splunk itself audited (meta-audit) — Splunk admin actions logged separately",
     "dataClassification": "Audit data: confidential; retain per regulatory requirements (typically 7+ years)"
    },
    "rollback": {
     "steps": [
      "Splunk events cannot be 'rolled back' (append-only by design)",
      "If forwarder misconfiguration sent wrong data: identify by sourcetype + time range and exclude from queries with caveat",
      "Document the issue in runbook for future avoidance"
     ],
     "estimatedTime": "n/a (events accumulate)",
     "dataLoss": "Forwarder buffers prevent data loss in most outages"
    },
    "recommendedMapping": [
     {
      "src": "CLM_System.event.id",
      "dst": "Splunk.event_id",
      "xform": "Direct",
      "mandatory": true,
      "note": "Event identifier per system"
     },
     {
      "src": "CLM_System.identifier",
      "dst": "Splunk.system",
      "xform": "Constant per source",
      "mandatory": true,
      "note": "Source system tag"
     },
     {
      "src": "CLM_System.event.timestamp",
      "dst": "Splunk._time",
      "xform": "ISO 8601 → epoch",
      "mandatory": true,
      "note": "Event time"
     },
     {
      "src": "CLM_System.event.user",
      "dst": "Splunk.user",
      "xform": "User lookup (Azure OID)",
      "mandatory": true,
      "note": "Actor identity"
     },
     {
      "src": "CLM_System.event.action",
      "dst": "Splunk.action",
      "xform": "Lookup to CIM action",
      "mandatory": true,
      "note": "What was done"
     },
     {
      "src": "CLM_System.event.object_uid",
      "dst": "Splunk.object_uid",
      "xform": "Direct",
      "mandatory": true,
      "note": "Affected object"
     },
     {
      "src": "CLM_System.event.object_type",
      "dst": "Splunk.object_type",
      "xform": "Lookup",
      "mandatory": true,
      "note": "Object class"
     },
     {
      "src": "CLM_System.event.outcome",
      "dst": "Splunk.outcome",
      "xform": "Success/Fail/Error",
      "mandatory": true,
      "note": "Event result"
     },
     {
      "src": "CLM_System.event.client_ip",
      "dst": "Splunk.src_ip",
      "xform": "Direct",
      "mandatory": false,
      "note": "Source IP"
     },
     {
      "src": "CLM_System.event.user_agent",
      "dst": "Splunk.user_agent",
      "xform": "Direct",
      "mandatory": false,
      "note": "Client identifier"
     },
     {
      "src": "CLM_System.event.signature_id",
      "dst": "Splunk.signature_id",
      "xform": "Direct (when present)",
      "mandatory": false,
      "note": "Link to IF-058 signature"
     },
     {
      "src": "CLM_System.event.session_id",
      "dst": "Splunk.session_id",
      "xform": "Direct",
      "mandatory": false,
      "note": "Login session correlation"
     },
     {
      "src": "CLM_System.event.raw_payload",
      "dst": "Splunk._raw",
      "xform": "JSON",
      "mandatory": false,
      "note": "Full event for forensics"
     }
    ],
    "configSteps": [
     "Deploy Splunk Enterprise with indexer cluster (or use existing)",
     "Create indexes: clm_app, clm_sec, clm_audit with retention",
     "Generate HEC tokens per source system",
     "Build common schema definitions (CIM extensions for CLM)",
     "For TC: configure audit forwarder (REST or file-based)",
     "For SAP: deploy Splunk Add-on for SAP or custom RFC bridge",
     "For Opcenter: configure REST event forwarder",
     "For Hub: configure audit log API or webhook forwarder",
     "For SFC: configure event forwarder with rate limits",
     "For AIG: enable built-in Splunk forwarder",
     "For Signature Service: direct ledger forwarding",
     "Build Splunk dashboards (Audit Overview, User Activity, Signature Events, Anomaly Detection)",
     "Configure alerts: anomalous login patterns, off-hours admin activity, role changes",
     "Configure compliance report templates",
     "Smoke test: trigger event in each system; verify Splunk visibility < 30s",
     "Volume test: simulate normal day traffic; verify no events dropped",
     "Tamper test: attempt to delete Splunk events (should be impossible with WORM)",
     "Incident-investigation tabletop: trace a synthetic incident across 3 systems"
    ]
   }
  ],
  "integrationStructure": {
   "primaryFlow": "Each CLM system → Forwarder → Splunk HEC → Indexer → Searchable",
   "correlationStrategy": "Splunk events linked by session_id, signature_id, object_uid for cross-system queries",
   "consistency": "Eventually consistent within 30s; events never lost (forwarder buffering)",
   "failureSemantics": "At-least-once; duplicate events de-duped at search time by event_id"
  },
  "implementationOrder": [
   "Phase 1: Splunk infrastructure + indexes + tokens",
   "Phase 2: Common schema definition",
   "Phase 3: Highest-value sources first (Signature Service + Azure AD + TC)",
   "Phase 4: SAP (most complex)",
   "Phase 5: Other systems",
   "Phase 6: Dashboards and alerts",
   "Phase 7: Compliance report templates",
   "Phase 8: SOC enablement and tabletop exercises"
  ],
  "tasks": [
   {
    "id": "T068a",
    "name": "Splunk Infrastructure",
    "type": "Install",
    "hours": 30,
    "cx": 3,
    "dod": [
     "Indexer cluster sized for expected event volume",
     "Search head(s) deployed",
     "Indexes with retention policies",
     "HEC tokens per system",
     "WORM retention for compliance index"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Install' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Procure and stage the Splunk HEC + Universal Forwarders component",
      "subSubTasks": [
       "Confirm licence + version vs compatibility matrix",
       "Download from Siemens Support/GTAC",
       "Stage installer on target host"
      ]
     },
     {
      "step": 2,
      "title": "Install onto the target host",
      "subSubTasks": [
       "Run installer with service account",
       "Set install path + ports",
       "Register the OS service"
      ]
     },
     {
      "step": 3,
      "title": "Configure endpoints to All CLM Systems (TC, SAP, Opcenter, Hub, SFC, AIG, Signature Service) and Splunk Enterprise",
      "subSubTasks": [
       "Enter source endpoint + credentials",
       "Enter target endpoint + credentials",
       "Set timeouts + TLS certificates"
      ]
     },
     {
      "step": 4,
      "title": "Verify and smoke-test",
      "subSubTasks": [
       "Confirm clean service startup",
       "Source connectivity test (HTTP 200)",
       "Target connectivity test (HTTP 200)",
       "Record in environments register"
      ]
     }
    ]
   },
   {
    "id": "T068b",
    "name": "Common Schema + High-Value Sources",
    "type": "Configure",
    "hours": 16,
    "cx": 3,
    "dod": [
     "CIM extensions for CLM defined and documented",
     "Signature Service forwarding (highest audit value)",
     "Azure AD forwarding",
     "TC audit forwarding",
     "Sample dashboards working with these three sources"
    ],
    "implementationType": "Customization",
    "classificationRationale": "Development signal 'signature service' implies bespoke build beyond supplied configuration.",
    "subTasks": [
     {
      "step": 1,
      "title": "Specify the bespoke logic for 'Common Schema + High-Value Sources'",
      "subSubTasks": [
       "Document why supplied config is insufficient",
       "Write the enhancement functional spec",
       "Obtain architecture-board approval"
      ]
     },
     {
      "step": 2,
      "title": "Develop using supplied extension hooks",
      "subSubTasks": [
       "Implement via BAdI/user-exit/callback (no core mod)",
       "Keep enhancement isolated + upgrade-safe",
       "Version the code in the repo"
      ]
     },
     {
      "step": 3,
      "title": "Review and test",
      "subSubTasks": [
       "Peer code review",
       "Unit test the logic",
       "Integration test against Splunk Enterprise"
      ]
     },
     {
      "step": 4,
      "title": "Promote with change advisory",
      "subSubTasks": [
       "Raise CHG flagging customization",
       "Document rollback",
       "Promote DEV→TEST"
      ]
     }
    ]
   },
   {
    "id": "T068c",
    "name": "SAP Audit Forwarding",
    "type": "Configure",
    "hours": 12,
    "cx": 4,
    "dod": [
     "SM19 audit policy configured for compliance-relevant events",
     "Splunk Add-on for SAP deployed (or custom bridge)",
     "Event normalization to common schema",
     "SAP audit visible in Splunk"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Splunk HEC + Universal Forwarders configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'SAP Audit Forwarding'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'SAP Audit Forwarding'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T068d",
    "name": "Other Systems Forwarding",
    "type": "Configure",
    "hours": 16,
    "cx": 3,
    "dod": [
     "Opcenter, Hub, SFC, AIG forwarders configured",
     "Volume from each system within expected range",
     "No dropped events in 7-day test window"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Splunk HEC + Universal Forwarders configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Other Systems Forwarding'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Other Systems Forwarding'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T068e",
    "name": "Dashboards + Alerts + Reports",
    "type": "Configure",
    "hours": 16,
    "cx": 3,
    "dod": [
     "CLM Audit Overview dashboard",
     "User Activity dashboard",
     "Signature Events dashboard (links to IF-058 ledger)",
     "Anomaly Detection dashboard with alerts",
     "Compliance report templates (Part 11, ISO 27001, SOC 2)",
     "SOC playbooks reference Splunk queries"
    ],
    "implementationType": "OOTB + Config",
    "classificationRationale": "Supplied configuration surface (mapping packs, rules, extension fields) — no code.",
    "subTasks": [
     {
      "step": 1,
      "title": "Open the Splunk HEC + Universal Forwarders configuration surface",
      "subSubTasks": [
       "Locate mapping/rule area for 'Dashboards + Alerts + Reports'",
       "Confirm use of supplied mapping pack",
       "Back up current configuration"
      ]
     },
     {
      "step": 2,
      "title": "Apply the mapping/rule for 'Dashboards + Alerts + Reports'",
      "subSubTasks": [
       "Map each source field to its target",
       "Configure code-list/value translations",
       "Set defaults + conditional logic"
      ]
     },
     {
      "step": 3,
      "title": "Verify the configuration",
      "subSubTasks": [
       "Run a representative sample",
       "Confirm field-by-field correctness",
       "Check UoM/unit conversions"
      ]
     },
     {
      "step": 4,
      "title": "Export for promotion",
      "subSubTasks": [
       "Export configuration artefact",
       "Log mapping-pack version + checksum",
       "Attach to the DIS"
      ]
     }
    ]
   },
   {
    "id": "T068f",
    "name": "SOC Enablement + Tabletop",
    "type": "Validate",
    "hours": 12,
    "cx": 3,
    "dod": [
     "SOC team trained on CLM dashboards",
     "Tabletop incident investigation completed",
     "Cross-system query training documented",
     "Compliance audit dry run completed"
    ],
    "implementationType": "OOTB",
    "classificationRationale": "Task type 'Validate' uses standard product capability as shipped.",
    "subTasks": [
     {
      "step": 1,
      "title": "Define validation criteria for 'SOC Enablement + Tabletop'",
      "subSubTasks": [
       "Map criteria to DoD",
       "Identify happy + negative paths"
      ]
     },
     {
      "step": 2,
      "title": "Execute happy-path validation",
      "subSubTasks": [
       "Run nominal flow",
       "Confirm expected target state"
      ]
     },
     {
      "step": 3,
      "title": "Execute negative-path validation",
      "subSubTasks": [
       "Inject missing/malformed data",
       "Confirm DLQ quarantine + reason",
       "Confirm source object flagged"
      ]
     },
     {
      "step": 4,
      "title": "Record evidence",
      "subSubTasks": [
       "Attach to DIS",
       "Confirm against DoD",
       "Sign off"
      ]
     }
    ]
   }
  ],
  "attrMap": [
   {
    "src": "CLM_System.event.id",
    "dst": "Splunk.event_id",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "CLM_System.identifier",
    "dst": "Splunk.system",
    "xform": "Constant",
    "category": "core"
   },
   {
    "src": "CLM_System.event.timestamp",
    "dst": "Splunk._time",
    "xform": "Epoch",
    "category": "core"
   },
   {
    "src": "CLM_System.event.user",
    "dst": "Splunk.user",
    "xform": "User lookup",
    "category": "core"
   },
   {
    "src": "CLM_System.event.action",
    "dst": "Splunk.action",
    "xform": "CIM lookup",
    "category": "core"
   },
   {
    "src": "CLM_System.event.object_uid",
    "dst": "Splunk.object_uid",
    "xform": "Direct",
    "category": "core"
   },
   {
    "src": "CLM_System.event.object_type",
    "dst": "Splunk.object_type",
    "xform": "Lookup",
    "category": "core"
   },
   {
    "src": "CLM_System.event.outcome",
    "dst": "Splunk.outcome",
    "xform": "Map",
    "category": "core"
   },
   {
    "src": "CLM_System.event.severity",
    "dst": "Splunk.severity",
    "xform": "CIM severity",
    "category": "additional"
   },
   {
    "src": "CLM_System.event.client_ip",
    "dst": "Splunk.src_ip",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "CLM_System.event.user_agent",
    "dst": "Splunk.user_agent",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "CLM_System.event.signature_id",
    "dst": "Splunk.signature_id",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "CLM_System.event.session_id",
    "dst": "Splunk.session_id",
    "xform": "Direct",
    "category": "audit"
   },
   {
    "src": "CLM_System.event.transaction_code",
    "dst": "Splunk.transaction",
    "xform": "Direct (SAP TX)",
    "category": "additional"
   },
   {
    "src": "CLM_System.event.previous_value",
    "dst": "Splunk.previous_value",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "CLM_System.event.new_value",
    "dst": "Splunk.new_value",
    "xform": "Direct",
    "category": "additional"
   },
   {
    "src": "CLM_System.event.raw_payload",
    "dst": "Splunk._raw",
    "xform": "JSON",
    "category": "audit"
   }
  ],
  "apis": [
   {
    "name": "Splunk HEC Event",
    "method": "POST",
    "url": "https://splunk-host:8088/services/collector/event",
    "prereq": [
     "HEC token",
     "Index exists"
    ],
    "purpose": "Forward audit event to Splunk",
    "sample": "Authorization: Splunk <token>\n{ \"time\":1731234567, \"source\":\"clm:tc:audit\", \"event\":{...} }",
    "rateLimit": "Per HEC capacity (thousands/sec)",
    "timeout": "10s"
   },
   {
    "name": "Splunk Search REST",
    "method": "POST",
    "url": "https://splunk-host:8089/services/search/jobs",
    "prereq": [
     "Search role",
     "Index access"
    ],
    "purpose": "Programmatic search for compliance reports",
    "sample": "search=search index=clm_audit user=jane.doe earliest=-7d",
    "rateLimit": "Per role",
    "timeout": "300s (long searches async)"
   },
   {
    "name": "Splunk Add-on for SAP",
    "method": "RFC + HEC",
    "url": "Add-on installed on Splunk + SAP RFC connection",
    "prereq": [
     "SAP NetWeaver",
     "RFC user",
     "Add-on configured"
    ],
    "purpose": "Pull SAP audit log to Splunk",
    "sample": "Configured via Splunk UI",
    "rateLimit": "Per add-on tuning",
    "timeout": "n/a"
   }
  ],
  "enhanced": {
   "moscow": "Should Have",
   "sourceBusinessObjectsInScope": "Per-system audit event (in All CLM Systems (TC, SAP, Opcenter, Hub, SFC, AIG, Signature Service)); related: Audit, SIEM, Splunk",
   "destinationBusinessObjectsInScope": "Normalized Splunk event with common schema (in Splunk Enterprise)",
   "meaning": "Centralized Audit Trail Aggregation to Splunk: Forwards audit, security, and compliance-relevant events from every CLM system to Splunk.",
   "purpose": "Delivers 'Cross-system audit trail; incident investigation in minutes; compliance reporting automated' (Security & Compliance). Events are normalized to a common schema (event_id, system, user, action, object, timestamp, outcome) so cross-system queries work.",
   "functionPrimary": "Move/transform Per-system audit event → Normalized Splunk event with common schema (Sync, Event (real-time)-driven).",
   "subFunctions": [
    "Splunk Infrastructure",
    "Common Schema + High-Value Sources",
    "SAP Audit Forwarding",
    "Other Systems Forwarding",
    "Dashboards + Alerts + Reports",
    "SOC Enablement + Tabletop"
   ],
   "architecture": "All CLM Systems (TC, SAP, Opcenter, Hub, SFC, AIG, Signature Service) --[HTTPS to Splunk HEC + Universal Forwarder (where applicable)]--> Splunk HEC + Universal Forwarders --> Splunk Enterprise. Pattern: Sync integration, Event (real-time) trigger. Complexity 3/4, Risk 2/4.",
   "harmoniousFlowChannel": "Channel: Splunk HEC + Universal Forwarders. INTER-system (governance): harmonises master-data governance across PLM/ERP.",
   "interfacePattern": "Sync · Event (real-time)",
   "systemOfRecord": "Aggregating interface — each contributing system remains system-of-record for its own data; this interface federates/forwards.",
   "idempotencyStrategy": "Idempotency via source key + payload hash; duplicate detection on repeat trigger.",
   "errorHandlingStrategy": "Transient → exponential-backoff retry; data error → DLQ with structured reason + source flag; auth error → halt + alert; conflict → authority-based resolution.",
   "securityCompliance": "mTLS + OAuth/credential vaulting; least-privilege service accounts; full audit envelope to SIEM.",
   "monitoringSignals": "Metrics: mdg_tx_total, _duration_seconds, dlq_depth, reconciliation_drift; alert on DLQ depth, p95 latency, subscription lag.",
   "upstreamDependencies": [
    "IF-058",
    "IF-067"
   ],
   "downstreamConsumers": [],
   "criticalityScore": 4,
   "reusability": "MEDIUM — pattern reusable; specifics vary by domain.",
   "keyAcceptanceSignal": "Indexer cluster sized for expected event volume",
   "docSearchKeywords": [
    "SAP MDG-M + AIG inbound governance",
    "\"Per-system audit event\" mapping",
    "\"Normalized Splunk event with common schema\" configuration",
    "Splunk HEC + Universal Forwarders",
    "Audit",
    "SIEM",
    "Splunk",
    "Compliance"
   ],
   "taskHours": 102,
   "classificationSummary": {
    "ootb": 2,
    "ootbConfig": 3,
    "customization": 1,
    "totalTasks": 6
   }
  }
 }
];

export const ENHANCEMENT_META = Object.freeze({
  version: "5.0.0",
  totalInterfaces: 56,
  totalTasks: 189,
  totalDoD: 876,
  totalTriggers: 65,
  totalAttributeMappings: 385,
  totalApiSpecs: 102,
  totalTaskHours: 1396,
  classification: { ootb: 85, ootbConfig: 98, customization: 6 },
  generatedBy: "Aether//CLM enrichment generator v5 (full fidelity)",
});

export const META = {"TRIGGER_TYPES": {"CREATE": {"label": "Create", "color": "#00ff88", "icon": "➕", "severity": "low", "description": "Object creation event"}, "UPDATE": {"label": "Update", "color": "#ffb300", "icon": "✏️", "severity": "medium", "description": "Attribute modification event"}, "DELETE": {"label": "Delete", "color": "#ff4444", "icon": "❌", "severity": "critical", "description": "Object deletion event"}, "STATE_CHANGE": {"label": "State Change", "color": "#00e5ff", "icon": "🔄", "severity": "medium", "description": "Status/state transition event"}, "ATTRIBUTE_CHANGE": {"label": "Attribute Change", "color": "#c084fc", "icon": "⚙️", "severity": "low", "description": "Specific attribute change"}, "RELEASE": {"label": "Release", "color": "#ffd600", "icon": "🚀", "severity": "medium", "description": "Object release/promotion event"}, "APPROVE": {"label": "Approve", "color": "#00d4c0", "icon": "✅", "severity": "low", "description": "Approval workflow event"}, "REJECT": {"label": "Reject", "color": "#fb923c", "icon": "❌", "severity": "high", "description": "Rejection/disapproval event"}, "COMPLETE": {"label": "Complete", "color": "#38a8ff", "icon": "🏁", "severity": "low", "description": "Process completion event"}, "SCHEDULE": {"label": "Schedule", "color": "#ff4f8b", "icon": "📅", "severity": "medium", "description": "Scheduling/planning event"}}, "GRP_META": {"CN4T": {"label": "CN4T — TC to Opcenter", "color": "#00e5ff", "order": 1, "category": "MES Gateway", "description": "Teamcenter to Opcenter Integration Gateway"}, "CN4S": {"label": "CN4S — SAP to Opcenter", "color": "#ffb300", "order": 2, "category": "ERP Gateway", "description": "SAP to Opcenter Integration Gateway"}, "AIG": {"label": "AIG — TC to SAP", "color": "#38a8ff", "order": 3, "category": "PLM-ERP Gateway", "description": "Teamcenter to SAP Integration Gateway"}, "EP": {"label": "EasyPlan", "color": "#ffd600", "order": 4, "category": "Engineering", "description": "EasyPlan Line Balancing & MTM"}, "SFC": {"label": "SFC", "color": "#fb923c", "order": 5, "category": "Shop Floor", "description": "Shop Floor Control System"}, "EDGE": {"label": "Industrial Edge", "color": "#00d4c0", "order": 6, "category": "IoT", "description": "Industrial Edge Devices"}, "HUB": {"label": "Insights Hub", "color": "#c084fc", "order": 7, "category": "Analytics", "description": "Insights Hub Analytics Platform"}, "QUAL": {"label": "Quality", "color": "#ff4f8b", "order": 8, "category": "Quality", "description": "Quality Management Systems"}}, "CX_META": {"1": {"l": "Low", "c": "#00ff88", "description": "Simple configuration, well-documented, minimal risk"}, "2": {"l": "Medium", "c": "#ffb300", "description": "Custom mapping required, moderate testing needed"}, "3": {"l": "High", "c": "#fb923c", "description": "Complex transformation, extensive testing required"}, "4": {"l": "Critical", "c": "#ff4444", "description": "Business-critical, expert implementation required"}}, "MVP_META": {"1": {"l": "MVP-1 Must", "c": "#ff4f8b", "description": "Go-live blocker - absolutely must be complete"}, "2": {"l": "MVP-2 Should", "c": "#ffb300", "description": "Phase 2 - post go-live, high business value"}, "3": {"l": "MVP-3 Could", "c": "#64b5d6", "description": "Advanced capabilities - nice to have"}}, "RISK_META": {"1": {"l": "Low", "c": "#00ff88", "description": "Well-understood, multiple fallback options"}, "2": {"l": "Medium", "c": "#ffd600", "description": "Some uncertainty, requires monitoring"}, "3": {"l": "High", "c": "#fb923c", "description": "Significant impact, rigorous testing required"}, "4": {"l": "Critical", "c": "#ff4444", "description": "Business continuity risk, executive attention"}}, "PHASE_META": {"1": {"l": "Phase 1 — EasyPlan", "c": "#ffd600", "duration": "4 weeks", "dependencies": [], "description": "Process engineering foundation"}, "2": {"l": "Phase 2 — CN4T (PLM→MES)", "c": "#00e5ff", "duration": "6 weeks", "dependencies": [1], "description": "PLM to MES integration"}, "3": {"l": "Phase 3 — CN4S (MES↔ERP)", "c": "#ffb300", "duration": "8 weeks", "dependencies": [2], "description": "MES to ERP integration"}, "4": {"l": "Phase 4 — AIG (PLM↔ERP)", "c": "#38a8ff", "duration": "6 weeks", "dependencies": [1], "description": "PLM to ERP integration"}, "5": {"l": "Phase 5 — SFC", "c": "#fb923c", "duration": "4 weeks", "dependencies": [2, 3], "description": "Shop floor execution"}, "6": {"l": "Phase 6 — Industrial Edge", "c": "#00d4c0", "duration": "4 weeks", "dependencies": [5], "description": "Edge computing layer"}, "7": {"l": "Phase 7 — Insights Hub", "c": "#c084fc", "duration": "3 weeks", "dependencies": [6], "description": "Analytics and insights"}, "8": {"l": "Phase 8 — Quality", "c": "#ff4f8b", "duration": "3 weeks", "dependencies": [3, 5], "description": "Quality management integration"}}};

// ─── Helper accessors ───────────────────────────────────────────────────────
export const byId      = (id)  => IFACES_ENHANCED.find((f) => f.id === id);
export const byGroup   = (grp) => IFACES_ENHANCED.filter((f) => f.grp === grp);
export const byPhase   = (p)   => IFACES_ENHANCED.filter((f) => f.phase === p);
export const byMoscow  = (m)   => IFACES_ENHANCED.filter((f) => f.enhanced.moscow === m);
export const byChannel = (mid) => IFACES_ENHANCED.filter((f) => f.mid === mid);
export const customizationTasks = () =>
  IFACES_ENHANCED.flatMap((f) =>
    f.tasks.filter((t) => t.implementationType === "Customization")
      .map((t) => ({ interface: f.id, taskId: t.id, name: t.name, rationale: t.classificationRationale })));
export const allTasks = () =>
  IFACES_ENHANCED.flatMap((f) => f.tasks.map((t) => ({ ...t, interfaceId: f.id })));
export const allTriggers = () =>
  IFACES_ENHANCED.flatMap((f) => (f.triggers || []).map((t) => ({ ...t, interfaceId: f.id })));
export const allAttributeMappings = () =>
  IFACES_ENHANCED.flatMap((f) => (f.attrMap || []).map((a) => ({ ...a, interfaceId: f.id })));
export const criticalInterfaces = (topN = 10) =>
  [...IFACES_ENHANCED].sort((a, b) => b.enhanced.criticalityScore - a.enhanced.criticalityScore).slice(0, topN);

export default IFACES_ENHANCED;

// ═══════════════════════════════════════════════════════════════════════════
// LEGACY COMPATIBILITY SHIM
// ═══════════════════════════════════════════════════════════════════════════
// The 23-file CLM Mission Control app was built against the older v9 shape
// of this module (IFACES, GRP_META, etc. as individual constants + helpers).
// This shim re-exports v5's IFACES_ENHANCED + META under the legacy names so
// every existing tab keeps working unchanged. It also adds richer helpers
// that take advantage of the enhanced layer.
// ═══════════════════════════════════════════════════════════════════════════

// ─── Legacy named exports (1:1 to the old IfacesData v9 API) ─────────────
export const IFACES        = IFACES_ENHANCED;
export const TRIGGER_TYPES = META.TRIGGER_TYPES;
export const GRP_META      = META.GRP_META;
export const MVP_META      = META.MVP_META;
export const RISK_META     = META.RISK_META;
export const PHASE_META    = META.PHASE_META;
export const CX_META       = META.CX_META;

// ─── Progress / DoD helpers ──────────────────────────────────────────────
// Computes per-interface completion based on the user's DoD checklist state
// (kept in App's reducer). DoD criteria are the leaf items inside tasks[].dod[].
//
export function getInterfaceProgress(iface, dodState = {}, nisState = {}) {
  if (!iface) return { done: 0, total: 0, pct: 0 };
  if (nisState[iface.id]) return { done: 0, total: 0, pct: 0, isNIS: true };
  let total = 0, done = 0;
  for (const t of iface.tasks || []) {
    for (let i = 0; i < (t.dod?.length || 0); i++) {
      total++;
      const key = `${t.id}-${i}`;
      if (dodState[key]) done++;
    }
  }
  return { done, total, pct: total > 0 ? Math.round((done / total) * 100) : 0 };
}

export function getProgressColor(pct) {
  if (pct >= 100) return "#00ff88";
  if (pct >= 75)  return "#00e5ff";
  if (pct >= 50)  return "#ffb300";
  if (pct >= 25)  return "#fb923c";
  return "#ff4444";
}

// ─── Dependency helpers (deps[] is on each interface) ────────────────────
export function getInterfaceDependencies(ifaceId) {
  const iface = IFACES_ENHANCED.find(f => f.id === ifaceId);
  if (!iface) return [];
  return (iface.deps || []).map(depId => {
    const dep = IFACES_ENHANCED.find(f => f.id === depId);
    return { id: depId, name: dep?.name || depId };
  });
}

export function getDependentInterfaces(ifaceId) {
  return IFACES_ENHANCED
    .filter(f => (f.deps || []).includes(ifaceId))
    .map(f => ({ id: f.id, name: f.name }));
}

// ─── Filter selectors (used by filterSystem, visualSelection) ────────────
export const getInterfacesByGroup = (grp) => IFACES_ENHANCED.filter(f => f.grp === grp);
export const getInterfacesByMVP   = (mvp) => IFACES_ENHANCED.filter(f => f.mvp === Number(mvp));
export const getInterfacesByRisk  = (r)   => IFACES_ENHANCED.filter(f => f.risk === Number(r));
export const getInterfacesByPhase = (p)   => IFACES_ENHANCED.filter(f => f.phase === Number(p));
export const getInterfacesByTag   = (tag) => IFACES_ENHANCED.filter(f => (f.tags || []).includes(tag));

// ─── Aggregate / programme-level helpers ─────────────────────────────────
export function getTotalInterfaces()    { return IFACES_ENHANCED.length; }
export function getTotalTasks()         { return IFACES_ENHANCED.reduce((n,f) => n + (f.tasks?.length || 0), 0); }
export function getTotalTriggers()      { return IFACES_ENHANCED.reduce((n,f) => n + (f.triggers?.length || 0), 0); }
export function getTotalDoDCriteria()   {
  let n = 0;
  for (const f of IFACES_ENHANCED) for (const t of (f.tasks||[])) n += (t.dod?.length || 0);
  return n;
}
export function getTotalAttributeMappings() {
  return IFACES_ENHANCED.reduce((n, f) => n + (f.attrMap?.length || 0), 0);
}
export function getTotalApiSpecs() {
  return IFACES_ENHANCED.reduce((n, f) => n + (f.apis?.length || 0), 0);
}
export function getTotalTaskHours() {
  return IFACES_ENHANCED.reduce((n, f) => n + (f.enhanced?.taskHours || 0), 0);
}

// Phase-level rollup
export function getPhaseProgress(phaseNum, dodState = {}, nisState = {}) {
  const ifs = IFACES_ENHANCED.filter(f => f.phase === phaseNum);
  let total = 0, done = 0;
  for (const f of ifs) {
    const p = getInterfaceProgress(f, dodState, nisState);
    total += p.total;
    done  += p.done;
  }
  return { done, total, pct: total > 0 ? Math.round((done / total) * 100) : 0, count: ifs.length };
}

// Group-level rollup
export function getGroupProgress(grp, dodState = {}, nisState = {}) {
  const ifs = IFACES_ENHANCED.filter(f => f.grp === grp);
  let total = 0, done = 0;
  for (const f of ifs) {
    const p = getInterfaceProgress(f, dodState, nisState);
    total += p.total;
    done  += p.done;
  }
  return { done, total, pct: total > 0 ? Math.round((done / total) * 100) : 0, count: ifs.length };
}

// ─── NEW helpers leveraging the enhanced layer ───────────────────────────
export function getInterfacesByMoscow(moscow) {
  return IFACES_ENHANCED.filter(f => f.enhanced?.moscow === moscow);
}

export function getInterfacesByImplementationType(implType) {
  return IFACES_ENHANCED.filter(f =>
    (f.tasks || []).some(t => t.implementationType === implType)
  );
}

export function getAllCustomizationTasks() {
  return IFACES_ENHANCED.flatMap(f =>
    (f.tasks || []).filter(t => t.implementationType === "Customization")
      .map(t => ({ ...t, interfaceId: f.id, interfaceName: f.name, grp: f.grp }))
  );
}

export function getClassificationSummary() {
  let ootb = 0, ootbConfig = 0, customization = 0;
  for (const f of IFACES_ENHANCED) {
    for (const t of (f.tasks || [])) {
      if (t.implementationType === "OOTB") ootb++;
      else if (t.implementationType === "OOTB + Config") ootbConfig++;
      else if (t.implementationType === "Customization") customization++;
    }
  }
  return { ootb, ootbConfig, customization, total: ootb + ootbConfig + customization };
}

export function getInterfacesByCriticality(threshold = 15) {
  return IFACES_ENHANCED
    .filter(f => (f.enhanced?.criticalityScore || 0) >= threshold)
    .sort((a, b) => (b.enhanced?.criticalityScore || 0) - (a.enhanced?.criticalityScore || 0));
}

export function getInterfacesByOutcomeCategory(cat) {
  return IFACES_ENHANCED.filter(f => f.outcomeCat === cat);
}

export function getAllOutcomeCategories() {
  return [...new Set(IFACES_ENHANCED.map(f => f.outcomeCat).filter(Boolean))].sort();
}

export function getAllTags() {
  const s = new Set();
  for (const f of IFACES_ENHANCED) (f.tags || []).forEach(t => s.add(t));
  return [...s].sort();
}

// Find interfaces by free-text search across name/about/tags/bo
export function searchInterfaces(query) {
  if (!query) return IFACES_ENHANCED;
  const q = query.toLowerCase();
  return IFACES_ENHANCED.filter(f => {
    const hay = `${f.id} ${f.name} ${f.about} ${f.bo} ${(f.tags||[]).join(" ")} ${f.outcome} ${f.outcomeCat}`.toLowerCase();
    return hay.includes(q);
  });
}

// Filter options for the filter panel
export function getTriggerFilterOptions() {
  return Object.entries(TRIGGER_TYPES).map(([k, v]) => ({ value: k, label: v.label, color: v.color }));
}

export function getAllTriggerTypes() {
  const s = new Set();
  for (const f of IFACES_ENHANCED) for (const t of (f.triggers || [])) s.add(t.type);
  return [...s];
}

// ─── Task-type color map + global progress ──────────────────────────────
export const TASK_TYPE_C = {
  "Install":      "#00d4c0",
  "Configure":    "#00e5ff",
  "Develop":      "#c084fc",
  "Test":         "#ffb300",
  "Validate":     "#00ff88",
  "Document":     "#64b5d6",
  "Train":        "#fb923c",
  "Deploy":       "#38a8ff",
  "Monitor":      "#ffd600",
  "Customize":    "#ff4f8b",
  "Integrate":    "#a78bfa",
  "Migrate":      "#ff4444",
};

export function getTotalProgress(dodState = {}, nisState = {}) {
  let done = 0, total = 0;
  for (const f of IFACES_ENHANCED) {
    if (nisState[f.id]) continue;
    for (const t of (f.tasks || [])) {
      for (let i = 0; i < (t.dod?.length || 0); i++) {
        total++;
        const key = `${t.id}-${i}`;
        if (dodState[key]) done++;
      }
    }
  }
  return { done, total, pct: total > 0 ? Math.round((done / total) * 100) : 0 };
}

/* ═══════════════════════════════════════════════════════════════════════
   BPH USER-STORY ALIGNMENT (reconciled to SprintPlan.pdf · 83 detailed use cases)
   Every interface gets userStories injected; full story↔interface cross-reference.
   ═══════════════════════════════════════════════════════════════════════ */
export const BPH_USER_STORIES = [
  { sn:1, id:"BPH.T.010A", fam:"T", group:"Receive & Manage Master Data", title:"Reverse Engineer Request: Analysis starts", bos:["Material Code Req.","Material Master","Reverse Eng. Req."] },
  { sn:2, id:"BPH.T.010B", fam:"T", group:"Receive & Manage Master Data", title:"Reverse Engineer Supervisor Projects", bos:["Material Code Req.","Material Master","Reverse Eng. Req."] },
  { sn:3, id:"BPH.T.020A", fam:"T", group:"Receive & Manage BOP", title:"Design Phase: Design begins", bos:["E-BOM"] },
  { sn:4, id:"BPH.T.020B", fam:"T", group:"Receive & Manage BOP", title:"Design Phase: Review begins", bos:["E-BOM"] },
  { sn:5, id:"BPH.T.020C", fam:"T", group:"Receive & Manage BOP", title:"Design Phase: Approval from SAP", bos:["Material Code Req.","Material Master"] },
  { sn:6, id:"BPH.T.030A", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: E-BOM Optimization", bos:["E-BOM"] },
  { sn:7, id:"BPH.T.030B", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: Manage M-BOM", bos:["M-BOM"] },
  { sn:8, id:"BPH.T.030C", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: M-BOM Approval", bos:["M-BOM"] },
  { sn:9, id:"BPH.T.030D", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: Quality Pre-Production Sampling", bos:["Inspection Result","Quality Sample"] },
  { sn:10, id:"BPH.T.030E", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: M-BOM Correction", bos:["M-BOM"] },
  { sn:11, id:"BPH.T.030F", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: Process design", bos:["BOP"] },
  { sn:12, id:"BPH.T.030G", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: Final approval", bos:["M-BOM"] },
  { sn:13, id:"BPH.T.030H", fam:"T", group:"Receive & Manage Orders", title:"Create Manufacturing Data: Force Closure", bos:["M-BOM"] },
  { sn:14, id:"BPH.T.040A", fam:"T", group:"Detailed Scheduling", title:"Release to Shop Floor Connect", bos:["BOP","Work Instructions"] },
  { sn:15, id:"BPH.T.040B", fam:"T", group:"Detailed Scheduling", title:"Closure Procedure", bos:["BOP","Work Instructions"] },
  { sn:16, id:"BPH.T.120A", fam:"T", group:"Correct Operation Completion / Change Request", title:"Manufacturing Change Request: Analysis starts", bos:["Corrective BOP","ECR / MCR"] },
  { sn:17, id:"BPH.T.120B", fam:"T", group:"Correct Operation Completion / Change Request", title:"Manufacturing Change Request: Process Definition begins", bos:["Corrective BOP","ECR / MCR"] },
  { sn:18, id:"BPH.T.120C", fam:"T", group:"Correct Operation Completion / Change Request", title:"Manufacturing Change Request: Manufacturing design begins", bos:["Corrective BOP","ECR / MCR"] },
  { sn:19, id:"BPH.T.120D", fam:"T", group:"Correct Operation Completion / Change Request", title:"Manufacturing Change Request: Manufacturing design approval", bos:["Corrective BOP","ECR / MCR"] },
  { sn:20, id:"BPH.T.120E", fam:"T", group:"Correct Operation Completion / Change Request", title:"Engineering Change Request Analysis starts", bos:["Design Rev.","ECR / MCR"] },
  { sn:21, id:"BPH.T.120F", fam:"T", group:"Correct Operation Completion / Change Request", title:"Engineering Change Request: Change EBOM Revision", bos:["Design Rev.","ECR / MCR"] },
  { sn:22, id:"BPH.T.120G", fam:"T", group:"Correct Operation Completion / Change Request", title:"Engineering Change Request: Change Design Revision", bos:["Design Rev.","ECR / MCR"] },
  { sn:23, id:"BPH.T.120H", fam:"T", group:"Correct Operation Completion / Change Request", title:"Engineering Change Request: Change Design Approval", bos:["Design Rev.","ECR / MCR"] },
  { sn:24, id:"BPH.T.120I", fam:"T", group:"Correct Operation Completion / Change Request", title:"Engineering Change Request: Finalize MCR Updates", bos:["Design Rev.","ECR / MCR"] },
  { sn:25, id:"BPH.O.010A", fam:"O", group:"Receive & Manage Master Data", title:"Receive Material List", bos:["Material Master"] },
  { sn:26, id:"BPH.O.010B", fam:"O", group:"Receive & Manage Master Data", title:"Receive BOM", bos:["M-BOM"] },
  { sn:27, id:"BPH.O.010C", fam:"O", group:"Receive & Manage Master Data", title:"Receive personnel / Roles", bos:["Personnel / Roles"] },
  { sn:28, id:"BPH.O.010D", fam:"O", group:"Receive & Manage Master Data", title:"Receive Material Inventory Stock Levels", bos:["Inventory / Stock"] },
  { sn:29, id:"BPH.O.010E", fam:"O", group:"Receive & Manage Master Data", title:"Receive Tools", bos:["Tools"] },
  { sn:30, id:"BPH.O.010F", fam:"O", group:"Receive & Manage Master Data", title:"Receive Maintenance Calendars", bos:["Maintenance Cal."] },
  { sn:31, id:"BPH.O.020A", fam:"O", group:"Receive & Manage BOP", title:"Receive BOP", bos:["BOP"] },
  { sn:32, id:"BPH.O.030A", fam:"O", group:"Receive & Manage Orders", title:"Receive Orders", bos:["Production Order","Work Order"] },
  { sn:33, id:"BPH.O.040A", fam:"O", group:"Detailed Scheduling", title:"Scheduling Operations", bos:["Schedule"] },
  { sn:34, id:"BPH.O.040B", fam:"O", group:"Detailed Scheduling", title:"Scheduling Machines", bos:["Schedule"] },
  { sn:35, id:"BPH.O.040C", fam:"O", group:"Detailed Scheduling", title:"Scheduling Resources", bos:["Schedule"] },
  { sn:36, id:"BPH.O.040D", fam:"O", group:"Detailed Scheduling", title:"Change machine status due to unexpected breakdown", bos:["Machine Status"] },
  { sn:37, id:"BPH.O.040E", fam:"O", group:"Detailed Scheduling", title:"Send the optimized plan to ERP", bos:["Optimized Plan","Work Order"] },
  { sn:38, id:"BPH.O.050A", fam:"O", group:"Logistic Movements", title:"Material Movement to staging", bos:["Inventory / Stock","Setpoint / Signal"] },
  { sn:39, id:"BPH.O.050B", fam:"O", group:"Logistic Movements", title:"Material Replenishment Request", bos:["Inventory / Stock"] },
  { sn:40, id:"BPH.O.050C", fam:"O", group:"Logistic Movements", title:"Material Replenishment Execution", bos:["Inventory / Stock","Setpoint / Signal"] },
  { sn:41, id:"BPH.O.050D", fam:"O", group:"Logistic Movements", title:"Material Move In Machine", bos:["Inventory / Stock","Setpoint / Signal"] },
  { sn:42, id:"BPH.O.050E", fam:"O", group:"Logistic Movements", title:"Move unused components to PSA staging", bos:["Inventory / Stock","Setpoint / Signal"] },
  { sn:43, id:"BPH.O.050F", fam:"O", group:"Logistic Movements", title:"Move unused components from staging location to Warehouse", bos:["Inventory / Stock","Setpoint / Signal"] },
  { sn:44, id:"BPH.O.080D", fam:"O", group:"Activities Before Preparation", title:"SAP downloads the Workorder", bos:["Work Order"] },
  { sn:45, id:"BPH.O.080E", fam:"O", group:"Activities Before Preparation", title:"Display and Dispatch work order in Opcenter", bos:["Work Order"] },
  { sn:46, id:"BPH.O.080F", fam:"O", group:"Activities Before Preparation", title:"Request Quality operator near the Machine", bos:["Inspection Result","Quality Sample"] },
  { sn:47, id:"BPH.O.080G", fam:"O", group:"Activities Before Preparation", title:"Collect Quality Samples before Preparation", bos:["Inspection Result","Quality Sample"] },
  { sn:48, id:"BPH.O.090A", fam:"O", group:"Operation Preparation", title:"Require Manufacturing Operator", bos:["Work Instructions"] },
  { sn:49, id:"BPH.O.090B", fam:"O", group:"Operation Preparation", title:"Execute EWI before execution", bos:["Work Instructions"] },
  { sn:50, id:"BPH.O.090C", fam:"O", group:"Operation Preparation", title:"Material Preparation", bos:["Work Instructions"] },
  { sn:51, id:"BPH.O.090D", fam:"O", group:"Operation Preparation", title:"Material Verification", bos:["Work Instructions"] },
  { sn:52, id:"BPH.O.090E", fam:"O", group:"Operation Preparation", title:"Consumption Declaration", bos:["Consumption"] },
  { sn:53, id:"BPH.O.090F", fam:"O", group:"Operation Preparation", title:"Set Part Program", bos:["Part Program"] },
  { sn:54, id:"BPH.O.100A", fam:"O", group:"Operation Execution", title:"Start the machine", bos:["Setpoint / Signal"] },
  { sn:55, id:"BPH.O.100B", fam:"O", group:"Operation Execution", title:"Execute EWI during execution", bos:["Work Instructions"] },
  { sn:56, id:"BPH.O.100F", fam:"O", group:"Operation Execution", title:"Traceability Data Collection", bos:["Traceability"] },
  { sn:57, id:"BPH.O.100I", fam:"O", group:"Operation Execution", title:"OEE Data Acquisition", bos:["OEE Data"] },
  { sn:58, id:"BPH.O.100L", fam:"O", group:"Operation Execution", title:"OEE Calculation", bos:["OEE Data"] },
  { sn:59, id:"BPH.O.100O", fam:"O", group:"Operation Execution", title:"Downtime Acquisition", bos:["Downtime Data"] },
  { sn:60, id:"BPH.O.100P", fam:"O", group:"Operation Execution", title:"Pareto of Downtime Reasons", bos:["Downtime Data"] },
  { sn:61, id:"BPH.O.110D", fam:"O", group:"Operation Post-Execution", title:"Automatic Quality Data Collection", bos:["Inspection Result"] },
  { sn:62, id:"BPH.O.110E", fam:"O", group:"Operation Post-Execution", title:"Manual Quality Data Collection", bos:["Inspection Result"] },
  { sn:63, id:"BPH.O.110F", fam:"O", group:"Operation Post-Execution", title:"EWI to confirm Byproduct Quantity", bos:["Byproduct Qty"] },
  { sn:64, id:"BPH.O.120A", fam:"O", group:"Correct Operation Completion / Change Request", title:"Confirmation of the material Produced", bos:["Order Confirmation"] },
  { sn:65, id:"BPH.O.140A", fam:"O", group:"Partial Completion With Issues", title:"Result not OK and Creation of Failures", bos:["NCR"] },
  { sn:66, id:"BPH.O.150A", fam:"O", group:"NCR on Standard Order", title:"Quality Supervisor confirms NCR", bos:["NCR"] },
  { sn:67, id:"BPH.O.150B", fam:"O", group:"NCR on Standard Order", title:"Supervisor selects Rework Operations from Catalogue", bos:["Rework Ops"] },
  { sn:68, id:"BPH.O.150C", fam:"O", group:"NCR on Standard Order", title:"Main Order is updated with Rework Operations", bos:["Rework Ops"] },
  { sn:69, id:"BPH.O.150D", fam:"O", group:"NCR on Standard Order", title:"Updated order is sent to SAP from Opcenter", bos:["Order Confirmation"] },
  { sn:70, id:"BPH.O.155A", fam:"O", group:"NCR With Impacts on BOP", title:"Quality Supervisor confirms NCR", bos:["NCR"] },
  { sn:71, id:"BPH.O.155B", fam:"O", group:"NCR With Impacts on BOP", title:"TC downloads corrective BOP to Opcenter and SAP", bos:["Corrective BOP"] },
  { sn:72, id:"BPH.O.160C", fam:"O", group:"Order Completion & Traceability", title:"Opcenter sends Order Completion Message to SAP", bos:["Order Confirmation"] },
  { sn:73, id:"BPH.O.170A", fam:"O", group:"Reporting", title:"Operator opens Opcenter Intelligence and runs a report", bos:["Report"] },
  { sn:74, id:"BPH.K.100C", fam:"K", group:"Operation Execution", title:"Traceability Data Collected with tags", bos:["Traceability"] },
  { sn:75, id:"BPH.K.100D", fam:"K", group:"Operation Execution", title:"Traceability Data Collected With Flat File", bos:["Traceability"] },
  { sn:76, id:"BPH.K.100E", fam:"K", group:"Operation Execution", title:"Traceability Data Standardization", bos:["Traceability"] },
  { sn:77, id:"BPH.K.100G", fam:"K", group:"Operation Execution", title:"OEE Data Collected with tags", bos:["OEE Data"] },
  { sn:78, id:"BPH.K.100H", fam:"K", group:"Operation Execution", title:"OEE Data Standardization", bos:["OEE Data"] },
  { sn:79, id:"BPH.K.100M", fam:"K", group:"Operation Execution", title:"Downtime Data Collected with tags", bos:["Downtime Data"] },
  { sn:80, id:"BPH.K.100N", fam:"K", group:"Operation Execution", title:"Downtime Data Standardization", bos:["Downtime Data"] },
  { sn:81, id:"BPH.K.110A", fam:"K", group:"Operation Post-Execution", title:"Quality Data Collected With OPC", bos:["Inspection Result"] },
  { sn:82, id:"BPH.K.110B", fam:"K", group:"Operation Post-Execution", title:"Quality Data Collected with Flat File", bos:["Inspection Result"] },
  { sn:83, id:"BPH.K.110C", fam:"K", group:"Operation Post-Execution", title:"Quality Data Standardization", bos:["Inspection Result"] },
];
export const BPH_STORY_IFACES = {
  "BPH.T.010A": ["IF-012","IF-024","IF-029","IF-032","IF-041","IF-042","IF-066"],
  "BPH.T.010B": ["IF-012","IF-024","IF-029","IF-032","IF-041","IF-042","IF-066"],
  "BPH.T.020A": ["IF-002","IF-012"],
  "BPH.T.020B": ["IF-002","IF-012"],
  "BPH.T.020C": ["IF-012","IF-029","IF-041","IF-042","IF-066"],
  "BPH.T.030A": ["IF-002","IF-012"],
  "BPH.T.030B": ["IF-002","IF-012"],
  "BPH.T.030C": ["IF-002","IF-012"],
  "BPH.T.030D": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.T.030E": ["IF-002","IF-012"],
  "BPH.T.030F": ["IF-001","IF-013"],
  "BPH.T.030G": ["IF-002","IF-012"],
  "BPH.T.030H": ["IF-002","IF-012"],
  "BPH.T.040A": ["IF-001","IF-003","IF-005","IF-013"],
  "BPH.T.040B": ["IF-001","IF-003","IF-005","IF-013"],
  "BPH.T.120A": ["IF-001","IF-013","IF-052","IF-059"],
  "BPH.T.120B": ["IF-001","IF-013","IF-052","IF-059"],
  "BPH.T.120C": ["IF-001","IF-013","IF-052","IF-059"],
  "BPH.T.120D": ["IF-001","IF-013","IF-052","IF-059"],
  "BPH.T.120E": ["IF-024","IF-032","IF-052","IF-059"],
  "BPH.T.120F": ["IF-024","IF-032","IF-052","IF-059"],
  "BPH.T.120G": ["IF-024","IF-032","IF-052","IF-059"],
  "BPH.T.120H": ["IF-024","IF-032","IF-052","IF-059"],
  "BPH.T.120I": ["IF-024","IF-032","IF-052","IF-059"],
  "BPH.O.010A": ["IF-029","IF-066"],
  "BPH.O.010B": ["IF-002"],
  "BPH.O.010C": ["IF-033"],
  "BPH.O.010D": ["IF-034","IF-008"],
  "BPH.O.010E": ["IF-035","IF-048"],
  "BPH.O.010F": ["IF-040","IF-023"],
  "BPH.O.020A": ["IF-001","IF-013"],
  "BPH.O.030A": ["IF-007","IF-047"],
  "BPH.O.040A": ["IF-016","IF-047"],
  "BPH.O.040B": ["IF-016","IF-047"],
  "BPH.O.040C": ["IF-016","IF-047"],
  "BPH.O.040D": ["IF-019","IF-021"],
  "BPH.O.040E": ["IF-007","IF-016","IF-047"],
  "BPH.O.050A": ["IF-008","IF-019","IF-020","IF-034"],
  "BPH.O.050B": ["IF-008","IF-034"],
  "BPH.O.050C": ["IF-008","IF-019","IF-020","IF-034"],
  "BPH.O.050D": ["IF-008","IF-019","IF-020","IF-034"],
  "BPH.O.050E": ["IF-008","IF-019","IF-020","IF-034"],
  "BPH.O.050F": ["IF-008","IF-019","IF-020","IF-034"],
  "BPH.O.080D": ["IF-007","IF-047"],
  "BPH.O.080E": ["IF-007","IF-047"],
  "BPH.O.080F": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.O.080G": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.O.090A": ["IF-003","IF-005"],
  "BPH.O.090B": ["IF-003","IF-005"],
  "BPH.O.090C": ["IF-003","IF-005"],
  "BPH.O.090D": ["IF-003","IF-005"],
  "BPH.O.090E": ["IF-008"],
  "BPH.O.090F": ["IF-004","IF-020"],
  "BPH.O.100A": ["IF-019","IF-020"],
  "BPH.O.100B": ["IF-003","IF-005"],
  "BPH.O.100F": ["IF-019","IF-021","IF-027"],
  "BPH.O.100I": ["IF-017","IF-021","IF-030"],
  "BPH.O.100L": ["IF-017","IF-021","IF-030"],
  "BPH.O.100O": ["IF-021","IF-030"],
  "BPH.O.100P": ["IF-021","IF-030"],
  "BPH.O.110D": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.O.110E": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.O.110F": ["IF-008"],
  "BPH.O.120A": ["IF-009","IF-026"],
  "BPH.O.140A": ["IF-011","IF-059"],
  "BPH.O.150A": ["IF-011","IF-059"],
  "BPH.O.150B": ["IF-011","IF-059"],
  "BPH.O.150C": ["IF-011","IF-059"],
  "BPH.O.150D": ["IF-009","IF-026"],
  "BPH.O.155A": ["IF-011","IF-059"],
  "BPH.O.155B": ["IF-001","IF-013","IF-059"],
  "BPH.O.160C": ["IF-009","IF-026"],
  "BPH.O.170A": ["IF-028","IF-036"],
  "BPH.K.100C": ["IF-019","IF-021","IF-027"],
  "BPH.K.100D": ["IF-019","IF-021","IF-027"],
  "BPH.K.100E": ["IF-019","IF-021","IF-027"],
  "BPH.K.100G": ["IF-017","IF-021","IF-030"],
  "BPH.K.100H": ["IF-017","IF-021","IF-030"],
  "BPH.K.100M": ["IF-021","IF-030"],
  "BPH.K.100N": ["IF-021","IF-030"],
  "BPH.K.110A": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.K.110B": ["IF-010","IF-025","IF-031","IF-039"],
  "BPH.K.110C": ["IF-010","IF-025","IF-031","IF-039"],
};
export const IFACE_BPH_STORIES = {
  "IF-001": ["BPH.T.030F","BPH.T.040A","BPH.T.040B","BPH.T.120A","BPH.T.120B","BPH.T.120C","BPH.T.120D","BPH.O.020A","BPH.O.155B"],
  "IF-002": ["BPH.T.020A","BPH.T.020B","BPH.T.030A","BPH.T.030B","BPH.T.030C","BPH.T.030E","BPH.T.030G","BPH.T.030H","BPH.O.010B"],
  "IF-003": ["BPH.T.040A","BPH.T.040B","BPH.O.090A","BPH.O.090B","BPH.O.090C","BPH.O.090D","BPH.O.100B"],
  "IF-004": ["BPH.O.090F"],
  "IF-005": ["BPH.T.040A","BPH.T.040B","BPH.O.090A","BPH.O.090B","BPH.O.090C","BPH.O.090D","BPH.O.100B"],
  "IF-007": ["BPH.O.030A","BPH.O.040E","BPH.O.080D","BPH.O.080E"],
  "IF-008": ["BPH.O.010D","BPH.O.050A","BPH.O.050B","BPH.O.050C","BPH.O.050D","BPH.O.050E","BPH.O.050F","BPH.O.090E","BPH.O.110F"],
  "IF-009": ["BPH.O.120A","BPH.O.150D","BPH.O.160C"],
  "IF-010": ["BPH.T.030D","BPH.O.080F","BPH.O.080G","BPH.O.110D","BPH.O.110E","BPH.K.110A","BPH.K.110B","BPH.K.110C"],
  "IF-011": ["BPH.O.140A","BPH.O.150A","BPH.O.150B","BPH.O.150C","BPH.O.155A"],
  "IF-012": ["BPH.T.010A","BPH.T.010B","BPH.T.020A","BPH.T.020B","BPH.T.020C","BPH.T.030A","BPH.T.030B","BPH.T.030C","BPH.T.030E","BPH.T.030G","BPH.T.030H"],
  "IF-013": ["BPH.T.030F","BPH.T.040A","BPH.T.040B","BPH.T.120A","BPH.T.120B","BPH.T.120C","BPH.T.120D","BPH.O.020A","BPH.O.155B"],
  "IF-016": ["BPH.O.040A","BPH.O.040B","BPH.O.040C","BPH.O.040E"],
  "IF-017": ["BPH.O.100I","BPH.O.100L","BPH.K.100G","BPH.K.100H"],
  "IF-019": ["BPH.O.040D","BPH.O.050A","BPH.O.050C","BPH.O.050D","BPH.O.050E","BPH.O.050F","BPH.O.100A","BPH.O.100F","BPH.K.100C","BPH.K.100D","BPH.K.100E"],
  "IF-020": ["BPH.O.050A","BPH.O.050C","BPH.O.050D","BPH.O.050E","BPH.O.050F","BPH.O.090F","BPH.O.100A"],
  "IF-021": ["BPH.O.040D","BPH.O.100F","BPH.O.100I","BPH.O.100L","BPH.O.100O","BPH.O.100P","BPH.K.100C","BPH.K.100D","BPH.K.100E","BPH.K.100G","BPH.K.100H","BPH.K.100M","BPH.K.100N"],
  "IF-023": ["BPH.O.010F"],
  "IF-024": ["BPH.T.010A","BPH.T.010B","BPH.T.120E","BPH.T.120F","BPH.T.120G","BPH.T.120H","BPH.T.120I"],
  "IF-025": ["BPH.T.030D","BPH.O.080F","BPH.O.080G","BPH.O.110D","BPH.O.110E","BPH.K.110A","BPH.K.110B","BPH.K.110C"],
  "IF-026": ["BPH.O.120A","BPH.O.150D","BPH.O.160C"],
  "IF-027": ["BPH.O.100F","BPH.K.100C","BPH.K.100D","BPH.K.100E"],
  "IF-028": ["BPH.O.170A"],
  "IF-029": ["BPH.T.010A","BPH.T.010B","BPH.T.020C","BPH.O.010A"],
  "IF-030": ["BPH.O.100I","BPH.O.100L","BPH.O.100O","BPH.O.100P","BPH.K.100G","BPH.K.100H","BPH.K.100M","BPH.K.100N"],
  "IF-031": ["BPH.T.030D","BPH.O.080F","BPH.O.080G","BPH.O.110D","BPH.O.110E","BPH.K.110A","BPH.K.110B","BPH.K.110C"],
  "IF-032": ["BPH.T.010A","BPH.T.010B","BPH.T.120E","BPH.T.120F","BPH.T.120G","BPH.T.120H","BPH.T.120I"],
  "IF-033": ["BPH.O.010C"],
  "IF-034": ["BPH.O.010D","BPH.O.050A","BPH.O.050B","BPH.O.050C","BPH.O.050D","BPH.O.050E","BPH.O.050F"],
  "IF-035": ["BPH.O.010E"],
  "IF-036": ["BPH.O.170A"],
  "IF-039": ["BPH.T.030D","BPH.O.080F","BPH.O.080G","BPH.O.110D","BPH.O.110E","BPH.K.110A","BPH.K.110B","BPH.K.110C"],
  "IF-040": ["BPH.O.010F"],
  "IF-041": ["BPH.T.010A","BPH.T.010B","BPH.T.020C"],
  "IF-042": ["BPH.T.010A","BPH.T.010B","BPH.T.020C"],
  "IF-047": ["BPH.O.030A","BPH.O.040A","BPH.O.040B","BPH.O.040C","BPH.O.040E","BPH.O.080D","BPH.O.080E"],
  "IF-048": ["BPH.O.010E"],
  "IF-052": ["BPH.T.120A","BPH.T.120B","BPH.T.120C","BPH.T.120D","BPH.T.120E","BPH.T.120F","BPH.T.120G","BPH.T.120H","BPH.T.120I"],
  "IF-059": ["BPH.T.120A","BPH.T.120B","BPH.T.120C","BPH.T.120D","BPH.T.120E","BPH.T.120F","BPH.T.120G","BPH.T.120H","BPH.T.120I","BPH.O.140A","BPH.O.150A","BPH.O.150B","BPH.O.150C","BPH.O.155A","BPH.O.155B"],
  "IF-066": ["BPH.T.010A","BPH.T.010B","BPH.T.020C","BPH.O.010A"],
};
IFACES_ENHANCED.forEach((f) => { f.userStories = IFACE_BPH_STORIES[f.id] || []; });
export const ifacesForStory = (storyId) => (BPH_STORY_IFACES[storyId] || []).map((id) => IFACES_ENHANCED.find((f) => f.id === id)).filter(Boolean);
export const storiesForIface = (ifaceId) => IFACE_BPH_STORIES[ifaceId] || [];
export const triggersForStory = (storyId) => ifacesForStory(storyId).flatMap((f) => (f.triggers || []).map((t) => ({ iface: f.id, ...t })));
